
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4SSe9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $38e644f71e40bb30$export$6503ec6e8aabbaf; }, function (v) { return $38e644f71e40bb30$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $38e644f71e40bb30$export$f7ad0328861e2f03; }, function (v) { return $38e644f71e40bb30$export$f7ad0328861e2f03 = v; });
var $38e644f71e40bb30$export$6503ec6e8aabbaf;
var $38e644f71e40bb30$export$f7ad0328861e2f03;
"use strict";
var $38e644f71e40bb30$var$mapping = new Map();
function $38e644f71e40bb30$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$38e644f71e40bb30$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $38e644f71e40bb30$var$resolve(id) {
    var resolved = $38e644f71e40bb30$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$38e644f71e40bb30$export$6503ec6e8aabbaf = $38e644f71e40bb30$var$register;
$38e644f71e40bb30$export$f7ad0328861e2f03 = $38e644f71e40bb30$var$resolve;

});

parcelRegister("dfCPr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9a5acbac3fe7cb52$export$bdfd709ae4826697; }, function (v) { return $9a5acbac3fe7cb52$export$bdfd709ae4826697 = v; });
var $9a5acbac3fe7cb52$export$bdfd709ae4826697;
var $9a5acbac3fe7cb52$export$c9e73fbda7da57b6;
var $9a5acbac3fe7cb52$export$5a759dc7a1cfb72a;
"use strict";
var $9a5acbac3fe7cb52$var$bundleURL = {};
function $9a5acbac3fe7cb52$var$getBundleURLCached(id) {
    var value = $9a5acbac3fe7cb52$var$bundleURL[id];
    if (!value) {
        value = $9a5acbac3fe7cb52$var$getBundleURL();
        $9a5acbac3fe7cb52$var$bundleURL[id] = value;
    }
    return value;
}
function $9a5acbac3fe7cb52$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9a5acbac3fe7cb52$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $9a5acbac3fe7cb52$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9a5acbac3fe7cb52$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$9a5acbac3fe7cb52$export$bdfd709ae4826697 = $9a5acbac3fe7cb52$var$getBundleURLCached;
$9a5acbac3fe7cb52$export$c9e73fbda7da57b6 = $9a5acbac3fe7cb52$var$getBaseURL;
$9a5acbac3fe7cb52$export$5a759dc7a1cfb72a = $9a5acbac3fe7cb52$var$getOrigin;

});

parcelRegister("bbzbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nzLi"));

});
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';
parcelRequire("013Yp");

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$g = 60103;
$1bb9784afa87e369$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $1bb9784afa87e369$var$h = Symbol.for;
    $1bb9784afa87e369$var$g = $1bb9784afa87e369$var$h("react.element");
    $1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$h("react.fragment");
}
var $1bb9784afa87e369$var$m = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$n = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$1bb9784afa87e369$var$n.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $1bb9784afa87e369$var$m.current
    };
}
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = 60103, $b9040d2deeb360f4$var$p = 60106;
$b9040d2deeb360f4$export$ffb0004e005737fa = 60107;
$b9040d2deeb360f4$export$5f8d39834fd61797 = 60108;
$b9040d2deeb360f4$export$e2c29f18771995cb = 60114;
var $b9040d2deeb360f4$var$q = 60109, $b9040d2deeb360f4$var$r = 60110, $b9040d2deeb360f4$var$t = 60112;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = 60113;
var $b9040d2deeb360f4$var$u = 60115, $b9040d2deeb360f4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $b9040d2deeb360f4$var$w = Symbol.for;
    $b9040d2deeb360f4$var$n = $b9040d2deeb360f4$var$w("react.element");
    $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$w("react.portal");
    $b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$w("react.fragment");
    $b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$w("react.strict_mode");
    $b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$w("react.profiler");
    $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$w("react.provider");
    $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$w("react.context");
    $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$w("react.forward_ref");
    $b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w("react.suspense");
    $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$w("react.memo");
    $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$w("react.lazy");
}
var $b9040d2deeb360f4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$x && a[$b9040d2deeb360f4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b9040d2deeb360f4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9040d2deeb360f4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$B = {};
function $b9040d2deeb360f4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
$b9040d2deeb360f4$var$C.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b9040d2deeb360f4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$D() {}
$b9040d2deeb360f4$var$D.prototype = $b9040d2deeb360f4$var$C.prototype;
function $b9040d2deeb360f4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
var $b9040d2deeb360f4$var$F = $b9040d2deeb360f4$var$E.prototype = new $b9040d2deeb360f4$var$D;
$b9040d2deeb360f4$var$F.constructor = $b9040d2deeb360f4$var$E;
$013Yp($b9040d2deeb360f4$var$F, $b9040d2deeb360f4$var$C.prototype);
$b9040d2deeb360f4$var$F.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$G = {
    current: null
}, $b9040d2deeb360f4$var$H = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$H.call(b, e) && !$b9040d2deeb360f4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $b9040d2deeb360f4$var$G.current
    };
}
function $b9040d2deeb360f4$var$K(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$n;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$M = /\/+/g;
function $b9040d2deeb360f4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$n:
                case $b9040d2deeb360f4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $b9040d2deeb360f4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($b9040d2deeb360f4$var$M, "$&/") + "/"), $b9040d2deeb360f4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($b9040d2deeb360f4$var$L(d) && (d = $b9040d2deeb360f4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($b9040d2deeb360f4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $b9040d2deeb360f4$var$N(k, g);
        h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    }
    else if (f = $b9040d2deeb360f4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $b9040d2deeb360f4$var$N(k, g++), h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($b9040d2deeb360f4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $b9040d2deeb360f4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $b9040d2deeb360f4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $b9040d2deeb360f4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $b9040d2deeb360f4$var$R = {
    current: null
};
function $b9040d2deeb360f4$var$S() {
    var a = $b9040d2deeb360f4$var$R.current;
    if (null === a) throw Error($b9040d2deeb360f4$var$z(321));
    return a;
}
var $b9040d2deeb360f4$var$T = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $b9040d2deeb360f4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $013Yp
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$P,
    forEach: function(a, b, c) {
        $b9040d2deeb360f4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$L(a)) throw Error($b9040d2deeb360f4$var$z(143));
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$C;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$T;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b9040d2deeb360f4$var$z(267, a));
    var e = $013Yp({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$H.call(b, f) && !$b9040d2deeb360f4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b9040d2deeb360f4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$J;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$t,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$L;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$Q
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useContext(a, b);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useEffect(a, b);
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useImperativeHandle(a, b, c);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$S().useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useReducer(a, b, c);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$S().useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$S().useState(a);
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "17.0.2";

});




parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$7fPBF) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $33s19.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $33s19.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $33s19.unstable_UserBlockingPriority, ed = $33s19.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $013Yp(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $013Yp({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $013Yp({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $013Yp({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $013Yp({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $013Yp({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $013Yp({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $013Yp({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $013Yp({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $013Yp({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $013Yp({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $013Yp({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $013Yp({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $013Yp({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $33s19.unstable_runWithPriority, Of = $33s19.unstable_scheduleCallback, Pf = $33s19.unstable_cancelCallback, Qf = $33s19.unstable_shouldYield, Rf = $33s19.unstable_requestPaint, Sf = $33s19.unstable_now, Tf = $33s19.unstable_getCurrentPriorityLevel, Uf = $33s19.unstable_ImmediatePriority, Vf = $33s19.unstable_UserBlockingPriority, Wf = $33s19.unstable_NormalPriority, Xf = $33s19.unstable_LowPriority, Yf = $33s19.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $013Yp({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $7fPBF.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $013Yp({}, e, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $013Yp({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
var $749777fefd570b40$var$f, $749777fefd570b40$var$g, $749777fefd570b40$var$h, $749777fefd570b40$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$t = null, $749777fefd570b40$var$u = null, $749777fefd570b40$var$w = function() {
        if (null !== $749777fefd570b40$var$t) try {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$t(!0, a);
            $749777fefd570b40$var$t = null;
        } catch (b) {
            throw setTimeout($749777fefd570b40$var$w, 0), b;
        }
    };
    $749777fefd570b40$var$f = function(a) {
        null !== $749777fefd570b40$var$t ? setTimeout($749777fefd570b40$var$f, 0, a) : ($749777fefd570b40$var$t = a, setTimeout($749777fefd570b40$var$w, 0));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$u = setTimeout(a, b);
    };
    $749777fefd570b40$var$h = function() {
        clearTimeout($749777fefd570b40$var$u);
    };
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $749777fefd570b40$var$k = $749777fefd570b40$export$d66a1c1c77bd778b = function() {};
} else {
    var $749777fefd570b40$var$x = window.setTimeout, $749777fefd570b40$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $749777fefd570b40$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $749777fefd570b40$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null, $749777fefd570b40$var$C = -1, $749777fefd570b40$var$D = 5, $749777fefd570b40$var$E = 0;
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return $749777fefd570b40$export$c4744153514ff05d() >= $749777fefd570b40$var$E;
    };
    $749777fefd570b40$var$k = function() {};
    $749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $749777fefd570b40$var$F = new MessageChannel, $749777fefd570b40$var$G = $749777fefd570b40$var$F.port2;
    $749777fefd570b40$var$F.port1.onmessage = function() {
        if (null !== $749777fefd570b40$var$B) {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$E = a + $749777fefd570b40$var$D;
            try {
                $749777fefd570b40$var$B(!0, a) ? $749777fefd570b40$var$G.postMessage(null) : ($749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null);
            } catch (b) {
                throw $749777fefd570b40$var$G.postMessage(null), b;
            }
        } else $749777fefd570b40$var$A = !1;
    };
    $749777fefd570b40$var$f = function(a) {
        $749777fefd570b40$var$B = a;
        $749777fefd570b40$var$A || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$G.postMessage(null));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$C = $749777fefd570b40$var$x(function() {
            a($749777fefd570b40$export$c4744153514ff05d());
        }, b);
    };
    $749777fefd570b40$var$h = function() {
        $749777fefd570b40$var$y($749777fefd570b40$var$C);
        $749777fefd570b40$var$C = -1;
    };
}
function $749777fefd570b40$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $749777fefd570b40$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $749777fefd570b40$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $749777fefd570b40$var$I(n, c)) void 0 !== r && 0 > $749777fefd570b40$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $749777fefd570b40$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $749777fefd570b40$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $749777fefd570b40$var$L = [], $749777fefd570b40$var$M = [], $749777fefd570b40$var$N = 1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = 3, $749777fefd570b40$var$Q = !1, $749777fefd570b40$var$R = !1, $749777fefd570b40$var$S = !1;
function $749777fefd570b40$var$T(a) {
    for(var b = $749777fefd570b40$var$J($749777fefd570b40$var$M); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$K($749777fefd570b40$var$M);
        else if (b.startTime <= a) $749777fefd570b40$var$K($749777fefd570b40$var$M), b.sortIndex = b.expirationTime, $749777fefd570b40$var$H($749777fefd570b40$var$L, b);
        else break;
        b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
    }
}
function $749777fefd570b40$var$U(a) {
    $749777fefd570b40$var$S = !1;
    $749777fefd570b40$var$T(a);
    if (!$749777fefd570b40$var$R) {
        if (null !== $749777fefd570b40$var$J($749777fefd570b40$var$L)) $749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V);
        else {
            var b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== b && $749777fefd570b40$var$g($749777fefd570b40$var$U, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$V(a, b) {
    $749777fefd570b40$var$R = !1;
    $749777fefd570b40$var$S && ($749777fefd570b40$var$S = !1, $749777fefd570b40$var$h());
    $749777fefd570b40$var$Q = !0;
    var c = $749777fefd570b40$var$P;
    try {
        $749777fefd570b40$var$T(b);
        for($749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L); null !== $749777fefd570b40$var$O && (!($749777fefd570b40$var$O.expirationTime > b) || a && !$749777fefd570b40$export$b5836b71941fa3ed());){
            var d = $749777fefd570b40$var$O.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$O.callback = null;
                $749777fefd570b40$var$P = $749777fefd570b40$var$O.priorityLevel;
                var e = d($749777fefd570b40$var$O.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$O.callback = e : $749777fefd570b40$var$O === $749777fefd570b40$var$J($749777fefd570b40$var$L) && $749777fefd570b40$var$K($749777fefd570b40$var$L);
                $749777fefd570b40$var$T(b);
            } else $749777fefd570b40$var$K($749777fefd570b40$var$L);
            $749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L);
        }
        if (null !== $749777fefd570b40$var$O) var m = !0;
        else {
            var n = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== n && $749777fefd570b40$var$g($749777fefd570b40$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = c, $749777fefd570b40$var$Q = !1;
    }
}
var $749777fefd570b40$var$W = $749777fefd570b40$var$k;
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V));
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$P;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$J($749777fefd570b40$var$L);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$P;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = $749777fefd570b40$var$W;
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$H($749777fefd570b40$var$M, a), null === $749777fefd570b40$var$J($749777fefd570b40$var$L) && a === $749777fefd570b40$var$J($749777fefd570b40$var$M) && ($749777fefd570b40$var$S ? $749777fefd570b40$var$h() : $749777fefd570b40$var$S = !0, $749777fefd570b40$var$g($749777fefd570b40$var$U, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$H($749777fefd570b40$var$L, a), $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V)));
    return a;
};
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$P;
    return function() {
        var c = $749777fefd570b40$var$P;
        $749777fefd570b40$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$P = c;
        }
    };
};

});




parcelRegister("9tqwB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e5b65c9cbae0db9$export$71511d61b312f219; });

var $cv8cX = parcelRequire("cv8cX");
function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cv8cX._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cv8cX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $919ebf39980bf8f3$export$71511d61b312f219; });
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2qxEV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c481e73824c6361$export$71511d61b312f219; });
function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("7o2xp", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $560cbe427eb95a5b$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $560cbe427eb95a5b$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "MemoryRouter", function () { return $560cbe427eb95a5b$export$ae46f04cfaffe093; });
$parcel$export(module.exports, "Prompt", function () { return $560cbe427eb95a5b$export$83716a4aa1642908; });
$parcel$export(module.exports, "generatePath", function () { return $560cbe427eb95a5b$export$82476f982757e71e; });
$parcel$export(module.exports, "Redirect", function () { return $560cbe427eb95a5b$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $560cbe427eb95a5b$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $560cbe427eb95a5b$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "StaticRouter", function () { return $560cbe427eb95a5b$export$cac06da4d76d935b; });
$parcel$export(module.exports, "Switch", function () { return $560cbe427eb95a5b$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "withRouter", function () { return $560cbe427eb95a5b$export$369b6b2b30582e8e; });
$parcel$export(module.exports, "useHistory", function () { return $560cbe427eb95a5b$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $560cbe427eb95a5b$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useParams", function () { return $560cbe427eb95a5b$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteMatch", function () { return $560cbe427eb95a5b$export$632be4bb944c1bc7; });

var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $iOYnm = parcelRequire("iOYnm");


var $b4iGv = parcelRequire("b4iGv");

var $kY3Ke = parcelRequire("kY3Ke");

var $iW0OW = parcelRequire("iW0OW");
parcelRequire("fD0W9");

var $cFLic = parcelRequire("cFLic");

var $8Ae2G = parcelRequire("8Ae2G");
var $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $560cbe427eb95a5b$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $560cbe427eb95a5b$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $560cbe427eb95a5b$var$commonjsGlobal[key] = ($560cbe427eb95a5b$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $560cbe427eb95a5b$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $560cbe427eb95a5b$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $560cbe427eb95a5b$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $560cbe427eb95a5b$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $560cbe427eb95a5b$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $1KLsX.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $560cbe427eb95a5b$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($560cbe427eb95a5b$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $1KLsX.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $560cbe427eb95a5b$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $560cbe427eb95a5b$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext || $560cbe427eb95a5b$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $560cbe427eb95a5b$var$createNamedContext = function createNamedContext(name) {
    var context = $560cbe427eb95a5b$var$createContext();
    context.displayName = name;
    return context;
};
var $560cbe427eb95a5b$export$c213558b66925821 = /*#__PURE__*/ $560cbe427eb95a5b$var$createNamedContext("Router-History");
var $560cbe427eb95a5b$export$63baa8ccbe60bb07 = /*#__PURE__*/ $560cbe427eb95a5b$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $560cbe427eb95a5b$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $560cbe427eb95a5b$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $iOYnm.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
var $560cbe427eb95a5b$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $560cbe427eb95a5b$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $b4iGv.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $560cbe427eb95a5b$var$messageType;
var $560cbe427eb95a5b$var$cache = {};
var $560cbe427eb95a5b$var$cacheLimit = 10000;
var $560cbe427eb95a5b$var$cacheCount = 0;
function $560cbe427eb95a5b$var$compilePath(path) {
    if ($560cbe427eb95a5b$var$cache[path]) return $560cbe427eb95a5b$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($iW0OW))).compile(path);
    if ($560cbe427eb95a5b$var$cacheCount < $560cbe427eb95a5b$var$cacheLimit) {
        $560cbe427eb95a5b$var$cache[path] = generator;
        $560cbe427eb95a5b$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $560cbe427eb95a5b$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $560cbe427eb95a5b$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $560cbe427eb95a5b$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $b4iGv.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $iOYnm.createLocation)(computedMatch ? typeof to === "string" ? $560cbe427eb95a5b$export$82476f982757e71e(to, computedMatch.params) : (0, $kY3Ke.default)({}, to, {
            pathname: $560cbe427eb95a5b$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $iOYnm.createLocation)(prevProps.to);
                if (!(0, $iOYnm.locationsAreEqual)(prevLocation, (0, $kY3Ke.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $560cbe427eb95a5b$var$cache$1 = {};
var $560cbe427eb95a5b$var$cacheLimit$1 = 10000;
var $560cbe427eb95a5b$var$cacheCount$1 = 0;
function $560cbe427eb95a5b$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $560cbe427eb95a5b$var$cache$1[cacheKey] || ($560cbe427eb95a5b$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($iW0OW)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($560cbe427eb95a5b$var$cacheCount$1 < $560cbe427eb95a5b$var$cacheLimit$1) {
        pathCache[path] = result;
        $560cbe427eb95a5b$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $560cbe427eb95a5b$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $560cbe427eb95a5b$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $560cbe427eb95a5b$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.count(children) === 0;
}
function $560cbe427eb95a5b$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $560cbe427eb95a5b$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $b4iGv.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $kY3Ke.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $560cbe427eb95a5b$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
function $560cbe427eb95a5b$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $560cbe427eb95a5b$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $kY3Ke.default)({}, location, {
        pathname: $560cbe427eb95a5b$var$addLeadingSlash(basename) + location.pathname
    });
}
function $560cbe427eb95a5b$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $560cbe427eb95a5b$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $kY3Ke.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $560cbe427eb95a5b$var$createURL(location) {
    return typeof location === "string" ? location : (0, $iOYnm.createPath)(location);
}
function $560cbe427eb95a5b$var$staticHandler(methodName) {
    return function() {
        (0, $b4iGv.default)(false);
    };
}
function $560cbe427eb95a5b$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $560cbe427eb95a5b$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $560cbe427eb95a5b$var$noop;
        };
        _this.handleBlock = function() {
            return $560cbe427eb95a5b$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $560cbe427eb95a5b$var$addBasename(basename, (0, $iOYnm.createLocation)(location));
        context.url = $560cbe427eb95a5b$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cFLic.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $560cbe427eb95a5b$var$addLeadingSlash(basename + $560cbe427eb95a5b$var$createURL(path));
            },
            action: "POP",
            location: $560cbe427eb95a5b$var$stripBasename(basename, (0, $iOYnm.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $560cbe427eb95a5b$var$staticHandler("go"),
            goBack: $560cbe427eb95a5b$var$staticHandler("goBack"),
            goForward: $560cbe427eb95a5b$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$55185c17a0fcbe46, (0, $kY3Ke.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $560cbe427eb95a5b$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $b4iGv.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, (0, $kY3Ke.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $560cbe427eb95a5b$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cFLic.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $b4iGv.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $kY3Ke.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Component);
}
var $560cbe427eb95a5b$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext;
function $560cbe427eb95a5b$export$3420e1dc2c4a518c() {
    return $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$c213558b66925821);
}
function $560cbe427eb95a5b$export$45d76561a5302f2b() {
    return $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).location;
}
function $560cbe427eb95a5b$export$99eaa27ddbbb95ef() {
    var match = $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $560cbe427eb95a5b$export$632be4bb944c1bc7(path) {
    var location = $560cbe427eb95a5b$export$45d76561a5302f2b();
    var match = $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).match;
    return path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, path) : match;
}
var $560cbe427eb95a5b$var$global$1, $560cbe427eb95a5b$var$key, $560cbe427eb95a5b$var$buildNames, $560cbe427eb95a5b$var$initialBuildName, $560cbe427eb95a5b$var$secondaryBuildName;

});
parcelRegister("1KLsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146ee816144a450d$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iJeDO.default)(t, o);
}

});
parcelRegister("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});



parcelRegister("iOYnm", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $db3bbae35c30d3fd$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $db3bbae35c30d3fd$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $db3bbae35c30d3fd$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $db3bbae35c30d3fd$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $db3bbae35c30d3fd$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $db3bbae35c30d3fd$export$2b76ad033c6e6d08; });

var $kY3Ke = parcelRequire("kY3Ke");

var $bHkMp = parcelRequire("bHkMp");

var $gJwxE = parcelRequire("gJwxE");


var $b4iGv = parcelRequire("b4iGv");
function $db3bbae35c30d3fd$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $db3bbae35c30d3fd$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $db3bbae35c30d3fd$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $db3bbae35c30d3fd$var$stripBasename(path, prefix) {
    return $db3bbae35c30d3fd$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $db3bbae35c30d3fd$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $db3bbae35c30d3fd$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $db3bbae35c30d3fd$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $db3bbae35c30d3fd$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $kY3Ke.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $bHkMp.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $db3bbae35c30d3fd$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $gJwxE.default)(a.state, b.state);
}
function $db3bbae35c30d3fd$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $db3bbae35c30d3fd$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $db3bbae35c30d3fd$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $db3bbae35c30d3fd$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $db3bbae35c30d3fd$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $db3bbae35c30d3fd$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $db3bbae35c30d3fd$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $db3bbae35c30d3fd$var$PopStateEvent = 'popstate';
var $db3bbae35c30d3fd$var$HashChangeEvent = 'hashchange';
function $db3bbae35c30d3fd$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $db3bbae35c30d3fd$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$db3bbae35c30d3fd$var$canUseDOM && (0, $b4iGv.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $db3bbae35c30d3fd$var$supportsHistory();
    var needsHashChangeListener = !$db3bbae35c30d3fd$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $db3bbae35c30d3fd$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $db3bbae35c30d3fd$var$stripTrailingSlash($db3bbae35c30d3fd$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $db3bbae35c30d3fd$var$stripBasename(path, basename);
        return $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($db3bbae35c30d3fd$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($db3bbae35c30d3fd$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($db3bbae35c30d3fd$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $db3bbae35c30d3fd$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($db3bbae35c30d3fd$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($db3bbae35c30d3fd$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($db3bbae35c30d3fd$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($db3bbae35c30d3fd$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $db3bbae35c30d3fd$var$HashChangeEvent$1 = 'hashchange';
var $db3bbae35c30d3fd$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $db3bbae35c30d3fd$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $db3bbae35c30d3fd$var$stripLeadingSlash,
        decodePath: $db3bbae35c30d3fd$var$addLeadingSlash
    },
    slash: {
        encodePath: $db3bbae35c30d3fd$var$addLeadingSlash,
        decodePath: $db3bbae35c30d3fd$var$addLeadingSlash
    }
};
function $db3bbae35c30d3fd$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $db3bbae35c30d3fd$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $db3bbae35c30d3fd$var$pushHashPath(path) {
    window.location.hash = path;
}
function $db3bbae35c30d3fd$var$replaceHashPath(path) {
    window.location.replace($db3bbae35c30d3fd$var$stripHash(window.location.href) + '#' + path);
}
function $db3bbae35c30d3fd$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$db3bbae35c30d3fd$var$canUseDOM && (0, $b4iGv.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $db3bbae35c30d3fd$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $db3bbae35c30d3fd$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $db3bbae35c30d3fd$var$stripTrailingSlash($db3bbae35c30d3fd$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $db3bbae35c30d3fd$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($db3bbae35c30d3fd$var$getHashPath());
        if (basename) path = $db3bbae35c30d3fd$var$stripBasename(path, basename);
        return $db3bbae35c30d3fd$export$90c043f1c57770b8(path);
    }
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $db3bbae35c30d3fd$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $db3bbae35c30d3fd$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $db3bbae35c30d3fd$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $db3bbae35c30d3fd$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $db3bbae35c30d3fd$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $db3bbae35c30d3fd$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $db3bbae35c30d3fd$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $db3bbae35c30d3fd$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $db3bbae35c30d3fd$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $db3bbae35c30d3fd$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $db3bbae35c30d3fd$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($db3bbae35c30d3fd$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($db3bbae35c30d3fd$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($db3bbae35c30d3fd$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $db3bbae35c30d3fd$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $db3bbae35c30d3fd$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $db3bbae35c30d3fd$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $db3bbae35c30d3fd$export$90c043f1c57770b8(entry, undefined, createKey()) : $db3bbae35c30d3fd$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $db3bbae35c30d3fd$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $db3bbae35c30d3fd$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("bHkMp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8843d44a77f8363b$export$2e2bcd8739ae039; });
function $8843d44a77f8363b$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $8843d44a77f8363b$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $8843d44a77f8363b$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $8843d44a77f8363b$var$isAbsolute(to);
    var isFromAbs = from && $8843d44a77f8363b$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $8843d44a77f8363b$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $8843d44a77f8363b$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $8843d44a77f8363b$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $8843d44a77f8363b$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$8843d44a77f8363b$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $8843d44a77f8363b$export$2e2bcd8739ae039 = $8843d44a77f8363b$var$resolvePathname;

});

parcelRegister("gJwxE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ea1770624fbc7e$export$2e2bcd8739ae039; });
function $c2ea1770624fbc7e$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $c2ea1770624fbc7e$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $c2ea1770624fbc7e$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $c2ea1770624fbc7e$var$valueOf(a);
        var bValue = $c2ea1770624fbc7e$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $c2ea1770624fbc7e$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $c2ea1770624fbc7e$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $c2ea1770624fbc7e$export$2e2bcd8739ae039 = $c2ea1770624fbc7e$var$valueEqual;

});

parcelRegister("b4iGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $80ee8fc99f5202eb$export$2e2bcd8739ae039; });
var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($80ee8fc99f5202eb$var$prefix, ": ").concat(provided) : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}

});


parcelRegister("iW0OW", function(module, exports) {

var $jP3JM = parcelRequire("jP3JM");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $dc8e47b99ce13961$var$pathToRegexp;
module.exports.parse = $dc8e47b99ce13961$var$parse;
module.exports.compile = $dc8e47b99ce13961$var$compile;
module.exports.tokensToFunction = $dc8e47b99ce13961$var$tokensToFunction;
module.exports.tokensToRegExp = $dc8e47b99ce13961$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $dc8e47b99ce13961$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $dc8e47b99ce13961$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $dc8e47b99ce13961$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $dc8e47b99ce13961$var$escapeGroup(pattern) : asterisk ? '.*' : $dc8e47b99ce13961$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $dc8e47b99ce13961$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $dc8e47b99ce13961$var$escapeString(delimiter) + ']+?';
    return $dc8e47b99ce13961$var$escapeString(prevText) + '|(?:(?!' + $dc8e47b99ce13961$var$escapeString(prevText) + ')[^' + $dc8e47b99ce13961$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $dc8e47b99ce13961$var$compile(str, options) {
    return $dc8e47b99ce13961$var$tokensToFunction($dc8e47b99ce13961$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $dc8e47b99ce13961$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $dc8e47b99ce13961$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $dc8e47b99ce13961$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $dc8e47b99ce13961$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $dc8e47b99ce13961$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($jP3JM(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $dc8e47b99ce13961$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $dc8e47b99ce13961$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $dc8e47b99ce13961$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $dc8e47b99ce13961$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $dc8e47b99ce13961$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($dc8e47b99ce13961$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $dc8e47b99ce13961$var$flags(options));
    return $dc8e47b99ce13961$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$stringToRegexp(path, keys, options) {
    return $dc8e47b99ce13961$var$tokensToRegExp($dc8e47b99ce13961$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$tokensToRegExp(tokens, keys, options) {
    if (!$jP3JM(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $dc8e47b99ce13961$var$escapeString(token);
        else {
            var prefix = $dc8e47b99ce13961$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $dc8e47b99ce13961$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $dc8e47b99ce13961$var$attachKeys(new RegExp('^' + route, $dc8e47b99ce13961$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$pathToRegexp(path, keys, options) {
    if (!$jP3JM(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $dc8e47b99ce13961$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($jP3JM(path)) return $dc8e47b99ce13961$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $dc8e47b99ce13961$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("jP3JM", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("fD0W9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gYL3V"));

});
parcelRegister("gYL3V", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $c5c6c18b1c76eb46$export$2b8d127b894957b9; }, function (v) { return $c5c6c18b1c76eb46$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $c5c6c18b1c76eb46$export$cea3a54a6425200c; }, function (v) { return $c5c6c18b1c76eb46$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $c5c6c18b1c76eb46$export$a7c73072b1a182ae; }, function (v) { return $c5c6c18b1c76eb46$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c5c6c18b1c76eb46$export$9f27bc3417b4524d; }, function (v) { return $c5c6c18b1c76eb46$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c5c6c18b1c76eb46$export$db77ccec0bb4ccac; }, function (v) { return $c5c6c18b1c76eb46$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35; }, function (v) { return $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c5c6c18b1c76eb46$export$ffb0004e005737fa; }, function (v) { return $c5c6c18b1c76eb46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c5c6c18b1c76eb46$export$b624eff549462981; }, function (v) { return $c5c6c18b1c76eb46$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c5c6c18b1c76eb46$export$7897aa7841a5380c; }, function (v) { return $c5c6c18b1c76eb46$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c5c6c18b1c76eb46$export$602eac185826482c; }, function (v) { return $c5c6c18b1c76eb46$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c5c6c18b1c76eb46$export$e2c29f18771995cb; }, function (v) { return $c5c6c18b1c76eb46$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c5c6c18b1c76eb46$export$5f8d39834fd61797; }, function (v) { return $c5c6c18b1c76eb46$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c5c6c18b1c76eb46$export$74bf444e3cd11ea5; }, function (v) { return $c5c6c18b1c76eb46$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c5c6c18b1c76eb46$export$92387174baf9b227; }, function (v) { return $c5c6c18b1c76eb46$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c5c6c18b1c76eb46$export$ec112efeb987d9c6; }, function (v) { return $c5c6c18b1c76eb46$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c5c6c18b1c76eb46$export$b706b080d889d2c9; }, function (v) { return $c5c6c18b1c76eb46$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c5c6c18b1c76eb46$export$5be5a87408f70ddc; }, function (v) { return $c5c6c18b1c76eb46$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d; }, function (v) { return $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c5c6c18b1c76eb46$export$455c2e768291efa6; }, function (v) { return $c5c6c18b1c76eb46$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c5c6c18b1c76eb46$export$9522e17588c12572; }, function (v) { return $c5c6c18b1c76eb46$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c5c6c18b1c76eb46$export$2110ac352bb060b9; }, function (v) { return $c5c6c18b1c76eb46$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c5c6c18b1c76eb46$export$56885ab8b9c456ab; }, function (v) { return $c5c6c18b1c76eb46$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c5c6c18b1c76eb46$export$d927fcb6adf8f9de; }, function (v) { return $c5c6c18b1c76eb46$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c5c6c18b1c76eb46$export$b82d16f27459e05a; }, function (v) { return $c5c6c18b1c76eb46$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c5c6c18b1c76eb46$export$522c17b4f5e123e8; }, function (v) { return $c5c6c18b1c76eb46$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6; }, function (v) { return $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c5c6c18b1c76eb46$export$9b621391a187a31a; }, function (v) { return $c5c6c18b1c76eb46$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c5c6c18b1c76eb46$export$f5bbd400c2f4426f; }, function (v) { return $c5c6c18b1c76eb46$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c5c6c18b1c76eb46$export$2b8d127b894957b9;
var $c5c6c18b1c76eb46$export$cea3a54a6425200c;
var $c5c6c18b1c76eb46$export$a7c73072b1a182ae;
var $c5c6c18b1c76eb46$export$9f27bc3417b4524d;
var $c5c6c18b1c76eb46$export$db77ccec0bb4ccac;
var $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35;
var $c5c6c18b1c76eb46$export$ffb0004e005737fa;
var $c5c6c18b1c76eb46$export$b624eff549462981;
var $c5c6c18b1c76eb46$export$7897aa7841a5380c;
var $c5c6c18b1c76eb46$export$602eac185826482c;
var $c5c6c18b1c76eb46$export$e2c29f18771995cb;
var $c5c6c18b1c76eb46$export$5f8d39834fd61797;
var $c5c6c18b1c76eb46$export$74bf444e3cd11ea5;
var $c5c6c18b1c76eb46$export$92387174baf9b227;
var $c5c6c18b1c76eb46$export$ec112efeb987d9c6;
var $c5c6c18b1c76eb46$export$b706b080d889d2c9;
var $c5c6c18b1c76eb46$export$5be5a87408f70ddc;
var $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d;
var $c5c6c18b1c76eb46$export$455c2e768291efa6;
var $c5c6c18b1c76eb46$export$9522e17588c12572;
var $c5c6c18b1c76eb46$export$2110ac352bb060b9;
var $c5c6c18b1c76eb46$export$56885ab8b9c456ab;
var $c5c6c18b1c76eb46$export$d927fcb6adf8f9de;
var $c5c6c18b1c76eb46$export$b82d16f27459e05a;
var $c5c6c18b1c76eb46$export$522c17b4f5e123e8;
var $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6;
var $c5c6c18b1c76eb46$export$9b621391a187a31a;
var $c5c6c18b1c76eb46$export$f5bbd400c2f4426f;
'use strict';
var $c5c6c18b1c76eb46$var$b = "function" === typeof Symbol && Symbol.for, $c5c6c18b1c76eb46$var$c = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.element") : 60103, $c5c6c18b1c76eb46$var$d = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.portal") : 60106, $c5c6c18b1c76eb46$var$e = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.fragment") : 60107, $c5c6c18b1c76eb46$var$f = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.strict_mode") : 60108, $c5c6c18b1c76eb46$var$g = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.profiler") : 60114, $c5c6c18b1c76eb46$var$h = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.provider") : 60109, $c5c6c18b1c76eb46$var$k = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.context") : 60110, $c5c6c18b1c76eb46$var$l = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.async_mode") : 60111, $c5c6c18b1c76eb46$var$m = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.concurrent_mode") : 60111, $c5c6c18b1c76eb46$var$n = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.forward_ref") : 60112, $c5c6c18b1c76eb46$var$p = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.suspense") : 60113, $c5c6c18b1c76eb46$var$q = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.suspense_list") : 60120, $c5c6c18b1c76eb46$var$r = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.memo") : 60115, $c5c6c18b1c76eb46$var$t = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.lazy") : 60116, $c5c6c18b1c76eb46$var$v = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.block") : 60121, $c5c6c18b1c76eb46$var$w = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.fundamental") : 60117, $c5c6c18b1c76eb46$var$x = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.responder") : 60118, $c5c6c18b1c76eb46$var$y = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.scope") : 60119;
function $c5c6c18b1c76eb46$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $c5c6c18b1c76eb46$var$c:
                switch(a = a.type, a){
                    case $c5c6c18b1c76eb46$var$l:
                    case $c5c6c18b1c76eb46$var$m:
                    case $c5c6c18b1c76eb46$var$e:
                    case $c5c6c18b1c76eb46$var$g:
                    case $c5c6c18b1c76eb46$var$f:
                    case $c5c6c18b1c76eb46$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c5c6c18b1c76eb46$var$k:
                            case $c5c6c18b1c76eb46$var$n:
                            case $c5c6c18b1c76eb46$var$t:
                            case $c5c6c18b1c76eb46$var$r:
                            case $c5c6c18b1c76eb46$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $c5c6c18b1c76eb46$var$d:
                return u;
        }
    }
}
function $c5c6c18b1c76eb46$var$A(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$m;
}
$c5c6c18b1c76eb46$export$2b8d127b894957b9 = $c5c6c18b1c76eb46$var$l;
$c5c6c18b1c76eb46$export$cea3a54a6425200c = $c5c6c18b1c76eb46$var$m;
$c5c6c18b1c76eb46$export$a7c73072b1a182ae = $c5c6c18b1c76eb46$var$k;
$c5c6c18b1c76eb46$export$9f27bc3417b4524d = $c5c6c18b1c76eb46$var$h;
$c5c6c18b1c76eb46$export$db77ccec0bb4ccac = $c5c6c18b1c76eb46$var$c;
$c5c6c18b1c76eb46$export$8392c0c9d3dcbd35 = $c5c6c18b1c76eb46$var$n;
$c5c6c18b1c76eb46$export$ffb0004e005737fa = $c5c6c18b1c76eb46$var$e;
$c5c6c18b1c76eb46$export$b624eff549462981 = $c5c6c18b1c76eb46$var$t;
$c5c6c18b1c76eb46$export$7897aa7841a5380c = $c5c6c18b1c76eb46$var$r;
$c5c6c18b1c76eb46$export$602eac185826482c = $c5c6c18b1c76eb46$var$d;
$c5c6c18b1c76eb46$export$e2c29f18771995cb = $c5c6c18b1c76eb46$var$g;
$c5c6c18b1c76eb46$export$5f8d39834fd61797 = $c5c6c18b1c76eb46$var$f;
$c5c6c18b1c76eb46$export$74bf444e3cd11ea5 = $c5c6c18b1c76eb46$var$p;
$c5c6c18b1c76eb46$export$92387174baf9b227 = function(a) {
    return $c5c6c18b1c76eb46$var$A(a) || $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$l;
};
$c5c6c18b1c76eb46$export$ec112efeb987d9c6 = $c5c6c18b1c76eb46$var$A;
$c5c6c18b1c76eb46$export$b706b080d889d2c9 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$k;
};
$c5c6c18b1c76eb46$export$5be5a87408f70ddc = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$h;
};
$c5c6c18b1c76eb46$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c5c6c18b1c76eb46$var$c;
};
$c5c6c18b1c76eb46$export$455c2e768291efa6 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$n;
};
$c5c6c18b1c76eb46$export$9522e17588c12572 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$e;
};
$c5c6c18b1c76eb46$export$2110ac352bb060b9 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$t;
};
$c5c6c18b1c76eb46$export$56885ab8b9c456ab = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$r;
};
$c5c6c18b1c76eb46$export$d927fcb6adf8f9de = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$d;
};
$c5c6c18b1c76eb46$export$b82d16f27459e05a = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$g;
};
$c5c6c18b1c76eb46$export$522c17b4f5e123e8 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$f;
};
$c5c6c18b1c76eb46$export$1aabd8a0274ecfd6 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$p;
};
$c5c6c18b1c76eb46$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c5c6c18b1c76eb46$var$e || a === $c5c6c18b1c76eb46$var$m || a === $c5c6c18b1c76eb46$var$g || a === $c5c6c18b1c76eb46$var$f || a === $c5c6c18b1c76eb46$var$p || a === $c5c6c18b1c76eb46$var$q || "object" === typeof a && null !== a && (a.$$typeof === $c5c6c18b1c76eb46$var$t || a.$$typeof === $c5c6c18b1c76eb46$var$r || a.$$typeof === $c5c6c18b1c76eb46$var$h || a.$$typeof === $c5c6c18b1c76eb46$var$k || a.$$typeof === $c5c6c18b1c76eb46$var$n || a.$$typeof === $c5c6c18b1c76eb46$var$w || a.$$typeof === $c5c6c18b1c76eb46$var$x || a.$$typeof === $c5c6c18b1c76eb46$var$y || a.$$typeof === $c5c6c18b1c76eb46$var$v);
};
$c5c6c18b1c76eb46$export$f5bbd400c2f4426f = $c5c6c18b1c76eb46$var$z;

});


parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("dOv1V", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3oWWu"));

});
parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
'use strict';
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});




parcelRegister("8knIu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6102969760a10d5a$export$2e2bcd8739ae039; });
var $6102969760a10d5a$var$isProduction = true;
function $6102969760a10d5a$var$warning(condition, message) {
    if (!$6102969760a10d5a$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $6102969760a10d5a$export$2e2bcd8739ae039 = $6102969760a10d5a$var$warning;

});

parcelRegister("aili3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ec199cefd4182a$export$2e2bcd8739ae039; });

var $ggBKj = parcelRequire("ggBKj");


var $kU6nt = parcelRequire("kU6nt");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");

var $dxABk = parcelRequire("dxABk");
'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $ggBKj.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $dxABk.default).root,
    generateClassName: (0, $kU6nt.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;

});
parcelRegister("ggBKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd7b6b8695507478$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $2dTiQ = parcelRequire("2dTiQ");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4kWyf.default)(defaultTheme);
        const _extendSxProp = (0, $mqrnX.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $2dTiQ.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});
parcelRegister("2dTiQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12640d84886d4066$export$2e2bcd8739ae039; });
function $12640d84886d4066$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $12640d84886d4066$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $12640d84886d4066$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $12640d84886d4066$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $12640d84886d4066$export$2e2bcd8739ae039 = $12640d84886d4066$export$4f5d2d50c9deca37;

});

parcelRegister("5VCcJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("5nUae")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("5nUae")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("e6xq6")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("5tMhb")).default; });
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $70jUf = parcelRequire("70jUf");

var $5nUae = parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $e6xq6 = parcelRequire("e6xq6");

var $5tMhb = parcelRequire("5tMhb");
'use client';
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $70jUf.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("70jUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5197f9709daec52b$export$2e2bcd8739ae039; });

var $lmsDT = parcelRequire("lmsDT");
parcelRequire("cvBp9");

parcelRequire("6lPck");
parcelRequire("9uXao");
parcelRequire("80dPg");
parcelRequire("7fPBF");
parcelRequire("9YmaI");
var $5197f9709daec52b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $5197f9709daec52b$export$2e2bcd8739ae039 = (0, $lmsDT.default).bind(null);
$5197f9709daec52b$var$tags.forEach(function(tagName) {
    $5197f9709daec52b$export$2e2bcd8739ae039[tagName] = $5197f9709daec52b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("lmsDT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d1dedc3623dfeb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");

var $80dPg = parcelRequire("80dPg");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
var $f8d1dedc3623dfeb$var$isBrowser = typeof document !== 'undefined';
var $f8d1dedc3623dfeb$var$isDevelopment = false;
var $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $f8d1dedc3623dfeb$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag : $f8d1dedc3623dfeb$var$testOmitPropsOnComponent;
};
var $f8d1dedc3623dfeb$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $f8d1dedc3623dfeb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f8d1dedc3623dfeb$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f8d1dedc3623dfeb$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $f8d1dedc3623dfeb$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $6te04.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6te04.T));
            }
            if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $6lPck.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($f8d1dedc3623dfeb$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $f8d1dedc3623dfeb$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $f8d1dedc3623dfeb$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("5nUae", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $3ebaaabf76fb5db5$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $3ebaaabf76fb5db5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $3ebaaabf76fb5db5$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6te04")).w; });

var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");

var $80dPg = parcelRequire("80dPg");

var $9uXao = parcelRequire("9uXao");

var $6lPck = parcelRequire("6lPck");
parcelRequire("3mESc");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $6te04.h).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6te04.E);
    createElementArgArray[1] = (0, $6te04.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6lPck.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6te04.T)));
    if (!(0, $6te04.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $80dPg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6lPck.serializeStyles)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $80dPg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $80dPg.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $6te04.i) && res !== undefined) rules += res;
        }
        if (!(0, $6te04.i)) return rules;
    });
    if (!(0, $6te04.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $6te04.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6lPck.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $80dPg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $6te04.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6te04.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("6te04", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $4b604f9ff2f6f5b8$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $4b604f9ff2f6f5b8$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $4b604f9ff2f6f5b8$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4b604f9ff2f6f5b8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $4b604f9ff2f6f5b8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $3mESc = parcelRequire("3mESc");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $10FT7 = parcelRequire("10FT7");

var $80dPg = parcelRequire("80dPg");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");
var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3mESc.default)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3mESc.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $10FT7.default)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6lPck.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;

});
parcelRegister("3mESc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273321b94be832ab$export$2e2bcd8739ae039; });

var $4cVy4 = parcelRequire("4cVy4");

var $cByrN = parcelRequire("cByrN");

var $lT6zG = parcelRequire("lT6zG");

var $4AWAi = parcelRequire("4AWAi");
var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($273321b94be832ab$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + 'box-$1$2' + (0, $cByrN.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-item-' + (0, $cByrN.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-line-pack' + (0, $cByrN.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + 'box-' + (0, $cByrN.replace)(value, '-grow', '') + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, '$1' + (0, $cByrN.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + '$1'), /(image-set)/, (0, $cByrN.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + 'box-pack:$3' + (0, $cByrN.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cByrN.WEBKIT) + '$2-$3' + '$1' + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $cByrN.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ':', ':' + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cByrN.WEBKIT) + '$2$3' + '$1' + (0, $cByrN.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, '@', '@' + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $lT6zG.default)(function() {
    return (0, $4AWAi.default)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cByrN.stringify),
            (0, $cByrN.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cByrN.stringify)
        ];
        var _serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $4cVy4.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("4cVy4", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3104ec53a35158ff$export$9d753cd7ae895cce; });
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("10FT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc6489980e08e1c$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});

parcelRegister("80dPg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5d390c582efd47c3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5d390c582efd47c3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5d390c582efd47c3$export$6f077d94b33a01aa; });
var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6lPck", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $49fc6b0b9a1bf345$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9uXao", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6ea4cfa701df259a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6ea4cfa701df259a$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});


parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("e6xq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44b8cbd62c27155$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $6te04 = parcelRequire("6te04");

var $3mESc = parcelRequire("3mESc");

var $bbzbN = parcelRequire("bbzbN");
'use client';
let $a44b8cbd62c27155$var$cache;
if (typeof document === 'object') $a44b8cbd62c27155$var$cache = (0, $3mESc.default)({
    key: 'css',
    prepend: true
});
function $a44b8cbd62c27155$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $a44b8cbd62c27155$var$cache ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.C), {
        value: $a44b8cbd62c27155$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5nUae = parcelRequire("5nUae");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5nUae.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $663795ec7cbfcd06$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $diYUK.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("diYUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afc3518733c6a5e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3wRTY.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});
parcelRegister("3wRTY", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $291e2c063c5d6173$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $291e2c063c5d6173$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || !$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key])) output[key] = source[key];
        else if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});
parcelRegister("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $91ad95ac62846a03$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $91ad95ac62846a03$export$980e6a259d807490; });

var $kY3Ke = parcelRequire("kY3Ke");


var $3wRTY = parcelRequire("3wRTY");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3wRTY.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});


parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $40d4ff9e66a5531b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRegister("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8543e3d4e0a2f626$var$createBorderStyle(prop, transform) {
    return (0, $190Wm.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = $8543e3d4e0a2f626$var$createBorderStyle('border', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = $8543e3d4e0a2f626$var$createBorderStyle('borderTop', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = $8543e3d4e0a2f626$var$createBorderStyle('borderRight', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = $8543e3d4e0a2f626$var$createBorderStyle('borderBottom', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$47658cca1a909427 = $8543e3d4e0a2f626$var$createBorderStyle('borderLeft', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = $8543e3d4e0a2f626$var$createBorderStyle('borderColor');
const $8543e3d4e0a2f626$export$126a92c968acdb85 = $8543e3d4e0a2f626$var$createBorderStyle('borderTopColor');
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = $8543e3d4e0a2f626$var$createBorderStyle('borderRightColor');
const $8543e3d4e0a2f626$export$340b0327727f6d1a = $8543e3d4e0a2f626$var$createBorderStyle('borderBottomColor');
const $8543e3d4e0a2f626$export$60beef91a985b4bf = $8543e3d4e0a2f626$var$createBorderStyle('borderLeftColor');
const $8543e3d4e0a2f626$export$f9258c55612cbed7 = $8543e3d4e0a2f626$var$createBorderStyle('outline', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$621fe586efeb64b9 = $8543e3d4e0a2f626$var$createBorderStyle('outlineColor');
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2, $8543e3d4e0a2f626$export$f9258c55612cbed7, $8543e3d4e0a2f626$export$621fe586efeb64b9);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRegister("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRegister("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: 'gridColumn'
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: 'gridRow'
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: 'gridAutoFlow'
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: 'gridAutoColumns'
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: 'gridAutoRows'
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: 'gridTemplateColumns'
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: 'gridTemplateRows'
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: 'gridTemplateAreas'
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: 'gridArea'
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRegister("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRegister("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: 'minWidth',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: 'maxHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: 'minHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: 'boxSizing'
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});



parcelRegister("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3wRTY.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}

});

parcelRegister("4kWyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328672c8d07e1c59$export$2e2bcd8739ae039; });

var $2G6xE = parcelRequire("2G6xE");

var $84PRT = parcelRequire("84PRT");
'use client';
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $84PRT.default)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");

var $56TFl = parcelRequire("56TFl");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $3wRTY.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $56TFl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("56TFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b88b157d6186746$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("84PRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e16ee62ac64bb0b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
'use client';
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6te04.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;

});



parcelRegister("kU6nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37dfc12e5d89c96$export$2e2bcd8739ae039; });
const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;

});

parcelRegister("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $8M6a3 = parcelRequire("8M6a3");
var $hXGiu = parcelRequire("hXGiu");

var $2G6xE = parcelRequire("2G6xE");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");
const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $diYUK.default)(18));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $3wRTY.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $eGmqa.default))
    });
    muiTheme = (0, $3wRTY.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;

});
parcelRegister("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $7jL4F = parcelRequire("7jL4F");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6akYf.default).white,
        default: (0, $6akYf.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6akYf.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $6akYf.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $7jL4F.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $7jL4F.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $7jL4F.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $diYUK.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $diYUK.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3wRTY.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $6akYf.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7jL4F", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $553ed2baba4347ed$var$alpha;
module.exports.blend = $553ed2baba4347ed$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $553ed2baba4347ed$var$darken;
module.exports.decomposeColor = $553ed2baba4347ed$var$decomposeColor;
module.exports.emphasize = $553ed2baba4347ed$var$emphasize;
module.exports.getContrastRatio = $553ed2baba4347ed$var$getContrastRatio;
module.exports.getLuminance = $553ed2baba4347ed$var$getLuminance;
module.exports.hexToRgb = $553ed2baba4347ed$var$hexToRgb;
module.exports.hslToRgb = $553ed2baba4347ed$var$hslToRgb;
module.exports.lighten = $553ed2baba4347ed$var$lighten;
module.exports.private_safeAlpha = $553ed2baba4347ed$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $553ed2baba4347ed$var$private_safeDarken;
module.exports.private_safeEmphasize = $553ed2baba4347ed$var$private_safeEmphasize;
module.exports.private_safeLighten = $553ed2baba4347ed$var$private_safeLighten;
module.exports.recomposeColor = $553ed2baba4347ed$var$recomposeColor;
module.exports.rgbToHex = $553ed2baba4347ed$var$rgbToHex;

var $553ed2baba4347ed$var$_formatMuiErrorMessage2 = $62qsu((parcelRequire("gzcup")));

var $553ed2baba4347ed$var$_clamp = $62qsu((parcelRequire("8m7yE")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $553ed2baba4347ed$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $553ed2baba4347ed$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $553ed2baba4347ed$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $553ed2baba4347ed$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $553ed2baba4347ed$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $553ed2baba4347ed$var$colorChannel = (color)=>{
    const decomposedColor = $553ed2baba4347ed$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $553ed2baba4347ed$var$colorChannel;
const $553ed2baba4347ed$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $553ed2baba4347ed$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $553ed2baba4347ed$var$private_safeColorChannel;
function $553ed2baba4347ed$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $553ed2baba4347ed$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $553ed2baba4347ed$var$decomposeColor(color);
    return `#${values.map((n, i)=>$553ed2baba4347ed$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $553ed2baba4347ed$var$hslToRgb(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $553ed2baba4347ed$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $553ed2baba4347ed$var$getLuminance(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $553ed2baba4347ed$var$getContrastRatio(foreground, background) {
    const lumA = $553ed2baba4347ed$var$getLuminance(foreground);
    const lumB = $553ed2baba4347ed$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$alpha(color, value) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    value = $553ed2baba4347ed$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeAlpha(color, value, warning) {
    try {
        return $553ed2baba4347ed$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$darken(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$lighten(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$emphasize(color, coefficient = 0.15) {
    return $553ed2baba4347ed$var$getLuminance(color) > 0.5 ? $553ed2baba4347ed$var$darken(color, coefficient) : $553ed2baba4347ed$var$lighten(color, coefficient);
}
function $553ed2baba4347ed$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $553ed2baba4347ed$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $553ed2baba4347ed$var$decomposeColor(background);
    const overlayColor = $553ed2baba4347ed$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $553ed2baba4347ed$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("62qsu", function(module, exports) {
function $4657741705a128f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $4657741705a128f0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gzcup", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("diYUK")).default; });

var $diYUK = parcelRequire("diYUK");

});

parcelRegister("8m7yE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5mrJy")).default; });

var $5mrJy = parcelRequire("5mrJy");

});
parcelRegister("5mrJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e74852d812b8b64$export$2e2bcd8739ae039; });
function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;

});



parcelRegister("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRegister("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRegister("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRegister("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRegister("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRegister("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRegister("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRegister("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRegister("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3wRTY.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRegister("kjiCM", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $ec94076b9ecccee1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});


parcelRegister("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("dxABk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dbabfa00f5ea67f$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");
const $9dbabfa00f5ea67f$var$boxClasses = (0, $4jzsB.default)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;

});
parcelRegister("4jzsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32447174989d1976$export$2e2bcd8739ae039; });

var $k6RDS = parcelRequire("k6RDS");
function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $k6RDS.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("k6RDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3dfa6b173640a4$export$2e2bcd8739ae039; });

var $kU6nt = parcelRequire("kU6nt");
const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $kU6nt.default).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}

});




parcelRegister("egzHc", function(module, exports) {
"use strict";
var $a62e3fc2b3db2912$var$__assign = module.exports && module.exports.__assign || function() {
    $a62e3fc2b3db2912$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a62e3fc2b3db2912$var$__assign.apply(this, arguments);
};
var $a62e3fc2b3db2912$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a62e3fc2b3db2912$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a62e3fc2b3db2912$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a62e3fc2b3db2912$var$__createBinding(result, mod, k);
    }
    $a62e3fc2b3db2912$var$__setModuleDefault(result, mod);
    return result;
};
var $a62e3fc2b3db2912$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a62e3fc2b3db2912$var$React = $a62e3fc2b3db2912$var$__importStar((parcelRequire("7fPBF")));

var $ebu6H = parcelRequire("ebu6H");

var $fLb7n = parcelRequire("fLb7n");
// 1.5 4.5 7.5
var $a62e3fc2b3db2912$var$distance = [
    1,
    3,
    5
];
var $a62e3fc2b3db2912$var$propagate = [
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat($a62e3fc2b3db2912$var$distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-0"),
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(-").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(-").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-1"),
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(-".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(-").concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-2"),
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    75% {transform: translateX(").concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-3"),
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-4"),
    (0, $fLb7n.createAnimation)("PropagateLoader", "25% {transform: translateX(".concat($a62e3fc2b3db2912$var$distance[0], "rem) scale(0.75)}\n    50% {transform: translateX(").concat($a62e3fc2b3db2912$var$distance[1], "rem) scale(0.6)}\n    75% {transform: translateX(").concat($a62e3fc2b3db2912$var$distance[2], "rem) scale(0.5)}\n    95% {transform: translateX(0rem) scale(1)}"), "propogate-5")
];
function $a62e3fc2b3db2912$var$PropagateLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 15 : _f, additionalprops = $a62e3fc2b3db2912$var$__rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size"
    ]);
    var _g = (0, $ebu6H.parseLengthAndUnit)(size), value = _g.value, unit = _g.unit;
    var wrapper = $a62e3fc2b3db2912$var$__assign({
        display: "inherit",
        position: "relative"
    }, cssOverride);
    var style = function(i) {
        return {
            position: "absolute",
            fontSize: "".concat(value / 3).concat(unit),
            width: "".concat(value).concat(unit),
            height: "".concat(value).concat(unit),
            background: color,
            borderRadius: "50%",
            animation: "".concat($a62e3fc2b3db2912$var$propagate[i], " ").concat(1.5 / speedMultiplier, "s infinite"),
            animationFillMode: "forwards"
        };
    };
    if (!loading) return null;
    return $a62e3fc2b3db2912$var$React.createElement("span", $a62e3fc2b3db2912$var$__assign({
        style: wrapper
    }, additionalprops), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(0)
    }), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(1)
    }), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(2)
    }), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(3)
    }), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(4)
    }), $a62e3fc2b3db2912$var$React.createElement("span", {
        style: style(5)
    }));
}
module.exports.default = $a62e3fc2b3db2912$var$PropagateLoader;

});
parcelRegister("ebu6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cssValue = module.exports.parseLengthAndUnit = void 0;
var $a5397268e1725fb0$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
/**
 * If size is a number, append px to the value as default unit.
 * If size is a string, validate against list of valid units.
 * If unit is valid, return size as is.
 * If unit is invalid, console warn issue, replace with px as the unit.
 *
 * @param {(number | string)} size
 * @return {LengthObject} LengthObject
 */ function $a5397268e1725fb0$var$parseLengthAndUnit(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($a5397268e1725fb0$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
module.exports.parseLengthAndUnit = $a5397268e1725fb0$var$parseLengthAndUnit;
/**
 * Take value as an input and return valid css value
 *
 * @param {(number | string)} value
 * @return {string} valid css value
 */ function $a5397268e1725fb0$var$cssValue(value) {
    var lengthWithunit = $a5397268e1725fb0$var$parseLengthAndUnit(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}
module.exports.cssValue = $a5397268e1725fb0$var$cssValue;

});

parcelRegister("fLb7n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAnimation = void 0;
var $b793de9d2c166c1c$var$createAnimation = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};
module.exports.createAnimation = $b793de9d2c166c1c$var$createAnimation;

});


parcelRegister("bLhVg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8901fc92b5563702$export$71511d61b312f219; });

var $a7m7Z = parcelRequire("a7m7Z");
function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $a7m7Z._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("a7m7Z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $75dbb8f78ee65245$export$71511d61b312f219; });
function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("kDBhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("HgAeG")).default; });

var $9xny7 = parcelRequire("9xny7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $HgAeG = parcelRequire("HgAeG");

var $yfUan = parcelRequire("yfUan");
'use client';
const $f0645ef192f222f7$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($9xny7)))({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $HgAeG.default
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRegister("9xny7", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f197680cb170281$var$createStyled;
module.exports.shouldForwardProp = $6f197680cb170281$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $6f197680cb170281$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $6f197680cb170281$var$_objectWithoutPropertiesLoose2 = $62qsu((parcelRequire("1ifJj")));

var $6f197680cb170281$var$_styledEngine = $6f197680cb170281$var$_interopRequireWildcard((parcelRequire("5VCcJ")));

var $3wRTY = parcelRequire("3wRTY");

var $6f197680cb170281$var$_capitalize = $62qsu((parcelRequire("3oBOp")));

var $6f197680cb170281$var$_getDisplayName = $62qsu((parcelRequire("ehv4n")));

var $6f197680cb170281$var$_createTheme = $62qsu((parcelRequire("eqNKX")));

var $6f197680cb170281$var$_styleFunctionSx = $62qsu((parcelRequire("3aVNX")));
const $6f197680cb170281$var$_excluded = [
    "ownerState"
], $6f197680cb170281$var$_excluded2 = [
    "variants"
], $6f197680cb170281$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $6f197680cb170281$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f197680cb170281$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6f197680cb170281$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6f197680cb170281$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $6f197680cb170281$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $6f197680cb170281$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $6f197680cb170281$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $6f197680cb170281$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $6f197680cb170281$var$_createTheme.default)();
const $6f197680cb170281$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $6f197680cb170281$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $6f197680cb170281$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $6f197680cb170281$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $6f197680cb170281$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(_ref, $6f197680cb170281$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $6f197680cb170281$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$6f197680cb170281$var$processStyleArg(resolvedStyle, (0, $6f197680cb170281$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $6f197680cb170281$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $6f197680cb170281$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $6f197680cb170281$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $6f197680cb170281$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $6f197680cb170281$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $6f197680cb170281$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $6f197680cb170281$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $6f197680cb170281$var$_styleFunctionSx.default)((0, $6f197680cb170281$var$_extends2.default)({}, props, {
            theme: $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $6f197680cb170281$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $6f197680cb170281$var$defaultOverridesResolver($6f197680cb170281$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $6f197680cb170281$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $6f197680cb170281$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($6f197680cb170281$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $6f197680cb170281$var$_styledEngine.default)(tag, (0, $6f197680cb170281$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3wRTY.isPlainObject)(stylesArg)) return (props)=>$6f197680cb170281$var$processStyleArg(stylesArg, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: $6f197680cb170281$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $6f197680cb170281$var$processStyleArg(slotStyle, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $6f197680cb170281$var$processStyleArg({
                    variants: themeVariants
                }, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3oBOp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iCiVn")).default; });

var $iCiVn = parcelRequire("iCiVn");

});

parcelRegister("ehv4n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bXHHW")).default; });

var $bXHHW = parcelRequire("bXHHW");
$parcel$exportWildcard(module.exports, $bXHHW);

});
parcelRegister("bXHHW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $8b571bd6b8501d36$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $8b571bd6b8501d36$export$2e2bcd8739ae039; });

var $61wrp = parcelRequire("61wrp");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $8b571bd6b8501d36$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $8b571bd6b8501d36$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($8b571bd6b8501d36$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $8b571bd6b8501d36$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $8b571bd6b8501d36$export$aad197c7121a6651(Component) || fallback;
}
function $8b571bd6b8501d36$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8b571bd6b8501d36$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8b571bd6b8501d36$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $8b571bd6b8501d36$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $61wrp.ForwardRef:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $61wrp.Memo:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("61wrp", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kzuP0"));

});
parcelRegister("kzuP0", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ef9efc139901a96c$export$a7c73072b1a182ae; }, function (v) { return $ef9efc139901a96c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ef9efc139901a96c$export$9f27bc3417b4524d; }, function (v) { return $ef9efc139901a96c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ef9efc139901a96c$export$db77ccec0bb4ccac; }, function (v) { return $ef9efc139901a96c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ef9efc139901a96c$export$8392c0c9d3dcbd35; }, function (v) { return $ef9efc139901a96c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ef9efc139901a96c$export$ffb0004e005737fa; }, function (v) { return $ef9efc139901a96c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ef9efc139901a96c$export$b624eff549462981; }, function (v) { return $ef9efc139901a96c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ef9efc139901a96c$export$7897aa7841a5380c; }, function (v) { return $ef9efc139901a96c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ef9efc139901a96c$export$602eac185826482c; }, function (v) { return $ef9efc139901a96c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ef9efc139901a96c$export$e2c29f18771995cb; }, function (v) { return $ef9efc139901a96c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ef9efc139901a96c$export$5f8d39834fd61797; }, function (v) { return $ef9efc139901a96c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ef9efc139901a96c$export$74bf444e3cd11ea5; }, function (v) { return $ef9efc139901a96c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ef9efc139901a96c$export$998bcd577473dd93; }, function (v) { return $ef9efc139901a96c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ef9efc139901a96c$export$b706b080d889d2c9; }, function (v) { return $ef9efc139901a96c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ef9efc139901a96c$export$5be5a87408f70ddc; }, function (v) { return $ef9efc139901a96c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ef9efc139901a96c$export$45a5e7f76e0caa8d; }, function (v) { return $ef9efc139901a96c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ef9efc139901a96c$export$455c2e768291efa6; }, function (v) { return $ef9efc139901a96c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ef9efc139901a96c$export$9522e17588c12572; }, function (v) { return $ef9efc139901a96c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ef9efc139901a96c$export$2110ac352bb060b9; }, function (v) { return $ef9efc139901a96c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ef9efc139901a96c$export$56885ab8b9c456ab; }, function (v) { return $ef9efc139901a96c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ef9efc139901a96c$export$d927fcb6adf8f9de; }, function (v) { return $ef9efc139901a96c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ef9efc139901a96c$export$b82d16f27459e05a; }, function (v) { return $ef9efc139901a96c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ef9efc139901a96c$export$522c17b4f5e123e8; }, function (v) { return $ef9efc139901a96c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ef9efc139901a96c$export$1aabd8a0274ecfd6; }, function (v) { return $ef9efc139901a96c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ef9efc139901a96c$export$3d6c20d97e46b957; }, function (v) { return $ef9efc139901a96c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ef9efc139901a96c$export$9b621391a187a31a; }, function (v) { return $ef9efc139901a96c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ef9efc139901a96c$export$f5bbd400c2f4426f; }, function (v) { return $ef9efc139901a96c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef9efc139901a96c$export$a7c73072b1a182ae;
var $ef9efc139901a96c$export$9f27bc3417b4524d;
var $ef9efc139901a96c$export$db77ccec0bb4ccac;
var $ef9efc139901a96c$export$8392c0c9d3dcbd35;
var $ef9efc139901a96c$export$ffb0004e005737fa;
var $ef9efc139901a96c$export$b624eff549462981;
var $ef9efc139901a96c$export$7897aa7841a5380c;
var $ef9efc139901a96c$export$602eac185826482c;
var $ef9efc139901a96c$export$e2c29f18771995cb;
var $ef9efc139901a96c$export$5f8d39834fd61797;
var $ef9efc139901a96c$export$74bf444e3cd11ea5;
var $ef9efc139901a96c$export$998bcd577473dd93;
var $ef9efc139901a96c$export$b706b080d889d2c9;
var $ef9efc139901a96c$export$5be5a87408f70ddc;
var $ef9efc139901a96c$export$45a5e7f76e0caa8d;
var $ef9efc139901a96c$export$455c2e768291efa6;
var $ef9efc139901a96c$export$9522e17588c12572;
var $ef9efc139901a96c$export$2110ac352bb060b9;
var $ef9efc139901a96c$export$56885ab8b9c456ab;
var $ef9efc139901a96c$export$d927fcb6adf8f9de;
var $ef9efc139901a96c$export$b82d16f27459e05a;
var $ef9efc139901a96c$export$522c17b4f5e123e8;
var $ef9efc139901a96c$export$1aabd8a0274ecfd6;
var $ef9efc139901a96c$export$3d6c20d97e46b957;
var $ef9efc139901a96c$export$9b621391a187a31a;
var $ef9efc139901a96c$export$f5bbd400c2f4426f;
"use strict";
var $ef9efc139901a96c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef9efc139901a96c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ef9efc139901a96c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $ef9efc139901a96c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ef9efc139901a96c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $ef9efc139901a96c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ef9efc139901a96c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ef9efc139901a96c$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $ef9efc139901a96c$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $ef9efc139901a96c$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE:
                    case $ef9efc139901a96c$var$REACT_PROFILER_TYPE:
                    case $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $ef9efc139901a96c$var$REACT_CONTEXT_TYPE:
                            case $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE:
                            case $ef9efc139901a96c$var$REACT_LAZY_TYPE:
                            case $ef9efc139901a96c$var$REACT_MEMO_TYPE:
                                return object;
                            case $ef9efc139901a96c$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $ef9efc139901a96c$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$ef9efc139901a96c$export$a7c73072b1a182ae = $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
$ef9efc139901a96c$export$9f27bc3417b4524d = $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
$ef9efc139901a96c$export$db77ccec0bb4ccac = $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
$ef9efc139901a96c$export$8392c0c9d3dcbd35 = $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
$ef9efc139901a96c$export$ffb0004e005737fa = $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
$ef9efc139901a96c$export$b624eff549462981 = $ef9efc139901a96c$var$REACT_LAZY_TYPE;
$ef9efc139901a96c$export$7897aa7841a5380c = $ef9efc139901a96c$var$REACT_MEMO_TYPE;
$ef9efc139901a96c$export$602eac185826482c = $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
$ef9efc139901a96c$export$e2c29f18771995cb = $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
$ef9efc139901a96c$export$5f8d39834fd61797 = $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
$ef9efc139901a96c$export$74bf444e3cd11ea5 = $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
$ef9efc139901a96c$export$998bcd577473dd93 = $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
$ef9efc139901a96c$export$b706b080d889d2c9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
};
$ef9efc139901a96c$export$5be5a87408f70ddc = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
};
$ef9efc139901a96c$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
};
$ef9efc139901a96c$export$455c2e768291efa6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
};
$ef9efc139901a96c$export$9522e17588c12572 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
};
$ef9efc139901a96c$export$2110ac352bb060b9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_LAZY_TYPE;
};
$ef9efc139901a96c$export$56885ab8b9c456ab = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_MEMO_TYPE;
};
$ef9efc139901a96c$export$d927fcb6adf8f9de = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
};
$ef9efc139901a96c$export$b82d16f27459e05a = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
};
$ef9efc139901a96c$export$522c17b4f5e123e8 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
};
$ef9efc139901a96c$export$1aabd8a0274ecfd6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
};
$ef9efc139901a96c$export$3d6c20d97e46b957 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
};
$ef9efc139901a96c$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE || type === $ef9efc139901a96c$var$REACT_PROFILER_TYPE || type === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE || type === $ef9efc139901a96c$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $ef9efc139901a96c$var$REACT_LAZY_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_MEMO_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$ef9efc139901a96c$export$f5bbd400c2f4426f = $ef9efc139901a96c$var$typeOf;

});




parcelRegister("eqNKX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2G6xE")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("iZrRs")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("56TFl")).default; });

var $2G6xE = parcelRequire("2G6xE");

var $iZrRs = parcelRequire("iZrRs");

var $56TFl = parcelRequire("56TFl");

});

parcelRegister("3aVNX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8M6a3")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("8M6a3")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("mqrnX")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("hXGiu")).default; });

var $8M6a3 = parcelRequire("8M6a3");

var $mqrnX = parcelRequire("mqrnX");

var $hXGiu = parcelRequire("hXGiu");

});


parcelRegister("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});

parcelRegister("HgAeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0820e164eb5fbaff$export$2e2bcd8739ae039; });

var $yfUan = parcelRequire("yfUan");
const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $yfUan.default)(prop) && prop !== 'classes';
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;

});
parcelRegister("yfUan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066f83798075d563$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;

});



parcelRegister("jilX7", function(module, exports) {

$parcel$export(module.exports, "useAuth", function () { return $e0c0ba18171914d7$export$1d39dc5b47e56ff0; });
$parcel$export(module.exports, "AuthProvider", function () { return $e0c0ba18171914d7$export$87091915187a1a85; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $e0c0ba18171914d7$var$authContext = /*#__PURE__*/ (0, $7fPBF.createContext)();
function $e0c0ba18171914d7$export$1d39dc5b47e56ff0() {
    return (0, $7fPBF.useContext)($e0c0ba18171914d7$var$authContext);
}
function $e0c0ba18171914d7$var$useAuthProvider() {
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [userName, setUserName] = (0, $7fPBF.useState)("");
    const [status, setStatus] = (0, $7fPBF.useState)(null);
    const signin = (statusValue, username)=>{
        localStorage.setItem("user", username);
        setUserName(username);
        setUser(username);
        setStatus(statusValue);
    };
    const signout = (fn)=>{
        setUser(null);
        fn();
    };
    return {
        user: user,
        userName: userName,
        status: status,
        signin: signin,
        signout: signout
    };
}
function $e0c0ba18171914d7$export$87091915187a1a85({ children: children }) {
    const auth = $e0c0ba18171914d7$var$useAuthProvider();
    return /*#__PURE__*/ (0, $bbzbN.jsx)($e0c0ba18171914d7$var$authContext.Provider, {
        value: auth,
        children: children
    });
}

});

parcelRegister("7TOmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c04bc14285128b0$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $a2ay0 = parcelRequire("a2ay0");

var $cjLM4 = parcelRequire("cjLM4");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5c04bc14285128b0$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            `position${(0, $b6UUh.default)(position)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cjLM4.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $kY3Ke.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $kY3Ke.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $kY3Ke.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $kY3Ke.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $cFLic.default)(props, $5c04bc14285128b0$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5c04bc14285128b0$var$AppBarRoot, (0, $kY3Ke.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $9MRga.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;

});
parcelRegister("9MRga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e86af3ffe0f83235$export$2e2bcd8739ae039; });
function $e86af3ffe0f83235$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $e86af3ffe0f83235$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $e86af3ffe0f83235$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $e86af3ffe0f83235$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e86af3ffe0f83235$export$2e2bcd8739ae039 = $e86af3ffe0f83235$export$4f5d2d50c9deca37;

});

parcelRegister("cFCqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93971f0806345477$export$2e2bcd8739ae039; });
function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("iVAEr", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $dc79fb0f6686e80b$export$2440da353cedad43; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $7eatR = parcelRequire("7eatR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $dc79fb0f6686e80b$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7eatR.default), (0, $kY3Ke.default)({}, props));
}
var $dc79fb0f6686e80b$export$2e2bcd8739ae039 = $dc79fb0f6686e80b$var$DefaultPropsProvider;
function $dc79fb0f6686e80b$export$2440da353cedad43(params) {
    return (0, $7eatR.useDefaultProps)(params);
}

});
parcelRegister("7eatR", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $5431f86afe49fae8$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $5431f86afe49fae8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $gjk5S = parcelRequire("gjk5S");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5431f86afe49fae8$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $5431f86afe49fae8$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5431f86afe49fae8$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $5431f86afe49fae8$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $gjk5S.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $gjk5S.default)(config, props);
    return props;
}
function $5431f86afe49fae8$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($5431f86afe49fae8$var$PropsContext);
    return $5431f86afe49fae8$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $5431f86afe49fae8$export$2e2bcd8739ae039 = $5431f86afe49fae8$var$DefaultPropsProvider;

});
parcelRegister("gjk5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdfe01df7c24351f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);

});

parcelRegister("a2ay0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e245c78e363f11$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");



var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");

var $ckFUN = parcelRequire("ckFUN");

var $iVAEr = parcelRequire("iVAEr");


var $giMq6 = parcelRequire("giMq6");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $giMq6.getPaperUtilityClass), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $7jL4F.alpha)('#fff', (0, $ckFUN.default)(ownerState.elevation))}, ${(0, $7jL4F.alpha)('#fff', (0, $ckFUN.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;

});
parcelRegister("ckFUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7ddbbf42193a7$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;

});

parcelRegister("giMq6", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $bde3e2fffcaea664$export$29cdb466b9b6f20b; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $k6RDS.default)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $4jzsB.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;

});


parcelRegister("cjLM4", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $8f7c5161bc7a509f$export$47a2da616e55e8e9; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $k6RDS.default)('MuiAppBar', slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $4jzsB.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;

});


parcelRegister("g9bTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc16b792e42cac5d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $4kWyf = parcelRequire("4kWyf");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
'use client';
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $4kWyf.default)((0, $9P91Y.default));
    return theme[0, $jwhZE.default] || theme;
}

});

parcelRegister("hxRgH", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc5ed6ba3196faf3$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $cc5ed6ba3196faf3$var$_default = module.exports.default = (0, $cc5ed6ba3196faf3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');

});
parcelRegister("3xowt", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6PKLM.default;
    }
});

var $6PKLM = parcelRequire("6PKLM");

});
parcelRegister("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRegister("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $9MRga.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRegister("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $k6RDS.default)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $4jzsB.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});





parcelRegister("lE3FT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc202f2249b2dd6f$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $kyirV = parcelRequire("kyirV");

var $ehw51 = parcelRequire("ehw51");

var $e4MmV = parcelRequire("e4MmV");

var $a2ay0 = parcelRequire("a2ay0");

var $b6UUh = parcelRequire("b6UUh");

var $g9bTP = parcelRequire("g9bTP");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $lAUlD = parcelRequire("lAUlD");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fc202f2249b2dd6f$var$_excluded = [
    "BackdropProps"
], $fc202f2249b2dd6f$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $fc202f2249b2dd6f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $fc202f2249b2dd6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $b6UUh.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $b6UUh.default)(anchor)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lAUlD.getDrawerUtilityClass), classes);
};
const $fc202f2249b2dd6f$var$DrawerRoot = (0, $kDBhE.default)((0, $ehw51.default), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $fc202f2249b2dd6f$var$DrawerDockedRoot = (0, $kDBhE.default)('div', {
    shouldForwardProp: (0, $HgAeG.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $fc202f2249b2dd6f$var$DrawerPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $b6UUh.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $b6UUh.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $fc202f2249b2dd6f$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $fc202f2249b2dd6f$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) ? $fc202f2249b2dd6f$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $fc202f2249b2dd6f$var$Drawer = /*#__PURE__*/ $7fPBF.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $g9bTP.default)();
    const isRtl = (0, $kyirV.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4MmV.default), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $cFLic.default)(props.ModalProps, $fc202f2249b2dd6f$var$_excluded), other = (0, $cFLic.default)(props, $fc202f2249b2dd6f$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $fc202f2249b2dd6f$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $fc202f2249b2dd6f$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerPaper, (0, $kY3Ke.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $9MRga.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        direction: $fc202f2249b2dd6f$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerRoot, (0, $kY3Ke.default)({
        BackdropProps: (0, $kY3Ke.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $9MRga.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $fc202f2249b2dd6f$export$2e2bcd8739ae039 = $fc202f2249b2dd6f$var$Drawer;

});
parcelRegister("kyirV", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $ef654b446fc390d6$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $ef654b446fc390d6$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
const $ef654b446fc390d6$var$_excluded = [
    "value"
];
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cFLic.default)(_ref, $ef654b446fc390d6$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ef654b446fc390d6$var$RtlContext.Provider, (0, $kY3Ke.default)({
        value: value != null ? value : true
    }, props));
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value != null ? value : false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;

});

parcelRegister("ehw51", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a65b89a1133e1fe4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");



var $cFCqu = parcelRequire("cFCqu");

var $elaRz = parcelRequire("elaRz");

var $cbZpX = parcelRequire("cbZpX");

var $ayhm7 = parcelRequire("ayhm7");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $jPUa4 = parcelRequire("jPUa4");

var $g3t58 = parcelRequire("g3t58");

var $1Qt6b = parcelRequire("1Qt6b");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1Qt6b.getModalUtilityClass), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $kDBhE.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cFLic.default)(props, $a65b89a1133e1fe4$var$_excluded);
    const propsWithDefaults = (0, $kY3Ke.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $g3t58.default)((0, $kY3Ke.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kY3Ke.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $elaRz.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9MRga.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $elaRz.default)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kY3Ke.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9MRga.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ayhm7.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, (0, $kY3Ke.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropSlot, (0, $kY3Ke.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cbZpX.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;

});
parcelRegister("elaRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70b740322660959$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $jTdAm = parcelRequire("jTdAm");

var $5VXZW = parcelRequire("5VXZW");

var $ex1Wy = parcelRequire("ex1Wy");

var $eWvFH = parcelRequire("eWvFH");
'use client';
const $a70b740322660959$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $a70b740322660959$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cFLic.default)(parameters, $a70b740322660959$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $eWvFH.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $ex1Wy.default)((0, $kY3Ke.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $jTdAm.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $5VXZW.default)(elementType, (0, $kY3Ke.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $a70b740322660959$export$2e2bcd8739ae039 = $a70b740322660959$var$useSlotProps;

});
parcelRegister("jTdAm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7adb12ba33c17bd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $k0OO4 = parcelRequire("k0OO4");
'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $k0OO4.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("k0OO4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91b37e03c9e5276$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("5VXZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4520d0f80a3f7305$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $ftQl8 = parcelRequire("ftQl8");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $4520d0f80a3f7305$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $ftQl8.default)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}
var $4520d0f80a3f7305$export$2e2bcd8739ae039 = $4520d0f80a3f7305$var$appendOwnerState;

});
parcelRegister("ftQl8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4522a0df256fb21$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b4522a0df256fb21$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $b4522a0df256fb21$export$2e2bcd8739ae039 = $b4522a0df256fb21$var$isHostComponent;

});


parcelRegister("ex1Wy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a945a7a9a1371b8c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $kauoJ = parcelRequire("kauoJ");

var $atytk = parcelRequire("atytk");

var $1XtzN = parcelRequire("1XtzN");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $a945a7a9a1371b8c$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $kauoJ.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $atytk.default)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $1XtzN.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $1XtzN.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $kauoJ.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $a945a7a9a1371b8c$export$2e2bcd8739ae039 = $a945a7a9a1371b8c$var$mergeSlotProps;

});
parcelRegister("kauoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46e727d5ca557610$export$2e2bcd8739ae039; });
function $46e727d5ca557610$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $46e727d5ca557610$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $46e727d5ca557610$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $46e727d5ca557610$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $46e727d5ca557610$export$2e2bcd8739ae039 = $46e727d5ca557610$export$4f5d2d50c9deca37;

});

parcelRegister("atytk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a075a443b93da2d$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7a075a443b93da2d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $7a075a443b93da2d$export$2e2bcd8739ae039 = $7a075a443b93da2d$var$extractEventHandlers;

});

parcelRegister("1XtzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d23e6599aa60ec$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16d23e6599aa60ec$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16d23e6599aa60ec$export$2e2bcd8739ae039 = $16d23e6599aa60ec$var$omitEventHandlers;

});


parcelRegister("eWvFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ae0f0ccae9f4b3cc$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039 = $ae0f0ccae9f4b3cc$var$resolveComponentProps;

});


parcelRegister("cbZpX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e062765deddb857$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $bNCjr = parcelRequire("bNCjr");
var $4CS7n = parcelRequire("4CS7n");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $8e062765deddb857$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $8e062765deddb857$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $8e062765deddb857$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $8e062765deddb857$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $8e062765deddb857$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $8e062765deddb857$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($8e062765deddb857$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $8e062765deddb857$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$8e062765deddb857$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $8e062765deddb857$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $8e062765deddb857$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $8e062765deddb857$var$defaultGetTabbable, isEnabled: isEnabled = $8e062765deddb857$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)((0, $bNCjr.default)(children), rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $8e062765deddb857$export$2e2bcd8739ae039 = $8e062765deddb857$var$FocusTrap;

});
parcelRegister("bNCjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8971fd60a8b100cf$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $8971fd60a8b100cf$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7fPBF.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

});

parcelRegister("4CS7n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e4b0c27d76b933$export$2e2bcd8739ae039; });
function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("ayhm7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aea8adc1cf7298d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $bNCjr = parcelRequire("bNCjr");
var $k0OO4 = parcelRequire("k0OO4");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $7aea8adc1cf7298d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $7aea8adc1cf7298d$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    const handleRef = (0, $jTdAm.default)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? (0, $bNCjr.default)(children) : null, forwardedRef);
    (0, $lJRRs.default)(()=>{
        if (!disablePortal) setMountNode($7aea8adc1cf7298d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $lJRRs.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $k0OO4.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $k0OO4.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode
    });
});
var $7aea8adc1cf7298d$export$2e2bcd8739ae039 = $7aea8adc1cf7298d$var$Portal;

});
parcelRegister("lJRRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3794ae41ea97a8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;

});


parcelRegister("jPUa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e583d684cb5f4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $8WhtA = parcelRequire("8WhtA");

var $4EOyv = parcelRequire("4EOyv");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4EOyv.getBackdropUtilityClass), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $kDBhE.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $8WhtA.default), transitionDuration: transitionDuration } = props, other = (0, $cFLic.default)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $kY3Ke.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9MRga.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;

});
parcelRegister("8WhtA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68214be7242cbfc8$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");


var $bNCjr = parcelRequire("bNCjr");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $g9bTP.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, (0, $bNCjr.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;

});
parcelRegister("8qMCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623678cbb6daf054$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $bTMtR = parcelRequire("bTMtR");


var $8ovTL = parcelRequire("8ovTL");

var $kKJSm = parcelRequire("kKJSm");
var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $kKJSm.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $8ovTL.default);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;

});
parcelRegister("bTMtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9a7006a9b8efe4$export$2e2bcd8739ae039; });
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("8ovTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c94efb1735eff6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);

});

parcelRegister("kKJSm", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $f1bbb084f2fb10b7$export$7d26bbb1236dafd6; });
var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("2j7bs", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $1ae2edacd7be6319$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $1ae2edacd7be6319$export$8cb1e9b404609ae9; });
const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});

parcelRegister("6NwTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f30d4c1188a58e6$export$2e2bcd8739ae039; });

var $jTdAm = parcelRequire("jTdAm");
'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $jTdAm.default);

});


parcelRegister("4EOyv", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $36421d1d94159248$export$9927a91fd93152bd; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $k6RDS.default)('MuiBackdrop', slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $4jzsB.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;

});


parcelRegister("g3t58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb037c33603903c5$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $irWkO = parcelRequire("irWkO");
var $4CS7n = parcelRequire("4CS7n");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $atytk = parcelRequire("atytk");

var $8x9gm = parcelRequire("8x9gm");
'use client';
function $bb037c33603903c5$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $bb037c33603903c5$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $bb037c33603903c5$var$defaultManager = new (0, $8x9gm.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $bb037c33603903c5$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $bb037c33603903c5$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $bb037c33603903c5$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4CS7n.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $giDhD.default)(()=>{
        const resolvedContainer = $bb037c33603903c5$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $giDhD.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $8x9gm.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $atytk.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kY3Ke.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kY3Ke.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kY3Ke.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $irWkO.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $irWkO.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $bb037c33603903c5$export$2e2bcd8739ae039 = $bb037c33603903c5$var$useModal;

});
parcelRegister("irWkO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e7ffad706c848e$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $d6e7ffad706c848e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("giDhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bddccca9f6cee29b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $lJRRs.default)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;

});

parcelRegister("8x9gm", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $6368973433f2cfde$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $6368973433f2cfde$export$ce11c4ecd08cea67; });

var $8c45K = parcelRequire("8c45K");
var $4CS7n = parcelRequire("4CS7n");
var $gE56a = parcelRequire("gE56a");
// Is a vertical scrollbar displayed?
function $6368973433f2cfde$var$isOverflowing(container) {
    const doc = (0, $4CS7n.default)(container);
    if (doc.body === container) return (0, $gE56a.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $6368973433f2cfde$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $6368973433f2cfde$var$getPaddingRight(element) {
    return parseInt((0, $gE56a.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $6368973433f2cfde$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $6368973433f2cfde$export$e1bd0c6150f13d96(element, show);
    });
}
function $6368973433f2cfde$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $6368973433f2cfde$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($6368973433f2cfde$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $8c45K.default)((0, $4CS7n.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4CS7n.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4CS7n.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $gE56a.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $6368973433f2cfde$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $6368973433f2cfde$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $6368973433f2cfde$var$getHiddenSiblings(container);
        $6368973433f2cfde$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $6368973433f2cfde$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $6368973433f2cfde$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}

});
parcelRegister("8c45K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f729e410b274c00$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $5f729e410b274c00$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});

parcelRegister("gE56a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e4563498af7952$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $4CS7n.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("1Qt6b", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $1581382eb39c1df6$export$67960e22b12a638d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $k6RDS.default)('MuiModal', slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $4jzsB.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;

});


parcelRegister("e4MmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f6f5762623b961$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");




var $bNCjr = parcelRequire("bNCjr");

var $52luK = parcelRequire("52luK");

var $6NwTb = parcelRequire("6NwTb");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $9kBlI = parcelRequire("9kBlI");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a3f6f5762623b961$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $9kBlI.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a3f6f5762623b961$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a3f6f5762623b961$var$resolveContainer(containerProp);
    const transform = $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a3f6f5762623b961$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    const theme = (0, $g9bTP.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $a3f6f5762623b961$var$_excluded);
    const childrenRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)((0, $bNCjr.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $2j7bs.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $kY3Ke.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $kY3Ke.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7fPBF.useCallback(()=>{
        if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $52luK.default)(()=>{
            if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $9kBlI.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                ref: handleRef,
                style: (0, $kY3Ke.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $a3f6f5762623b961$export$2e2bcd8739ae039 = $a3f6f5762623b961$var$Slide;

});
parcelRegister("52luK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aadd01758bd49c1$export$2e2bcd8739ae039; });

var $gHrsh = parcelRequire("gHrsh");
var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $gHrsh.default);

});
parcelRegister("gHrsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c285f587ed4585eb$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("9kBlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cb2f4180c9526e0$export$2e2bcd8739ae039; });

var $gE56a = parcelRequire("gE56a");
var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $gE56a.default);

});


parcelRegister("lAUlD", function(module, exports) {

$parcel$export(module.exports, "getDrawerUtilityClass", function () { return $fb88ab4f6dbff241$export$b801318a856c9cd2; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fb88ab4f6dbff241$export$b801318a856c9cd2(slot) {
    return (0, $k6RDS.default)('MuiDrawer', slot);
}
const $fb88ab4f6dbff241$var$drawerClasses = (0, $4jzsB.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $fb88ab4f6dbff241$export$2e2bcd8739ae039 = $fb88ab4f6dbff241$var$drawerClasses;

});


parcelRegister("57cKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b977dfc67db1ec5$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $awhCL = parcelRequire("awhCL");

var $cMvyt = parcelRequire("cMvyt");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3b977dfc67db1ec5$var$_excluded = [
    "className"
];
const $3b977dfc67db1ec5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $awhCL.getListItemIconUtilityClass), classes);
};
const $3b977dfc67db1ec5$var$ListItemIconRoot = (0, $kDBhE.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $3b977dfc67db1ec5$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $3b977dfc67db1ec5$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $3b977dfc67db1ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3b977dfc67db1ec5$var$ListItemIconRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $3b977dfc67db1ec5$export$2e2bcd8739ae039 = $3b977dfc67db1ec5$var$ListItemIcon;

});
parcelRegister("awhCL", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", function () { return $7a8a9052410fb062$export$81478e24460c57f2; });
$parcel$export(module.exports, "default", function () { return $7a8a9052410fb062$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $k6RDS.default)('MuiListItemIcon', slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $4jzsB.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;

});

parcelRegister("cMvyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e271e17fd22222$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;

});


parcelRegister("5ZeKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45be1777d6a28263$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $gjk5S = parcelRequire("gjk5S");

var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $grOnY = parcelRequire("grOnY");

var $5zBGX = parcelRequire("5zBGX");

var $juR2n = parcelRequire("juR2n");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $grOnY.getButtonUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $kY3Ke.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $grOnY.default).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $grOnY.default).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $grOnY.default).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $grOnY.default).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $5zBGX.default));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $juR2n.default));
    const resolvedProps = (0, $gjk5S.default)(contextProps, inProps);
    const props = (0, $iVAEr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $9MRga.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9MRga.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;

});
parcelRegister("3RNaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d0c76ae9ca5c817$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");



var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $6NwTb = parcelRequire("6NwTb");

var $1XFnq = parcelRequire("1XFnq");

var $ahx27 = parcelRequire("ahx27");

var $5rlhe = parcelRequire("5rlhe");

var $i9gyt = parcelRequire("i9gyt");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $i9gyt.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $i9gyt.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $6NwTb.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $ahx27.default)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $1XFnq.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $1XFnq.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $1XFnq.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $1XFnq.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $6NwTb.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $5rlhe.default), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;

});
parcelRegister("1XFnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16db65b1f19e65f7$export$2e2bcd8739ae039; });

var $giDhD = parcelRequire("giDhD");
'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $giDhD.default);

});

parcelRegister("ahx27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77c51d9bab7ec5dd$export$2e2bcd8739ae039; });

var $76aGm = parcelRequire("76aGm");
'use client';
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $76aGm.default);

});
parcelRegister("76aGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52b16131f46e7800$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $de55R = parcelRequire("de55R");
'use client';
let $52b16131f46e7800$var$hadKeyboardEvent = true;
let $52b16131f46e7800$var$hadFocusVisibleRecently = false;
const $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout = new (0, $de55R.Timeout)();
const $52b16131f46e7800$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $52b16131f46e7800$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $52b16131f46e7800$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $52b16131f46e7800$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $52b16131f46e7800$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $52b16131f46e7800$var$handlePointerDown() {
    $52b16131f46e7800$var$hadKeyboardEvent = false;
}
function $52b16131f46e7800$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($52b16131f46e7800$var$hadFocusVisibleRecently) $52b16131f46e7800$var$hadKeyboardEvent = true;
    }
}
function $52b16131f46e7800$var$prepare(doc) {
    doc.addEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $52b16131f46e7800$var$hadKeyboardEvent || $52b16131f46e7800$var$focusTriggersKeyboardModality(target);
}
function $52b16131f46e7800$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $52b16131f46e7800$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $52b16131f46e7800$var$hadFocusVisibleRecently = true;
            $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $52b16131f46e7800$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($52b16131f46e7800$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("de55R", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $9a1088a9a7141b09$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $9a1088a9a7141b09$export$2e2bcd8739ae039; });

var $bLtIh = parcelRequire("bLtIh");

var $2v2Iy = parcelRequire("2v2Iy");
'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $bLtIh.default)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $2v2Iy.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("bLtIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890b21ec8e20082a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("2v2Iy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d2095ad20314533$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("5rlhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5ffa895ad4456e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $4axyc = parcelRequire("4axyc");

var $9MRga = parcelRequire("9MRga");

var $5nUae = parcelRequire("5nUae");

var $de55R = parcelRequire("de55R");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $5geXw = parcelRequire("5geXw");

var $lCBOk = parcelRequire("lCBOk");

var $bbzbN = parcelRequire("bbzbN");
'use client';
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$t, $3f5ffa895ad4456e$var$t1, $3f5ffa895ad4456e$var$t2, $3f5ffa895ad4456e$var$t3;
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_1 = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t || ($3f5ffa895ad4456e$var$t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t1 || ($3f5ffa895ad4456e$var$t1 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t2 || ($3f5ffa895ad4456e$var$t2 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $5geXw.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t3 || ($3f5ffa895ad4456e$var$t3 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $lCBOk.default).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $lCBOk.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $lCBOk.default).child, (0, $lCBOk.default).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $lCBOk.default).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $de55R.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9MRga.default)(classes.ripple, (0, $lCBOk.default).ripple),
                        rippleVisible: (0, $9MRga.default)(classes.rippleVisible, (0, $lCBOk.default).rippleVisible),
                        ripplePulsate: (0, $9MRga.default)(classes.ripplePulsate, (0, $lCBOk.default).ripplePulsate),
                        child: (0, $9MRga.default)(classes.child, (0, $lCBOk.default).child),
                        childLeaving: (0, $9MRga.default)(classes.childLeaving, (0, $lCBOk.default).childLeaving),
                        childPulsate: (0, $9MRga.default)(classes.childPulsate, (0, $lCBOk.default).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)((0, $lCBOk.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4axyc.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;

});
parcelRegister("4axyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30921f11ad4ef55c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $3zeAJ = parcelRequire("3zeAJ");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $8ovTL = parcelRequire("8ovTL");

var $3CAnX = parcelRequire("3CAnX");
var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3zeAJ.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $3CAnX.getInitialChildMapping)(nextProps, handleExited) : (0, $3CAnX.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $3CAnX.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;

});
parcelRegister("3zeAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298ff58efa174465$export$2e2bcd8739ae039; });
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("3CAnX", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $2a31251aa5f7eb4f$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $2a31251aa5f7eb4f$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $2a31251aa5f7eb4f$export$36fd1af28d383ec0; });

var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("5geXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $9MRga.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9MRga.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;

});

parcelRegister("lCBOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbda7a0931c56f58$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $k6RDS.default)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $4jzsB.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;

});


parcelRegister("i9gyt", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $d365e8bde1350eb0$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $d365e8bde1350eb0$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $k6RDS.default)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $4jzsB.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;

});


parcelRegister("grOnY", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $bf96407f1f5b4126$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $bf96407f1f5b4126$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $k6RDS.default)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $4jzsB.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;

});

parcelRegister("5zBGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40ed7573a59c2be9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;

});

parcelRegister("juR2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e319f5c3a4402058$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;

});


parcelRegister("aUdfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f096abd658f7c85$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");

var $b6UUh = parcelRequire("b6UUh");

var $ehw51 = parcelRequire("ehw51");

var $8WhtA = parcelRequire("8WhtA");

var $a2ay0 = parcelRequire("a2ay0");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $bqHow = parcelRequire("bqHow");

var $5wwR3 = parcelRequire("5wwR3");

var $jPUa4 = parcelRequire("jPUa4");

var $g9bTP = parcelRequire("g9bTP");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $b6UUh.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $b6UUh.default)(scroll)}`,
            `paperWidth${(0, $b6UUh.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bqHow.getDialogUtilityClass), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $kDBhE.default)((0, $ehw51.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $kDBhE.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $b6UUh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $b6UUh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $g9bTP.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $a2ay0.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $8WhtA.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $65Itt.default)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kY3Ke.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $9MRga.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $kY3Ke.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9MRga.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5wwR3.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;

});
parcelRegister("65Itt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f5b561912058f9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF['useId'.toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}

});

parcelRegister("bqHow", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $8523c8ab2139cf2c$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $8523c8ab2139cf2c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $k6RDS.default)('MuiDialog', slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $4jzsB.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;

});

parcelRegister("5wwR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40596d25b0f9c334$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;

});


parcelRegister("8smOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6282a3c293a0d8c9$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $4Ox9X = parcelRequire("4Ox9X");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $6282a3c293a0d8c9$var$_excluded = [
    "className",
    "disableSpacing"
];
const $6282a3c293a0d8c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4Ox9X.getDialogActionsUtilityClass), classes);
};
const $6282a3c293a0d8c9$var$DialogActionsRoot = (0, $kDBhE.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $6282a3c293a0d8c9$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $cFLic.default)(props, $6282a3c293a0d8c9$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $6282a3c293a0d8c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6282a3c293a0d8c9$var$DialogActionsRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6282a3c293a0d8c9$export$2e2bcd8739ae039 = $6282a3c293a0d8c9$var$DialogActions;

});
parcelRegister("4Ox9X", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $38158dbfc23b097a$export$5e57a444791c63be; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $38158dbfc23b097a$export$5e57a444791c63be(slot) {
    return (0, $k6RDS.default)('MuiDialogActions', slot);
}
const $38158dbfc23b097a$var$dialogActionsClasses = (0, $4jzsB.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $38158dbfc23b097a$export$2e2bcd8739ae039 = $38158dbfc23b097a$var$dialogActionsClasses;

});


parcelRegister("8wwTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634ad3fd5060cf75$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $8FpGF = parcelRequire("8FpGF");

var $25LML = parcelRequire("25LML");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8FpGF.getDialogContentUtilityClass), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $kDBhE.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $25LML.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cFLic.default)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;

});
parcelRegister("8FpGF", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $64f614045184fa19$export$61b0ee1f05fb344e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $k6RDS.default)('MuiDialogContent', slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $4jzsB.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;

});

parcelRegister("25LML", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $18611d95980659c6$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $18611d95980659c6$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $k6RDS.default)('MuiDialogTitle', slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $4jzsB.default)('MuiDialogTitle', [
    'root'
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;

});


parcelRegister("eNZsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac75506ecdb312f1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $25LML = parcelRequire("25LML");

var $5wwR3 = parcelRequire("5wwR3");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ac75506ecdb312f1$var$_excluded = [
    "className",
    "id"
];
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $25LML.getDialogTitleUtilityClass), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $cFLic.default)(props, $ac75506ecdb312f1$var$_excluded);
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $5wwR3.default));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, (0, $kY3Ke.default)({
        component: "h2",
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;

});
parcelRegister("3loMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f68e516ee75fc4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $mqrnX = parcelRequire("mqrnX");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $iG6DO = parcelRequire("iG6DO");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iG6DO.getTypographyUtilityClass), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $mqrnX.default)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;

});
parcelRegister("iG6DO", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $d9914d0380157c73$export$24c1f8f60cbac79e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $k6RDS.default)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $4jzsB.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;

});



parcelRegister("58CWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bdbe9250415b022$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $cMvyt = parcelRequire("cMvyt");

var $3RNaF = parcelRequire("3RNaF");

var $hQtyv = parcelRequire("hQtyv");

var $6NwTb = parcelRequire("6NwTb");

var $glmzs = parcelRequire("glmzs");

var $awhCL = parcelRequire("awhCL");

var $3Er4K = parcelRequire("3Er4K");

var $b9wlN = parcelRequire("b9wlN");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $b9wlN.getMenuItemUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b9wlN.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b9wlN.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b9wlN.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $b9wlN.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b9wlN.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $glmzs.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $glmzs.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $3Er4K.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $3Er4K.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $awhCL.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $kY3Ke.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $awhCL.default).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $cFLic.default)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $hQtyv.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $6NwTb.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9MRga.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9MRga.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;

});
parcelRegister("hQtyv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfde3819487a0686$export$2e2bcd8739ae039; });

var $lJRRs = parcelRequire("lJRRs");
'use client';
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $lJRRs.default);

});

parcelRegister("glmzs", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $be601d991ccbe49a$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $be601d991ccbe49a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $k6RDS.default)('MuiDivider', slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $4jzsB.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;

});

parcelRegister("3Er4K", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $2a8a1c268392e331$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $2a8a1c268392e331$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $k6RDS.default)('MuiListItemText', slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $4jzsB.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;

});

parcelRegister("b9wlN", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $81e9a11bd449f186$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $81e9a11bd449f186$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $k6RDS.default)('MuiMenuItem', slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $4jzsB.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;

});


parcelRegister("f6ezL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe2b905acb8b9f6$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");


var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $jiLAb = parcelRequire("jiLAb");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $lHSFU = parcelRequire("lHSFU");

var $3jMGu = parcelRequire("3jMGu");

var $gFr0F = parcelRequire("gFr0F");

var $jh0sD = parcelRequire("jh0sD");

var $1VsKU = parcelRequire("1VsKU");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $afe2b905acb8b9f6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $jiLAb.default),
    filled: (0, $lxNRp.default),
    outlined: (0, $6WEW6.default)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1VsKU.getTextFieldUtilityClass), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $kDBhE.default)((0, $3jMGu.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $cFLic.default)(props, $afe2b905acb8b9f6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $65Itt.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $bbzbN.jsx)(InputComponent, (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($afe2b905acb8b9f6$var$TextFieldRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), (0, $kY3Ke.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jh0sD.default), (0, $kY3Ke.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFr0F.default), (0, $kY3Ke.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;

});
parcelRegister("jiLAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d49bb29c2f8b76$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $3wRTY = parcelRequire("3wRTY");


var $g1o71 = parcelRequire("g1o71");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $eFvie = parcelRequire("eFvie");

var $g1o71 = parcelRequire("g1o71");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $eFvie.getInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kY3Ke.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $eFvie.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $eFvie.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $eFvie.default).disabled}, .${(0, $eFvie.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $eFvie.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3wRTY.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = 'Input';
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;

});
parcelRegister("g1o71", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $ba9f7182d6802613$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $ba9f7182d6802613$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $ba9f7182d6802613$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $ba9f7182d6802613$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $ba9f7182d6802613$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");



var $cFCqu = parcelRequire("cFCqu");

var $ftQl8 = parcelRequire("ftQl8");

var $lBj2s = parcelRequire("lBj2s");

var $jHiZl = parcelRequire("jHiZl");

var $kPqR2 = parcelRequire("kPqR2");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $eaAgo = parcelRequire("eaAgo");

var $87FKv = parcelRequire("87FKv");

var $3HkEr = parcelRequire("3HkEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $b6UUh.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $3HkEr.getInputBaseUtilityClass), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $kDBhE.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $3HkEr.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $kDBhE.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $kY3Ke.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kY3Ke.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $3HkEr.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $3HkEr.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eaAgo.default), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $cFLic.default)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $6NwTb.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $87FKv.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $hQtyv.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $diYUK.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $kY3Ke.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kY3Ke.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $lBj2s.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $kY3Ke.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $ftQl8.default)(Root) && {
                ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9MRga.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, (0, $kY3Ke.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $ftQl8.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kY3Ke.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9MRga.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;

});
parcelRegister("lBj2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9bd25a2238f701$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $gHrsh = parcelRequire("gHrsh");
var $gE56a = parcelRequire("gE56a");
var $lJRRs = parcelRequire("lJRRs");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fb9bd25a2238f701$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $fb9bd25a2238f701$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $fb9bd25a2238f701$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $fb9bd25a2238f701$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $fb9bd25a2238f701$var$isEmpty(obj) {
    return $fb9bd25a2238f701$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $fb9bd25a2238f701$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cFLic.default)(props, $fb9bd25a2238f701$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const textareaRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(forwardedRef, textareaRef);
    const heightRef = $7fPBF.useRef(null);
    const hiddenTextareaRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $gE56a.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingBottom) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingTop);
        const border = $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderBottomWidth) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $giDhD.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $7fPBF.useRef(-1);
    (0, $lJRRs.default)(()=>{
        const debouncedHandleResize = (0, $gHrsh.default)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $gE56a.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $lJRRs.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", (0, $kY3Ke.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $kY3Ke.default)({}, $fb9bd25a2238f701$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $fb9bd25a2238f701$export$2e2bcd8739ae039 = $fb9bd25a2238f701$var$TextareaAutosize;

});

parcelRegister("jHiZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e570c333aacea667$export$2e2bcd8739ae039; });
function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("kPqR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f29d66cab44a33c0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;

});

parcelRegister("2jx1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1af6f86e160474f0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kPqR2 = parcelRequire("kPqR2");
'use client';
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $kPqR2.default));
}

});

parcelRegister("eaAgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50e20ff7f02e09b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $krgTN = parcelRequire("krgTN");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $krgTN.default), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;

});
parcelRegister("krgTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee13700d4d997375$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4kWyf.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;

});


parcelRegister("87FKv", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $5e9f5ca6e3e911fc$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("3HkEr", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $2b15682cef07fc0a$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $2b15682cef07fc0a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $k6RDS.default)('MuiInputBase', slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $4jzsB.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;

});


parcelRegister("eFvie", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $aadd2b32ac43594b$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $aadd2b32ac43594b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $k6RDS.default)('MuiInput', slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;

});


parcelRegister("lxNRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf35b44bb61ebfd$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $3wRTY = parcelRequire("3wRTY");



var $cFCqu = parcelRequire("cFCqu");

var $g1o71 = parcelRequire("g1o71");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $gImJ8 = parcelRequire("gImJ8");

var $g1o71 = parcelRequire("g1o71");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $gImJ8.getFilledInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $kY3Ke.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $gImJ8.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $gImJ8.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $gImJ8.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $gImJ8.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $gImJ8.default).disabled}, .${(0, $gImJ8.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $gImJ8.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3wRTY.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = 'Input';
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;

});
parcelRegister("gImJ8", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $c2b262889cde4af1$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $c2b262889cde4af1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $k6RDS.default)('MuiFilledInput', slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;

});


parcelRegister("6WEW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e7e9efec2c0b8c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $cFCqu = parcelRequire("cFCqu");

var $eYwIX = parcelRequire("eYwIX");

var $2jx1n = parcelRequire("2jx1n");

var $jHiZl = parcelRequire("jHiZl");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $lCN2y = parcelRequire("lCN2y");

var $g1o71 = parcelRequire("g1o71");

var $iVAEr = parcelRequire("iVAEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $lCN2y.getOutlinedInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $g1o71.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $kY3Ke.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $lCN2y.default).focused} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $lCN2y.default).error} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $lCN2y.default).disabled} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $kDBhE.default)((0, $eYwIX.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kY3Ke.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = 'Input';
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;

});
parcelRegister("eYwIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae700d9709d2b786$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $kDBhE.default)('fieldset', {
    shouldForwardProp: (0, $HgAeG.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $kDBhE.default)('legend', {
    shouldForwardProp: (0, $HgAeG.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kY3Ke.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cFLic.default)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

});

parcelRegister("lCN2y", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $fbe32ff46b8bf823$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $fbe32ff46b8bf823$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $k6RDS.default)('MuiOutlinedInput', slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;

});


parcelRegister("lHSFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd80672e9993aad$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $9MRga = parcelRequire("9MRga");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $cnEvg = parcelRequire("cnEvg");
var $cN7rN = parcelRequire("cN7rN");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $3Ha1S = parcelRequire("3Ha1S");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $b6UUh.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $3Ha1S.getInputLabelUtilityClasses), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $kDBhE.default)((0, $cnEvg.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cN7rN.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $kY3Ke.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $kY3Ke.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $kY3Ke.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cFLic.default)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $kY3Ke.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9MRga.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;

});
parcelRegister("cnEvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90370d1df15229dd$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $b6UUh = parcelRequire("b6UUh");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $cN7rN = parcelRequire("cN7rN");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cN7rN.getFormLabelUtilityClasses), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $kDBhE.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $cN7rN.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $cN7rN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $cN7rN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $kDBhE.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $cN7rN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $cFLic.default)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;

});
parcelRegister("cN7rN", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $94ffd68a66aaae7e$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $94ffd68a66aaae7e$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $k6RDS.default)('MuiFormLabel', slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $4jzsB.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;

});


parcelRegister("3Ha1S", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $2b0d2ae144238f59$export$c1c4b4545ad2ea5f; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $k6RDS.default)('MuiInputLabel', slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $4jzsB.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;

});


parcelRegister("3jMGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a8e925f0aa9998$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $87FKv = parcelRequire("87FKv");

var $b6UUh = parcelRequire("b6UUh");

var $91ID4 = parcelRequire("91ID4");

var $kPqR2 = parcelRequire("kPqR2");

var $9AiVZ = parcelRequire("9AiVZ");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $b6UUh.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $9AiVZ.getFormControlUtilityClasses), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $kDBhE.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, styles[`margin${(0, $b6UUh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $cFLic.default)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $91ID4.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $87FKv.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $87FKv.isFilled)(child.props, true) || (0, $87FKv.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9MRga.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;

});
parcelRegister("91ID4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6926d37cb7ff7774$export$2e2bcd8739ae039; });

var $j4EgL = parcelRequire("j4EgL");
var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $j4EgL.default);

});
parcelRegister("j4EgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2da0b284b1a3c2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $de2da0b284b1a3c2$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

});


parcelRegister("9AiVZ", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $6fa629ce89e8ad57$export$149c8b8bab2289d1; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $k6RDS.default)('MuiFormControl', slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $4jzsB.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;

});


parcelRegister("gFr0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0321a2cb63129955$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $b6UUh = parcelRequire("b6UUh");

var $1qExZ = parcelRequire("1qExZ");

var $iVAEr = parcelRequire("iVAEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $b6UUh.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1qExZ.getFormHelperTextUtilityClasses), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $kDBhE.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $1qExZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1qExZ.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $cFLic.default)(props, $0321a2cb63129955$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0321a2cb63129955$var$FormHelperTextRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;

});
parcelRegister("1qExZ", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $10a7abfeb1405549$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $10a7abfeb1405549$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $k6RDS.default)('MuiFormHelperText', slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $4jzsB.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;

});


parcelRegister("jh0sD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e07ff65b28ac412d$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $3wRTY = parcelRequire("3wRTY");

var $bNCjr = parcelRequire("bNCjr");

var $7HA9s = parcelRequire("7HA9s");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $aI4oF = parcelRequire("aI4oF");

var $jiLAb = parcelRequire("jiLAb");

var $avrPa = parcelRequire("avrPa");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $iVAEr = parcelRequire("iVAEr");

var $6NwTb = parcelRequire("6NwTb");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $e07ff65b28ac412d$var$_excluded2 = [
    "root"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e07ff65b28ac412d$var$StyledInput = (0, $kDBhE.default)((0, $jiLAb.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $kDBhE.default)((0, $6WEW6.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $kDBhE.default)((0, $lxNRp.default), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $aI4oF.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $cFLic.default)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $avrPa.default) : (0, $7HA9s.default);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cFLic.default)(classes, $e07ff65b28ac412d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $6NwTb.default)(ref, (0, $bNCjr.default)(InputComponent));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kY3Ke.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kY3Ke.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3wRTY.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9MRga.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = 'Select';
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;

});
parcelRegister("7HA9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b8977b1194262f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");



var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");


var $cNbkS = parcelRequire("cNbkS");

var $b6UUh = parcelRequire("b6UUh");

var $gPL9h = parcelRequire("gPL9h");

var $avrPa = parcelRequire("avrPa");

var $87FKv = parcelRequire("87FKv");

var $kDBhE = parcelRequire("kDBhE");
var $yfUan = parcelRequire("yfUan");

var $6NwTb = parcelRequire("6NwTb");

var $568MF = parcelRequire("568MF");

var $87RNG = parcelRequire("87RNG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $kDBhE.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $87RNG.default).select}`]: styles.select
            },
            {
                [`&.${(0, $87RNG.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $87RNG.default).error}`]: styles.error
            },
            {
                [`&.${(0, $87RNG.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $avrPa.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $87RNG.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $kDBhE.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $avrPa.nativeSelectIconStyles));
const $59b8977b1194262f$var$SelectNativeInput = (0, $kDBhE.default)('input', {
    shouldForwardProp: (prop)=>(0, $yfUan.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $b6UUh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $87RNG.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $568MF.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $568MF.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $6NwTb.default)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $cNbkS.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $87FKv.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $diYUK.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kY3Ke.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $65Itt.default)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, (0, $kY3Ke.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9MRga.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $kY3Ke.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gPL9h.default), (0, $kY3Ke.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $kY3Ke.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kY3Ke.default)({}, MenuProps.slotProps, {
                    paper: (0, $kY3Ke.default)({}, paperProps, {
                        style: (0, $kY3Ke.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;

});
parcelRegister("cNbkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9502daaf177b272b$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $4CS7n.default);

});

parcelRegister("gPL9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c415fb7f3f0f9d08$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");


var $kyirV = parcelRequire("kyirV");

var $elaRz = parcelRequire("elaRz");

var $dseJp = parcelRequire("dseJp");

var $ahaA4 = parcelRequire("ahaA4");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $ewYvI = parcelRequire("ewYvI");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ewYvI.getMenuUtilityClass), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $kDBhE.default)((0, $ahaA4.default), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $kDBhE.default)((0, $ahaA4.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $kDBhE.default)((0, $dseJp.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $cFLic.default)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const isRtl = (0, $kyirV.useRtl)();
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $elaRz.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $elaRz.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $kY3Ke.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $kY3Ke.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9MRga.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;

});
parcelRegister("dseJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb95136bc90d127$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $cNbkS = parcelRequire("cNbkS");

var $lAoIf = parcelRequire("lAoIf");

var $1RLwL = parcelRequire("1RLwL");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $cFLic.default)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $hQtyv.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1RLwL.default)((0, $cNbkS.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $cNbkS.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $6NwTb.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lAoIf.default), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;

});
parcelRegister("lAoIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb70212a09473954$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $cMvyt = parcelRequire("cMvyt");

var $ik5ek = parcelRequire("ik5ek");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ik5ek.getListUtilityClass), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $kDBhE.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cFLic.default)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, (0, $kY3Ke.default)({
            as: component,
            className: (0, $9MRga.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;

});
parcelRegister("ik5ek", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $d56e26d1d10ff784$export$c6bd6795ed6e3203; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $k6RDS.default)('MuiList', slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $4jzsB.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;

});


parcelRegister("1RLwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15bf9ba27fbfc052$export$2e2bcd8739ae039; });

var $8c45K = parcelRequire("8c45K");
var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $8c45K.default);

});


parcelRegister("ahaA4", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $77b3b30833fb8c12$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $77b3b30833fb8c12$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");






var $elaRz = parcelRequire("elaRz");

var $ftQl8 = parcelRequire("ftQl8");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $52luK = parcelRequire("52luK");

var $cNbkS = parcelRequire("cNbkS");

var $9kBlI = parcelRequire("9kBlI");

var $6NwTb = parcelRequire("6NwTb");

var $aSK9T = parcelRequire("aSK9T");

var $ehw51 = parcelRequire("ehw51");

var $a2ay0 = parcelRequire("a2ay0");

var $edKHw = parcelRequire("edKHw");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $edKHw.getPopoverUtilityClass), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $kDBhE.default)((0, $ehw51.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $aSK9T.default), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $cFLic.default)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $6NwTb.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $cNbkS.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9kBlI.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $52luK.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9kBlI.default)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $cNbkS.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $elaRz.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kY3Ke.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kY3Ke.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $elaRz.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cFLic.default)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, (0, $kY3Ke.default)({}, rootProps, !(0, $ftQl8.default)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, (0, $kY3Ke.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;

});
parcelRegister("aSK9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec2c0aa92d4d29c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $de55R = parcelRequire("de55R");


var $bNCjr = parcelRequire("bNCjr");

var $8qMCX = parcelRequire("8qMCX");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = (0, $de55R.default)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $g9bTP.default)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, (0, $bNCjr.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;

});

parcelRegister("edKHw", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $a5a68170633995c3$export$88f455dd56c95edb; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $k6RDS.default)('MuiPopover', slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $4jzsB.default)('MuiPopover', [
    'root',
    'paper'
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;

});


parcelRegister("ewYvI", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $a942fdfc6e6c5d42$export$2cf86a63a84fe23d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $k6RDS.default)('MuiMenu', slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $4jzsB.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;

});


parcelRegister("avrPa", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $7a6261f84c63d345$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $7a6261f84c63d345$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $7a6261f84c63d345$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $ecolw = parcelRequire("ecolw");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $b6UUh.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ecolw.getNativeSelectUtilityClasses), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $kY3Ke.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $ecolw.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $kDBhE.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $HgAeG.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $ecolw.default).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $ecolw.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $kDBhE.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $kY3Ke.default)({
                ownerState: ownerState,
                className: (0, $9MRga.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;

});
parcelRegister("ecolw", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $a5651256592f6f65$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $a5651256592f6f65$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $k6RDS.default)('MuiNativeSelect', slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $4jzsB.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;

});


parcelRegister("568MF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b64539a8a5729fa$export$2e2bcd8739ae039; });

var $gaYwN = parcelRequire("gaYwN");
'use client';
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $gaYwN.default);

});
parcelRegister("gaYwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc6c881cebb96954$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("87RNG", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $5ea8b5d2968b699c$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $5ea8b5d2968b699c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $k6RDS.default)('MuiSelect', slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $4jzsB.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;

});


parcelRegister("aI4oF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cc16c93aade5bc5$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("1VsKU", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $16716b95f6c79ff6$export$c1bdcbaf0596aeda; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $k6RDS.default)('MuiTextField', slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $4jzsB.default)('MuiTextField', [
    'root'
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;

});


parcelRegister("nTWXA", function(module, exports) {

$parcel$export(module.exports, "useDashboards", function () { return $047d8c9869ae35a0$export$629317fe769e0258; });
//my edits

var $7fPBF = parcelRequire("7fPBF");

var $7bFjM = parcelRequire("7bFjM");
function $047d8c9869ae35a0$export$629317fe769e0258() {
    const [dashboards, setDashboards] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetchDashboardList = (0, $7fPBF.useCallback)(async ()=>{
        try {
            setLoading(true);
            const response = await (0, $7bFjM.default)("GET", "get_dashboard_list/", "", "");
            if (response.msg === "success") setDashboards(response.data || []);
            else throw new Error(response.msg || "Failed to fetch dashboards");
        } catch (e) {
            setError("Network error");
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetchDashboardList();
    }, [
        fetchDashboardList
    ]);
    return (0, $7fPBF.useMemo)(()=>({
            dashboards: dashboards,
            loading: loading,
            setLoading: setLoading,
            error: error,
            fetchDashboardList: fetchDashboardList
        }), [
        dashboards,
        loading,
        error,
        fetchDashboardList
    ]);
}

});
parcelRegister("7bFjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53b99c62d0282702$export$2e2bcd8739ae039; });
//my edits

var $9tqwB = parcelRequire("9tqwB");

var $h3OEn = parcelRequire("h3OEn");

var $aqd0z = parcelRequire("aqd0z");
(0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).defaults.withCredentials = true;
(0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).defaults.xsrfHeaderName = "X-CSRFTOKEN";
(0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).defaults.xsrfCookieName = "csrftoken";
class $53b99c62d0282702$var$ApiClient {
    async getCsrfToken() {
        // Return existing token if available
        if (this.csrfToken) return this.csrfToken;
        // If there's already a request in progress, return its promise
        if (this.csrfPromise) return this.csrfPromise;
        // Create new request
        this.csrfPromise = (0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).get(`${(0, $aqd0z.API_HOST)}/csrf/`).then((response)=>{
            this.csrfToken = response.csrfToken;
            this.csrfPromise = null;
            return this.csrfToken;
        }).catch((error)=>{
            this.csrfPromise = null;
            throw error;
        });
        return this.csrfPromise;
    }
    async callAPI(method, route, options = null, apiHost = null) {
        let isFileDownload = false;
        const base = apiHost || (0, $aqd0z.API_HOST);
        try {
            // Check if this is a file download request
            isFileDownload = route.startsWith('download/') && (options === null || options === void 0 ? void 0 : options.responseType) === 'blob';
            if (isFileDownload) {
                // Special handling for file downloads
                const config = (0, $9tqwB._)({
                    method: method,
                    url: `${base}/${route.replace(/^\/+/, '')}`,
                    responseType: 'blob',
                    headers: (0, $9tqwB._)({
                        'Accept': 'application/pdf'
                    }, (options === null || options === void 0 ? void 0 : options.headers) || {})
                }, options);
                const response = await (0, (/*@__PURE__*/$parcel$interopDefault($h3OEn)))(config);
                return {
                    msg: "success",
                    data: response.data,
                    headers: response.headers
                };
            }
            // if is is POST request then we can proceed with standard api call
            let response;
            if (method === "POST") {
                (0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).defaults.headers.common["X-CSRFTOKEN"] = await this.getCsrfToken();
                response = await (0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).post(`${base}/${route.replace(/^\/+/, '')}`, options);
            } else if (method === "GET") response = await (0, (/*@__PURE__*/$parcel$interopDefault($h3OEn))).get(`${base}/${route.replace(/^\/+/, '')}`, {
                signal: options === null || options === void 0 ? void 0 : options.signal
            });
            return response.data;
        } catch (error) {
            var _error_response, _error_response1, _error_response_data, _error_response2;
            // Special handling for blob errors in file downloads
            if (isFileDownload && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) instanceof Blob) try {
                const text = await error.response.data.text();
                return {
                    msg: "fail",
                    message: `Download failed: ${text}`
                };
            } catch (blobError) {
                return {
                    msg: "fail",
                    message: 'Failed to process response'
                };
            }
            if (((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status) === 403 && ((_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : (_error_response_data = _error_response2.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.code) === "invalid_csrf_token") this.csrfToken = null;
            return {
                msg: "fail",
                message: error.message
            };
        }
    }
    constructor(){
        this.csrfToken = null;
        this.csrfPromise = null;
    }
}
// Create a singleton instance
const $53b99c62d0282702$var$apiClient = new $53b99c62d0282702$var$ApiClient();
var $53b99c62d0282702$export$2e2bcd8739ae039 = $53b99c62d0282702$var$apiClient.callAPI.bind($53b99c62d0282702$var$apiClient);

});
parcelRegister("h3OEn", function(module, exports) {

module.exports = (parcelRequire("a04va"));

});
parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $ef5jC = parcelRequire("ef5jC");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance($5f6d7(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($ef5jC);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.Cancel = (parcelRequire("2W85d"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));

$747d656b899e6115$var$axios.VERSION = (parcelRequire("cR4ZD")).version;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));

// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (parcelRequire("kgiwQ"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");
// utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBuffer(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object FormData]';
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $77146a31cb578292$var$isPlainObject(val) {
    if ($77146a31cb578292$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $77146a31cb578292$var$isDate(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $77146a31cb578292$var$isFile(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $77146a31cb578292$var$isBlob(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $77146a31cb578292$var$isURLSearchParams(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object URLSearchParams]';
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($77146a31cb578292$var$isPlainObject(result[key]) && $77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge(result[key], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $77146a31cb578292$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $2iR5D = parcelRequire("2iR5D");
var $66f2b8a41463d1e8$var$validators = $2iR5D.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $5f6d7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2iR5D.assertOptions(transitional, {
        silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eystn,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eystn(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$66f2b8a41463d1e8$var$Axios.prototype.getUri = function getUri(config) {
    config = $5f6d7(this.defaults, config);
    return $6nvAH(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $ef5jC = parcelRequire("ef5jC");

var $2W85d = parcelRequire("2W85d");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $2W85d('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $ef5jC.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $ef5jC = parcelRequire("ef5jC");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $ef5jC;
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("ef5jC", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");

var $3leq5 = parcelRequire("3leq5");

var $aP7qx = parcelRequire("aP7qx");
var $a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}


function $a5e696f232d0dc12$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    else if (typeof $4ZL0H !== 'undefined' && Object.prototype.toString.call($4ZL0H) === '[object process]') // For node use HTTP adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ($adReO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $adReO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $a5e696f232d0dc12$var$defaults = {
    transitional: $aP7qx,
    adapter: $a5e696f232d0dc12$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Accept');
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($adReO.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, 'application/json');
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $adReO.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $3leq5(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = $adReO.merge($a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $a5e696f232d0dc12$var$defaults;

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3leq5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("aP7qx", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $hHo9F = parcelRequire("hHo9F");

var $aP7qx = parcelRequire("aP7qx");

var $2W85d = parcelRequire("2W85d");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($adReO.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $40T1q(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $6nvAH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hHo9F('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hHo9F('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $aP7qx;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hHo9F(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(fullPath)) && config.xsrfCookieName ? $79n0f.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$adReO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $2W85d('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $hHo9F = parcelRequire("hHo9F");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hHo9F('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hHo9F", function(module, exports) {
'use strict';

var $3leq5 = parcelRequire("3leq5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3leq5(error, config, code, request, response);
};

});


parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("40T1q", function(module, exports) {
'use strict';

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1yk63(requestedURL)) return $l45Ly(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("2W85d", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $223744b24e5d0b4c$var$Cancel(message) {
    this.message = message;
}
$223744b24e5d0b4c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$223744b24e5d0b4c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $223744b24e5d0b4c$var$Cancel;

});




parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5f6d7", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($adReO.isPlainObject(target) && $adReO.isPlainObject(source)) return $adReO.merge(target, source);
        else if ($adReO.isPlainObject(source)) return $adReO.merge({}, source);
        else if ($adReO.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $adReO.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $adReO.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("2iR5D", function(module, exports) {
'use strict';

var $cR4ZD = parcelRequire("cR4ZD");
var $1ad671c27810423e$require$VERSION = $cR4ZD.version;
var $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1ad671c27810423e$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRegister("cR4ZD", function(module, exports) {
module.exports = {
    "version": "0.26.1"
};

});



parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $2W85d = parcelRequire("2W85d");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2W85d(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kgiwQ", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $adReO.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRegister("aqd0z", function(module, exports) {

$parcel$export(module.exports, "API_HOST", function () { return $79666c3d64a0437e$export$961a507a52292452; });
$parcel$export(module.exports, "BORDER_GREY", function () { return $79666c3d64a0437e$export$31c5ce631d772006; });
$parcel$export(module.exports, "BUTTON_BORDER_RADIUS", function () { return $79666c3d64a0437e$export$6836610752de4c9b; });
$parcel$export(module.exports, "WHITE", function () { return $79666c3d64a0437e$export$29814851e0aa981f; });
$parcel$export(module.exports, "COLORS", function () { return $79666c3d64a0437e$export$56d196d2844d1ca1; });
$parcel$export(module.exports, "BOX_SHADOW", function () { return $79666c3d64a0437e$export$c1ebb7fd473186f7; });
$parcel$export(module.exports, "FORMAL_BOX_SHADOW", function () { return $79666c3d64a0437e$export$380cbe3fc72b2243; });
$parcel$export(module.exports, "NAVBAR_BLUE", function () { return $79666c3d64a0437e$export$2d5dd6a24bc5674a; });
$parcel$export(module.exports, "GREEN", function () { return $79666c3d64a0437e$export$48d4b2cd5bc0e88b; });
$parcel$export(module.exports, "OPP_FUNCTION_MAPPING", function () { return $79666c3d64a0437e$export$3b5116c459f0ce42; });
$parcel$export(module.exports, "OPP_KEYS_MAPPING", function () { return $79666c3d64a0437e$export$897747553a39d0c2; });
const $79666c3d64a0437e$export$961a507a52292452 = "https://sa.perceptiviti.com/api";
const $79666c3d64a0437e$export$a7c5707626fc90f = "https://sa.perceptiviti.com";
const $79666c3d64a0437e$export$31c5ce631d772006 = "#E8E9EC";
const $79666c3d64a0437e$export$6836610752de4c9b = "5px";
const $79666c3d64a0437e$export$29814851e0aa981f = "#FFFFFF";
const $79666c3d64a0437e$export$56d196d2844d1ca1 = [
    "#55CBCF",
    "#37A1EA",
    "#FF6384",
    "#1E355C",
    "#FEC920",
    "#BCBCCB"
];
const $79666c3d64a0437e$export$c1ebb7fd473186f7 = "5px 4px 30px rgba(0,0,0,.10)";
const $79666c3d64a0437e$export$380cbe3fc72b2243 = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
const $79666c3d64a0437e$export$91d4f307e66165b7 = "rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset";
const $79666c3d64a0437e$export$2d5dd6a24bc5674a = "#305697";
const $79666c3d64a0437e$export$48d4b2cd5bc0e88b = "#4caf50";
const $79666c3d64a0437e$export$74a65eb1306d187a = {
    Claims: "claims",
    "Amount Submitted": "amount",
    "Activity Amount Submitted": "activity_amount",
    "Paid Amount": "paid_amount",
    "Activity Paid Amount": "activity_paid_amount",
    "Denied Amount": "denied_amount",
    "Activity Denied Amount": "activity_denied_amount",
    Members: "members",
    Clinicians: "clinicians",
    "ICD1 Code": "icd1_codes",
    "ICD2 Code": "icd2_codes",
    "ICD3 Code": "icd3_codes",
    "ICD4 Code": "icd4_codes"
};
const $79666c3d64a0437e$export$b96190af3c254715 = {
    Count: "count",
    "Distinct Count": "distinctcount",
    Average: "average",
    Max: "max",
    Min: "min",
    Sum: "sum"
};
const $79666c3d64a0437e$export$3b5116c459f0ce42 = {
    count: "Count",
    distinctcount: "Distinct Count",
    average: "Average",
    max: "Max",
    min: "Min",
    sum: "Sum"
};
const $79666c3d64a0437e$export$897747553a39d0c2 = {
    claims: "Claims",
    amount: "Amount Submitted",
    activity_amount: "Activity Amount Submitted",
    paid_amount: "Paid Amount",
    activity_paid_amount: "Activity Paid Amount",
    denied_amount: "Denied Amount",
    activity_denied_amount: "Activity Denied Amount",
    members: "Members",
    clinicians: "Clinicians",
    icd1_codes: "ICD1 Code",
    icd2_codes: "ICD2 Code",
    icd3_codes: "ICD3 Code",
    icd4_codes: "ICD4 Code"
};

});



parcelRegister("gj7kf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bdf41a6bde7ffb35$export$2e2bcd8739ae039; });

var $9tqwB = parcelRequire("9tqwB");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8TTBx = parcelRequire("8TTBx");

var $j4U3I = parcelRequire("j4U3I");

var $a3nRA = parcelRequire("a3nRA");

var $6mEEW = parcelRequire("6mEEW");

var $awsKY = parcelRequire("awsKY");

var $7LZtP = parcelRequire("7LZtP");


// const ResponsiveGridLayout = WidthProvider(RGL);
const $bdf41a6bde7ffb35$var$DialogExample = ()=>{
    const parentRef = (0, $7fPBF.useRef)(null);
    const mapRef = (0, $7fPBF.useRef)(null);
    const initialLayouts = {
        lg: [
            {
                w: 6,
                h: 6,
                x: 0,
                y: 0,
                i: "a",
                moved: false,
                static: false
            },
            {
                w: 3,
                h: 6,
                x: 9,
                y: 0,
                i: "b",
                moved: false,
                static: false
            },
            {
                w: 3,
                h: 6,
                x: 6,
                y: 0,
                i: "c",
                moved: false,
                static: false
            },
            {
                w: 12,
                h: 4,
                x: 0,
                y: 6,
                i: "d",
                moved: false,
                static: false
            },
            {
                w: 12,
                h: 4,
                x: 0,
                y: 6,
                i: "e",
                moved: false,
                static: false
            }
        ]
    };
    const uniqueKey = `res${Date.now()}`;
    const [providersList, setProvidersList] = (0, $7fPBF.useState)((0, $9tqwB._)({}, (0, $7LZtP.CONSTPROVIDERLIST)));
    const [layouts, setLayouts] = (0, $7fPBF.useState)(initialLayouts);
    const onLayoutChange = (_, allLayouts)=>{
        setLayouts(()=>allLayouts);
    };
    const handleAddProvider = ()=>{
        if (Object.keys(providersList).length < (0, $7LZtP.MAXPROVIDERCOUNT)) {
            const newProvider = {
                "provider-group": [],
                emirate: [],
                "provider-type": [],
                "provider-name": [],
                "clinician-speciality": [],
                "clinician-name": [],
                "transaction-fromdate": [
                    "01-01-2022"
                ],
                "transaction-todate": [
                    "31-12-2022"
                ],
                "claim-status": [
                    "partially_paid",
                    "paid",
                    "open",
                    "rejected"
                ],
                "claim-type": [
                    "1"
                ],
                encounter: [
                    "outpatient"
                ]
            };
            const providersListClone = (0, $9tqwB._)({}, providersList);
            providersListClone[Object.keys(providersListClone).length] = newProvider;
            setProvidersList((0, $9tqwB._)({}, providersListClone));
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            Object.keys(providersList).map((provider, providerIdx)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3nRA.default), {
                    providerLabel: provider,
                    setProvider: setProvidersList,
                    provider: providersList,
                    handleAddProvider: handleAddProvider,
                    providerIdx: providerIdx
                }, `${provider}_global_filter`)),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $awsKY.Responsive), {
                layouts: layouts,
                breakpoints: {
                    lg: 1200,
                    md: 996,
                    sm: 768,
                    xs: 480,
                    xxs: 0
                },
                cols: {
                    lg: 12,
                    md: 10,
                    sm: 6,
                    xs: 4,
                    xxs: 2
                },
                rowHeight: 60,
                width: window.screen.width - 150,
                onLayoutChange: onLayoutChange,
                style: {
                    marginTop: "3rem"
                },
                children: [
                    Object.keys((0, $8TTBx.dummyData)).map((dataKey, index)=>{
                        const dataExtract = (0, $8TTBx.dummyData)[dataKey];
                        return Object.keys(dataExtract).map((Key, dataIndex)=>{
                            const dataToUse = (0, $8TTBx.dummyData)[dataKey][Key];
                            if (!Array.isArray(dataToUse)) return null;
                            const y = index + dataIndex * 3;
                            return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "widget ",
                                "data-grid": {
                                    w: dataToUse[4].w,
                                    h: dataToUse[4].h,
                                    x: dataToUse[4].x,
                                    y: dataToUse[4].y,
                                    marginTop: "12rem"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j4U3I.default), {
                                    isOptionsEnabled: dataToUse[0] === "Claim Trends" ? true : false,
                                    title: dataToUse[0],
                                    data: dataToUse[1],
                                    options: dataToUse[2],
                                    type: dataToUse[3]
                                })
                            }, `${index}_${dataIndex}_container`);
                        });
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "widget ",
                        "data-grid": {
                            w: 6,
                            h: 5,
                            x: 6,
                            y: 5
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6mEEW.default), {
                            mapRef: mapRef
                        })
                    }, `provider_predictions_container`)
                ]
            }, `res${uniqueKey}`)
        ]
    });
};
var $bdf41a6bde7ffb35$export$2e2bcd8739ae039 = $bdf41a6bde7ffb35$var$DialogExample;

});
parcelRegister("8TTBx", function(module, exports) {

$parcel$export(module.exports, "dummyData", function () { return $67ae97b0938285f4$export$366bb43832bb97dc; });
parcelRequire("7fPBF");
const $67ae97b0938285f4$var$ctx = document.createElement("canvas").getContext("2d");
const $67ae97b0938285f4$var$gradient = $67ae97b0938285f4$var$ctx.createLinearGradient(0, 0, 0, 400);
$67ae97b0938285f4$var$gradient.addColorStop(0, "rgba(2, 139, 232, 0.2)");
$67ae97b0938285f4$var$gradient.addColorStop(1, "rgba(2, 139, 232, 0)");
const $67ae97b0938285f4$var$specialtiesData = {
    specialty1: {
        label: "Specialty 1",
        data: [
            30,
            40,
            35,
            50,
            45,
            60
        ],
        borderColor: "#1DE5EC",
        backgroundColor: "#1DE5EC"
    },
    specialty2: {
        label: "Specialty 2",
        data: [
            20,
            35,
            25,
            40,
            30,
            50
        ],
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: "rgba(54, 162, 235, 0.2)"
    }
};
const $67ae97b0938285f4$export$366bb43832bb97dc = {
    claimTrends: {
        // title: "Claim Trends Forecast",
        MonthlyClaimTrendsChart: [
            "Claim Trends",
            {
                labels: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    // "",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                datasets: [
                    {
                        // label: "Claims",
                        // data: [1200000, 190000, 300000, 50000, 1200000, 3000], // Replace this with your actual data
                        label: "Current",
                        backgroundColor: "#039BFF",
                        borderColor: "#039BFF",
                        hoverBackgroundColor: "#039BFF",
                        hoverBorderColor: "#039BFF",
                        data: [
                            129200,
                            113400,
                            110000,
                            114600,
                            120400,
                            // null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ]
                    },
                    {
                        label: "Forecasted",
                        backgroundColor: "#1DE5EC",
                        borderColor: "#1DE5EC",
                        hoverBackgroundColor: "#1DE5EC",
                        hoverBorderColor: "#1DE5EC",
                        data: [
                            null,
                            null,
                            null,
                            null,
                            null,
                            // null,
                            119000,
                            120700,
                            117200,
                            127200,
                            130100,
                            120800,
                            138800
                        ]
                    }
                ]
            },
            {
                indexAxis: "x",
                scales: {
                    x: {
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: {
                        position: "bottom"
                    }
                }
            },
            "line",
            {
                w: 6,
                h: 5,
                x: 0,
                y: 0
            }
        ]
    },
    memberShip: {
        GrowthMemberPolicies: [
            "Policy Trends",
            {
                labels: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                datasets: [
                    {
                        label: "Current",
                        backgroundColor: "#039BFF",
                        borderColor: "#039BFF",
                        borderWidth: 1,
                        hoverBackgroundColor: "#039BFF",
                        hoverBorderColor: "#039BFF",
                        data: [
                            100,
                            90,
                            140,
                            160,
                            180,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ]
                    },
                    {
                        label: "Forecasted",
                        backgroundColor: "#1DE5EC",
                        borderColor: "#1DE5EC",
                        hoverBackgroundColor: "#1DE5EC",
                        hoverBorderColor: "#1DE5EC",
                        data: [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            280,
                            200,
                            320,
                            340,
                            360,
                            null,
                            null
                        ]
                    }
                ]
            },
            {
                scales: {
                    x: {
                        stacked: false
                    },
                    y: {
                        stacked: false
                    }
                },
                plugins: {
                    legend: {
                        position: "bottom"
                    }
                }
            },
            "bar",
            {
                w: 6,
                h: 5,
                x: 6,
                y: 0
            }
        ]
    },
    providers: {
        // title: "Provider Numbers Forecast",
        ProviderNumber: [
            "Provider Network Growth",
            {
                labels: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                datasets: [
                    {
                        label: "Current",
                        backgroundColor: "#039BFF",
                        borderColor: "#039BFF",
                        borderWidth: 1,
                        hoverBackgroundColor: "#039BFF",
                        hoverBorderColor: "#039BFF",
                        data: [
                            28,
                            48,
                            40,
                            19,
                            66,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ]
                    },
                    {
                        label: "Forecasted",
                        backgroundColor: "#1DE5EC",
                        borderColor: "#1DE5EC",
                        hoverBackgroundColor: "#1DE5EC",
                        hoverBorderColor: "#1DE5EC",
                        data: [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            59,
                            80,
                            81,
                            56,
                            65,
                            null,
                            null
                        ]
                    }
                ]
            },
            {
                scales: {
                    x: {
                        stacked: false
                    },
                    y: {
                        stacked: false
                    }
                },
                plugins: {
                    legend: {
                        position: "bottom"
                    }
                }
            },
            "bar",
            {
                w: 6,
                h: 5,
                x: 0,
                y: 5
            }
        ]
    }
};

});

parcelRegister("j4U3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de39e028c4102dc9$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gsokU = parcelRequire("gsokU");
var $3jMGu = parcelRequire("3jMGu");
var $58CWL = parcelRequire("58CWL");
var $jh0sD = parcelRequire("jh0sD");

var $5nUae = parcelRequire("5nUae");

var $4eU7y = parcelRequire("4eU7y");

var $itmb4 = parcelRequire("itmb4");

var $9Zbkq = parcelRequire("9Zbkq");

let $de39e028c4102dc9$var$_ = (t)=>t, $de39e028c4102dc9$var$t;
(0, $itmb4.Chart).register((0, $itmb4.CategoryScale), (0, $itmb4.LinearScale), (0, $itmb4.BarElement), (0, $itmb4.PointElement), (0, $itmb4.LineElement), (0, $itmb4.Legend), (0, $itmb4.Tooltip), (0, $itmb4.LineController), (0, $itmb4.BarController));
const $de39e028c4102dc9$var$DynamicChart = ({ title: title, data: data, options: options, type: type, isOptionsEnabled: isOptionsEnabled })=>{
    const [viewType, setViewType] = (0, $7fPBF.useState)("monthly"); // Monthly, quarterly, weekly
    const [dataType, setDataType] = (0, $7fPBF.useState)("amounts"); // Amounts or Counts
    // console.log("Dynamic", title, data, options, type, isOptionsEnabled);
    const useStyles = (0, $4eU7y.default)({
        root: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "20px"
        }
    });
    const override = (0, $5nUae.css)($de39e028c4102dc9$var$t || ($de39e028c4102dc9$var$t = $de39e028c4102dc9$var$_`
    display: block;
    margin: auto;
  `));
    const classes = useStyles();
    const handleViewTypeChange = (event)=>{
        setViewType(event.target.value);
    // Update chart data based on the selected view type
    };
    const handleDataTypeChange = (event)=>{
        setDataType(event.target.value);
    // Update chart data based on the selected data type
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gsokU.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            children: [
                isOptionsEnabled ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "0.5rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                            className: "text-xl mt-[3%]",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "claim-trends-forecast",
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "options",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                        sx: {
                                            m: 0.5,
                                            width: 120
                                        },
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
                                            value: viewType,
                                            onChange: handleViewTypeChange,
                                            style: {
                                                marginRight: "10px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "monthly",
                                                    children: "Monthly"
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "quarterly",
                                                    children: "Quarterly"
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "weekly",
                                                    children: "Weekly"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                        sx: {
                                            m: 0.5,
                                            width: 120
                                        },
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
                                            value: dataType,
                                            onChange: handleDataTypeChange,
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "amounts",
                                                    children: "Amounts"
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "counts",
                                                    children: "Counts"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    className: "text-xl mt-[3%]",
                    children: title
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Zbkq.Chart), {
                        type: type,
                        data: data,
                        options: options,
                        style: {
                            maxHeight: isOptionsEnabled ? "270px" : null
                        }
                    })
                })
            ]
        })
    });
};
var $de39e028c4102dc9$export$2e2bcd8739ae039 = $de39e028c4102dc9$var$DynamicChart;

});
parcelRegister("gsokU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb223886c302418$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $a2ay0 = parcelRequire("a2ay0");

var $bgCoQ = parcelRequire("bgCoQ");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bgCoQ.getCardUtilityClass), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $cFLic.default)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;

});
parcelRegister("bgCoQ", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $833ef9b800b82ea7$export$f3b76d2cce458caa; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $k6RDS.default)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $4jzsB.default)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;

});


parcelRegister("4eU7y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316400a86e66613a$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $44Txg = parcelRequire("44Txg");

var $dGBsa = parcelRequire("dGBsa");

var $kz9aJ = parcelRequire("kz9aJ");

var $1iERc = parcelRequire("1iERc");

var $cRTRJ = parcelRequire("cRTRJ");

var $cML5X = parcelRequire("cML5X");

var $lWzUV = parcelRequire("lWzUV");

var $cQCE4 = parcelRequire("cQCE4");
const $316400a86e66613a$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $316400a86e66613a$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $dGBsa.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $316400a86e66613a$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $kz9aJ.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $kz9aJ.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $kY3Ke.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $kz9aJ.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $kY3Ke.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $kz9aJ.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $44Txg.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $kY3Ke.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $dGBsa.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $316400a86e66613a$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $316400a86e66613a$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $kz9aJ.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $kz9aJ.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $316400a86e66613a$var$useSynchronousEffect(func, values) {
    const key = $7fPBF.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $7fPBF.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $7fPBF.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $316400a86e66613a$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $cQCE4.default) } = options, stylesOptions2 = (0, $cFLic.default)(options, $316400a86e66613a$var$_excluded);
    const stylesCreator = (0, $lWzUV.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $cML5X.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $1iERc.default)() || defaultTheme;
        const stylesOptions = (0, $kY3Ke.default)({}, $7fPBF.useContext((0, $cRTRJ.StylesContext)), stylesOptions2);
        const instance = $7fPBF.useRef();
        const shouldUpdate = $7fPBF.useRef();
        $316400a86e66613a$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $316400a86e66613a$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $316400a86e66613a$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $7fPBF.useEffect(()=>{
            if (shouldUpdate.current) $316400a86e66613a$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $316400a86e66613a$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("44Txg", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $kY3Ke = parcelRequire("kY3Ke");

var $8RSXT = parcelRequire("8RSXT");

var $8knIu = parcelRequire("8knIu");

var $4OFm0 = parcelRequire("4OFm0");

var $1KLsX = parcelRequire("1KLsX");

var $3zeAJ = parcelRequire("3zeAJ");

var $cFLic = parcelRequire("cFLic");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1KLsX.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $3zeAJ.default)((0, $3zeAJ.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kY3Ke.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $4OFm0.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1KLsX.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kY3Ke.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $kY3Ke.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $kY3Ke.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $kY3Ke.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $cFLic.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $4OFm0.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $8RSXT.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $kY3Ke.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $kY3Ke.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $kY3Ke.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $8knIu.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $8knIu.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $4OFm0.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $2f829d591bf300a5$export$2e2bcd8739ae039 = index;

});
parcelRegister("8RSXT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674de8e403e00348$export$2e2bcd8739ae039; });
var $674de8e403e00348$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $674de8e403e00348$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $674de8e403e00348$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $674de8e403e00348$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $674de8e403e00348$export$2e2bcd8739ae039 = $674de8e403e00348$export$4e09c449d6c407f7;

});

parcelRegister("4OFm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381be8fad7784fe9$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $381be8fad7784fe9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aYCSV.default)(o.key), o);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(e, r, t) {
    return r && $381be8fad7784fe9$var$_defineProperties(e.prototype, r), t && $381be8fad7784fe9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("aYCSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fddabb4b045308c$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $3qCmf = parcelRequire("3qCmf");
function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $3qCmf.default)(t, "string");
    return "symbol" == (0, $6TO5S.default)(i) ? i : i + "";
}

});
parcelRegister("6TO5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $505ebcb184373782$export$2e2bcd8739ae039; });
function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3qCmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f18dd8fc16da3b$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");
function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6TO5S.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6TO5S.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("dGBsa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f6c400ddb67e2cb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

function $9f6c400ddb67e2cb$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $kY3Ke.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

});

parcelRegister("kz9aJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef8e30e4e21a1401$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $ef8e30e4e21a1401$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $ef8e30e4e21a1401$export$2e2bcd8739ae039 = $ef8e30e4e21a1401$var$multiKeyStore;

});

parcelRegister("1iERc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f272a3c386a8051$export$2e2bcd8739ae039; });

var $fC1zT = parcelRequire("fC1zT");
function $0f272a3c386a8051$export$2e2bcd8739ae039() {
    var _privateTheme$$$mater;
    const privateTheme = (0, $fC1zT.default)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}

});
parcelRegister("fC1zT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5dba0f0f3e50f8f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $gFfZb = parcelRequire("gFfZb");
function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $gFfZb.default));
    return theme;
}

});
parcelRegister("gFfZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c21ce0253dc11cd3$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;

});



parcelRegister("cRTRJ", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $95e5c5018bb7a43f$export$f4de434b269fe487; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $44Txg = parcelRequire("44Txg");

var $4Prns = parcelRequire("4Prns");

var $cCsjv = parcelRequire("cCsjv");

var $bbzbN = parcelRequire("bbzbN");
const $95e5c5018bb7a43f$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $95e5c5018bb7a43f$var$defaultJSS = (0, $44Txg.create)((0, $cCsjv.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $95e5c5018bb7a43f$var$defaultGenerateClassName = (0, $4Prns.default)();
const $95e5c5018bb7a43f$export$70a8aea9ff58d1cd = new Map();
const $95e5c5018bb7a43f$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $95e5c5018bb7a43f$var$defaultGenerateClassName,
    jss: $95e5c5018bb7a43f$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $95e5c5018bb7a43f$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $95e5c5018bb7a43f$export$f4de434b269fe487 = /*#__PURE__*/ $7fPBF.createContext($95e5c5018bb7a43f$var$defaultOptions);
let $95e5c5018bb7a43f$var$injectFirstNode;
function $95e5c5018bb7a43f$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $cFLic.default)(props, $95e5c5018bb7a43f$var$_excluded);
    const outerOptions = $7fPBF.useContext($95e5c5018bb7a43f$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $kY3Ke.default)({}, outerOptions, localOptions);
    const value = $7fPBF.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!$95e5c5018bb7a43f$var$injectFirstNode) {
                const head = document.head;
                $95e5c5018bb7a43f$var$injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore($95e5c5018bb7a43f$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $44Txg.create)({
                plugins: (0, $cCsjv.default)().plugins,
                insertionPoint: $95e5c5018bb7a43f$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($95e5c5018bb7a43f$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("4Prns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3841296ab5a480d6$export$2e2bcd8739ae039; });

var $3ax6g = parcelRequire("3ax6g");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $3841296ab5a480d6$var$stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function $3841296ab5a480d6$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = 'jss', seed: seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($3841296ab5a480d6$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $3ax6g.default] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}

});
parcelRegister("3ax6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24ebfb3bf89f6ffe$export$2e2bcd8739ae039; });
const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("cCsjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92feff2003b49ef6$export$2e2bcd8739ae039; });

var $hQ0MI = parcelRequire("hQ0MI");

var $iHUoJ = parcelRequire("iHUoJ");

var $2st1L = parcelRequire("2st1L");

var $8UI4A = parcelRequire("8UI4A");

var $HJOoC = parcelRequire("HJOoC");

var $k1ICi = parcelRequire("k1ICi");

var $ereeq = parcelRequire("ereeq");
function $92feff2003b49ef6$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $hQ0MI.default)(),
            (0, $iHUoJ.default)(),
            (0, $2st1L.default)(),
            (0, $8UI4A.default)(),
            (0, $HJOoC.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $k1ICi.default)(),
            (0, $ereeq.default)()
        ]
    };
}

});
parcelRegister("hQ0MI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc7e6da35572a9f$export$2e2bcd8739ae039; });


var $44Txg = parcelRequire("44Txg");
var $cfc7e6da35572a9f$var$now = Date.now();
var $cfc7e6da35572a9f$var$fnValuesNs = "fnValues" + $cfc7e6da35572a9f$var$now;
var $cfc7e6da35572a9f$var$fnRuleNs = "fnStyle" + ++$cfc7e6da35572a9f$var$now;
var $cfc7e6da35572a9f$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $44Txg.createRule)(name, {}, options);
            rule[$cfc7e6da35572a9f$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($cfc7e6da35572a9f$var$fnValuesNs in rule || $cfc7e6da35572a9f$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$cfc7e6da35572a9f$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$cfc7e6da35572a9f$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$cfc7e6da35572a9f$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $cfc7e6da35572a9f$export$2e2bcd8739ae039 = $cfc7e6da35572a9f$var$functionPlugin;

});

parcelRegister("iHUoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9e7fd9a87ac63d8$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $44Txg = parcelRequire("44Txg");
var $d9e7fd9a87ac63d8$var$at = '@global';
var $d9e7fd9a87ac63d8$var$atPrefix = '@global ';
var $d9e7fd9a87ac63d8$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $d9e7fd9a87ac63d8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $44Txg.RuleList)((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $d9e7fd9a87ac63d8$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $d9e7fd9a87ac63d8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($d9e7fd9a87ac63d8$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $kY3Ke.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $d9e7fd9a87ac63d8$var$separatorRegExp = /\s*,\s*/g;
function $d9e7fd9a87ac63d8$var$addScope(selector, scope) {
    var parts = selector.split($d9e7fd9a87ac63d8$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $d9e7fd9a87ac63d8$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$d9e7fd9a87ac63d8$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $kY3Ke.default)({}, options, {
        selector: $d9e7fd9a87ac63d8$var$addScope(name, rule.selector)
    }));
    delete style[$d9e7fd9a87ac63d8$var$at];
}
function $d9e7fd9a87ac63d8$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $d9e7fd9a87ac63d8$var$at.length) !== $d9e7fd9a87ac63d8$var$at) continue;
        var selector = $d9e7fd9a87ac63d8$var$addScope(prop.substr($d9e7fd9a87ac63d8$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $kY3Ke.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $d9e7fd9a87ac63d8$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $d9e7fd9a87ac63d8$var$at) return new $d9e7fd9a87ac63d8$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $d9e7fd9a87ac63d8$var$atPrefix.length) === $d9e7fd9a87ac63d8$var$atPrefix) return new $d9e7fd9a87ac63d8$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $d9e7fd9a87ac63d8$var$handleNestedGlobalContainerRule(rule, sheet);
        $d9e7fd9a87ac63d8$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $d9e7fd9a87ac63d8$export$2e2bcd8739ae039 = $d9e7fd9a87ac63d8$var$jssGlobal;

});

parcelRegister("2st1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca4b68b05337263$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $1ca4b68b05337263$var$separatorRegExp = /\s*,\s*/g;
var $1ca4b68b05337263$var$parentRegExp = /&/g;
var $1ca4b68b05337263$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1ca4b68b05337263$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($1ca4b68b05337263$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($1ca4b68b05337263$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($1ca4b68b05337263$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $kY3Ke.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $kY3Ke.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($1ca4b68b05337263$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $kY3Ke.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $kY3Ke.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $1ca4b68b05337263$export$2e2bcd8739ae039 = $1ca4b68b05337263$var$jssNested;

});

parcelRegister("8UI4A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67d5bda86214f661$export$2e2bcd8739ae039; });

var $2l6VF = parcelRequire("2l6VF");
/**
 * Convert camel cased property names to dash separated.
 */ function $67d5bda86214f661$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $2l6VF.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($67d5bda86214f661$var$convertCase);
        else converted.fallbacks = $67d5bda86214f661$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $67d5bda86214f661$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $67d5bda86214f661$var$convertCase(style[index]);
            return style;
        }
        return $67d5bda86214f661$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $2l6VF.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $67d5bda86214f661$export$2e2bcd8739ae039 = $67d5bda86214f661$var$camelCase;

});
parcelRegister("2l6VF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b42eaed349bc9b0$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $1b42eaed349bc9b0$var$uppercasePattern = /[A-Z]/g;
var $1b42eaed349bc9b0$var$msPattern = /^ms-/;
var $1b42eaed349bc9b0$var$cache = {};
function $1b42eaed349bc9b0$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $1b42eaed349bc9b0$var$hyphenateStyleName(name) {
    if ($1b42eaed349bc9b0$var$cache.hasOwnProperty(name)) return $1b42eaed349bc9b0$var$cache[name];
    var hName = name.replace($1b42eaed349bc9b0$var$uppercasePattern, $1b42eaed349bc9b0$var$toHyphenLower);
    return $1b42eaed349bc9b0$var$cache[name] = $1b42eaed349bc9b0$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $1b42eaed349bc9b0$export$2e2bcd8739ae039 = $1b42eaed349bc9b0$var$hyphenateStyleName;

});


parcelRegister("HJOoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08378d8b5b0526fb$export$2e2bcd8739ae039; });

var $44Txg = parcelRequire("44Txg");
var $08378d8b5b0526fb$var$px = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $08378d8b5b0526fb$var$ms = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $08378d8b5b0526fb$var$percent = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $08378d8b5b0526fb$var$defaultUnits = {
    // Animation properties
    'animation-delay': $08378d8b5b0526fb$var$ms,
    'animation-duration': $08378d8b5b0526fb$var$ms,
    // Background properties
    'background-position': $08378d8b5b0526fb$var$px,
    'background-position-x': $08378d8b5b0526fb$var$px,
    'background-position-y': $08378d8b5b0526fb$var$px,
    'background-size': $08378d8b5b0526fb$var$px,
    // Border Properties
    border: $08378d8b5b0526fb$var$px,
    'border-bottom': $08378d8b5b0526fb$var$px,
    'border-bottom-left-radius': $08378d8b5b0526fb$var$px,
    'border-bottom-right-radius': $08378d8b5b0526fb$var$px,
    'border-bottom-width': $08378d8b5b0526fb$var$px,
    'border-left': $08378d8b5b0526fb$var$px,
    'border-left-width': $08378d8b5b0526fb$var$px,
    'border-radius': $08378d8b5b0526fb$var$px,
    'border-right': $08378d8b5b0526fb$var$px,
    'border-right-width': $08378d8b5b0526fb$var$px,
    'border-top': $08378d8b5b0526fb$var$px,
    'border-top-left-radius': $08378d8b5b0526fb$var$px,
    'border-top-right-radius': $08378d8b5b0526fb$var$px,
    'border-top-width': $08378d8b5b0526fb$var$px,
    'border-width': $08378d8b5b0526fb$var$px,
    'border-block': $08378d8b5b0526fb$var$px,
    'border-block-end': $08378d8b5b0526fb$var$px,
    'border-block-end-width': $08378d8b5b0526fb$var$px,
    'border-block-start': $08378d8b5b0526fb$var$px,
    'border-block-start-width': $08378d8b5b0526fb$var$px,
    'border-block-width': $08378d8b5b0526fb$var$px,
    'border-inline': $08378d8b5b0526fb$var$px,
    'border-inline-end': $08378d8b5b0526fb$var$px,
    'border-inline-end-width': $08378d8b5b0526fb$var$px,
    'border-inline-start': $08378d8b5b0526fb$var$px,
    'border-inline-start-width': $08378d8b5b0526fb$var$px,
    'border-inline-width': $08378d8b5b0526fb$var$px,
    'border-start-start-radius': $08378d8b5b0526fb$var$px,
    'border-start-end-radius': $08378d8b5b0526fb$var$px,
    'border-end-start-radius': $08378d8b5b0526fb$var$px,
    'border-end-end-radius': $08378d8b5b0526fb$var$px,
    // Margin properties
    margin: $08378d8b5b0526fb$var$px,
    'margin-bottom': $08378d8b5b0526fb$var$px,
    'margin-left': $08378d8b5b0526fb$var$px,
    'margin-right': $08378d8b5b0526fb$var$px,
    'margin-top': $08378d8b5b0526fb$var$px,
    'margin-block': $08378d8b5b0526fb$var$px,
    'margin-block-end': $08378d8b5b0526fb$var$px,
    'margin-block-start': $08378d8b5b0526fb$var$px,
    'margin-inline': $08378d8b5b0526fb$var$px,
    'margin-inline-end': $08378d8b5b0526fb$var$px,
    'margin-inline-start': $08378d8b5b0526fb$var$px,
    // Padding properties
    padding: $08378d8b5b0526fb$var$px,
    'padding-bottom': $08378d8b5b0526fb$var$px,
    'padding-left': $08378d8b5b0526fb$var$px,
    'padding-right': $08378d8b5b0526fb$var$px,
    'padding-top': $08378d8b5b0526fb$var$px,
    'padding-block': $08378d8b5b0526fb$var$px,
    'padding-block-end': $08378d8b5b0526fb$var$px,
    'padding-block-start': $08378d8b5b0526fb$var$px,
    'padding-inline': $08378d8b5b0526fb$var$px,
    'padding-inline-end': $08378d8b5b0526fb$var$px,
    'padding-inline-start': $08378d8b5b0526fb$var$px,
    // Mask properties
    'mask-position-x': $08378d8b5b0526fb$var$px,
    'mask-position-y': $08378d8b5b0526fb$var$px,
    'mask-size': $08378d8b5b0526fb$var$px,
    // Width and height properties
    height: $08378d8b5b0526fb$var$px,
    width: $08378d8b5b0526fb$var$px,
    'min-height': $08378d8b5b0526fb$var$px,
    'max-height': $08378d8b5b0526fb$var$px,
    'min-width': $08378d8b5b0526fb$var$px,
    'max-width': $08378d8b5b0526fb$var$px,
    // Position properties
    bottom: $08378d8b5b0526fb$var$px,
    left: $08378d8b5b0526fb$var$px,
    top: $08378d8b5b0526fb$var$px,
    right: $08378d8b5b0526fb$var$px,
    inset: $08378d8b5b0526fb$var$px,
    'inset-block': $08378d8b5b0526fb$var$px,
    'inset-block-end': $08378d8b5b0526fb$var$px,
    'inset-block-start': $08378d8b5b0526fb$var$px,
    'inset-inline': $08378d8b5b0526fb$var$px,
    'inset-inline-end': $08378d8b5b0526fb$var$px,
    'inset-inline-start': $08378d8b5b0526fb$var$px,
    // Shadow properties
    'box-shadow': $08378d8b5b0526fb$var$px,
    'text-shadow': $08378d8b5b0526fb$var$px,
    // Column properties
    'column-gap': $08378d8b5b0526fb$var$px,
    'column-rule': $08378d8b5b0526fb$var$px,
    'column-rule-width': $08378d8b5b0526fb$var$px,
    'column-width': $08378d8b5b0526fb$var$px,
    // Font and text properties
    'font-size': $08378d8b5b0526fb$var$px,
    'font-size-delta': $08378d8b5b0526fb$var$px,
    'letter-spacing': $08378d8b5b0526fb$var$px,
    'text-decoration-thickness': $08378d8b5b0526fb$var$px,
    'text-indent': $08378d8b5b0526fb$var$px,
    'text-stroke': $08378d8b5b0526fb$var$px,
    'text-stroke-width': $08378d8b5b0526fb$var$px,
    'word-spacing': $08378d8b5b0526fb$var$px,
    // Motion properties
    motion: $08378d8b5b0526fb$var$px,
    'motion-offset': $08378d8b5b0526fb$var$px,
    // Outline properties
    outline: $08378d8b5b0526fb$var$px,
    'outline-offset': $08378d8b5b0526fb$var$px,
    'outline-width': $08378d8b5b0526fb$var$px,
    // Perspective properties
    perspective: $08378d8b5b0526fb$var$px,
    'perspective-origin-x': $08378d8b5b0526fb$var$percent,
    'perspective-origin-y': $08378d8b5b0526fb$var$percent,
    // Transform properties
    'transform-origin': $08378d8b5b0526fb$var$percent,
    'transform-origin-x': $08378d8b5b0526fb$var$percent,
    'transform-origin-y': $08378d8b5b0526fb$var$percent,
    'transform-origin-z': $08378d8b5b0526fb$var$percent,
    // Transition properties
    'transition-delay': $08378d8b5b0526fb$var$ms,
    'transition-duration': $08378d8b5b0526fb$var$ms,
    // Alignment properties
    'vertical-align': $08378d8b5b0526fb$var$px,
    'flex-basis': $08378d8b5b0526fb$var$px,
    // Some random properties
    'shape-margin': $08378d8b5b0526fb$var$px,
    size: $08378d8b5b0526fb$var$px,
    gap: $08378d8b5b0526fb$var$px,
    // Grid properties
    grid: $08378d8b5b0526fb$var$px,
    'grid-gap': $08378d8b5b0526fb$var$px,
    'row-gap': $08378d8b5b0526fb$var$px,
    'grid-row-gap': $08378d8b5b0526fb$var$px,
    'grid-column-gap': $08378d8b5b0526fb$var$px,
    'grid-template-rows': $08378d8b5b0526fb$var$px,
    'grid-template-columns': $08378d8b5b0526fb$var$px,
    'grid-auto-rows': $08378d8b5b0526fb$var$px,
    'grid-auto-columns': $08378d8b5b0526fb$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $08378d8b5b0526fb$var$px,
    'box-shadow-y': $08378d8b5b0526fb$var$px,
    'box-shadow-blur': $08378d8b5b0526fb$var$px,
    'box-shadow-spread': $08378d8b5b0526fb$var$px,
    'font-line-height': $08378d8b5b0526fb$var$px,
    'text-shadow-x': $08378d8b5b0526fb$var$px,
    'text-shadow-y': $08378d8b5b0526fb$var$px,
    'text-shadow-blur': $08378d8b5b0526fb$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $08378d8b5b0526fb$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $08378d8b5b0526fb$var$units = $08378d8b5b0526fb$var$addCamelCasedVersion($08378d8b5b0526fb$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $08378d8b5b0526fb$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $08378d8b5b0526fb$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $08378d8b5b0526fb$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $08378d8b5b0526fb$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $08378d8b5b0526fb$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $08378d8b5b0526fb$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $08378d8b5b0526fb$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $08378d8b5b0526fb$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $08378d8b5b0526fb$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $08378d8b5b0526fb$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $08378d8b5b0526fb$export$2e2bcd8739ae039 = $08378d8b5b0526fb$var$defaultUnit;

});

parcelRegister("k1ICi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9468291f7d3e685$export$2e2bcd8739ae039; });

var $8Ne5j = parcelRequire("8Ne5j");

var $44Txg = parcelRequire("44Txg");
/**
 * Add vendor prefix to a property name when needed.
 */ function $e9468291f7d3e685$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $8Ne5j.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $8Ne5j.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $8Ne5j.supportedValue)(supportedProp, (0, $44Txg.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $8Ne5j.supportedValue)(prop, (0, $44Txg.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $e9468291f7d3e685$export$2e2bcd8739ae039 = $e9468291f7d3e685$var$jssVendorPrefixer;

});
parcelRegister("8Ne5j", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $666dd33fa502ad5d$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $666dd33fa502ad5d$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $666dd33fa502ad5d$export$511766124059c277; });

var $8RSXT = parcelRequire("8RSXT");

var $cwJVy = parcelRequire("cwJVy");
// Export javascript style and css style vendor prefixes.
var $666dd33fa502ad5d$var$js = '';
var $666dd33fa502ad5d$var$css = '';
var $666dd33fa502ad5d$var$vendor = '';
var $666dd33fa502ad5d$var$browser = '';
var $666dd33fa502ad5d$var$isTouch = (0, $8RSXT.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $8RSXT.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $666dd33fa502ad5d$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $666dd33fa502ad5d$var$_document$createEleme = document.createElement('p'), $666dd33fa502ad5d$var$style = $666dd33fa502ad5d$var$_document$createEleme.style;
    var $666dd33fa502ad5d$var$testProp = 'Transform';
    for(var $666dd33fa502ad5d$var$key in $666dd33fa502ad5d$var$jsCssMap)if ($666dd33fa502ad5d$var$key + $666dd33fa502ad5d$var$testProp in $666dd33fa502ad5d$var$style) {
        $666dd33fa502ad5d$var$js = $666dd33fa502ad5d$var$key;
        $666dd33fa502ad5d$var$css = $666dd33fa502ad5d$var$jsCssMap[$666dd33fa502ad5d$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($666dd33fa502ad5d$var$js === 'Webkit' && 'msHyphens' in $666dd33fa502ad5d$var$style) {
        $666dd33fa502ad5d$var$js = 'ms';
        $666dd33fa502ad5d$var$css = $666dd33fa502ad5d$var$jsCssMap.ms;
        $666dd33fa502ad5d$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($666dd33fa502ad5d$var$js === 'Webkit' && '-apple-trailing-word' in $666dd33fa502ad5d$var$style) $666dd33fa502ad5d$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $666dd33fa502ad5d$export$82e9f45cca5ba907 = {
    js: $666dd33fa502ad5d$var$js,
    css: $666dd33fa502ad5d$var$css,
    vendor: $666dd33fa502ad5d$var$vendor,
    browser: $666dd33fa502ad5d$var$browser,
    isTouch: $666dd33fa502ad5d$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $666dd33fa502ad5d$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $666dd33fa502ad5d$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $666dd33fa502ad5d$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $666dd33fa502ad5d$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$camelize(str) {
    return str.replace($666dd33fa502ad5d$var$regExp, $666dd33fa502ad5d$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$pascalize(str) {
    return $666dd33fa502ad5d$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $666dd33fa502ad5d$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($666dd33fa502ad5d$var$camelize(longhand) in style) return prop;
            if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(longhand) in style) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $666dd33fa502ad5d$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.vendor === 'apple' && !$666dd33fa502ad5d$export$82e9f45cca5ba907.isTouch) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $666dd33fa502ad5d$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $666dd33fa502ad5d$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $666dd33fa502ad5d$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit' || $666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms' && $666dd33fa502ad5d$export$82e9f45cca5ba907.browser !== 'edge') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $666dd33fa502ad5d$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz' || $666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms' || $666dd33fa502ad5d$export$82e9f45cca5ba907.vendor === 'apple') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $666dd33fa502ad5d$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $666dd33fa502ad5d$var$pascalize(prop);
            return jsProp in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $666dd33fa502ad5d$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $666dd33fa502ad5d$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $666dd33fa502ad5d$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $666dd33fa502ad5d$var$camelize(prop) in style ? prop : false;
    }
};
var $666dd33fa502ad5d$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $666dd33fa502ad5d$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js + pascalized in style) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $666dd33fa502ad5d$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return "" + $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $666dd33fa502ad5d$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $666dd33fa502ad5d$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $666dd33fa502ad5d$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $666dd33fa502ad5d$var$propMap[prop];
        if (!newProp) return false;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $666dd33fa502ad5d$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $666dd33fa502ad5d$var$propKeys = Object.keys($666dd33fa502ad5d$var$propMap$1);
var $666dd33fa502ad5d$var$prefixCss = function prefixCss(p) {
    return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $666dd33fa502ad5d$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($666dd33fa502ad5d$var$propKeys.indexOf(prop) > -1) {
            var newProp = $666dd33fa502ad5d$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($666dd33fa502ad5d$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $666dd33fa502ad5d$var$plugins = [
    $666dd33fa502ad5d$var$appearence,
    $666dd33fa502ad5d$var$colorAdjust,
    $666dd33fa502ad5d$var$mask,
    $666dd33fa502ad5d$var$textOrientation,
    $666dd33fa502ad5d$var$transform,
    $666dd33fa502ad5d$var$transition,
    $666dd33fa502ad5d$var$writingMode,
    $666dd33fa502ad5d$var$userSelect,
    $666dd33fa502ad5d$var$breakPropsOld,
    $666dd33fa502ad5d$var$inlineLogicalOld,
    $666dd33fa502ad5d$var$unprefixed,
    $666dd33fa502ad5d$var$prefixed,
    $666dd33fa502ad5d$var$scrollSnap,
    $666dd33fa502ad5d$var$overscrollBehavior,
    $666dd33fa502ad5d$var$flex2012,
    $666dd33fa502ad5d$var$flex2009
];
var $666dd33fa502ad5d$var$propertyDetectors = $666dd33fa502ad5d$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $666dd33fa502ad5d$var$noPrefill = $666dd33fa502ad5d$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $cwJVy.default)(p.noPrefill));
    return a;
}, []);
var $666dd33fa502ad5d$var$el;
var $666dd33fa502ad5d$var$cache = {};
if (0, $8RSXT.default) {
    $666dd33fa502ad5d$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $666dd33fa502ad5d$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $666dd33fa502ad5d$var$key$1 in $666dd33fa502ad5d$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($666dd33fa502ad5d$var$key$1)) $666dd33fa502ad5d$var$cache[$666dd33fa502ad5d$var$computed[$666dd33fa502ad5d$var$key$1]] = $666dd33fa502ad5d$var$computed[$666dd33fa502ad5d$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $666dd33fa502ad5d$var$noPrefill.forEach(function(x) {
        return delete $666dd33fa502ad5d$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $666dd33fa502ad5d$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$666dd33fa502ad5d$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($666dd33fa502ad5d$var$cache[prop] != null) return $666dd33fa502ad5d$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $666dd33fa502ad5d$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $666dd33fa502ad5d$var$propertyDetectors.length; i++){
        $666dd33fa502ad5d$var$cache[prop] = $666dd33fa502ad5d$var$propertyDetectors[i](prop, $666dd33fa502ad5d$var$el.style, options); // Break loop, if value found.
        if ($666dd33fa502ad5d$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $666dd33fa502ad5d$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $666dd33fa502ad5d$var$cache[prop];
}
var $666dd33fa502ad5d$var$cache$1 = {};
var $666dd33fa502ad5d$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $666dd33fa502ad5d$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $666dd33fa502ad5d$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $666dd33fa502ad5d$export$ce097f82c2e4551a(p1) : ", " + $666dd33fa502ad5d$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $8RSXT.default) $666dd33fa502ad5d$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $666dd33fa502ad5d$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$666dd33fa502ad5d$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($666dd33fa502ad5d$var$cache$1[cacheKey] != null) return $666dd33fa502ad5d$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $666dd33fa502ad5d$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $666dd33fa502ad5d$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($666dd33fa502ad5d$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($666dd33fa502ad5d$var$transPropsRegExp, $666dd33fa502ad5d$var$prefixTransitionCallback);
    else if ($666dd33fa502ad5d$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $666dd33fa502ad5d$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $666dd33fa502ad5d$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($666dd33fa502ad5d$var$el$1.style[property] === '') {
            $666dd33fa502ad5d$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $666dd33fa502ad5d$var$el$1.style[property] = ''; // Write current value to cache.
    $666dd33fa502ad5d$var$cache$1[cacheKey] = prefixedValue;
    return $666dd33fa502ad5d$var$cache$1[cacheKey];
}

});
parcelRegister("cwJVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ec1961173e898a$export$2e2bcd8739ae039; });

var $hogKY = parcelRequire("hogKY");

var $1DcFf = parcelRequire("1DcFf");

var $6A22e = parcelRequire("6A22e");

var $aqkvt = parcelRequire("aqkvt");
function $91ec1961173e898a$export$2e2bcd8739ae039(r) {
    return (0, $hogKY.default)(r) || (0, $1DcFf.default)(r) || (0, $6A22e.default)(r) || (0, $aqkvt.default)();
}

});
parcelRegister("hogKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca91ad18e54285de$export$2e2bcd8739ae039; });

var $9A91F = parcelRequire("9A91F");
function $ca91ad18e54285de$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9A91F.default)(r);
}

});
parcelRegister("9A91F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9e7a38a1550ef5$export$2e2bcd8739ae039; });
function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1DcFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130341d5473c4bb5$export$2e2bcd8739ae039; });
function $130341d5473c4bb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6A22e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca7aef5b7b26ccf$export$2e2bcd8739ae039; });

var $9A91F = parcelRequire("9A91F");
function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9A91F.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9A91F.default)(r, a) : void 0;
    }
}

});

parcelRegister("aqkvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $796c3d48dfd34a55$export$2e2bcd8739ae039; });
function $796c3d48dfd34a55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("ereeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a82ea068e11a8bb7$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $a82ea068e11a8bb7$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $a82ea068e11a8bb7$export$2e2bcd8739ae039 = $a82ea068e11a8bb7$var$jssPropsSort;

});



parcelRegister("cML5X", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $94ee7fd859f0a74a$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $94ee7fd859f0a74a$var$indexCounter = -1000000000;
function $94ee7fd859f0a74a$export$a2647aa13413c947() {
    $94ee7fd859f0a74a$var$indexCounter += 1;
    return $94ee7fd859f0a74a$var$indexCounter;
}

});

parcelRegister("lWzUV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff9ae02a07a34750$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $3wRTY = parcelRequire("3wRTY");

var $3A9pH = parcelRequire("3A9pH");

function $ff9ae02a07a34750$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $kY3Ke.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $3wRTY.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $3A9pH.default)(definition.props);
                stylesWithOverrides[classKey] = (0, $3wRTY.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("3A9pH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29bc09328aab4d1d$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $iCiVn = parcelRequire("iCiVn");
const $29bc09328aab4d1d$var$_excluded = [
    "variant"
];
function $29bc09328aab4d1d$var$isEmpty(string) {
    return string.length === 0;
}
function $29bc09328aab4d1d$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $cFLic.default)(props, $29bc09328aab4d1d$var$_excluded);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $29bc09328aab4d1d$var$isEmpty(classKey) ? props[key] : (0, $iCiVn.default)(props[key]);
        else classKey += `${$29bc09328aab4d1d$var$isEmpty(classKey) ? key : (0, $iCiVn.default)(key)}${(0, $iCiVn.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRegister("cQCE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95a85185fc312138$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
const $95a85185fc312138$var$noopTheme = {};
var $95a85185fc312138$export$2e2bcd8739ae039 = $95a85185fc312138$var$noopTheme;

});


parcelRegister("itmb4", function(module, exports) {

$parcel$export(module.exports, "BarController", function () { return $f600c28388caa19c$export$e97d5dc64e999004; });
$parcel$export(module.exports, "BubbleController", function () { return $f600c28388caa19c$export$19b5c4773f17abe; });
$parcel$export(module.exports, "DoughnutController", function () { return $f600c28388caa19c$export$e04603e7d8b77172; });
$parcel$export(module.exports, "LineController", function () { return $f600c28388caa19c$export$3c9b5d28c11cbfd0; });
$parcel$export(module.exports, "PolarAreaController", function () { return $f600c28388caa19c$export$2a270b3a0d973c85; });
$parcel$export(module.exports, "PieController", function () { return $f600c28388caa19c$export$b21a3f1286706191; });
$parcel$export(module.exports, "RadarController", function () { return $f600c28388caa19c$export$48dbc6ac651bf8be; });
$parcel$export(module.exports, "ScatterController", function () { return $f600c28388caa19c$export$b2f2bae6713db87; });
$parcel$export(module.exports, "Chart", function () { return $f600c28388caa19c$export$acaa6426d77a227e; });
$parcel$export(module.exports, "ArcElement", function () { return $f600c28388caa19c$export$d48203c759d6a1fc; });
$parcel$export(module.exports, "LineElement", function () { return $f600c28388caa19c$export$55e463fa7bcd3469; });
$parcel$export(module.exports, "PointElement", function () { return $f600c28388caa19c$export$bd159b522b230b7a; });
$parcel$export(module.exports, "BarElement", function () { return $f600c28388caa19c$export$a16ed71bf4b07672; });
$parcel$export(module.exports, "Filler", function () { return $f600c28388caa19c$export$d19ba4d812bed757; });
$parcel$export(module.exports, "Legend", function () { return $f600c28388caa19c$export$ed247974535929c7; });
$parcel$export(module.exports, "Title", function () { return $f600c28388caa19c$export$f99233281efd08a0; });
$parcel$export(module.exports, "Tooltip", function () { return $f600c28388caa19c$export$28c660c63b792dea; });
$parcel$export(module.exports, "CategoryScale", function () { return $f600c28388caa19c$export$29e663ba4d09fe7; });
$parcel$export(module.exports, "LinearScale", function () { return $f600c28388caa19c$export$e7f4e5e8656f0b93; });
$parcel$export(module.exports, "RadialLinearScale", function () { return $f600c28388caa19c$export$cfafc36d95386d38; });
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $6bgWD = parcelRequire("6bgWD");
class $f600c28388caa19c$var$Animator {
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $6bgWD.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
}
var $f600c28388caa19c$export$a424a0aa8f687495 = new $f600c28388caa19c$var$Animator();
const $f600c28388caa19c$var$transparent = 'transparent';
const $f600c28388caa19c$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $6bgWD.c)(from || $f600c28388caa19c$var$transparent);
        const c1 = c0.valid && (0, $6bgWD.c)(to || $f600c28388caa19c$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $f600c28388caa19c$export$c35d437ae5945fcd {
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $6bgWD.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $6bgWD.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $6bgWD.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $6bgWD.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $f600c28388caa19c$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $6bgWD.e)[cfg.easing] || (0, $6bgWD.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
}
const $f600c28388caa19c$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $f600c28388caa19c$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
(0, $6bgWD.d).set('animation', {
    delay: undefined,
    duration: 1000,
    easing: 'easeOutQuart',
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $f600c28388caa19c$var$animationOptions = Object.keys((0, $6bgWD.d).animation);
(0, $6bgWD.d).describe('animation', {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
});
(0, $6bgWD.d).set('animations', {
    colors: {
        type: 'color',
        properties: $f600c28388caa19c$var$colors
    },
    numbers: {
        type: 'number',
        properties: $f600c28388caa19c$var$numbers
    }
});
(0, $6bgWD.d).describe('animations', {
    _fallback: 'animation'
});
(0, $6bgWD.d).set('transitions', {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: 'transparent'
            },
            visible: {
                type: 'boolean',
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: 'transparent'
            },
            visible: {
                type: 'boolean',
                easing: 'linear',
                fn: (v)=>v | 0
            }
        }
    }
});
class $f600c28388caa19c$export$8ab227dac26677d {
    configure(config) {
        if (!(0, $6bgWD.i)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $6bgWD.i)(cfg)) return;
            const resolved = {};
            for (const option of $f600c28388caa19c$var$animationOptions)resolved[option] = cfg[option];
            ((0, $6bgWD.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $f600c28388caa19c$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $f600c28388caa19c$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $f600c28388caa19c$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $f600c28388caa19c$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
}
function $f600c28388caa19c$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $f600c28388caa19c$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $f600c28388caa19c$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $f600c28388caa19c$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $f600c28388caa19c$var$scaleClip(xScale, allowedOverflow);
    const y = $f600c28388caa19c$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $f600c28388caa19c$var$toClip(value) {
    let t, r, b, l;
    if ((0, $6bgWD.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $f600c28388caa19c$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $f600c28388caa19c$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $6bgWD.g)(otherValue) && (singleMode || value === 0 || (0, $6bgWD.s)(value) === (0, $6bgWD.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $f600c28388caa19c$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $f600c28388caa19c$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $f600c28388caa19c$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $f600c28388caa19c$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $f600c28388caa19c$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $f600c28388caa19c$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $f600c28388caa19c$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $f600c28388caa19c$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $f600c28388caa19c$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $f600c28388caa19c$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $f600c28388caa19c$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $f600c28388caa19c$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $f600c28388caa19c$var$createDatasetContext(parent, index) {
    return (0, $6bgWD.h)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $f600c28388caa19c$var$createDataContext(parent, index, element) {
    return (0, $6bgWD.h)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $f600c28388caa19c$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $f600c28388caa19c$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $f600c28388caa19c$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $f600c28388caa19c$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $f600c28388caa19c$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $f600c28388caa19c$export$75572ec5c55b4048 {
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $f600c28388caa19c$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $f600c28388caa19c$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $6bgWD.v)(dataset.xAxisID, $f600c28388caa19c$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $6bgWD.v)(dataset.yAxisID, $f600c28388caa19c$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $6bgWD.v)(dataset.rAxisID, $f600c28388caa19c$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $6bgWD.u)(this._data, this);
        if (meta._stacked) $f600c28388caa19c$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $6bgWD.i)(data)) this._data = $f600c28388caa19c$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $6bgWD.u)(_data, this);
                const meta = this._cachedMeta;
                $f600c28388caa19c$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $6bgWD.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $f600c28388caa19c$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $f600c28388caa19c$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $f600c28388caa19c$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $6bgWD.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $6bgWD.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $f600c28388caa19c$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $6bgWD.f)(item, xAxisKey), index),
                y: yScale.parse((0, $6bgWD.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $f600c28388caa19c$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $f600c28388caa19c$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $f600c28388caa19c$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $f600c28388caa19c$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $f600c28388caa19c$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $6bgWD.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $6bgWD.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $f600c28388caa19c$var$toClip((0, $6bgWD.v)(this.options.clip, $f600c28388caa19c$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $f600c28388caa19c$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $f600c28388caa19c$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $6bgWD.j)(index);
        if (cached) return $f600c28388caa19c$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $6bgWD.d).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($f600c28388caa19c$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $f600c28388caa19c$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $f600c28388caa19c$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($f600c28388caa19c$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$f600c28388caa19c$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $f600c28388caa19c$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
}
$f600c28388caa19c$export$75572ec5c55b4048.defaults = {};
$f600c28388caa19c$export$75572ec5c55b4048.prototype.datasetElementType = null;
$f600c28388caa19c$export$75572ec5c55b4048.prototype.dataElementType = null;
function $f600c28388caa19c$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $6bgWD._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $f600c28388caa19c$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $f600c28388caa19c$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $6bgWD.j)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $f600c28388caa19c$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $6bgWD.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $f600c28388caa19c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $f600c28388caa19c$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $f600c28388caa19c$var$parseValue(entry, item, vScale, i) {
    if ((0, $6bgWD.b)(entry)) $f600c28388caa19c$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $f600c28388caa19c$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($f600c28388caa19c$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $f600c28388caa19c$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $f600c28388caa19c$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $6bgWD.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $f600c28388caa19c$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $f600c28388caa19c$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $f600c28388caa19c$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$f600c28388caa19c$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$f600c28388caa19c$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $f600c28388caa19c$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $f600c28388caa19c$var$swap(edge, a, b);
        edge = $f600c28388caa19c$var$startEnd(edge, b, a);
    } else edge = $f600c28388caa19c$var$startEnd(edge, a, b);
    return edge;
}
function $f600c28388caa19c$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $f600c28388caa19c$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $f600c28388caa19c$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $f600c28388caa19c$export$e97d5dc64e999004 extends $f600c28388caa19c$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $f600c28388caa19c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $f600c28388caa19c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $6bgWD.f)(obj, iAxisKey), i);
            parsed.push($f600c28388caa19c$var$parseValue((0, $6bgWD.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $f600c28388caa19c$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $6bgWD.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $f600c28388caa19c$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $f600c28388caa19c$var$setBorderSkipped(properties, options, stack, index);
            $f600c28388caa19c$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $6bgWD.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $f600c28388caa19c$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $f600c28388caa19c$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $6bgWD.s)(value) !== (0, $6bgWD.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $6bgWD.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $f600c28388caa19c$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $6bgWD.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $6bgWD.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $f600c28388caa19c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $f600c28388caa19c$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$f600c28388caa19c$export$e97d5dc64e999004.id = 'bar';
$f600c28388caa19c$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'base',
                'width',
                'height'
            ]
        }
    }
};
$f600c28388caa19c$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: 'category',
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: 'linear',
            beginAtZero: true
        }
    }
};
class $f600c28388caa19c$export$19b5c4773f17abe extends $f600c28388caa19c$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $6bgWD.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $6bgWD.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $6bgWD.v)(parsed && parsed._custom, radius);
        return values;
    }
}
$f600c28388caa19c$export$19b5c4773f17abe.id = 'bubble';
$f600c28388caa19c$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: 'point',
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'borderWidth',
                'radius'
            ]
        }
    }
};
$f600c28388caa19c$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return '';
                }
            }
        }
    }
};
function $f600c28388caa19c$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $6bgWD.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $6bgWD.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $6bgWD.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $6bgWD.H), startY, endY);
        const minX = calcMin((0, $6bgWD.P), startX, endX);
        const minY = calcMin((0, $6bgWD.P) + (0, $6bgWD.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $f600c28388caa19c$export$e04603e7d8b77172 extends $f600c28388caa19c$export$75572ec5c55b4048 {
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $6bgWD.i)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $6bgWD.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $6bgWD.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $6bgWD.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $6bgWD.T);
        let max = -(0, $6bgWD.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $6bgWD.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $f600c28388caa19c$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $6bgWD.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $6bgWD.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $6bgWD.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $6bgWD.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $6bgWD.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
}
$f600c28388caa19c$export$e04603e7d8b77172.id = 'doughnut';
$f600c28388caa19c$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'circumference',
                'endAngle',
                'innerRadius',
                'outerRadius',
                'startAngle',
                'x',
                'y',
                'offset',
                'borderWidth',
                'spacing'
            ]
        }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
};
$f600c28388caa19c$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== 'spacing',
    _indexable: (name)=>name !== 'spacing'
};
$f600c28388caa19c$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ': ' + tooltipItem.formattedValue;
                    if ((0, $6bgWD.b)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $f600c28388caa19c$export$3c9b5d28c11cbfd0 extends $f600c28388caa19c$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $6bgWD.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $6bgWD.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $6bgWD.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $6bgWD.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$f600c28388caa19c$export$3c9b5d28c11cbfd0.id = 'line';
$f600c28388caa19c$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
};
$f600c28388caa19c$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: 'category'
        },
        _value_: {
            type: 'linear'
        }
    }
};
class $f600c28388caa19c$export$2a270b3a0d973c85 extends $f600c28388caa19c$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $6bgWD.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $6bgWD.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $6bgWD.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $6bgWD.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
}
$f600c28388caa19c$export$2a270b3a0d973c85.id = 'polarArea';
$f600c28388caa19c$export$2a270b3a0d973c85.defaults = {
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'startAngle',
                'endAngle',
                'innerRadius',
                'outerRadius'
            ]
        }
    },
    indexAxis: 'r',
    startAngle: 0
};
$f600c28388caa19c$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ': ' + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $f600c28388caa19c$export$b21a3f1286706191 extends $f600c28388caa19c$export$e04603e7d8b77172 {
}
$f600c28388caa19c$export$b21a3f1286706191.id = 'pie';
$f600c28388caa19c$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: '100%'
};
class $f600c28388caa19c$export$48dbc6ac651bf8be extends $f600c28388caa19c$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $6bgWD.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$f600c28388caa19c$export$48dbc6ac651bf8be.id = 'radar';
$f600c28388caa19c$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: 'line',
    dataElementType: 'point',
    indexAxis: 'r',
    showLine: true,
    elements: {
        line: {
            fill: 'start'
        }
    }
};
$f600c28388caa19c$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: 'radialLinear'
        }
    }
};
class $f600c28388caa19c$export$db77ccec0bb4ccac {
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $6bgWD.x)(this.x) && (0, $6bgWD.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
}
$f600c28388caa19c$export$db77ccec0bb4ccac.defaults = {};
$f600c28388caa19c$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $f600c28388caa19c$var$formatters = {
    values (value) {
        return (0, $6bgWD.b)(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $f600c28388caa19c$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $6bgWD.z)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $6bgWD.o)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = tickValue / Math.pow(10, Math.floor((0, $6bgWD.z)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $f600c28388caa19c$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $f600c28388caa19c$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $f600c28388caa19c$export$27c7467594ef87bd = {
    formatters: $f600c28388caa19c$var$formatters
};
(0, $6bgWD.d).set('scale', {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: 'ticks',
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: '',
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: '',
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $f600c28388caa19c$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: 'center',
        crossAlign: 'near',
        showLabelBackdrop: false,
        backdropColor: 'rgba(255, 255, 255, 0.75)',
        backdropPadding: 2
    }
});
(0, $6bgWD.d).route('scale.ticks', 'color', '', 'color');
(0, $6bgWD.d).route('scale.grid', 'color', '', 'borderColor');
(0, $6bgWD.d).route('scale.grid', 'borderColor', '', 'borderColor');
(0, $6bgWD.d).route('scale.title', 'color', '', 'color');
(0, $6bgWD.d).describe('scale', {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
    _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash'
});
(0, $6bgWD.d).describe('scales', {
    _fallback: 'scale'
});
(0, $6bgWD.d).describe('scale.ticks', {
    _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
    _indexable: (name)=>name !== 'backdropPadding'
});
function $f600c28388caa19c$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $f600c28388caa19c$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $f600c28388caa19c$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $f600c28388caa19c$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $f600c28388caa19c$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $f600c28388caa19c$var$skip(ticks, newTicks, spacing, (0, $6bgWD.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$f600c28388caa19c$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $f600c28388caa19c$var$skip(ticks, newTicks, spacing, last, (0, $6bgWD.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $f600c28388caa19c$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $f600c28388caa19c$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $f600c28388caa19c$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $f600c28388caa19c$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $6bgWD.A)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $f600c28388caa19c$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $f600c28388caa19c$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $f600c28388caa19c$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $6bgWD.v)(majorStart, 0);
    const end = Math.min((0, $6bgWD.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $f600c28388caa19c$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $f600c28388caa19c$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $f600c28388caa19c$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
function $f600c28388caa19c$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $f600c28388caa19c$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $f600c28388caa19c$var$garbageCollect(caches, length) {
    (0, $6bgWD.Q)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $f600c28388caa19c$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $f600c28388caa19c$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $6bgWD.O)(options.font, fallback);
    const padding = (0, $6bgWD.K)(options.padding);
    const lines = (0, $6bgWD.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $f600c28388caa19c$var$createScaleContext(parent, scale) {
    return (0, $6bgWD.h)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $f600c28388caa19c$var$createTickContext(parent, index, tick) {
    return (0, $6bgWD.h)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $f600c28388caa19c$var$titleAlign(align, position, reverse) {
    let ret = (0, $6bgWD.R)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $f600c28388caa19c$var$reverseAlign(ret);
    return ret;
}
function $f600c28388caa19c$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $6bgWD.S)(align, left, right);
        if ((0, $6bgWD.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $f600c28388caa19c$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $6bgWD.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $f600c28388caa19c$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $6bgWD.S)(align, bottom, top);
        rotation = position === 'left' ? -(0, $6bgWD.H) : (0, $6bgWD.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $f600c28388caa19c$export$d60cfc58d3c358b6 extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $6bgWD.B)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $6bgWD.B)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $6bgWD.B)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $6bgWD.B)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $6bgWD.B)(_userMin, _suggestedMin),
            max: (0, $6bgWD.B)(_userMax, _suggestedMax),
            minDefined: (0, $6bgWD.g)(_userMin),
            maxDefined: (0, $6bgWD.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $6bgWD.B)(min, (0, $6bgWD.B)(max, min)),
            max: (0, $6bgWD.B)(max, (0, $6bgWD.B)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $6bgWD.C)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $6bgWD.D)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $f600c28388caa19c$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $f600c28388caa19c$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $6bgWD.C)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $6bgWD.C)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $6bgWD.C)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $6bgWD.C)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $6bgWD.C)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $6bgWD.C)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $6bgWD.C)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $6bgWD.C)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $6bgWD.E)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $f600c28388caa19c$var$getTickMarkLength(options.grid) - tickOpts.padding - $f600c28388caa19c$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $6bgWD.F)(Math.min(Math.asin((0, $6bgWD.E)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $6bgWD.E)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $6bgWD.E)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $6bgWD.C)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $6bgWD.C)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $f600c28388caa19c$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $f600c28388caa19c$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $f600c28388caa19c$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $6bgWD.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $6bgWD.C)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $6bgWD.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $f600c28388caa19c$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $6bgWD.k)(label) && !(0, $6bgWD.b)(label)) {
                width = (0, $6bgWD.G)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $6bgWD.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $6bgWD.k)(nestedLabel) && !(0, $6bgWD.b)(nestedLabel)) {
                    width = (0, $6bgWD.G)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $f600c28388caa19c$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $6bgWD.I)(this._alignToPixels ? (0, $6bgWD.J)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $f600c28388caa19c$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $f600c28388caa19c$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $6bgWD.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $f600c28388caa19c$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $6bgWD.J)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $6bgWD.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $6bgWD.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $6bgWD.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $f600c28388caa19c$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $6bgWD.J)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $f600c28388caa19c$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $6bgWD.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $6bgWD.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $6bgWD.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $6bgWD.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $6bgWD.K)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $6bgWD.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $6bgWD.J)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $6bgWD.J)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $6bgWD.J)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $6bgWD.J)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $6bgWD.L)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $6bgWD.M)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $6bgWD.N)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $6bgWD.O)(title.font);
        const padding = (0, $6bgWD.K)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $6bgWD.i)(position)) {
            offset += padding.bottom;
            if ((0, $6bgWD.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $f600c28388caa19c$var$titleArgs(this, offset, position, align);
        (0, $6bgWD.M)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $f600c28388caa19c$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $6bgWD.v)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $f600c28388caa19c$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $6bgWD.O)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
}
class $f600c28388caa19c$var$TypedRegistry {
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($f600c28388caa19c$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $f600c28388caa19c$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $6bgWD.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $6bgWD.d)[scope]) {
            delete (0, $6bgWD.d)[scope][id];
            if (this.override) delete (0, $6bgWD.U)[id];
        }
    }
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
}
function $f600c28388caa19c$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $6bgWD.V)(Object.create(null), [
        parentScope ? (0, $6bgWD.d).get(parentScope) : {},
        (0, $6bgWD.d).get(scope),
        item.defaults
    ]);
    (0, $6bgWD.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $f600c28388caa19c$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $6bgWD.d).describe(scope, item.descriptors);
}
function $f600c28388caa19c$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $6bgWD.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $f600c28388caa19c$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $f600c28388caa19c$var$Registry {
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $6bgWD.Q)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $6bgWD.W)(method);
        (0, $6bgWD.C)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $6bgWD.C)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
    constructor(){
        this.controllers = new $f600c28388caa19c$var$TypedRegistry($f600c28388caa19c$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $f600c28388caa19c$var$TypedRegistry($f600c28388caa19c$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $f600c28388caa19c$var$TypedRegistry(Object, 'plugins');
        this.scales = new $f600c28388caa19c$var$TypedRegistry($f600c28388caa19c$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
}
var $f600c28388caa19c$export$4bb7493d241fd8a5 = new $f600c28388caa19c$var$Registry();
class $f600c28388caa19c$export$b2f2bae6713db87 extends $f600c28388caa19c$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $6bgWD.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $6bgWD.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $f600c28388caa19c$export$4bb7493d241fd8a5.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $6bgWD.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $6bgWD.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$f600c28388caa19c$export$b2f2bae6713db87.id = 'scatter';
$f600c28388caa19c$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: 'point',
    showLine: false,
    fill: false
};
$f600c28388caa19c$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: 'point'
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return '';
                },
                label (item) {
                    return '(' + item.label + ', ' + item.formattedValue + ')';
                }
            }
        }
    },
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
};
var $f600c28388caa19c$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $f600c28388caa19c$export$e97d5dc64e999004,
    BubbleController: $f600c28388caa19c$export$19b5c4773f17abe,
    DoughnutController: $f600c28388caa19c$export$e04603e7d8b77172,
    LineController: $f600c28388caa19c$export$3c9b5d28c11cbfd0,
    PolarAreaController: $f600c28388caa19c$export$2a270b3a0d973c85,
    PieController: $f600c28388caa19c$export$b21a3f1286706191,
    RadarController: $f600c28388caa19c$export$48dbc6ac651bf8be,
    ScatterController: $f600c28388caa19c$export$b2f2bae6713db87
});
function $f600c28388caa19c$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
class $f600c28388caa19c$var$DateAdapter {
    init(chartOptions) {}
    formats() {
        return $f600c28388caa19c$var$abstract();
    }
    parse(value, format) {
        return $f600c28388caa19c$var$abstract();
    }
    format(timestamp, format) {
        return $f600c28388caa19c$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $f600c28388caa19c$var$abstract();
    }
    diff(a, b, unit) {
        return $f600c28388caa19c$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $f600c28388caa19c$var$abstract();
    }
    endOf(timestamp, unit) {
        return $f600c28388caa19c$var$abstract();
    }
    constructor(options){
        this.options = options || {};
    }
}
$f600c28388caa19c$var$DateAdapter.override = function(members) {
    Object.assign($f600c28388caa19c$var$DateAdapter.prototype, members);
};
var $f600c28388caa19c$export$f32766ea09ec8bc4 = {
    _date: $f600c28388caa19c$var$DateAdapter
};
function $f600c28388caa19c$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $6bgWD.Y) : (0, $6bgWD.Z);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $f600c28388caa19c$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $f600c28388caa19c$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $f600c28388caa19c$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $f600c28388caa19c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $6bgWD.$)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $f600c28388caa19c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $f600c28388caa19c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $6bgWD.a0)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $6bgWD.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $f600c28388caa19c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $f600c28388caa19c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $f600c28388caa19c$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $f600c28388caa19c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $f600c28388caa19c$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $f600c28388caa19c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $f600c28388caa19c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $f600c28388caa19c$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $f600c28388caa19c$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $f600c28388caa19c$export$a13296960cae0384 = {
    evaluateInteractionItems: $f600c28388caa19c$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $f600c28388caa19c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $f600c28388caa19c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $f600c28388caa19c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $f600c28388caa19c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $f600c28388caa19c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $f600c28388caa19c$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            return $f600c28388caa19c$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $6bgWD.X)(e, chart);
            return $f600c28388caa19c$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $f600c28388caa19c$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $f600c28388caa19c$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $f600c28388caa19c$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$f600c28388caa19c$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $f600c28388caa19c$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $f600c28388caa19c$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $f600c28388caa19c$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$f600c28388caa19c$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $f600c28388caa19c$var$setLayoutDims(layouts, params) {
    const stacks = $f600c28388caa19c$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $f600c28388caa19c$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $f600c28388caa19c$var$wrapBoxes(boxes);
    const fullSize = $f600c28388caa19c$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $f600c28388caa19c$var$sortByWeight($f600c28388caa19c$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $f600c28388caa19c$var$sortByWeight($f600c28388caa19c$var$filterByPosition(layoutBoxes, 'right'));
    const top = $f600c28388caa19c$var$sortByWeight($f600c28388caa19c$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $f600c28388caa19c$var$sortByWeight($f600c28388caa19c$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $f600c28388caa19c$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $f600c28388caa19c$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $f600c28388caa19c$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $f600c28388caa19c$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $f600c28388caa19c$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $f600c28388caa19c$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $6bgWD.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $f600c28388caa19c$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $f600c28388caa19c$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $f600c28388caa19c$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $f600c28388caa19c$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $f600c28388caa19c$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $f600c28388caa19c$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $f600c28388caa19c$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $f600c28388caa19c$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $f600c28388caa19c$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $f600c28388caa19c$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $f600c28388caa19c$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $6bgWD.j)(stack.start)) y = stack.start;
            if (box.fullSize) $f600c28388caa19c$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $f600c28388caa19c$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $6bgWD.j)(stack.start)) x = stack.start;
            if (box.fullSize) $f600c28388caa19c$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $f600c28388caa19c$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $6bgWD.d).set('layout', {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $f600c28388caa19c$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $6bgWD.K)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $f600c28388caa19c$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $6bgWD.Q)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $f600c28388caa19c$var$updateMaxPadding(maxPadding, (0, $6bgWD.K)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $f600c28388caa19c$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $f600c28388caa19c$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $f600c28388caa19c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($f600c28388caa19c$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $f600c28388caa19c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $f600c28388caa19c$var$handleMaxPadding(chartArea);
        $f600c28388caa19c$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $f600c28388caa19c$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $6bgWD.Q)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $f600c28388caa19c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $f600c28388caa19c$export$a40a96b24b46cf35 extends $f600c28388caa19c$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $f600c28388caa19c$var$EXPANDO_KEY = '$chartjs';
const $f600c28388caa19c$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $f600c28388caa19c$var$isNullOrEmpty = (value)=>value === null || value === '';
function $f600c28388caa19c$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$f600c28388caa19c$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($f600c28388caa19c$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $6bgWD.a3)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($f600c28388caa19c$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $6bgWD.a3)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $f600c28388caa19c$var$eventListenerOptions = (0, $6bgWD.a5) ? {
    passive: true
} : false;
function $f600c28388caa19c$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $f600c28388caa19c$var$eventListenerOptions);
}
function $f600c28388caa19c$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $f600c28388caa19c$var$eventListenerOptions);
}
function $f600c28388caa19c$var$fromNativeEvent(event, chart) {
    const type = $f600c28388caa19c$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $6bgWD.X)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $f600c28388caa19c$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $f600c28388caa19c$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $f600c28388caa19c$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$f600c28388caa19c$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $f600c28388caa19c$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $f600c28388caa19c$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$f600c28388caa19c$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $f600c28388caa19c$var$drpListeningCharts = new Map();
let $f600c28388caa19c$var$oldDevicePixelRatio = 0;
function $f600c28388caa19c$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $f600c28388caa19c$var$oldDevicePixelRatio) return;
    $f600c28388caa19c$var$oldDevicePixelRatio = dpr;
    $f600c28388caa19c$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $f600c28388caa19c$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$f600c28388caa19c$var$drpListeningCharts.size) window.addEventListener('resize', $f600c28388caa19c$var$onWindowResize);
    $f600c28388caa19c$var$drpListeningCharts.set(chart, resize);
}
function $f600c28388caa19c$var$unlistenDevicePixelRatioChanges(chart) {
    $f600c28388caa19c$var$drpListeningCharts.delete(chart);
    if (!$f600c28388caa19c$var$drpListeningCharts.size) window.removeEventListener('resize', $f600c28388caa19c$var$onWindowResize);
}
function $f600c28388caa19c$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $6bgWD.a2)(canvas);
    if (!container) return;
    const resize = (0, $6bgWD.a4)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $f600c28388caa19c$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $f600c28388caa19c$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $f600c28388caa19c$var$unlistenDevicePixelRatioChanges(chart);
}
function $f600c28388caa19c$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $6bgWD.a4)((event)=>{
        if (chart.ctx !== null) listener($f600c28388caa19c$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $f600c28388caa19c$var$addListener(canvas, type, proxy);
    return proxy;
}
class $f600c28388caa19c$export$f02da7f882cf6b2e extends $f600c28388caa19c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $f600c28388caa19c$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$f600c28388caa19c$var$EXPANDO_KEY]) return false;
        const initial = canvas[$f600c28388caa19c$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $6bgWD.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$f600c28388caa19c$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $f600c28388caa19c$var$createAttachObserver,
            detach: $f600c28388caa19c$var$createDetachObserver,
            resize: $f600c28388caa19c$var$createResizeObserver
        };
        const handler = handlers[type] || $f600c28388caa19c$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $f600c28388caa19c$var$releaseObserver,
            detach: $f600c28388caa19c$var$releaseObserver,
            resize: $f600c28388caa19c$var$releaseObserver
        };
        const handler = handlers[type] || $f600c28388caa19c$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $6bgWD.a1)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $6bgWD.a2)(canvas);
        return !!(container && container.isConnected);
    }
}
function $f600c28388caa19c$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $6bgWD.a6)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $f600c28388caa19c$export$a40a96b24b46cf35;
    return $f600c28388caa19c$export$f02da7f882cf6b2e;
}
class $f600c28388caa19c$var$PluginService {
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $6bgWD.C)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $6bgWD.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $6bgWD.v)(config.options && config.options.plugins, {});
        const plugins = $f600c28388caa19c$var$allPlugins(config);
        return options === false && !all ? [] : $f600c28388caa19c$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
    constructor(){
        this._init = [];
    }
}
function $f600c28388caa19c$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($f600c28388caa19c$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($f600c28388caa19c$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $f600c28388caa19c$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $f600c28388caa19c$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $f600c28388caa19c$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $f600c28388caa19c$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $f600c28388caa19c$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $f600c28388caa19c$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $6bgWD.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $f600c28388caa19c$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $f600c28388caa19c$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $f600c28388caa19c$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $f600c28388caa19c$var$determineAxis(id, scaleOptions) {
    if (id === 'x' || id === 'y') return id;
    return scaleOptions.axis || $f600c28388caa19c$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $f600c28388caa19c$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $6bgWD.U)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $f600c28388caa19c$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $6bgWD.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $f600c28388caa19c$var$determineAxis(id, scaleConf);
        const defaultId = $f600c28388caa19c$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $6bgWD.ac)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $f600c28388caa19c$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $6bgWD.U)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $f600c28388caa19c$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $6bgWD.ac)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $6bgWD.ac)(scale, [
            (0, $6bgWD.d).scales[scale.type],
            (0, $6bgWD.d).scale
        ]);
    });
    return scales;
}
function $f600c28388caa19c$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $6bgWD.v)(options.plugins, {});
    options.scales = $f600c28388caa19c$var$mergeScaleConfig(config, options);
}
function $f600c28388caa19c$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $f600c28388caa19c$var$initConfig(config) {
    config = config || {};
    config.data = $f600c28388caa19c$var$initData(config.data);
    $f600c28388caa19c$var$initOptions(config);
    return config;
}
const $f600c28388caa19c$var$keyCache = new Map();
const $f600c28388caa19c$var$keysCached = new Set();
function $f600c28388caa19c$var$cachedKeys(cacheKey, generate) {
    let keys = $f600c28388caa19c$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $f600c28388caa19c$var$keyCache.set(cacheKey, keys);
        $f600c28388caa19c$var$keysCached.add(keys);
    }
    return keys;
}
const $f600c28388caa19c$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $6bgWD.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $f600c28388caa19c$var$Config {
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $f600c28388caa19c$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $f600c28388caa19c$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $f600c28388caa19c$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $f600c28388caa19c$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $f600c28388caa19c$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $f600c28388caa19c$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$f600c28388caa19c$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$f600c28388caa19c$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$f600c28388caa19c$var$addIfFound(scopes, (0, $6bgWD.U)[type] || {}, key));
            keys.forEach((key)=>$f600c28388caa19c$var$addIfFound(scopes, (0, $6bgWD.d), key));
            keys.forEach((key)=>$f600c28388caa19c$var$addIfFound(scopes, (0, $6bgWD.a7), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($f600c28388caa19c$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $6bgWD.U)[type] || {},
            (0, $6bgWD.d).datasets[type] || {},
            {
                type: type
            },
            (0, $6bgWD.d),
            (0, $6bgWD.a7)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $f600c28388caa19c$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($f600c28388caa19c$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $6bgWD.a8)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $6bgWD.a9)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $f600c28388caa19c$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $6bgWD.i)(context) ? (0, $6bgWD.a9)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
    constructor(config){
        this._config = $f600c28388caa19c$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
}
function $f600c28388caa19c$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $6bgWD.aa)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $f600c28388caa19c$var$hasFunction = (value)=>(0, $6bgWD.i)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $6bgWD.a8)(value[key]), false);
function $f600c28388caa19c$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $6bgWD.ab)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $6bgWD.a8)(value) || $f600c28388caa19c$var$hasFunction(value)) || indexable && (0, $6bgWD.b)(value)) return true;
    }
    return false;
}
var $f600c28388caa19c$var$version = "3.9.1";
const $f600c28388caa19c$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $f600c28388caa19c$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $f600c28388caa19c$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $f600c28388caa19c$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $f600c28388caa19c$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $6bgWD.C)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $f600c28388caa19c$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $6bgWD.C)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $f600c28388caa19c$var$getCanvas(item) {
    if ((0, $6bgWD.a6)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $f600c28388caa19c$var$instances = {};
const $f600c28388caa19c$var$getChart = (key)=>{
    const canvas = $f600c28388caa19c$var$getCanvas(key);
    return Object.values($f600c28388caa19c$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $f600c28388caa19c$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $f600c28388caa19c$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $f600c28388caa19c$export$acaa6426d77a227e {
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $6bgWD.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $6bgWD.af)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $6bgWD.ag)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $f600c28388caa19c$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$f600c28388caa19c$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $6bgWD.af)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $6bgWD.C)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $6bgWD.Q)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $f600c28388caa19c$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $6bgWD.Q)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $f600c28388caa19c$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $6bgWD.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $f600c28388caa19c$var$positionIsHorizontal(scaleOptions.position, axis) !== $f600c28388caa19c$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $f600c28388caa19c$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $6bgWD.Q)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $6bgWD.Q)(scales, (scale)=>{
            $f600c28388caa19c$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $f600c28388caa19c$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($f600c28388caa19c$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $f600c28388caa19c$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $f600c28388caa19c$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $6bgWD.d).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $f600c28388caa19c$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $f600c28388caa19c$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $6bgWD.Q)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $6bgWD.Q)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($f600c28388caa19c$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $6bgWD.Q)(this.scales, (scale)=>{
            $f600c28388caa19c$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $6bgWD.ah)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $f600c28388caa19c$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $6bgWD.ah)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $f600c28388caa19c$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $6bgWD.Q)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $6bgWD.a8)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($f600c28388caa19c$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$f600c28388caa19c$export$a424a0aa8f687495.running(this)) $f600c28388caa19c$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $f600c28388caa19c$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $6bgWD.L)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $6bgWD.N)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $6bgWD.$)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $f600c28388caa19c$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $6bgWD.h)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $6bgWD.j)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $f600c28388caa19c$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $6bgWD.ag)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins('destroy');
        delete $f600c28388caa19c$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $6bgWD.Q)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $6bgWD.Q)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $6bgWD.Q)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $6bgWD.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $6bgWD.aj)(e);
        const lastEvent = $f600c28388caa19c$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $6bgWD.C)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $6bgWD.C)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $6bgWD.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
    constructor(item, userConfig){
        const config = this.config = new $f600c28388caa19c$var$Config(userConfig);
        const initialCanvas = $f600c28388caa19c$var$getCanvas(item);
        const existingChart = $f600c28388caa19c$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $f600c28388caa19c$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $6bgWD.ad)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $f600c28388caa19c$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $6bgWD.ae)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $f600c28388caa19c$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $f600c28388caa19c$export$a424a0aa8f687495.listen(this, 'complete', $f600c28388caa19c$var$onAnimationsComplete);
        $f600c28388caa19c$export$a424a0aa8f687495.listen(this, 'progress', $f600c28388caa19c$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
}
const $f600c28388caa19c$var$invalidatePlugins = ()=>(0, $6bgWD.Q)($f600c28388caa19c$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $f600c28388caa19c$var$enumerable = true;
Object.defineProperties($f600c28388caa19c$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: (0, $6bgWD.d)
    },
    instances: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: $f600c28388caa19c$var$instances
    },
    overrides: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: (0, $6bgWD.U)
    },
    registry: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: $f600c28388caa19c$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: $f600c28388caa19c$var$version
    },
    getChart: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: $f600c28388caa19c$var$getChart
    },
    register: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: (...items)=>{
            $f600c28388caa19c$export$4bb7493d241fd8a5.add(...items);
            $f600c28388caa19c$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $f600c28388caa19c$var$enumerable,
        value: (...items)=>{
            $f600c28388caa19c$export$4bb7493d241fd8a5.remove(...items);
            $f600c28388caa19c$var$invalidatePlugins();
        }
    }
});
function $f600c28388caa19c$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $6bgWD.H), startAngle - (0, $6bgWD.H));
    ctx.closePath();
    ctx.clip();
}
function $f600c28388caa19c$var$toRadiusCorners(value) {
    return (0, $6bgWD.al)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
function $f600c28388caa19c$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $f600c28388caa19c$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $6bgWD.E)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $6bgWD.E)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $6bgWD.E)(o.innerEnd, 0, innerLimit)
    };
}
function $f600c28388caa19c$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $f600c28388caa19c$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $6bgWD.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $f600c28388caa19c$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $f600c28388caa19c$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $6bgWD.H));
        }
        const p4 = $f600c28388caa19c$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $f600c28388caa19c$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $6bgWD.H), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $f600c28388caa19c$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $6bgWD.H));
        }
        const p8 = $f600c28388caa19c$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $f600c28388caa19c$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $6bgWD.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $f600c28388caa19c$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $f600c28388caa19c$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $6bgWD.T), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $6bgWD.T);
            if (circumference % (0, $6bgWD.T) === 0) endAngle += (0, $6bgWD.T);
        }
    }
    $f600c28388caa19c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $f600c28388caa19c$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $f600c28388caa19c$var$clipArc(ctx, element, startAngle + (0, $6bgWD.T));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $6bgWD.T), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $6bgWD.T));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $f600c28388caa19c$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    if (element.fullCircles) $f600c28388caa19c$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $f600c28388caa19c$var$clipArc(ctx, element, endAngle);
    $f600c28388caa19c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $f600c28388caa19c$export$d48203c759d6a1fc extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $6bgWD.a0)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $6bgWD.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $6bgWD.T) || (0, $6bgWD.p)(angle, startAngle, endAngle);
        const withinRadius = (0, $6bgWD.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $6bgWD.T) ? Math.floor(circumference / (0, $6bgWD.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $6bgWD.P)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $f600c28388caa19c$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $f600c28388caa19c$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
}
$f600c28388caa19c$export$d48203c759d6a1fc.id = 'arc';
$f600c28388caa19c$export$d48203c759d6a1fc.defaults = {
    borderAlign: 'center',
    borderColor: '#fff',
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$f600c28388caa19c$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: 'backgroundColor'
};
function $f600c28388caa19c$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $6bgWD.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $6bgWD.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $6bgWD.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $6bgWD.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $6bgWD.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $6bgWD.v)(style.borderColor, options.borderColor);
}
function $f600c28388caa19c$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $f600c28388caa19c$var$getLineMethod(options) {
    if (options.stepped) return 0, $6bgWD.as;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $6bgWD.at;
    return $f600c28388caa19c$var$lineTo;
}
function $f600c28388caa19c$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $f600c28388caa19c$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $f600c28388caa19c$var$pathVars(points, segment, params);
    const lineMethod = $f600c28388caa19c$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $f600c28388caa19c$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $f600c28388caa19c$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $f600c28388caa19c$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $f600c28388caa19c$var$fastPathSegment : $f600c28388caa19c$var$pathSegment;
}
function $f600c28388caa19c$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $6bgWD.ap;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $6bgWD.aq;
    return 0, $6bgWD.ar;
}
function $f600c28388caa19c$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $f600c28388caa19c$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $f600c28388caa19c$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $f600c28388caa19c$var$_getSegmentMethod(line);
    for (const segment of segments){
        $f600c28388caa19c$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $f600c28388caa19c$var$usePath2D = typeof Path2D === 'function';
function $f600c28388caa19c$var$draw(ctx, line, start, count) {
    if ($f600c28388caa19c$var$usePath2D && !line.options.segment) $f600c28388caa19c$var$strokePathWithCache(ctx, line, start, count);
    else $f600c28388caa19c$var$strokePathDirect(ctx, line, start, count);
}
class $f600c28388caa19c$export$55e463fa7bcd3469 extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $6bgWD.am)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $6bgWD.an)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $6bgWD.ao)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $f600c28388caa19c$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $f600c28388caa19c$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $f600c28388caa19c$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $f600c28388caa19c$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$f600c28388caa19c$export$55e463fa7bcd3469.id = 'line';
$f600c28388caa19c$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$f600c28388caa19c$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
$f600c28388caa19c$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
};
function $f600c28388caa19c$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $f600c28388caa19c$export$bd159b522b230b7a extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $f600c28388caa19c$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $f600c28388caa19c$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $6bgWD.$)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $6bgWD.au)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$f600c28388caa19c$export$bd159b522b230b7a.id = 'point';
$f600c28388caa19c$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
};
$f600c28388caa19c$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
function $f600c28388caa19c$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $f600c28388caa19c$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $6bgWD.E)(value, min, max);
}
function $f600c28388caa19c$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $6bgWD.aw)(value);
    return {
        t: $f600c28388caa19c$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $f600c28388caa19c$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $f600c28388caa19c$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $f600c28388caa19c$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $f600c28388caa19c$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $6bgWD.ax)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $6bgWD.i)(value);
    return {
        topLeft: $f600c28388caa19c$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $f600c28388caa19c$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $f600c28388caa19c$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $f600c28388caa19c$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $f600c28388caa19c$var$boundingRects(bar) {
    const bounds = $f600c28388caa19c$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $f600c28388caa19c$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $f600c28388caa19c$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $f600c28388caa19c$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $f600c28388caa19c$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $6bgWD.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $6bgWD.ak)(y, bounds.top, bounds.bottom));
}
function $f600c28388caa19c$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $f600c28388caa19c$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $f600c28388caa19c$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $f600c28388caa19c$export$a16ed71bf4b07672 extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $f600c28388caa19c$var$boundingRects(this);
        const addRectPath = $f600c28388caa19c$var$hasRadius(outer.radius) ? (0, $6bgWD.av) : $f600c28388caa19c$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $f600c28388caa19c$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $f600c28388caa19c$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $f600c28388caa19c$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $f600c28388caa19c$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $f600c28388caa19c$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $f600c28388caa19c$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
$f600c28388caa19c$export$a16ed71bf4b07672.id = 'bar';
$f600c28388caa19c$export$a16ed71bf4b07672.defaults = {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
};
$f600c28388caa19c$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
};
var $f600c28388caa19c$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $f600c28388caa19c$export$d48203c759d6a1fc,
    LineElement: $f600c28388caa19c$export$55e463fa7bcd3469,
    PointElement: $f600c28388caa19c$export$bd159b522b230b7a,
    BarElement: $f600c28388caa19c$export$a16ed71bf4b07672
});
function $f600c28388caa19c$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $f600c28388caa19c$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $6bgWD.k)(minIndex) && !(0, $6bgWD.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push((0, $2qxEV._)((0, $9tqwB._)({}, data[intermediateIndex1]), {
                    x: avgX
                }));
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push((0, $2qxEV._)((0, $9tqwB._)({}, data[intermediateIndex2]), {
                    x: avgX
                }));
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $f600c28388caa19c$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            value: data
        });
    }
}
function $f600c28388caa19c$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $f600c28388caa19c$var$cleanDecimatedDataset(dataset);
    });
}
function $f600c28388caa19c$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $6bgWD.E)((0, $6bgWD.Z)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $6bgWD.E)((0, $6bgWD.Z)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $f600c28388caa19c$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $f600c28388caa19c$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $6bgWD.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $f600c28388caa19c$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $f600c28388caa19c$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $6bgWD.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $f600c28388caa19c$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $f600c28388caa19c$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $f600c28388caa19c$var$cleanDecimatedData(chart);
    }
};
function $f600c28388caa19c$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $f600c28388caa19c$var$_findSegmentEnd(start, end, points);
        const bounds = $f600c28388caa19c$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $6bgWD.ao)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $f600c28388caa19c$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $6bgWD.ay)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $f600c28388caa19c$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $f600c28388caa19c$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $f600c28388caa19c$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $6bgWD.az)(start);
        end = (0, $6bgWD.az)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $f600c28388caa19c$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $f600c28388caa19c$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $f600c28388caa19c$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $f600c28388caa19c$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $f600c28388caa19c$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $6bgWD.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $f600c28388caa19c$var$_pointsFromSegments(boundary, line);
    return points.length ? new $f600c28388caa19c$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $f600c28388caa19c$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $f600c28388caa19c$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $6bgWD.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $f600c28388caa19c$var$_decodeFill(line, index, count) {
    const fill = $f600c28388caa19c$var$parseFillOption(line);
    if ((0, $6bgWD.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $6bgWD.g)(target) && Math.floor(target) === target) return $f600c28388caa19c$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $f600c28388caa19c$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $f600c28388caa19c$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $6bgWD.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $f600c28388caa19c$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $6bgWD.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $f600c28388caa19c$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $6bgWD.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $f600c28388caa19c$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $f600c28388caa19c$var$getLinesBelow(scale, index);
    linesBelow.push($f600c28388caa19c$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$f600c28388caa19c$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $f600c28388caa19c$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $f600c28388caa19c$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $f600c28388caa19c$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $f600c28388caa19c$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $f600c28388caa19c$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $6bgWD.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $f600c28388caa19c$var$simpleArc {
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $6bgWD.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
}
function $f600c28388caa19c$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $6bgWD.g)(fill)) return $f600c28388caa19c$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $f600c28388caa19c$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $f600c28388caa19c$var$computeBoundary(source);
    if (boundary instanceof $f600c28388caa19c$var$simpleArc) return boundary;
    return $f600c28388caa19c$var$_createBoundaryLine(boundary, line);
}
function $f600c28388caa19c$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $f600c28388caa19c$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $f600c28388caa19c$var$computeCircularBoundary(source);
    return $f600c28388caa19c$var$computeLinearBoundary(source);
}
function $f600c28388caa19c$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $f600c28388caa19c$var$_getTargetPixel(fill, scale);
    if ((0, $6bgWD.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $f600c28388caa19c$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $f600c28388caa19c$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $f600c28388caa19c$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $f600c28388caa19c$var$_drawfill(ctx, source, area) {
    const target = $f600c28388caa19c$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $6bgWD.L)(ctx, area);
        $f600c28388caa19c$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $6bgWD.N)(ctx);
    }
}
function $f600c28388caa19c$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $f600c28388caa19c$var$clipVertical(ctx, target, area.top);
        $f600c28388caa19c$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $f600c28388caa19c$var$clipVertical(ctx, target, area.bottom);
    }
    $f600c28388caa19c$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $f600c28388caa19c$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$f600c28388caa19c$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $f600c28388caa19c$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $f600c28388caa19c$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $f600c28388caa19c$var$clipBounds(ctx, scale, notShape && $f600c28388caa19c$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $f600c28388caa19c$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $f600c28388caa19c$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $f600c28388caa19c$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $f600c28388caa19c$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $f600c28388caa19c$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $f600c28388caa19c$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $f600c28388caa19c$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $f600c28388caa19c$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $f600c28388caa19c$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($f600c28388caa19c$var$_shouldApplyFill(source)) $f600c28388caa19c$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$f600c28388caa19c$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $f600c28388caa19c$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $f600c28388caa19c$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $f600c28388caa19c$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $f600c28388caa19c$var$Legend extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $6bgWD.C)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $6bgWD.O)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $f600c28388caa19c$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $6bgWD.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $6bgWD.S)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $6bgWD.S)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $6bgWD.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $6bgWD.S)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $6bgWD.L)(ctx, this);
            this._draw();
            (0, $6bgWD.N)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $6bgWD.d).color;
        const rtlHelper = (0, $6bgWD.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, $6bgWD.O)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $f600c28388caa19c$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $6bgWD.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $6bgWD.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $6bgWD.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $6bgWD.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $6bgWD.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $6bgWD.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $6bgWD.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $6bgWD.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $6bgWD.ax)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $6bgWD.av)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $6bgWD.M)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $6bgWD.S)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $6bgWD.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $6bgWD.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $6bgWD.S)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $6bgWD.S)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $6bgWD.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $6bgWD.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $6bgWD.O)(titleOpts.font);
        const titlePadding = (0, $6bgWD.K)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $6bgWD.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $6bgWD.S)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $6bgWD.S)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $6bgWD.S)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $6bgWD.R)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $6bgWD.M)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $6bgWD.O)(titleOpts.font);
        const titlePadding = (0, $6bgWD.K)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $6bgWD.ak)(x, this.left, this.right) && (0, $6bgWD.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $6bgWD.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $6bgWD.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$f600c28388caa19c$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $f600c28388caa19c$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $6bgWD.C)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $6bgWD.C)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $6bgWD.C)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $f600c28388caa19c$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $f600c28388caa19c$export$ed247974535929c7 = {
    id: 'legend',
    _element: $f600c28388caa19c$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $f600c28388caa19c$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $f600c28388caa19c$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $f600c28388caa19c$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $6bgWD.K)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $f600c28388caa19c$var$Title extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $6bgWD.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $6bgWD.K)(opts.padding);
        const textSize = lineCount * (0, $6bgWD.O)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $6bgWD.S)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $6bgWD.S)(align, bottom, top);
                rotation = (0, $6bgWD.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $6bgWD.S)(align, top, bottom);
                rotation = (0, $6bgWD.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $6bgWD.O)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $6bgWD.M)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $6bgWD.R)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $f600c28388caa19c$var$createTitle(chart, titleOpts) {
    const title = new $f600c28388caa19c$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $f600c28388caa19c$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $f600c28388caa19c$export$f99233281efd08a0 = {
    id: 'title',
    _element: $f600c28388caa19c$var$Title,
    start (chart, _args, options) {
        $f600c28388caa19c$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $f600c28388caa19c$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $f600c28388caa19c$var$map = new WeakMap();
var $f600c28388caa19c$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $f600c28388caa19c$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, title, options);
        $f600c28388caa19c$export$1ecca0613f5e56d2.addBox(chart, title);
        $f600c28388caa19c$var$map.set(chart, title);
    },
    stop (chart) {
        $f600c28388caa19c$export$1ecca0613f5e56d2.removeBox(chart, $f600c28388caa19c$var$map.get(chart));
        $f600c28388caa19c$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $f600c28388caa19c$var$map.get(chart);
        $f600c28388caa19c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $f600c28388caa19c$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $6bgWD.aG)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $f600c28388caa19c$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $6bgWD.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $f600c28388caa19c$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $f600c28388caa19c$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $f600c28388caa19c$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $6bgWD.O)(options.bodyFont);
    const titleFont = (0, $6bgWD.O)(options.titleFont);
    const footerFont = (0, $6bgWD.O)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $6bgWD.K)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $6bgWD.Q)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $6bgWD.Q)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $6bgWD.Q)(body, (bodyItem)=>{
        (0, $6bgWD.Q)(bodyItem.before, maxLineWidth);
        (0, $6bgWD.Q)(bodyItem.lines, maxLineWidth);
        (0, $6bgWD.Q)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $6bgWD.Q)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $f600c28388caa19c$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $f600c28388caa19c$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $f600c28388caa19c$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($f600c28388caa19c$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $f600c28388caa19c$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $f600c28388caa19c$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $f600c28388caa19c$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $f600c28388caa19c$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $f600c28388caa19c$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $f600c28388caa19c$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $6bgWD.ax)(cornerRadius);
    let x = $f600c28388caa19c$var$alignX(size, xAlign);
    const y = $f600c28388caa19c$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $6bgWD.E)(x, 0, chart.width - size.width),
        y: (0, $6bgWD.E)(y, 0, chart.height - size.height)
    };
}
function $f600c28388caa19c$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $6bgWD.K)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $f600c28388caa19c$var$getBeforeAfterBodyLines(callback) {
    return $f600c28388caa19c$var$pushOrConcat([], $f600c28388caa19c$var$splitNewlines(callback));
}
function $f600c28388caa19c$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $6bgWD.h)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $f600c28388caa19c$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $f600c28388caa19c$var$Tooltip extends $f600c28388caa19c$export$db77ccec0bb4ccac {
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $f600c28388caa19c$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $f600c28388caa19c$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(beforeTitle));
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(title));
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $f600c28388caa19c$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $6bgWD.Q)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $f600c28388caa19c$var$overrideCallbacks(callbacks, context);
            $f600c28388caa19c$var$pushOrConcat(bodyItem.before, $f600c28388caa19c$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $f600c28388caa19c$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $f600c28388caa19c$var$pushOrConcat(bodyItem.after, $f600c28388caa19c$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $f600c28388caa19c$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(beforeFooter));
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(footer));
        lines = $f600c28388caa19c$var$pushOrConcat(lines, $f600c28388caa19c$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($f600c28388caa19c$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $6bgWD.Q)(tooltipItems, (context)=>{
            const scoped = $f600c28388caa19c$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $f600c28388caa19c$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $f600c28388caa19c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $f600c28388caa19c$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $f600c28388caa19c$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $6bgWD.ax)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $6bgWD.aA)(options.rtl, this.x, this.width);
            pt.x = $f600c28388caa19c$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $6bgWD.O)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $6bgWD.O)(options.bodyFont);
        const colorX = $f600c28388caa19c$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $6bgWD.au)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $6bgWD.au)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $6bgWD.i)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $6bgWD.ax)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $6bgWD.av)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $6bgWD.av)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $6bgWD.O)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $6bgWD.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $f600c28388caa19c$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $6bgWD.Q)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $6bgWD.Q)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $6bgWD.Q)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $6bgWD.Q)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $6bgWD.aA)(options.rtl, this.x, this.width);
            pt.x = $f600c28388caa19c$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $6bgWD.O)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $6bgWD.ax)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $f600c28388caa19c$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $f600c28388caa19c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $f600c28388caa19c$var$determineAlignment(chart, options, positionAndSize);
            const point = $f600c28388caa19c$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $6bgWD.K)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $6bgWD.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $6bgWD.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $6bgWD.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $6bgWD.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $f600c28388caa19c$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
}
$f600c28388caa19c$var$Tooltip.positioners = $f600c28388caa19c$var$positioners;
var $f600c28388caa19c$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $f600c28388caa19c$var$Tooltip,
    positioners: $f600c28388caa19c$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $f600c28388caa19c$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $6bgWD.aF),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return '';
            },
            afterTitle: (0, $6bgWD.aF),
            beforeBody: (0, $6bgWD.aF),
            beforeLabel: (0, $6bgWD.aF),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || '';
                if (label) label += ': ';
                const value = tooltipItem.formattedValue;
                if (!(0, $6bgWD.k)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $6bgWD.aF),
            afterBody: (0, $6bgWD.aF),
            beforeFooter: (0, $6bgWD.aF),
            footer: (0, $6bgWD.aF),
            afterFooter: (0, $6bgWD.aF)
        }
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $f600c28388caa19c$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $f600c28388caa19c$export$be17f937e9aa7533,
    Filler: $f600c28388caa19c$export$d19ba4d812bed757,
    Legend: $f600c28388caa19c$export$ed247974535929c7,
    SubTitle: $f600c28388caa19c$export$d5c56664638992a4,
    Title: $f600c28388caa19c$export$f99233281efd08a0,
    Tooltip: $f600c28388caa19c$export$28c660c63b792dea
});
const $f600c28388caa19c$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $f600c28388caa19c$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $f600c28388caa19c$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $f600c28388caa19c$var$validIndex = (index, max)=>index === null ? null : (0, $6bgWD.E)(Math.round(index), 0, max);
class $f600c28388caa19c$export$29e663ba4d09fe7 extends $f600c28388caa19c$export$d60cfc58d3c358b6 {
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $6bgWD.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $f600c28388caa19c$var$findOrAddLabel(labels, raw, (0, $6bgWD.v)(index, raw), this._addedLabels);
        return $f600c28388caa19c$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
}
$f600c28388caa19c$export$29e663ba4d09fe7.id = 'category';
$f600c28388caa19c$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $f600c28388caa19c$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $f600c28388caa19c$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $6bgWD.k)(min);
    const maxDefined = !(0, $6bgWD.k)(max);
    const countDefined = !(0, $6bgWD.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $6bgWD.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $6bgWD.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $6bgWD.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $6bgWD.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $6bgWD.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $6bgWD.aL)(spacing), (0, $6bgWD.aL)(niceMin));
    factor = Math.pow(10, (0, $6bgWD.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $6bgWD.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, $f600c28388caa19c$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $6bgWD.aK)(ticks[ticks.length - 1].value, max, $f600c28388caa19c$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $f600c28388caa19c$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $6bgWD.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $f600c28388caa19c$var$LinearScaleBase extends $f600c28388caa19c$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        if ((0, $6bgWD.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $6bgWD.s)(min);
            const maxSign = (0, $6bgWD.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $f600c28388caa19c$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $6bgWD.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $6bgWD.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
}
class $f600c28388caa19c$export$e7f4e5e8656f0b93 extends $f600c28388caa19c$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $6bgWD.g)(min) ? min : 0;
        this.max = (0, $6bgWD.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $6bgWD.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$f600c28388caa19c$export$e7f4e5e8656f0b93.id = 'linear';
$f600c28388caa19c$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $f600c28388caa19c$export$27c7467594ef87bd.formatters.numeric
    }
};
function $f600c28388caa19c$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $6bgWD.z)(tickVal)));
    return remain === 1;
}
function $f600c28388caa19c$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $6bgWD.z)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $6bgWD.B)(generationOptions.min, Math.pow(10, Math.floor((0, $6bgWD.z)(dataRange.min))));
    let exp = Math.floor((0, $6bgWD.z)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $f600c28388caa19c$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $6bgWD.B)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $f600c28388caa19c$var$isMajor(tickVal)
    });
    return ticks;
}
class $f600c28388caa19c$export$85295eaf7cb3ac3e extends $f600c28388caa19c$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        const value = $f600c28388caa19c$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $6bgWD.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $6bgWD.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $6bgWD.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $6bgWD.z)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $f600c28388caa19c$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $6bgWD.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $6bgWD.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $6bgWD.z)(start);
        this._valueRange = (0, $6bgWD.z)(this.max) - (0, $6bgWD.z)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $6bgWD.z)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
}
$f600c28388caa19c$export$85295eaf7cb3ac3e.id = 'logarithmic';
$f600c28388caa19c$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $f600c28388caa19c$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $f600c28388caa19c$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $6bgWD.K)(tickOpts.backdropPadding);
        return (0, $6bgWD.v)(tickOpts.font && tickOpts.font.size, (0, $6bgWD.d).font.size) + padding.height;
    }
    return 0;
}
function $f600c28388caa19c$var$measureLabelSize(ctx, font, label) {
    label = (0, $6bgWD.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $6bgWD.aM)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $f600c28388caa19c$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $f600c28388caa19c$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $6bgWD.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $6bgWD.O)(opts.font);
        const textSize = $f600c28388caa19c$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $6bgWD.az)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $6bgWD.F)(angleRadians));
        const hLimits = $f600c28388caa19c$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $f600c28388caa19c$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $f600c28388caa19c$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $f600c28388caa19c$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $f600c28388caa19c$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $f600c28388caa19c$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $f600c28388caa19c$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $6bgWD.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $6bgWD.F)((0, $6bgWD.az)(pointLabelPosition.angle + (0, $6bgWD.H))));
        const size = labelSizes[i];
        const y = $f600c28388caa19c$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $f600c28388caa19c$var$getTextAlignForAngle(angle);
        const left = $f600c28388caa19c$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $f600c28388caa19c$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $f600c28388caa19c$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $f600c28388caa19c$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $f600c28388caa19c$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $6bgWD.O)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $6bgWD.k)(backdropColor)) {
            const borderRadius = (0, $6bgWD.ax)(optsAtIndex.borderRadius);
            const padding = (0, $6bgWD.K)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $6bgWD.av)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $6bgWD.M)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $f600c28388caa19c$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $6bgWD.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $f600c28388caa19c$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $f600c28388caa19c$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $f600c28388caa19c$var$createPointLabelContext(parent, index, label) {
    return (0, $6bgWD.h)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $f600c28388caa19c$export$cfafc36d95386d38 extends $f600c28388caa19c$var$LinearScaleBase {
    setDimensions() {
        const padding = this._padding = (0, $6bgWD.K)($f600c28388caa19c$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $6bgWD.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $6bgWD.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $f600c28388caa19c$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $f600c28388caa19c$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $6bgWD.C)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $f600c28388caa19c$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $6bgWD.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $6bgWD.az)(index * angleMultiplier + (0, $6bgWD.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $6bgWD.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $6bgWD.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $f600c28388caa19c$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $6bgWD.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $f600c28388caa19c$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $f600c28388caa19c$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $f600c28388caa19c$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $6bgWD.O)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $6bgWD.K)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $6bgWD.M)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
}
$f600c28388caa19c$export$cfafc36d95386d38.id = 'radialLinear';
$f600c28388caa19c$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $f600c28388caa19c$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$f600c28388caa19c$export$cfafc36d95386d38.defaultRoutes = {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
};
$f600c28388caa19c$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: 'grid'
    }
};
const $f600c28388caa19c$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $f600c28388caa19c$var$UNITS = Object.keys($f600c28388caa19c$var$INTERVALS);
function $f600c28388caa19c$var$sorter(a, b) {
    return a - b;
}
function $f600c28388caa19c$var$parse(scale, input) {
    if ((0, $6bgWD.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $6bgWD.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $6bgWD.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $f600c28388caa19c$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $f600c28388caa19c$var$UNITS.length;
    for(let i = $f600c28388caa19c$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $f600c28388caa19c$var$INTERVALS[$f600c28388caa19c$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $f600c28388caa19c$var$UNITS[i];
    }
    return $f600c28388caa19c$var$UNITS[ilen - 1];
}
function $f600c28388caa19c$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $f600c28388caa19c$var$UNITS.length - 1; i >= $f600c28388caa19c$var$UNITS.indexOf(minUnit); i--){
        const unit = $f600c28388caa19c$var$UNITS[i];
        if ($f600c28388caa19c$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $f600c28388caa19c$var$UNITS[minUnit ? $f600c28388caa19c$var$UNITS.indexOf(minUnit) : 0];
}
function $f600c28388caa19c$var$determineMajorUnit(unit) {
    for(let i = $f600c28388caa19c$var$UNITS.indexOf(unit) + 1, ilen = $f600c28388caa19c$var$UNITS.length; i < ilen; ++i){
        if ($f600c28388caa19c$var$INTERVALS[$f600c28388caa19c$var$UNITS[i]].common) return $f600c28388caa19c$var$UNITS[i];
    }
}
function $f600c28388caa19c$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $6bgWD.aO)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $f600c28388caa19c$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $f600c28388caa19c$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $f600c28388caa19c$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $f600c28388caa19c$export$a894c72689ff3ec extends $f600c28388caa19c$export$d60cfc58d3c358b6 {
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $f600c28388caa19c$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $6bgWD.ac)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $f600c28388caa19c$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $6bgWD.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $6bgWD.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $6bgWD.aN)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $f600c28388caa19c$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $f600c28388caa19c$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $f600c28388caa19c$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $f600c28388caa19c$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $6bgWD.E)(start, 0, limit);
        end = (0, $6bgWD.E)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $f600c28388caa19c$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $6bgWD.v)(timeOpts.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $6bgWD.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$f600c28388caa19c$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $f600c28388caa19c$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $6bgWD.C)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $6bgWD.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $f600c28388caa19c$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($f600c28388caa19c$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $6bgWD._)(values.sort($f600c28388caa19c$var$sorter));
    }
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
}
$f600c28388caa19c$export$a894c72689ff3ec.id = 'time';
$f600c28388caa19c$export$a894c72689ff3ec.defaults = {
    bounds: 'data',
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
    },
    ticks: {
        source: 'auto',
        major: {
            enabled: false
        }
    }
};
function $f600c28388caa19c$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $6bgWD.Z)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $6bgWD.Z)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $f600c28388caa19c$export$85df64a8eb6dc986 extends $f600c28388caa19c$export$a894c72689ff3ec {
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $f600c28388caa19c$var$interpolate(table, this.min);
        this._tableRange = $f600c28388caa19c$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($f600c28388caa19c$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $f600c28388caa19c$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
}
$f600c28388caa19c$export$85df64a8eb6dc986.id = 'timeseries';
$f600c28388caa19c$export$85df64a8eb6dc986.defaults = $f600c28388caa19c$export$a894c72689ff3ec.defaults;
var $f600c28388caa19c$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $f600c28388caa19c$export$29e663ba4d09fe7,
    LinearScale: $f600c28388caa19c$export$e7f4e5e8656f0b93,
    LogarithmicScale: $f600c28388caa19c$export$85295eaf7cb3ac3e,
    RadialLinearScale: $f600c28388caa19c$export$cfafc36d95386d38,
    TimeScale: $f600c28388caa19c$export$a894c72689ff3ec,
    TimeSeriesScale: $f600c28388caa19c$export$85df64a8eb6dc986
});
const $f600c28388caa19c$export$e8959e79e3af550f = [
    $f600c28388caa19c$export$a6506504f799c5d5,
    $f600c28388caa19c$export$7a5d735b2ab6389d,
    $f600c28388caa19c$export$8b3ca321c77fdea6,
    $f600c28388caa19c$export$bcac1c16f1530ec2
];

});
parcelRegister("6bgWD", function(module, exports) {

$parcel$export(module.exports, "aF", function () { return $d458fd3af41ff437$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "ad", function () { return $d458fd3af41ff437$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "k", function () { return $d458fd3af41ff437$export$342063e11d6c3cad; });
$parcel$export(module.exports, "b", function () { return $d458fd3af41ff437$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $d458fd3af41ff437$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $d458fd3af41ff437$export$39b482c5e57630a8; });
$parcel$export(module.exports, "B", function () { return $d458fd3af41ff437$export$ef35774e6d314e91; });
$parcel$export(module.exports, "v", function () { return $d458fd3af41ff437$export$90a7f3efeed30595; });
$parcel$export(module.exports, "m", function () { return $d458fd3af41ff437$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $d458fd3af41ff437$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "C", function () { return $d458fd3af41ff437$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Q", function () { return $d458fd3af41ff437$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "ai", function () { return $d458fd3af41ff437$export$f38c853ae54ed474; });
$parcel$export(module.exports, "V", function () { return $d458fd3af41ff437$export$e7c866399fa523f5; });
$parcel$export(module.exports, "ac", function () { return $d458fd3af41ff437$export$2219238a014317b0; });
$parcel$export(module.exports, "f", function () { return $d458fd3af41ff437$export$2d1720544b23b823; });
$parcel$export(module.exports, "W", function () { return $d458fd3af41ff437$export$71cec2538cb2c617; });
$parcel$export(module.exports, "j", function () { return $d458fd3af41ff437$export$35e795649ee09318; });
$parcel$export(module.exports, "a8", function () { return $d458fd3af41ff437$export$c3950d9923825c02; });
$parcel$export(module.exports, "ah", function () { return $d458fd3af41ff437$export$995eb9fca571757; });
$parcel$export(module.exports, "aj", function () { return $d458fd3af41ff437$export$3b513254972cfc9c; });
$parcel$export(module.exports, "P", function () { return $d458fd3af41ff437$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $d458fd3af41ff437$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $d458fd3af41ff437$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "z", function () { return $d458fd3af41ff437$export$df995fae86a55f06; });
$parcel$export(module.exports, "s", function () { return $d458fd3af41ff437$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aI", function () { return $d458fd3af41ff437$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "aK", function () { return $d458fd3af41ff437$export$23ebac1979863676; });
$parcel$export(module.exports, "A", function () { return $d458fd3af41ff437$export$ebd11618f299a286; });
$parcel$export(module.exports, "x", function () { return $d458fd3af41ff437$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "aJ", function () { return $d458fd3af41ff437$export$a05254e7c3aeba6e; });
$parcel$export(module.exports, "aH", function () { return $d458fd3af41ff437$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "t", function () { return $d458fd3af41ff437$export$625550452a3fa3ec; });
$parcel$export(module.exports, "F", function () { return $d458fd3af41ff437$export$d66501df72047452; });
$parcel$export(module.exports, "aL", function () { return $d458fd3af41ff437$export$91477dc880baac21; });
$parcel$export(module.exports, "a0", function () { return $d458fd3af41ff437$export$34aec0b863436764; });
$parcel$export(module.exports, "aG", function () { return $d458fd3af41ff437$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "az", function () { return $d458fd3af41ff437$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "p", function () { return $d458fd3af41ff437$export$ffb5f4729a158638; });
$parcel$export(module.exports, "E", function () { return $d458fd3af41ff437$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "I", function () { return $d458fd3af41ff437$export$9bb611d729802a56; });
$parcel$export(module.exports, "ak", function () { return $d458fd3af41ff437$export$21579262ef46735b; });
$parcel$export(module.exports, "aO", function () { return $d458fd3af41ff437$export$c03999cb2f36933f; });
$parcel$export(module.exports, "Z", function () { return $d458fd3af41ff437$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "Y", function () { return $d458fd3af41ff437$export$8743009a87fcb00f; });
$parcel$export(module.exports, "aN", function () { return $d458fd3af41ff437$export$faec65b429be379; });
$parcel$export(module.exports, "l", function () { return $d458fd3af41ff437$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $d458fd3af41ff437$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $d458fd3af41ff437$export$71511d61b312f219; });
$parcel$export(module.exports, "r", function () { return $d458fd3af41ff437$export$43caf9889c228507; });
$parcel$export(module.exports, "a4", function () { return $d458fd3af41ff437$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "ae", function () { return $d458fd3af41ff437$export$f787f51d84a910ad; });
$parcel$export(module.exports, "R", function () { return $d458fd3af41ff437$export$db202ddc8be9136; });
$parcel$export(module.exports, "S", function () { return $d458fd3af41ff437$export$25ce5a424b770e84; });
$parcel$export(module.exports, "aC", function () { return $d458fd3af41ff437$export$890c4ad488842ce7; });
$parcel$export(module.exports, "q", function () { return $d458fd3af41ff437$export$9e5f44173e64f162; });
$parcel$export(module.exports, "w", function () { return $d458fd3af41ff437$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "e", function () { return $d458fd3af41ff437$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $d458fd3af41ff437$export$db3b6bfb95261072; });
$parcel$export(module.exports, "U", function () { return $d458fd3af41ff437$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "a7", function () { return $d458fd3af41ff437$export$a93c5207d687da10; });
$parcel$export(module.exports, "d", function () { return $d458fd3af41ff437$export$4368d992c4eafac0; });
$parcel$export(module.exports, "G", function () { return $d458fd3af41ff437$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "aM", function () { return $d458fd3af41ff437$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "J", function () { return $d458fd3af41ff437$export$b4171a6734a65d42; });
$parcel$export(module.exports, "ag", function () { return $d458fd3af41ff437$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "au", function () { return $d458fd3af41ff437$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "aE", function () { return $d458fd3af41ff437$export$158acd800e1ef08b; });
$parcel$export(module.exports, "$", function () { return $d458fd3af41ff437$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "L", function () { return $d458fd3af41ff437$export$61196ced6d74a310; });
$parcel$export(module.exports, "N", function () { return $d458fd3af41ff437$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "as", function () { return $d458fd3af41ff437$export$6554612db691658e; });
$parcel$export(module.exports, "at", function () { return $d458fd3af41ff437$export$493d36ec626b6698; });
$parcel$export(module.exports, "M", function () { return $d458fd3af41ff437$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "av", function () { return $d458fd3af41ff437$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "al", function () { return $d458fd3af41ff437$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "aw", function () { return $d458fd3af41ff437$export$92108d983e8ee699; });
$parcel$export(module.exports, "ax", function () { return $d458fd3af41ff437$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "K", function () { return $d458fd3af41ff437$export$3466f893ebf79586; });
$parcel$export(module.exports, "O", function () { return $d458fd3af41ff437$export$c4ce752e73470fba; });
$parcel$export(module.exports, "a", function () { return $d458fd3af41ff437$export$407448d2b89b1813; });
$parcel$export(module.exports, "D", function () { return $d458fd3af41ff437$export$96f57966bedc81b4; });
$parcel$export(module.exports, "h", function () { return $d458fd3af41ff437$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "aa", function () { return $d458fd3af41ff437$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "a9", function () { return $d458fd3af41ff437$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "ab", function () { return $d458fd3af41ff437$export$555508cbc6add439; });
$parcel$export(module.exports, "y", function () { return $d458fd3af41ff437$export$4a5767248b18ef41; });
$parcel$export(module.exports, "am", function () { return $d458fd3af41ff437$export$1a82df3d29112e01; });
$parcel$export(module.exports, "a6", function () { return $d458fd3af41ff437$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a2", function () { return $d458fd3af41ff437$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "X", function () { return $d458fd3af41ff437$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a1", function () { return $d458fd3af41ff437$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "af", function () { return $d458fd3af41ff437$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "a5", function () { return $d458fd3af41ff437$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a3", function () { return $d458fd3af41ff437$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "ar", function () { return $d458fd3af41ff437$export$d24c54395ce0c509; });
$parcel$export(module.exports, "ap", function () { return $d458fd3af41ff437$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "aq", function () { return $d458fd3af41ff437$export$8a5498727ef6be21; });
$parcel$export(module.exports, "o", function () { return $d458fd3af41ff437$export$ae1af26003f05816; });
$parcel$export(module.exports, "aA", function () { return $d458fd3af41ff437$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aB", function () { return $d458fd3af41ff437$export$9d398bebfec1c039; });
$parcel$export(module.exports, "aD", function () { return $d458fd3af41ff437$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "ay", function () { return $d458fd3af41ff437$export$28f7fcd39efa255; });
$parcel$export(module.exports, "ao", function () { return $d458fd3af41ff437$export$7a38258bbe170828; });
$parcel$export(module.exports, "an", function () { return $d458fd3af41ff437$export$306ddfe3a8403e2; });
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $d458fd3af41ff437$export$cf2f7c5792f80b46() {}
const $d458fd3af41ff437$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $d458fd3af41ff437$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
function $d458fd3af41ff437$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
function $d458fd3af41ff437$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
const $d458fd3af41ff437$export$39b482c5e57630a8 = (value)=>(typeof value === 'number' || value instanceof Number) && isFinite(+value);
function $d458fd3af41ff437$export$ef35774e6d314e91(value, defaultValue) {
    return $d458fd3af41ff437$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $d458fd3af41ff437$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $d458fd3af41ff437$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : value / dimension;
const $d458fd3af41ff437$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
function $d458fd3af41ff437$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $d458fd3af41ff437$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($d458fd3af41ff437$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($d458fd3af41ff437$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $d458fd3af41ff437$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $d458fd3af41ff437$export$738ab4df8bf92ae9(source) {
    if ($d458fd3af41ff437$export$8b22cf2602fb60ce(source)) return source.map($d458fd3af41ff437$export$738ab4df8bf92ae9);
    if ($d458fd3af41ff437$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $d458fd3af41ff437$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $d458fd3af41ff437$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
function $d458fd3af41ff437$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$d458fd3af41ff437$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($d458fd3af41ff437$export$23f2a1d2818174ef(tval) && $d458fd3af41ff437$export$23f2a1d2818174ef(sval)) $d458fd3af41ff437$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $d458fd3af41ff437$export$738ab4df8bf92ae9(sval);
}
function $d458fd3af41ff437$export$e7c866399fa523f5(target, source, options) {
    const sources = $d458fd3af41ff437$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$d458fd3af41ff437$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $d458fd3af41ff437$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$d458fd3af41ff437$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $d458fd3af41ff437$export$2219238a014317b0(target, source) {
    return $d458fd3af41ff437$export$e7c866399fa523f5(target, source, {
        merger: $d458fd3af41ff437$export$667d3bf0c5f83305
    });
}
function $d458fd3af41ff437$export$667d3bf0c5f83305(key, target, source) {
    if (!$d458fd3af41ff437$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($d458fd3af41ff437$export$23f2a1d2818174ef(tval) && $d458fd3af41ff437$export$23f2a1d2818174ef(sval)) $d458fd3af41ff437$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $d458fd3af41ff437$export$738ab4df8bf92ae9(sval);
}
function $d458fd3af41ff437$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $d458fd3af41ff437$var$keyResolvers = {
    '': (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $d458fd3af41ff437$export$2d1720544b23b823(obj, key) {
    const resolver = $d458fd3af41ff437$var$keyResolvers[key] || ($d458fd3af41ff437$var$keyResolvers[key] = $d458fd3af41ff437$var$_getKeyResolver(key));
    return resolver(obj);
}
function $d458fd3af41ff437$var$_getKeyResolver(key) {
    const keys = $d458fd3af41ff437$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $d458fd3af41ff437$export$1ee57be6f6687d2c(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $d458fd3af41ff437$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $d458fd3af41ff437$export$35e795649ee09318 = (value)=>typeof value !== 'undefined';
const $d458fd3af41ff437$export$c3950d9923825c02 = (value)=>typeof value === 'function';
const $d458fd3af41ff437$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $d458fd3af41ff437$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
const $d458fd3af41ff437$export$56c0d5a1e737357d = Math.PI;
const $d458fd3af41ff437$export$971d5caa766a69d7 = 2 * $d458fd3af41ff437$export$56c0d5a1e737357d;
const $d458fd3af41ff437$export$8c78c7c36408ea29 = $d458fd3af41ff437$export$971d5caa766a69d7 + $d458fd3af41ff437$export$56c0d5a1e737357d;
const $d458fd3af41ff437$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $d458fd3af41ff437$export$2ec5befb9e6c97d4 = $d458fd3af41ff437$export$56c0d5a1e737357d / 180;
const $d458fd3af41ff437$export$7f8ddf7c7c20b3cd = $d458fd3af41ff437$export$56c0d5a1e737357d / 2;
const $d458fd3af41ff437$export$53c86fa97d611818 = $d458fd3af41ff437$export$56c0d5a1e737357d / 4;
const $d458fd3af41ff437$export$39c1cc7c062529d4 = $d458fd3af41ff437$export$56c0d5a1e737357d * 2 / 3;
const $d458fd3af41ff437$export$df995fae86a55f06 = Math.log10;
const $d458fd3af41ff437$export$2408f22a0fab9ae5 = Math.sign;
function $d458fd3af41ff437$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $d458fd3af41ff437$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($d458fd3af41ff437$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $d458fd3af41ff437$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $d458fd3af41ff437$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $d458fd3af41ff437$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $d458fd3af41ff437$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $d458fd3af41ff437$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $d458fd3af41ff437$export$625550452a3fa3ec(degrees) {
    return degrees * ($d458fd3af41ff437$export$56c0d5a1e737357d / 180);
}
function $d458fd3af41ff437$export$d66501df72047452(radians) {
    return radians * (180 / $d458fd3af41ff437$export$56c0d5a1e737357d);
}
function $d458fd3af41ff437$export$91477dc880baac21(x) {
    if (!$d458fd3af41ff437$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $d458fd3af41ff437$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $d458fd3af41ff437$export$56c0d5a1e737357d) angle += $d458fd3af41ff437$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $d458fd3af41ff437$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $d458fd3af41ff437$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $d458fd3af41ff437$export$8c78c7c36408ea29) % $d458fd3af41ff437$export$971d5caa766a69d7 - $d458fd3af41ff437$export$56c0d5a1e737357d;
}
function $d458fd3af41ff437$export$3d12bd131bb975d1(a) {
    return (a % $d458fd3af41ff437$export$971d5caa766a69d7 + $d458fd3af41ff437$export$971d5caa766a69d7) % $d458fd3af41ff437$export$971d5caa766a69d7;
}
function $d458fd3af41ff437$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $d458fd3af41ff437$export$3d12bd131bb975d1(angle);
    const s = $d458fd3af41ff437$export$3d12bd131bb975d1(start);
    const e = $d458fd3af41ff437$export$3d12bd131bb975d1(end);
    const angleToStart = $d458fd3af41ff437$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $d458fd3af41ff437$export$3d12bd131bb975d1(e - a);
    const startToAngle = $d458fd3af41ff437$export$3d12bd131bb975d1(a - s);
    const endToAngle = $d458fd3af41ff437$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $d458fd3af41ff437$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $d458fd3af41ff437$export$9bb611d729802a56(value) {
    return $d458fd3af41ff437$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $d458fd3af41ff437$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $d458fd3af41ff437$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $d458fd3af41ff437$export$dc98b0b04f4c7758 = (table, key, value, last)=>$d458fd3af41ff437$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $d458fd3af41ff437$export$8743009a87fcb00f = (table, key, value)=>$d458fd3af41ff437$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $d458fd3af41ff437$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $d458fd3af41ff437$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $d458fd3af41ff437$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $d458fd3af41ff437$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $d458fd3af41ff437$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $d458fd3af41ff437$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $d458fd3af41ff437$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $d458fd3af41ff437$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $d458fd3af41ff437$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
const $d458fd3af41ff437$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $d458fd3af41ff437$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $d458fd3af41ff437$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $d458fd3af41ff437$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $d458fd3af41ff437$export$db202ddc8be9136 = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
const $d458fd3af41ff437$export$25ce5a424b770e84 = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
const $d458fd3af41ff437$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
function $d458fd3af41ff437$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $d458fd3af41ff437$export$a9c23c6ac3fc3eca(Math.min($d458fd3af41ff437$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $d458fd3af41ff437$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $d458fd3af41ff437$export$a9c23c6ac3fc3eca(Math.max($d458fd3af41ff437$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $d458fd3af41ff437$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $d458fd3af41ff437$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $d458fd3af41ff437$var$atEdge = (t)=>t === 0 || t === 1;
const $d458fd3af41ff437$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $d458fd3af41ff437$export$971d5caa766a69d7 / p));
const $d458fd3af41ff437$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $d458fd3af41ff437$export$971d5caa766a69d7 / p) + 1;
const $d458fd3af41ff437$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $d458fd3af41ff437$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $d458fd3af41ff437$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($d458fd3af41ff437$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$d458fd3af41ff437$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$d458fd3af41ff437$var$atEdge(t) ? t : $d458fd3af41ff437$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$d458fd3af41ff437$var$atEdge(t) ? t : $d458fd3af41ff437$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $d458fd3af41ff437$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $d458fd3af41ff437$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $d458fd3af41ff437$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $d458fd3af41ff437$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $d458fd3af41ff437$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $d458fd3af41ff437$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $d458fd3af41ff437$var$round(v) {
    return v + 0.5 | 0;
}
const $d458fd3af41ff437$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $d458fd3af41ff437$var$p2b(v) {
    return $d458fd3af41ff437$var$lim($d458fd3af41ff437$var$round(v * 2.55), 0, 255);
}
function $d458fd3af41ff437$var$n2b(v) {
    return $d458fd3af41ff437$var$lim($d458fd3af41ff437$var$round(v * 255), 0, 255);
}
function $d458fd3af41ff437$var$b2n(v) {
    return $d458fd3af41ff437$var$lim($d458fd3af41ff437$var$round(v / 2.55) / 100, 0, 1);
}
function $d458fd3af41ff437$var$n2p(v) {
    return $d458fd3af41ff437$var$lim($d458fd3af41ff437$var$round(v * 100), 0, 100);
}
const $d458fd3af41ff437$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $d458fd3af41ff437$var$hex = [
    ...'0123456789ABCDEF'
];
const $d458fd3af41ff437$var$h1 = (b)=>$d458fd3af41ff437$var$hex[b & 0xF];
const $d458fd3af41ff437$var$h2 = (b)=>$d458fd3af41ff437$var$hex[(b & 0xF0) >> 4] + $d458fd3af41ff437$var$hex[b & 0xF];
const $d458fd3af41ff437$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $d458fd3af41ff437$var$isShort = (v)=>$d458fd3af41ff437$var$eq(v.r) && $d458fd3af41ff437$var$eq(v.g) && $d458fd3af41ff437$var$eq(v.b) && $d458fd3af41ff437$var$eq(v.a);
function $d458fd3af41ff437$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $d458fd3af41ff437$var$map$1[str[1]] * 17,
            g: 255 & $d458fd3af41ff437$var$map$1[str[2]] * 17,
            b: 255 & $d458fd3af41ff437$var$map$1[str[3]] * 17,
            a: len === 5 ? $d458fd3af41ff437$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $d458fd3af41ff437$var$map$1[str[1]] << 4 | $d458fd3af41ff437$var$map$1[str[2]],
            g: $d458fd3af41ff437$var$map$1[str[3]] << 4 | $d458fd3af41ff437$var$map$1[str[4]],
            b: $d458fd3af41ff437$var$map$1[str[5]] << 4 | $d458fd3af41ff437$var$map$1[str[6]],
            a: len === 9 ? $d458fd3af41ff437$var$map$1[str[7]] << 4 | $d458fd3af41ff437$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $d458fd3af41ff437$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $d458fd3af41ff437$var$hexString(v) {
    var f = $d458fd3af41ff437$var$isShort(v) ? $d458fd3af41ff437$var$h1 : $d458fd3af41ff437$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $d458fd3af41ff437$var$alpha(v.a, f) : undefined;
}
const $d458fd3af41ff437$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $d458fd3af41ff437$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $d458fd3af41ff437$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $d458fd3af41ff437$var$hwb2rgbn(h, w, b) {
    const rgb = $d458fd3af41ff437$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $d458fd3af41ff437$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $d458fd3af41ff437$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $d458fd3af41ff437$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $d458fd3af41ff437$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($d458fd3af41ff437$var$n2b);
}
function $d458fd3af41ff437$var$hsl2rgb(h, s, l) {
    return $d458fd3af41ff437$var$calln($d458fd3af41ff437$var$hsl2rgbn, h, s, l);
}
function $d458fd3af41ff437$var$hwb2rgb(h, w, b) {
    return $d458fd3af41ff437$var$calln($d458fd3af41ff437$var$hwb2rgbn, h, w, b);
}
function $d458fd3af41ff437$var$hsv2rgb(h, s, v) {
    return $d458fd3af41ff437$var$calln($d458fd3af41ff437$var$hsv2rgbn, h, s, v);
}
function $d458fd3af41ff437$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $d458fd3af41ff437$var$hueParse(str) {
    const m = $d458fd3af41ff437$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $d458fd3af41ff437$var$p2b(+m[5]) : $d458fd3af41ff437$var$n2b(+m[5]);
    const h = $d458fd3af41ff437$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $d458fd3af41ff437$var$hwb2rgb(h, p1, p2);
    else if (m[1] === 'hsv') v = $d458fd3af41ff437$var$hsv2rgb(h, p1, p2);
    else v = $d458fd3af41ff437$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $d458fd3af41ff437$var$rotate(v, deg) {
    var h = $d458fd3af41ff437$var$rgb2hsl(v);
    h[0] = $d458fd3af41ff437$var$hue(h[0] + deg);
    h = $d458fd3af41ff437$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $d458fd3af41ff437$var$hslString(v) {
    if (!v) return;
    const a = $d458fd3af41ff437$var$rgb2hsl(v);
    const h = a[0];
    const s = $d458fd3af41ff437$var$n2p(a[1]);
    const l = $d458fd3af41ff437$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$d458fd3af41ff437$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $d458fd3af41ff437$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $d458fd3af41ff437$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $d458fd3af41ff437$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($d458fd3af41ff437$var$names$1);
    const tkeys = Object.keys($d458fd3af41ff437$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $d458fd3af41ff437$var$map[k]);
        }
        k = parseInt($d458fd3af41ff437$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $d458fd3af41ff437$var$names;
function $d458fd3af41ff437$var$nameParse(str) {
    if (!$d458fd3af41ff437$var$names) {
        $d458fd3af41ff437$var$names = $d458fd3af41ff437$var$unpack();
        $d458fd3af41ff437$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $d458fd3af41ff437$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $d458fd3af41ff437$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $d458fd3af41ff437$var$rgbParse(str) {
    const m = $d458fd3af41ff437$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $d458fd3af41ff437$var$p2b(v) : $d458fd3af41ff437$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $d458fd3af41ff437$var$p2b(r) : $d458fd3af41ff437$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $d458fd3af41ff437$var$p2b(g) : $d458fd3af41ff437$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $d458fd3af41ff437$var$p2b(b) : $d458fd3af41ff437$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $d458fd3af41ff437$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$d458fd3af41ff437$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $d458fd3af41ff437$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $d458fd3af41ff437$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $d458fd3af41ff437$var$interpolate(rgb1, rgb2, t) {
    const r = $d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb1.r));
    const g = $d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb1.g));
    const b = $d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb1.b));
    return {
        r: $d458fd3af41ff437$var$n2b($d458fd3af41ff437$var$to(r + t * ($d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb2.r)) - r))),
        g: $d458fd3af41ff437$var$n2b($d458fd3af41ff437$var$to(g + t * ($d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb2.g)) - g))),
        b: $d458fd3af41ff437$var$n2b($d458fd3af41ff437$var$to(b + t * ($d458fd3af41ff437$var$from($d458fd3af41ff437$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $d458fd3af41ff437$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $d458fd3af41ff437$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $d458fd3af41ff437$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $d458fd3af41ff437$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $d458fd3af41ff437$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $d458fd3af41ff437$var$n2b(input[3]);
        }
    } else {
        v = $d458fd3af41ff437$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $d458fd3af41ff437$var$n2b(v.a);
    }
    return v;
}
function $d458fd3af41ff437$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $d458fd3af41ff437$var$rgbParse(str);
    return $d458fd3af41ff437$var$hueParse(str);
}
class $d458fd3af41ff437$var$Color {
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $d458fd3af41ff437$var$clone(this._rgb);
        if (v) v.a = $d458fd3af41ff437$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $d458fd3af41ff437$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $d458fd3af41ff437$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $d458fd3af41ff437$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $d458fd3af41ff437$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $d458fd3af41ff437$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $d458fd3af41ff437$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $d458fd3af41ff437$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $d458fd3af41ff437$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $d458fd3af41ff437$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $d458fd3af41ff437$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $d458fd3af41ff437$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $d458fd3af41ff437$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $d458fd3af41ff437$var$rotate(this._rgb, deg);
        return this;
    }
    constructor(input){
        if (input instanceof $d458fd3af41ff437$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $d458fd3af41ff437$var$fromObject(input);
        else if (type === 'string') v = $d458fd3af41ff437$var$hexParse(input) || $d458fd3af41ff437$var$nameParse(input) || $d458fd3af41ff437$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
}
function $d458fd3af41ff437$var$index_esm(input) {
    return new $d458fd3af41ff437$var$Color(input);
}
function $d458fd3af41ff437$export$2ed0fc6709e59212(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $d458fd3af41ff437$export$db3b6bfb95261072(value) {
    return $d458fd3af41ff437$export$2ed0fc6709e59212(value) ? value : $d458fd3af41ff437$var$index_esm(value);
}
function $d458fd3af41ff437$export$f96d196f7728bb5(value) {
    return $d458fd3af41ff437$export$2ed0fc6709e59212(value) ? value : $d458fd3af41ff437$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $d458fd3af41ff437$export$3a6d5c9ae78a2c08 = Object.create(null);
const $d458fd3af41ff437$export$a93c5207d687da10 = Object.create(null);
function $d458fd3af41ff437$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $d458fd3af41ff437$var$set(root, scope, values) {
    if (typeof scope === 'string') return $d458fd3af41ff437$export$e7c866399fa523f5($d458fd3af41ff437$var$getScope$1(root, scope), values);
    return $d458fd3af41ff437$export$e7c866399fa523f5($d458fd3af41ff437$var$getScope$1(root, ''), scope);
}
class $d458fd3af41ff437$var$Defaults {
    set(scope, values) {
        return $d458fd3af41ff437$var$set(this, scope, values);
    }
    get(scope) {
        return $d458fd3af41ff437$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $d458fd3af41ff437$var$set($d458fd3af41ff437$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $d458fd3af41ff437$var$set($d458fd3af41ff437$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $d458fd3af41ff437$var$getScope$1(this, scope);
        const targetScopeObject = $d458fd3af41ff437$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($d458fd3af41ff437$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $d458fd3af41ff437$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$d458fd3af41ff437$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$d458fd3af41ff437$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$d458fd3af41ff437$export$f96d196f7728bb5(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
}
var $d458fd3af41ff437$export$4368d992c4eafac0 = new $d458fd3af41ff437$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $d458fd3af41ff437$export$9d0e2d13d04f7070(font) {
    if (!font || $d458fd3af41ff437$export$342063e11d6c3cad(font.size) || $d458fd3af41ff437$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
function $d458fd3af41ff437$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $d458fd3af41ff437$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $d458fd3af41ff437$export$8b22cf2602fb60ce(thing) !== true) longest = $d458fd3af41ff437$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($d458fd3af41ff437$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$d458fd3af41ff437$export$8b22cf2602fb60ce(nestedThing)) longest = $d458fd3af41ff437$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $d458fd3af41ff437$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $d458fd3af41ff437$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $d458fd3af41ff437$export$1fbe638ecf81657e(ctx, options, x, y) {
    $d458fd3af41ff437$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $d458fd3af41ff437$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $d458fd3af41ff437$export$2ec5befb9e6c97d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $d458fd3af41ff437$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $d458fd3af41ff437$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $d458fd3af41ff437$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $d458fd3af41ff437$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $d458fd3af41ff437$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $d458fd3af41ff437$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $d458fd3af41ff437$export$56c0d5a1e737357d, rad - $d458fd3af41ff437$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $d458fd3af41ff437$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $d458fd3af41ff437$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $d458fd3af41ff437$export$7f8ddf7c7c20b3cd, rad + $d458fd3af41ff437$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $d458fd3af41ff437$export$53c86fa97d611818;
        case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $d458fd3af41ff437$export$53c86fa97d611818;
        case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $d458fd3af41ff437$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $d458fd3af41ff437$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $d458fd3af41ff437$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $d458fd3af41ff437$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $d458fd3af41ff437$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $d458fd3af41ff437$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $d458fd3af41ff437$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $d458fd3af41ff437$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $d458fd3af41ff437$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$d458fd3af41ff437$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $d458fd3af41ff437$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $d458fd3af41ff437$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$d458fd3af41ff437$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $d458fd3af41ff437$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $d458fd3af41ff437$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$d458fd3af41ff437$export$7f8ddf7c7c20b3cd, $d458fd3af41ff437$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $d458fd3af41ff437$export$56c0d5a1e737357d, $d458fd3af41ff437$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $d458fd3af41ff437$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$d458fd3af41ff437$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $d458fd3af41ff437$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $d458fd3af41ff437$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $d458fd3af41ff437$export$fef3dfd9bad05307(value, size) {
    const matches = ('' + value).match($d458fd3af41ff437$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $d458fd3af41ff437$var$numberOrZero = (v)=>+v || 0;
function $d458fd3af41ff437$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $d458fd3af41ff437$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $d458fd3af41ff437$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$d458fd3af41ff437$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $d458fd3af41ff437$var$numberOrZero(read(prop));
    return ret;
}
function $d458fd3af41ff437$export$92108d983e8ee699(value) {
    return $d458fd3af41ff437$export$ab83b03e4111b1d0(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
function $d458fd3af41ff437$export$9fa96a7d116ea3ce(value) {
    return $d458fd3af41ff437$export$ab83b03e4111b1d0(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
function $d458fd3af41ff437$export$3466f893ebf79586(value) {
    const obj = $d458fd3af41ff437$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $d458fd3af41ff437$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $d458fd3af41ff437$export$4368d992c4eafac0.font;
    let size = $d458fd3af41ff437$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $d458fd3af41ff437$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($d458fd3af41ff437$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = '';
    }
    const font = {
        family: $d458fd3af41ff437$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $d458fd3af41ff437$export$fef3dfd9bad05307($d458fd3af41ff437$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $d458fd3af41ff437$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $d458fd3af41ff437$export$9d0e2d13d04f7070(font);
    return font;
}
function $d458fd3af41ff437$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $d458fd3af41ff437$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $d458fd3af41ff437$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $d458fd3af41ff437$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $d458fd3af41ff437$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $d458fd3af41ff437$export$7910e0436ed8d1de(scopes, prefixes = [
    ''
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$d458fd3af41ff437$export$35e795649ee09318(fallback)) fallback = $d458fd3af41ff437$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$d458fd3af41ff437$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $d458fd3af41ff437$var$_cached(target, prop, ()=>$d458fd3af41ff437$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $d458fd3af41ff437$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $d458fd3af41ff437$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $d458fd3af41ff437$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $d458fd3af41ff437$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$d458fd3af41ff437$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$d458fd3af41ff437$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $d458fd3af41ff437$var$_cached(target, prop, ()=>$d458fd3af41ff437$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $d458fd3af41ff437$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $d458fd3af41ff437$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $d458fd3af41ff437$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $d458fd3af41ff437$var$readKey = (prefix, name)=>prefix ? prefix + $d458fd3af41ff437$export$71cec2538cb2c617(name) : name;
const $d458fd3af41ff437$var$needsSubResolver = (prop, value)=>$d458fd3af41ff437$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $d458fd3af41ff437$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $d458fd3af41ff437$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($d458fd3af41ff437$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $d458fd3af41ff437$var$_resolveScriptable(prop, value, target, receiver);
    if ($d458fd3af41ff437$export$8b22cf2602fb60ce(value) && value.length) value = $d458fd3af41ff437$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($d458fd3af41ff437$var$needsSubResolver(prop, value)) value = $d458fd3af41ff437$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $d458fd3af41ff437$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($d458fd3af41ff437$var$needsSubResolver(prop, value)) value = $d458fd3af41ff437$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $d458fd3af41ff437$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($d458fd3af41ff437$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($d458fd3af41ff437$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $d458fd3af41ff437$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($d458fd3af41ff437$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $d458fd3af41ff437$var$resolveFallback(fallback, prop, value) {
    return $d458fd3af41ff437$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $d458fd3af41ff437$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $d458fd3af41ff437$export$2d1720544b23b823(parent, key) : undefined;
function $d458fd3af41ff437$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $d458fd3af41ff437$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $d458fd3af41ff437$var$resolveFallback(scope._fallback, key, value);
            if ($d458fd3af41ff437$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $d458fd3af41ff437$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $d458fd3af41ff437$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $d458fd3af41ff437$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $d458fd3af41ff437$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($d458fd3af41ff437$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $d458fd3af41ff437$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $d458fd3af41ff437$export$7910e0436ed8d1de(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$d458fd3af41ff437$var$subGetTarget(resolver, prop, value));
}
function $d458fd3af41ff437$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $d458fd3af41ff437$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $d458fd3af41ff437$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($d458fd3af41ff437$export$8b22cf2602fb60ce(target) && $d458fd3af41ff437$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $d458fd3af41ff437$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $d458fd3af41ff437$var$_resolve($d458fd3af41ff437$var$readKey(prefix, prop), scopes);
        if ($d458fd3af41ff437$export$35e795649ee09318(value)) return $d458fd3af41ff437$var$needsSubResolver(prop, value) ? $d458fd3af41ff437$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $d458fd3af41ff437$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($d458fd3af41ff437$export$35e795649ee09318(value)) return value;
    }
}
function $d458fd3af41ff437$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $d458fd3af41ff437$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $d458fd3af41ff437$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $d458fd3af41ff437$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($d458fd3af41ff437$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $d458fd3af41ff437$var$EPSILON = Number.EPSILON || 1e-14;
const $d458fd3af41ff437$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $d458fd3af41ff437$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $d458fd3af41ff437$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $d458fd3af41ff437$export$53a70dd1ebbae346(current, previous);
    const d12 = $d458fd3af41ff437$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $d458fd3af41ff437$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $d458fd3af41ff437$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $d458fd3af41ff437$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($d458fd3af41ff437$export$23ebac1979863676(deltaK[i], 0, $d458fd3af41ff437$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $d458fd3af41ff437$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $d458fd3af41ff437$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $d458fd3af41ff437$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $d458fd3af41ff437$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $d458fd3af41ff437$export$e171bab687b50e0(points, indexAxis = 'x') {
    const valueAxis = $d458fd3af41ff437$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $d458fd3af41ff437$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $d458fd3af41ff437$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $d458fd3af41ff437$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $d458fd3af41ff437$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $d458fd3af41ff437$var$monotoneAdjust(points, deltaK, mK);
    $d458fd3af41ff437$var$monotoneCompute(points, mK, indexAxis);
}
function $d458fd3af41ff437$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $d458fd3af41ff437$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $d458fd3af41ff437$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $d458fd3af41ff437$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $d458fd3af41ff437$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $d458fd3af41ff437$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $d458fd3af41ff437$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $d458fd3af41ff437$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $d458fd3af41ff437$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $d458fd3af41ff437$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $d458fd3af41ff437$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $d458fd3af41ff437$var$capBezierPoints(points, area);
}
function $d458fd3af41ff437$export$2e2af4578d910ddf() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function $d458fd3af41ff437$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
function $d458fd3af41ff437$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $d458fd3af41ff437$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $d458fd3af41ff437$export$527e9aa3390079e9(el, property) {
    return $d458fd3af41ff437$var$getComputedStyle(el).getPropertyValue(property);
}
const $d458fd3af41ff437$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $d458fd3af41ff437$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $d458fd3af41ff437$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $d458fd3af41ff437$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $d458fd3af41ff437$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($d458fd3af41ff437$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $d458fd3af41ff437$export$78acf4525d8a74c4(evt, chart) {
    if ('native' in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $d458fd3af41ff437$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $d458fd3af41ff437$var$getPositionedStyle(style, 'padding');
    const borders = $d458fd3af41ff437$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $d458fd3af41ff437$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $d458fd3af41ff437$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $d458fd3af41ff437$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $d458fd3af41ff437$var$getComputedStyle(container);
            const containerBorder = $d458fd3af41ff437$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $d458fd3af41ff437$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $d458fd3af41ff437$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $d458fd3af41ff437$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $d458fd3af41ff437$export$d29e374196577086,
        maxHeight: maxHeight || $d458fd3af41ff437$export$d29e374196577086
    };
}
const $d458fd3af41ff437$var$round1 = (v)=>Math.round(v * 10) / 10;
function $d458fd3af41ff437$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $d458fd3af41ff437$var$getComputedStyle(canvas);
    const margins = $d458fd3af41ff437$var$getPositionedStyle(style, 'margin');
    const maxWidth = $d458fd3af41ff437$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $d458fd3af41ff437$export$d29e374196577086;
    const maxHeight = $d458fd3af41ff437$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $d458fd3af41ff437$export$d29e374196577086;
    const containerSize = $d458fd3af41ff437$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $d458fd3af41ff437$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $d458fd3af41ff437$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $d458fd3af41ff437$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $d458fd3af41ff437$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $d458fd3af41ff437$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $d458fd3af41ff437$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $d458fd3af41ff437$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $d458fd3af41ff437$export$6559d589eb85fbb6(element, property) {
    const value = $d458fd3af41ff437$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $d458fd3af41ff437$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $d458fd3af41ff437$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $d458fd3af41ff437$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $d458fd3af41ff437$export$d24c54395ce0c509(p1, cp1, t);
    const b = $d458fd3af41ff437$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $d458fd3af41ff437$export$d24c54395ce0c509(cp2, p2, t);
    const d = $d458fd3af41ff437$export$d24c54395ce0c509(a, b, t);
    const e = $d458fd3af41ff437$export$d24c54395ce0c509(b, c, t);
    return $d458fd3af41ff437$export$d24c54395ce0c509(d, e, t);
}
const $d458fd3af41ff437$var$intlCache = new Map();
function $d458fd3af41ff437$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $d458fd3af41ff437$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $d458fd3af41ff437$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $d458fd3af41ff437$export$ae1af26003f05816(num, locale, options) {
    return $d458fd3af41ff437$var$getNumberFormat(locale, options).format(num);
}
const $d458fd3af41ff437$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $d458fd3af41ff437$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $d458fd3af41ff437$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $d458fd3af41ff437$var$getRightToLeftAdapter(rectX, width) : $d458fd3af41ff437$var$getLeftToRightAdapter();
}
function $d458fd3af41ff437$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $d458fd3af41ff437$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $d458fd3af41ff437$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $d458fd3af41ff437$export$ffb5f4729a158638,
        compare: $d458fd3af41ff437$export$7a0bdf7d4a91ea88,
        normalize: $d458fd3af41ff437$export$3d12bd131bb975d1
    };
    return {
        between: $d458fd3af41ff437$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $d458fd3af41ff437$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $d458fd3af41ff437$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $d458fd3af41ff437$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $d458fd3af41ff437$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $d458fd3af41ff437$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $d458fd3af41ff437$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($d458fd3af41ff437$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($d458fd3af41ff437$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $d458fd3af41ff437$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $d458fd3af41ff437$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $d458fd3af41ff437$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $d458fd3af41ff437$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $d458fd3af41ff437$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $d458fd3af41ff437$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $d458fd3af41ff437$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $d458fd3af41ff437$var$splitByStyles(line, $d458fd3af41ff437$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $d458fd3af41ff437$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $d458fd3af41ff437$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $d458fd3af41ff437$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $d458fd3af41ff437$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $d458fd3af41ff437$var$readStyle(segmentOptions.setContext($d458fd3af41ff437$export$dda1d9f60106f0e9(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($d458fd3af41ff437$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $d458fd3af41ff437$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $d458fd3af41ff437$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

});


parcelRegister("9Zbkq", function(module, exports) {

$parcel$export(module.exports, "Chart", function () { return $7452992c2225c418$export$acaa6426d77a227e; });
$parcel$export(module.exports, "Line", function () { return $7452992c2225c418$export$17d680238e50603e; });
$parcel$export(module.exports, "Bar", function () { return $7452992c2225c418$export$bbc6c6369b38e3d1; });
$parcel$export(module.exports, "Doughnut", function () { return $7452992c2225c418$export$b8b3cfdc3fe36b10; });
$parcel$export(module.exports, "Pie", function () { return $7452992c2225c418$export$2ae8800cf67c848c; });
$parcel$export(module.exports, "Scatter", function () { return $7452992c2225c418$export$1c460fb4285edadc; });

var $9tqwB = parcelRequire("9tqwB");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");

var $itmb4 = parcelRequire("itmb4");
const $7452992c2225c418$var$defaultDatasetIdKey = 'label';
function $7452992c2225c418$var$reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $7452992c2225c418$var$setOptions(chart, nextOptions) {
    Object.assign(chart.options, nextOptions);
}
function $7452992c2225c418$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $7452992c2225c418$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $7452992c2225c418$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return (0, $9tqwB._)({}, nextDataset);
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $7452992c2225c418$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7452992c2225c418$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $7452992c2225c418$var$setLabels(nextData, data.labels);
    $7452992c2225c418$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function $7452992c2225c418$var$ChartComponent(param, ref) {
    let { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode } = param, props = (0, $bLhVg._)(param, [
        "height",
        "width",
        "redraw",
        "datasetIdKey",
        "type",
        "data",
        "options",
        "plugins",
        "fallbackContent",
        "updateMode"
    ]);
    const canvasRef = (0, $7fPBF.useRef)(null);
    const chartRef = (0, $7fPBF.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $itmb4.Chart)(canvasRef.current, {
            type: type,
            data: $7452992c2225c418$var$cloneData(data, datasetIdKey),
            options: options && (0, $9tqwB._)({}, options),
            plugins: plugins
        });
        $7452992c2225c418$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $7452992c2225c418$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $7452992c2225c418$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current) $7452992c2225c418$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $7452992c2225c418$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $7fPBF.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent);
}
const $7452992c2225c418$export$acaa6426d77a227e = /*#__PURE__*/ (0, $7fPBF.forwardRef)($7452992c2225c418$var$ChartComponent);
function $7452992c2225c418$var$createTypedChart(type, registerables) {
    (0, $itmb4.Chart).register(registerables);
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7452992c2225c418$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $7452992c2225c418$export$17d680238e50603e = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('line', (0, $itmb4.LineController));
const $7452992c2225c418$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('bar', (0, $itmb4.BarController));
const $7452992c2225c418$export$bace472c466fdd25 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('radar', (0, $itmb4.RadarController));
const $7452992c2225c418$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('doughnut', (0, $itmb4.DoughnutController));
const $7452992c2225c418$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('polarArea', (0, $itmb4.PolarAreaController));
const $7452992c2225c418$export$646feb54fbadbe06 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('bubble', (0, $itmb4.BubbleController));
const $7452992c2225c418$export$2ae8800cf67c848c = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('pie', (0, $itmb4.PieController));
const $7452992c2225c418$export$1c460fb4285edadc = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('scatter', (0, $itmb4.ScatterController));

});


parcelRegister("a3nRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751cb1f3cac6697b$export$2e2bcd8739ae039; });
// import React, { useEffect } from "react";
// import AutocompleteInput from "./components/autoCompleteInput";
// import FilterContainer from "./components/filterContainer";
// import { COLORS } from "~src/data/constant";
// import DateFilterContainer from "./components/dateFilter/dateFilterContainer";
// import moment from "moment";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import AddIcon from "@mui/icons-material/Add";
// function GlobalFilters({
//   provider,
//   setProvider,
//   providerLabel,
//   handleAddProvider,
//   providerIdx,
//   handleDeleteProvider,
//   displayDates,
//   setDisplayDates,
// }) {
//   const handleFilterChange = (event) => {
//     const fieldName = event.target.name;
//     const fieldValue = event.target.value;
//     const currentProvider = { ...provider[providerLabel] };
//     currentProvider[fieldName] = Array.isArray(fieldValue)
//       ? fieldValue
//       : [fieldValue];
//     const providerListCopy = { ...provider };
//     providerListCopy[providerLabel] = currentProvider;
//     setProvider(() => providerListCopy);
//   };
//   const handleDateChange = (event) => {
//     setDisplayDates(() => ({ startDate: null, endDate: null }));
//     const fieldName = event.target.name;
//     const fieldValueFrom = event.target.fromDate;
//     const fieldValueTo = event.target.toDate;
//     if (fieldName === "time-period") {
//       const currentProvider = { ...provider[providerLabel] };
//       currentProvider["transaction-fromdate"] = [
//         moment(fieldValueFrom, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];
//       currentProvider["transaction-todate"] = [
//         moment(fieldValueTo, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];
//       const providerListCopy = { ...provider };
//       providerListCopy[providerLabel] = currentProvider;
//       setProvider(() => providerListCopy);
//     } else {
//       const fieldValue = event.target.value;
//       const currentProvider = { ...provider[providerLabel] };
//       currentProvider[fieldName] = [
//         moment(fieldValue, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];
//       const providerListCopy = { ...provider };
//       providerListCopy[providerLabel] = currentProvider;
//       setProvider(() => providerListCopy);
//     }
//   };
//   const inputFilters = [
//     { filtername: "group", placeholder: "Group" },
//     { filtername: "type", placeholder: "Type" },
//     { filtername: "name", placeholder: "Name" },
//     { filtername: "clinician-speciality", placeholder: "Speciality" },
//     { filtername: "clinician-name", placeholder: "Clinician" },
//   ];
//   return (
//     <div className="providers p-0 mb-2 w-100">
//       <div className="d-flex flex-row w-100 justify-content-between align-items-center pt-2 px-2">
//         <div
//           className="mt-2 dot"
//           style={{
//             backgroundColor:
//               COLORS.length > providerIdx ? COLORS[providerIdx] : COLORS[0],
//           }}
//         />
//         <div className="d-flex ms-2 mt-2 flex-grow-1">
//           {inputFilters.map((filter, index) => (
//             <AutocompleteInput
//               key={`autocomplete_${provider}_${index}`}
//               page="comparisons"
//               filtername={filter.filtername}
//               placeholder={filter.placeholder}
//               type="main"
//               setProvider={setProvider}
//               provider={provider[providerLabel]}
//               providerLabel={providerLabel}
//               providerList={provider}
//             />
//           ))}
//         </div>
//         <div
//           className="d-flex align-items-center ms-5 mb-1"
//           style={{ width: "40rem" }}
//         >
//           <div>
//             <FilterContainer
//               provider={provider[providerLabel]}
//               handleFilterChange={handleFilterChange}
//             />
//           </div>
//           <div>
//             <DateFilterContainer
//               provider={provider[providerLabel]}
//               handleDateChange={handleDateChange}
//               displayDates={displayDates}
//               setDisplayDates={setDisplayDates}
//             />
//           </div>
//           {providerIdx === 0 ? (
//             <AddIcon
//               color="primary"
//               style={{ cursor: "pointer" }}
//               onClick={() => handleAddProvider()}
//             />
//           ) : (
//             <DeleteOutlineIcon
//               color="primary"
//               style={{ cursor: "pointer" }}
//               onClick={() => handleDeleteProvider(providerLabel)}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
// export default GlobalFilters;
//code for linking dash

var $9tqwB = parcelRequire("9tqwB");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $hWqqs = parcelRequire("hWqqs");

var $1m95Z = parcelRequire("1m95Z");

var $aqd0z = parcelRequire("aqd0z");

var $6oHM0 = parcelRequire("6oHM0");

var $6qwOn = parcelRequire("6qwOn");

var $bjG5Z = parcelRequire("bjG5Z");

var $exavO = parcelRequire("exavO");
function $751cb1f3cac6697b$var$GlobalFilters({ provider: provider, setProvider: setProvider, providerLabel: providerLabel, handleAddProvider: handleAddProvider, providerIdx: providerIdx, handleDeleteProvider: handleDeleteProvider, displayDates: displayDates, setDisplayDates: setDisplayDates }) {
    const location = (0, $7o2xp.useLocation)();
    const history = (0, $7o2xp.useHistory)(); // For setting URL query parameter
    // Set provider name from navigation state on mount
    (0, $7fPBF.useEffect)(()=>{
        var _location_state;
        const providerName = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.providerName;
        if (providerName) {
            const currentProvider = (0, $9tqwB._)({}, provider[providerLabel]);
            currentProvider["name"] = [
                providerName
            ]; // Set as array for AutocompleteInput
            const providerListCopy = (0, $9tqwB._)({}, provider);
            providerListCopy[providerLabel] = currentProvider;
            setProvider(providerListCopy);
            // Set URL query parameter to sync with AutocompleteInput
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("provider-name", providerName);
            history.push({
                pathname: location.pathname,
                search: searchParams.toString()
            });
        }
    }, [
        location.state,
        provider,
        providerLabel,
        setProvider,
        history,
        location.pathname,
        location.search
    ]);
    const handleFilterChange = (event)=>{
        const fieldName = event.target.name;
        const fieldValue = event.target.value;
        const currentProvider = (0, $9tqwB._)({}, provider[providerLabel]);
        currentProvider[fieldName] = Array.isArray(fieldValue) ? fieldValue : [
            fieldValue
        ];
        const providerListCopy = (0, $9tqwB._)({}, provider);
        providerListCopy[providerLabel] = currentProvider;
        setProvider(()=>providerListCopy);
    };
    const handleDateChange = (event)=>{
        setDisplayDates(()=>({
                startDate: null,
                endDate: null
            }));
        const fieldName = event.target.name;
        const fieldValueFrom = event.target.fromDate;
        const fieldValueTo = event.target.toDate;
        if (fieldName === "time-period") {
            const currentProvider = (0, $9tqwB._)({}, provider[providerLabel]);
            currentProvider["transaction-fromdate"] = [
                (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(fieldValueFrom, "YYYY-MM-DD").format("DD-MM-YYYY")
            ];
            currentProvider["transaction-todate"] = [
                (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(fieldValueTo, "YYYY-MM-DD").format("DD-MM-YYYY")
            ];
            const providerListCopy = (0, $9tqwB._)({}, provider);
            providerListCopy[providerLabel] = currentProvider;
            setProvider(()=>providerListCopy);
        } else {
            const fieldValue = event.target.value;
            const currentProvider = (0, $9tqwB._)({}, provider[providerLabel]);
            currentProvider[fieldName] = [
                (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(fieldValue, "YYYY-MM-DD").format("DD-MM-YYYY")
            ];
            const providerListCopy = (0, $9tqwB._)({}, provider);
            providerListCopy[providerLabel] = currentProvider;
            setProvider(()=>providerListCopy);
        }
    };
    const inputFilters = [
        {
            filtername: "group",
            placeholder: "Group"
        },
        {
            filtername: "type",
            placeholder: "Type"
        },
        {
            filtername: "name",
            placeholder: "Name"
        },
        {
            filtername: "clinician-speciality",
            placeholder: "Speciality"
        },
        {
            filtername: "clinician-name",
            placeholder: "Clinician"
        }
    ];
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "providers p-0 mb-2 w-100",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "d-flex flex-row w-100 justify-content-between align-items-center pt-2 px-2",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "mt-2 dot",
                    style: {
                        backgroundColor: (0, $aqd0z.COLORS).length > providerIdx ? (0, $aqd0z.COLORS)[providerIdx] : (0, $aqd0z.COLORS)[0]
                    }
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "d-flex ms-2 mt-2 flex-grow-1",
                    children: inputFilters.map((filter, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $hWqqs.default), {
                            page: "comparisons",
                            filtername: filter.filtername,
                            placeholder: filter.placeholder,
                            type: "main",
                            setProvider: setProvider,
                            provider: provider[providerLabel],
                            providerLabel: providerLabel,
                            providerList: provider
                        }, `autocomplete_${provider}_${index}`))
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "d-flex align-items-center ms-5 mb-1",
                    style: {
                        width: "40rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1m95Z.default), {
                                provider: provider[providerLabel],
                                handleFilterChange: handleFilterChange
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6oHM0.default), {
                                provider: provider[providerLabel],
                                handleDateChange: handleDateChange,
                                displayDates: displayDates,
                                setDisplayDates: setDisplayDates
                            })
                        }),
                        providerIdx === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exavO))), {
                            color: "primary",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>handleAddProvider()
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjG5Z))), {
                            color: "primary",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>handleDeleteProvider(providerLabel)
                        })
                    ]
                })
            ]
        })
    });
}
var $751cb1f3cac6697b$export$2e2bcd8739ae039 = $751cb1f3cac6697b$var$GlobalFilters;

});
parcelRegister("hWqqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0fc5a06678d45af$export$2e2bcd8739ae039; });
// import React, { useState, useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import CircularProgress from "@mui/material/CircularProgress";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import callAPI from "~src/utils/callAPI";
// export default function AutocompleteInput(props) {
//   const {
//     placeholder,
//     filtername,
//     type,
//     provider,
//     setProvider,
//     providerLabel,
//     providerList,
//   } = props;
//   const history = useHistory();
//   const location = useLocation();
//   const { pathname } = location;
//   const searchParams = new URLSearchParams(location.search);
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterValue, setFilterValue] = useState(() => {
//     const paramValue = searchParams.get(filtername);
//     return paramValue ? { name: paramValue } : { name: "" };
//   });
//   const [options, setOptions] = useState([]);
//   const loading = isOpen && options.length === 0;
//   const handleInput = (event, value, reason) => {
//     if (reason === "input") {
//       setSearchTerm(value);
//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }
//       if (type === undefined) {
//         if (value.length === 0) {
//           searchParams.delete(filterAPI);
//           history.push({
//             pathname,
//             search: searchParams.toString(),
//           });
//           setFilterValue({ name: "" });
//         }
//       } else {
//         if (value.length === 0) {
//           setSearchTerm("");
//           const currentProvider = { ...provider };
//           currentProvider[filterAPI] = [];
//           const providerListCopy = { ...providerList };
//           providerListCopy[providerLabel] = currentProvider;
//           setProvider(() => ({
//             ...providerListCopy,
//           }));
//           searchParams.delete(filterAPI);
//           history.push({
//             pathname,
//             search: searchParams.toString(),
//           });
//           setFilterValue({ name: "" });
//         }
//       }
//     }
//   };
//   const handleChange = (event, value, reason) => {
//     if (reason === "selectOption") {
//       setIsOpen(false);
//       setOptions([]);
//       setSearchTerm("");
//       setFilterValue({ name: value.name });
//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }
//       if (type === undefined) {
//         searchParams.set(`${filterAPI}`, value.name);
//         history.push({
//           pathname,
//           search: searchParams.toString(),
//         });
//       } else {
//         const currentProvider = { ...provider };
//         // console.log("curr",currentProvider);
//         currentProvider[filterAPI] = [value.name];
//         const providerListCopy = { ...providerList };
//         providerListCopy[providerLabel] = currentProvider;
//         setProvider(() => ({
//           ...providerListCopy,
//         }));
//       }
//     }
//   };
//   useEffect(() => {
//     if (isOpen) {
//       searchParams.delete(filtername);
//       let queryString = "";
//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }
//       const providerDetails = {};
//       providerDetails["provider-group"] = provider["provider-group"];
//       providerDetails["provider-type"] = provider["provider-type"];
//       providerDetails["provider-name"] = provider["provider-name"];
//       providerDetails["clinician-speciality"] =
//         provider["clinician-speciality"];
//       const existingParams = new URLSearchParams(providerDetails).toString();
//       queryString = `${existingParams}&q=${searchTerm}&filter_name=${filterAPI}`;
//       if (
//         filtername === "clinician-name" ||
//         filtername === "clinician-speciality"
//       ) {
//         const providerDetails = {};
//         providerDetails["provider-group"] = provider["provider-group"];
//         providerDetails["provider-type"] = provider["provider-type"];
//         providerDetails["provider-name"] = provider["provider-name"];
//         providerDetails["clinician-speciality"] =
//           provider["clinician-speciality"];
//         callAPI("GET", `get_filters/?${queryString}`, "").then((res) => {
//           let providerField = [];
//           if (res && Array.isArray(res)) {
//             if (filtername === "clinician-name") {
//               providerField = res?.map((value) => ({
//                 name: value.clinician__name,
//               }));
//             } else {
//               providerField = res?.map((value) => ({
//                 name: value.clinician__category,
//               }));
//             }
//             setOptions([...providerField]);
//           } else {
//             setOptions(["undefined"]);
//           }
//         });
//       } else {
//         callAPI("GET", `get_filters/provider?${queryString}`, "").then(
//           (res) => {
//             let providerField = [];
//             if (filtername === "group" || filtername === "provider-group") {
//               providerField =
//                 res && Array.isArray(res)
//                   ? res.map((value) => ({
//                       name: value.prov_group,
//                     }))
//                   : [];
//             } else if (
//               filtername === "group" ||
//               filtername === "provider-group" ||
//               filtername === "name" ||
//               filtername === "provider-name"
//             ) {
//               providerField = res.map((value) => ({
//                 name: value.name,
//               }));
//             } else if (
//               filtername === "type" ||
//               filtername === "provider-type"
//             ) {
//               providerField = res.map((value) => ({
//                 name: value.facility_type,
//               }));
//             }
//             setOptions([...providerField]);
//           }
//         );
//       }
//     }
//   }, [searchTerm, isOpen]);
//   useEffect(() => {
//     if (!isOpen) {
//       setOptions([]);
//     }
//   }, [isOpen]);
//   useEffect(() => {
//     // set filter value if we pass global filter in browser search bar directly
//     setFilterValue(() => {
//       const paramValue = searchParams.get(filtername);
//       return paramValue ? { name: paramValue } : { name: "" };
//     });
//   }, []);
//   return (
//     <>
//       <div className="w-100">
//         <Autocomplete
//           open={isOpen}
//           openOnFocus
//           onClose={() => {
//             setIsOpen(false);
//           }}
//           onOpen={() => {
//             setIsOpen(true);
//           }}
//           autoComplete
//           value={filterValue}
//           className="w-100 px-2"
//           filterOptions={(x) => x}
//           noOptionsText="loading..."
//           isOptionEqualToValue={(option, value) => option.name === value.name}
//           onClick={() => setIsOpen(true)}
//           getOptionLabel={(option) => option.name}
//           onInputChange={handleInput}
//           onChange={handleChange}
//           options={options}
//           renderOption={(props, option) => (
//             <li
//               {...props}
//               key={`${option.name}`}
//               className="option-row d-flex justify-content-between px-3 py-2 border-bottom"
//             >
//               {option.name}
//             </li>
//           )}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               variant="standard"
//               placeholder={placeholder}
//               InputProps={{
//                 ...params.InputProps,
//                 style: { fontSize: "12px", padding: "0" },
//                 disableUnderline: false,
//                 endAdornment: (
//                   <div>
//                     {loading ? (
//                       <CircularProgress color="inherit" size={20} />
//                     ) : null}
//                   </div>
//                 ),
//               }}
//             />
//           )}
//         />
//       </div>
//       <span>/ </span>
//     </>
//   );
// }
// code for linking dash and increased width for filters

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $iibPM = parcelRequire("iibPM");

var $f6ezL = parcelRequire("f6ezL");

var $fE4eY = parcelRequire("fE4eY");

var $7bFjM = parcelRequire("7bFjM");

var $41bfV = parcelRequire("41bfV");
function $d0fc5a06678d45af$export$2e2bcd8739ae039(props) {
    const { placeholder: placeholder, filtername: filtername, type: type, provider: provider, setProvider: setProvider, providerLabel: providerLabel, providerList: providerList } = props;
    const history = (0, $7o2xp.useHistory)();
    const location = (0, $7o2xp.useLocation)();
    const { pathname: pathname } = location;
    const searchParams = new URLSearchParams(location.search);
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $7fPBF.useState)("");
    const [filterValue, setFilterValue] = (0, $7fPBF.useState)(()=>{
        var _provider_filtername;
        const providerValue = (_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0];
        const paramValue = searchParams.get(filtername);
        return providerValue ? {
            name: providerValue
        } : paramValue ? {
            name: paramValue
        } : {
            name: ""
        };
    });
    const [options, setOptions] = (0, $7fPBF.useState)([]);
    const loading = isOpen && options.length === 0;
    // Sync filterValue with provider[filtername] or searchParams
    (0, $7fPBF.useEffect)(()=>{
        var _provider_filtername;
        const providerValue = (_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0];
        const paramValue = searchParams.get(filtername);
        if (providerValue && filterValue.name !== providerValue) setFilterValue({
            name: providerValue
        });
        else if (paramValue && filterValue.name !== paramValue && !providerValue) setFilterValue({
            name: paramValue
        });
    }, [
        provider,
        filtername,
        searchParams
    ]);
    // Fetch options on mount if provider[filtername] or searchParams is set
    (0, $7fPBF.useEffect)(()=>{
        var _provider_filtername;
        const providerValue = (_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0];
        const paramValue = searchParams.get(filtername);
        if ((providerValue || paramValue) && options.length === 0) fetchOptions(providerValue || paramValue || "");
    }, [
        provider,
        filtername,
        searchParams
    ]);
    const fetchOptions = (query = "")=>{
        let filterAPI = filtername;
        if (filtername.split("-").length === 1) filterAPI = `provider-${filtername}`;
        const providerDetails = {
            "provider-group": provider["provider-group"],
            "provider-type": provider["provider-type"],
            "provider-name": provider["provider-name"],
            "clinician-speciality": provider["clinician-speciality"]
        };
        const existingParams = new URLSearchParams(providerDetails).toString();
        const queryString = `${existingParams}&q=${query}&filter_name=${filterAPI}`;
        if (filtername === "clinician-name" || filtername === "clinician-speciality") (0, $7bFjM.default)("GET", `get_filters/?${queryString}`, "").then((res)=>{
            var _provider_filtername;
            let providerField = [];
            if (Array.isArray(res)) {
                if (filtername === "clinician-name") providerField = res.map((value)=>({
                        name: value.clinician__name
                    }));
                else providerField = res.map((value)=>({
                        name: value.clinician__category
                    }));
            } else console.error(`API response for ${filtername} is not an array:`, res);
            const providerValue = ((_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0]) || query;
            if (providerValue && !providerField.some((opt)=>opt.name === providerValue)) providerField.push({
                name: providerValue
            });
            setOptions([
                ...providerField
            ]);
        }).catch((error)=>{
            var _provider_filtername;
            console.error(`Error fetching ${filtername} options:`, error);
            const providerValue = ((_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0]) || query;
            setOptions(providerValue ? [
                {
                    name: providerValue
                }
            ] : []);
        });
        else (0, $7bFjM.default)("GET", `get_filters/provider?${queryString}`, "").then((res)=>{
            var _provider_filtername;
            let providerField = [];
            if (Array.isArray(res)) {
                if (filtername === "group" || filtername === "provider-group") providerField = res.map((value)=>({
                        name: value.prov_group
                    })) || [];
                else if (filtername === "name" || filtername === "provider-name") providerField = res.map((value)=>({
                        name: value.name
                    })) || [];
                else if (filtername === "type" || filtername === "provider-type") providerField = res.map((value)=>({
                        name: value.facility_type
                    })) || [];
            } else console.error(`API response for ${filtername} is not an array:`, res);
            const providerValue = ((_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0]) || query;
            if (providerValue && !providerField.some((opt)=>opt.name === providerValue)) providerField.push({
                name: providerValue
            });
            setOptions([
                ...providerField
            ]);
        }).catch((error)=>{
            var _provider_filtername;
            console.error(`Error fetching ${filtername} options:`, error);
            const providerValue = ((_provider_filtername = provider[filtername]) === null || _provider_filtername === void 0 ? void 0 : _provider_filtername[0]) || query;
            setOptions(providerValue ? [
                {
                    name: providerValue
                }
            ] : []);
        });
    };
    const handleInput = (event, value, reason)=>{
        if (reason === "input") {
            setSearchTerm(value);
            let filterAPI = filtername;
            if (filtername.split("-").length === 1) filterAPI = `provider-${filtername}`;
            if (value.length === 0) {
                setFilterValue({
                    name: ""
                });
                const currentProvider = (0, $9tqwB._)({}, provider);
                currentProvider[filterAPI] = [];
                const providerListCopy = (0, $9tqwB._)({}, providerList);
                providerListCopy[providerLabel] = currentProvider;
                setProvider((0, $9tqwB._)({}, providerListCopy));
                searchParams.delete(filterAPI);
                history.push({
                    pathname: pathname,
                    search: searchParams.toString()
                });
            }
        }
    };
    const handleChange = (event, value, reason)=>{
        if (reason === "selectOption") {
            setIsOpen(false);
            setOptions([]);
            setSearchTerm("");
            setFilterValue({
                name: value.name
            });
            let filterAPI = filtername;
            if (filtername.split("-").length === 1) filterAPI = `provider-${filtername}`;
            const currentProvider = (0, $9tqwB._)({}, provider);
            currentProvider[filterAPI] = [
                value.name
            ];
            const providerListCopy = (0, $9tqwB._)({}, providerList);
            providerListCopy[providerLabel] = currentProvider;
            setProvider((0, $9tqwB._)({}, providerListCopy));
            searchParams.set(filterAPI, value.name);
            history.push({
                pathname: pathname,
                search: searchParams.toString()
            });
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isOpen) fetchOptions(searchTerm);
        else setOptions([]);
    }, [
        searchTerm,
        isOpen
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "w-100",
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fE4eY.default), {
                open: isOpen,
                openOnFocus: true,
                onClose: ()=>setIsOpen(false),
                onOpen: ()=>setIsOpen(true),
                autoComplete: true,
                value: filterValue,
                className: "w-100 px-2",
                filterOptions: (x)=>x,
                noOptionsText: "loading...",
                isOptionEqualToValue: (option, value)=>option.name === value.name,
                onClick: ()=>setIsOpen(true),
                getOptionLabel: (option)=>option.name || "",
                onInputChange: handleInput,
                onChange: handleChange,
                options: options,
                PopperComponent: (popperProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $41bfV.default), (0, $2qxEV._)((0, $9tqwB._)({}, popperProps), {
                        style: (0, $2qxEV._)((0, $9tqwB._)({}, popperProps.style), {
                            minWidth: "200px",
                            maxWidth: "90vw"
                        }),
                        placement: "bottom-start"
                    })),
                renderOption: (props, option)=>/*#__PURE__*/ (0, $7fPBF.createElement)("li", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                        key: `${option.name}`,
                        className: "option-row d-flex justify-content-between px-3 py-2 border-bottom",
                        style: {
                            whiteSpace: "normal",
                            wordBreak: "break-word"
                        }
                    }), option.name),
                renderInput: (params)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), (0, $2qxEV._)((0, $9tqwB._)({}, params), {
                        variant: "standard",
                        placeholder: placeholder,
                        "aria-label": `Filter by ${placeholder}`,
                        InputProps: (0, $2qxEV._)((0, $9tqwB._)({}, params.InputProps), {
                            style: {
                                fontSize: "12px",
                                padding: "0"
                            },
                            disableUnderline: false,
                            endAdornment: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: loading ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iibPM.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null
                            })
                        })
                    })),
                sx: {
                    "& .MuiAutocomplete-popper": {
                        minWidth: "300px",
                        maxWidth: "90vw",
                        width: "auto !important"
                    },
                    "& .MuiAutocomplete-listbox": {
                        maxHeight: "50vh",
                        overflowY: "auto",
                        padding: 0
                    },
                    "& .MuiAutocomplete-option": {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        padding: "8px 16px"
                    }
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: "/ "
            })
        ]
    });
}

});
parcelRegister("iibPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d513166e63c42433$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $5nUae = parcelRequire("5nUae");

var $b6UUh = parcelRequire("b6UUh");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $d0vho = parcelRequire("d0vho");

var $bbzbN = parcelRequire("bbzbN");
'use client';
let $d513166e63c42433$var$_ = (t)=>t, $d513166e63c42433$var$t, $d513166e63c42433$var$t1, $d513166e63c42433$var$t2, $d513166e63c42433$var$t3;
const $d513166e63c42433$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $d513166e63c42433$var$_1 = (t)=>t, $d513166e63c42433$var$_t, $d513166e63c42433$var$_t2, $d513166e63c42433$var$_t3, $d513166e63c42433$var$_t4;
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t || ($d513166e63c42433$var$_t = $d513166e63c42433$var$_1($d513166e63c42433$var$t || ($d513166e63c42433$var$t = $d513166e63c42433$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $d513166e63c42433$var$circularDashKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t2 || ($d513166e63c42433$var$_t2 = $d513166e63c42433$var$_1($d513166e63c42433$var$t1 || ($d513166e63c42433$var$t1 = $d513166e63c42433$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $b6UUh.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $b6UUh.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $d0vho.getCircularProgressUtilityClass), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $kDBhE.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $5nUae.css)($d513166e63c42433$var$_t3 || ($d513166e63c42433$var$_t3 = $d513166e63c42433$var$_1($d513166e63c42433$var$t2 || ($d513166e63c42433$var$t2 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $d513166e63c42433$var$circularRotateKeyframe));
const $d513166e63c42433$var$CircularProgressSVG = (0, $kDBhE.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $kDBhE.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $5nUae.css)($d513166e63c42433$var$_t4 || ($d513166e63c42433$var$_t4 = $d513166e63c42433$var$_1($d513166e63c42433$var$t3 || ($d513166e63c42433$var$t3 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $d513166e63c42433$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $cFLic.default)(props, $d513166e63c42433$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        style: (0, $kY3Ke.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;

});
parcelRegister("d0vho", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $978389e4a0c045ec$export$29cad1383b3f235d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $k6RDS.default)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $4jzsB.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;

});


parcelRegister("fE4eY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b63de180c8636c16$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");



var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $8ux4Q = parcelRequire("8ux4Q");

var $41bfV = parcelRequire("41bfV");

var $laXAF = parcelRequire("laXAF");

var $a2ay0 = parcelRequire("a2ay0");

var $8TDId = parcelRequire("8TDId");

var $2hGJ2 = parcelRequire("2hGJ2");

var $eFvie = parcelRequire("eFvie");

var $3HkEr = parcelRequire("3HkEr");

var $lCN2y = parcelRequire("lCN2y");

var $gImJ8 = parcelRequire("gImJ8");

var $bVWI3 = parcelRequire("bVWI3");

var $aI4oF = parcelRequire("aI4oF");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $f75vu = parcelRequire("f75vu");

var $b6UUh = parcelRequire("b6UUh");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $b63de180c8636c16$var$_ClearIcon, $b63de180c8636c16$var$_ArrowDropDownIcon;
const $b63de180c8636c16$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $b63de180c8636c16$var$_excluded2 = [
    "ref"
], $b63de180c8636c16$var$_excluded3 = [
    "key"
], $b63de180c8636c16$var$_excluded4 = [
    "key"
];
const $b63de180c8636c16$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $b6UUh.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $f75vu.getAutocompleteUtilityClass), classes);
};
const $b63de180c8636c16$var$AutocompleteRoot = (0, $kDBhE.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $f75vu.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $f75vu.default).tag}`]: styles[`tagSize${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $f75vu.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $f75vu.default).input}`]: styles.input
            },
            {
                [`& .${(0, $f75vu.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $f75vu.default).focused} .${(0, $f75vu.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $f75vu.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $f75vu.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $f75vu.default).inputRoot}`]: {
        [`.${(0, $f75vu.default).hasPopupIcon}&, .${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $f75vu.default).hasPopupIcon}.${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $f75vu.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $eFvie.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $eFvie.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
        [`& .${(0, $eFvie.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $lCN2y.default).root}`]: {
        padding: 9,
        [`.${(0, $f75vu.default).hasPopupIcon}&, .${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $f75vu.default).hasPopupIcon}.${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $f75vu.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $f75vu.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $lCN2y.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $f75vu.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $gImJ8.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $f75vu.default).hasPopupIcon}&, .${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $f75vu.default).hasPopupIcon}.${(0, $f75vu.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $gImJ8.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $f75vu.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $gImJ8.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $3HkEr.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $f75vu.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).hiddenLabel}.${(0, $3HkEr.default).sizeSmall}`]: {
        [`& .${(0, $f75vu.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $f75vu.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $f75vu.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $f75vu.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $f75vu.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $b63de180c8636c16$var$AutocompleteEndAdornment = (0, $kDBhE.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $b63de180c8636c16$var$AutocompleteClearIndicator = (0, $kDBhE.default)((0, $8TDId.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $b63de180c8636c16$var$AutocompletePopupIndicator = (0, $kDBhE.default)((0, $8TDId.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $kY3Ke.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $b63de180c8636c16$var$AutocompletePopper = (0, $kDBhE.default)((0, $41bfV.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f75vu.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $b63de180c8636c16$var$AutocompletePaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $b63de180c8636c16$var$AutocompleteLoading = (0, $kDBhE.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $b63de180c8636c16$var$AutocompleteNoOptions = (0, $kDBhE.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $b63de180c8636c16$var$AutocompleteListbox = (0, $kDBhE.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $f75vu.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $f75vu.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $f75vu.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $f75vu.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $f75vu.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $b63de180c8636c16$var$AutocompleteGroupLabel = (0, $kDBhE.default)((0, $laXAF.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $b63de180c8636c16$var$AutocompleteGroupUl = (0, $kDBhE.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $f75vu.default).option}`]: {
        paddingLeft: 24
    }
});
const $b63de180c8636c16$var$Autocomplete = /*#__PURE__*/ $7fPBF.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $b63de180c8636c16$var$_ClearIcon || ($b63de180c8636c16$var$_ClearIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bVWI3.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $a2ay0.default), PopperComponent: PopperComponent = (0, $41bfV.default), popupIcon: popupIcon = $b63de180c8636c16$var$_ArrowDropDownIcon || ($b63de180c8636c16$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aI4oF.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $cFLic.default)(props, $b63de180c8636c16$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $8ux4Q.default)((0, $kY3Ke.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $cFLic.default)(_getListboxProps, $b63de180c8636c16$var$_excluded2);
    const combinedListboxRef = (0, $6NwTb.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $b63de180c8636c16$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $kY3Ke.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $cFLic.default)(_getCustomizedTagProp, $b63de180c8636c16$var$_excluded3);
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), (0, $kY3Ke.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $cFLic.default)(props2, $b63de180c8636c16$var$_excluded4);
        return /*#__PURE__*/ (0, $bbzbN.jsx)("li", (0, $kY3Ke.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $kY3Ke.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteRoot, (0, $kY3Ke.default)({
                ref: ref,
                className: (0, $9MRga.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $kY3Ke.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)($b63de180c8636c16$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteClearIndicator, (0, $kY3Ke.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9MRga.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompletePopupIndicator, (0, $kY3Ke.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9MRga.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $kY3Ke.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompletePopper, (0, $kY3Ke.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9MRga.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)($b63de180c8636c16$var$AutocompletePaper, (0, $kY3Ke.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9MRga.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteListbox, (0, $kY3Ke.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $b63de180c8636c16$export$2e2bcd8739ae039 = $b63de180c8636c16$var$Autocomplete;

});
parcelRegister("8ux4Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62eac8852838d022$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $k0OO4 = parcelRequire("k0OO4");
var $gaYwN = parcelRequire("gaYwN");
var $giDhD = parcelRequire("giDhD");
var $65Itt = parcelRequire("65Itt");
var $8oWeT = parcelRequire("8oWeT");
'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $62eac8852838d022$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $62eac8852838d022$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $62eac8852838d022$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $62eac8852838d022$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $62eac8852838d022$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $62eac8852838d022$var$defaultFilterOptions = $62eac8852838d022$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $62eac8852838d022$var$pageSize = 5;
const $62eac8852838d022$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $62eac8852838d022$var$MULTIPLE_DEFAULT_VALUE = [];
function $62eac8852838d022$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $62eac8852838d022$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $62eac8852838d022$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $62eac8852838d022$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $65Itt.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $7fPBF.useRef(false);
    const firstFocus = $7fPBF.useRef(true);
    const inputRef = $7fPBF.useRef(null);
    const listboxRef = $7fPBF.useRef(null);
    const [anchorEl, setAnchorEl] = $7fPBF.useState(null);
    const [focusedTag, setFocusedTag] = $7fPBF.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $7fPBF.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $gaYwN.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $gaYwN.default)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $7fPBF.useState(false);
    const resetInputValue = $7fPBF.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $gaYwN.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $7fPBF.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $8oWeT.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $7fPBF.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $giDhD.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $7fPBF.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $giDhD.default)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $giDhD.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $62eac8852838d022$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $7fPBF.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $62eac8852838d022$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $62eac8852838d022$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $giDhD.default)((node)=>{
        (0, $k0OO4.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $7fPBF.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $7fPBF.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $62eac8852838d022$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$62eac8852838d022$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $62eac8852838d022$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $kY3Ke.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $kY3Ke.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $62eac8852838d022$export$2e2bcd8739ae039 = $62eac8852838d022$var$useAutocomplete;

});
parcelRegister("8oWeT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ddbdba53ac770c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $61ddbdba53ac770c$var$usePreviousProps = (value)=>{
    const ref = $7fPBF.useRef({});
    $7fPBF.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $61ddbdba53ac770c$export$2e2bcd8739ae039 = $61ddbdba53ac770c$var$usePreviousProps;

});


parcelRegister("41bfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecffc9bd505b8cc$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7kowk = parcelRequire("7kowk");




var $7fPBF = parcelRequire("7fPBF");

var $hkmqm = parcelRequire("hkmqm");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2ecffc9bd505b8cc$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2ecffc9bd505b8cc$var$PopperRoot = (0, $kDBhE.default)((0, $hkmqm.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2ecffc9bd505b8cc$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($7kowk)))();
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cFLic.default)(props, $2ecffc9bd505b8cc$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $kY3Ke.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($2ecffc9bd505b8cc$var$PopperRoot, (0, $kY3Ke.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2ecffc9bd505b8cc$export$2e2bcd8739ae039 = $2ecffc9bd505b8cc$var$Popper;

});
parcelRegister("7kowk", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $555d6be71c82d9fe$var$React = $555d6be71c82d9fe$var$_interopRequireWildcard((parcelRequire("7fPBF")));
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
function $555d6be71c82d9fe$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($555d6be71c82d9fe$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $555d6be71c82d9fe$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $555d6be71c82d9fe$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $555d6be71c82d9fe$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $555d6be71c82d9fe$var$useTheme(defaultTheme = null) {
    const contextTheme = $555d6be71c82d9fe$var$React.useContext($6te04.T);
    return !contextTheme || $555d6be71c82d9fe$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $555d6be71c82d9fe$var$_default = module.exports.default = $555d6be71c82d9fe$var$useTheme;

});

parcelRegister("hkmqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d5b2e364679937$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $4CS7n = parcelRequire("4CS7n");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $efdLW = parcelRequire("efdLW");


var $cFCqu = parcelRequire("cFCqu");

var $elaRz = parcelRequire("elaRz");

var $ayhm7 = parcelRequire("ayhm7");

var $7lvIS = parcelRequire("7lvIS");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c9d5b2e364679937$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $c9d5b2e364679937$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $c9d5b2e364679937$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $c9d5b2e364679937$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $c9d5b2e364679937$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $c9d5b2e364679937$var$isVirtualElement(element) {
    return !$c9d5b2e364679937$var$isHTMLElement(element);
}
const $c9d5b2e364679937$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7lvIS.getPopperUtilityClass), classes);
};
const $c9d5b2e364679937$var$defaultPopperOptions = {};
const $c9d5b2e364679937$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $c9d5b2e364679937$var$_excluded);
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $jTdAm.default)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $jTdAm.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $lJRRs.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $c9d5b2e364679937$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $7fPBF.useState($c9d5b2e364679937$var$resolveAnchorEl(anchorEl));
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $7fPBF.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($c9d5b2e364679937$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $lJRRs.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $efdLW.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $kY3Ke.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $c9d5b2e364679937$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $elaRz.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $c9d5b2e364679937$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $c9d5b2e364679937$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cFLic.default)(props, $c9d5b2e364679937$var$_excluded2);
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $c9d5b2e364679937$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $c9d5b2e364679937$var$isHTMLElement(resolvedAnchorEl) ? (0, $4CS7n.default)(resolvedAnchorEl).body : (0, $4CS7n.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ayhm7.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c9d5b2e364679937$var$PopperTooltip, (0, $kY3Ke.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $kY3Ke.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $c9d5b2e364679937$export$2e2bcd8739ae039 = $c9d5b2e364679937$var$Popper;

});
parcelRegister("efdLW", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $a5ed26444bdb4d3e$export$8f7491d57c8f97a9; });

var $bDLFF = parcelRequire("bDLFF");

var $1PRym = parcelRequire("1PRym");

var $jh6oc = parcelRequire("jh6oc");

var $eWblW = parcelRequire("eWblW");

var $7TCz5 = parcelRequire("7TCz5");

var $eylfk = parcelRequire("eylfk");

var $exXrj = parcelRequire("exXrj");

var $hOZ6Q = parcelRequire("hOZ6Q");

var $jUFYE = parcelRequire("jUFYE");

var $a2tLm = parcelRequire("a2tLm");


var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1PRym.default),
    (0, $jh6oc.default),
    (0, $eWblW.default),
    (0, $7TCz5.default),
    (0, $eylfk.default),
    (0, $exXrj.default),
    (0, $hOZ6Q.default),
    (0, $jUFYE.default),
    (0, $a2tLm.default)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bDLFF.popperGenerator)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bDLFF", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $879850b738b0fd85$export$ed5e13716264f202; });

var $7A5zv = parcelRequire("7A5zv");

var $aooBM = parcelRequire("aooBM");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $1HbbS = parcelRequire("1HbbS");

var $6zw26 = parcelRequire("6zw26");

var $4irPP = parcelRequire("4irPP");


var $kWkO0 = parcelRequire("kWkO0");
var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kWkO0.isElement)(reference) ? (0, $5fhgl.default)(reference) : reference.contextElement ? (0, $5fhgl.default)(reference.contextElement) : [],
                    popper: (0, $5fhgl.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1HbbS.default)((0, $4irPP.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7A5zv.default)(reference, (0, $9vuui.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $aooBM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6zw26.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7A5zv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585037a155f95873$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $luMSI = parcelRequire("luMSI");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");

var $jhPl0 = parcelRequire("jhPl0");

var $aMuSx = parcelRequire("aMuSx");

var $dbfQ4 = parcelRequire("dbfQ4");

var $hsTEw = parcelRequire("hsTEw");
function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hsTEw.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hsTEw.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kWkO0.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kWkO0.isHTMLElement)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $aMuSx.default)(offsetParent);
    var rect = (0, $jTgmx.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fRINz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $dbfQ4.default)(documentElement)) scroll = (0, $luMSI.default)(offsetParent);
        if ((0, $kWkO0.isHTMLElement)(offsetParent)) {
            offsets = (0, $jTgmx.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $jhPl0.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("jTgmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7afd89efa353b85$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");

var $hsTEw = parcelRequire("hsTEw");

var $7LvDQ = parcelRequire("7LvDQ");

var $fv6RK = parcelRequire("fv6RK");
function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kWkO0.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hsTEw.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hsTEw.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kWkO0.isElement)(element) ? (0, $7LvDQ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fv6RK.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("kWkO0", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $f3e95cf60f991b3e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $f3e95cf60f991b3e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $f3e95cf60f991b3e$export$af51f0f06c0f328a; });

var $7LvDQ = parcelRequire("7LvDQ");
function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7LvDQ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7LvDQ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7LvDQ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("7LvDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7577945ba4d648$export$2e2bcd8739ae039; });
function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hsTEw", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cb70389d1b75072d$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cb70389d1b75072d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cb70389d1b75072d$export$2077e0241d6afd3c; });
var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fv6RK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48f13af3862f004$export$2e2bcd8739ae039; });

var $h7lOM = parcelRequire("h7lOM");
function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $h7lOM.default)());
}

});
parcelRegister("h7lOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76403bd29ed319a$export$2e2bcd8739ae039; });
function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("luMSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa62512f527d34a4$export$2e2bcd8739ae039; });

var $k28Ly = parcelRequire("k28Ly");

var $7LvDQ = parcelRequire("7LvDQ");

var $kWkO0 = parcelRequire("kWkO0");

var $91ESz = parcelRequire("91ESz");
function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $7LvDQ.default)(node) || !(0, $kWkO0.isHTMLElement)(node)) return (0, $k28Ly.default)(node);
    else return (0, $91ESz.default)(node);
}

});
parcelRegister("k28Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95acb4acf5ee909$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $7LvDQ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("91ESz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6923eaccf7a43aef$export$2e2bcd8739ae039; });
function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("fRINz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ce8e5214ef2302$export$2e2bcd8739ae039; });
function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("jhPl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a76d77d33c9d6e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $aMuSx = parcelRequire("aMuSx");

var $k28Ly = parcelRequire("k28Ly");
function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jTgmx.default)((0, $aMuSx.default)(element)).left + (0, $k28Ly.default)(element).scrollLeft;
}

});
parcelRegister("aMuSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9656f011992b2b$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kWkO0.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("dbfQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998896b7349c78b7$export$2e2bcd8739ae039; });

var $5lm85 = parcelRequire("5lm85");
function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5lm85.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5lm85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e40145ffd569d9c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $7LvDQ.default)(element).getComputedStyle(element);
}

});



parcelRegister("aooBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790f3bf845b39e8e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");
function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jTgmx.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("5fhgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1bbe7c8c599173$export$2e2bcd8739ae039; });

var $2vPbO = parcelRequire("2vPbO");

var $d8xUD = parcelRequire("d8xUD");

var $7LvDQ = parcelRequire("7LvDQ");

var $dbfQ4 = parcelRequire("dbfQ4");
function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2vPbO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7LvDQ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $dbfQ4.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $d8xUD.default)(target)));
}

});
parcelRegister("2vPbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d462f2c86b4c65a$export$2e2bcd8739ae039; });

var $d8xUD = parcelRequire("d8xUD");

var $dbfQ4 = parcelRequire("dbfQ4");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $fRINz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kWkO0.isHTMLElement)(node) && (0, $dbfQ4.default)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $d8xUD.default)(node));
}

});
parcelRegister("d8xUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9906540837c752ea$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $aMuSx = parcelRequire("aMuSx");

var $kWkO0 = parcelRequire("kWkO0");
function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $fRINz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kWkO0.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $aMuSx.default)(element) // fallback
    );
}

});



parcelRegister("9vuui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ebea87f6f98e49c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $fRINz = parcelRequire("fRINz");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $KQ9YG = parcelRequire("KQ9YG");

var $d8xUD = parcelRequire("d8xUD");

var $h7lOM = parcelRequire("h7lOM");
function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $kWkO0.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5lm85.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $h7lOM.default)());
    var isIE = /Trident/i.test((0, $h7lOM.default)());
    if (isIE && (0, $kWkO0.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5lm85.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $d8xUD.default)(element);
    if ((0, $kWkO0.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kWkO0.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $fRINz.default)(currentNode)) < 0){
        var css = (0, $5lm85.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $7LvDQ.default)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $KQ9YG.default)(offsetParent) && (0, $5lm85.default)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fRINz.default)(offsetParent) === 'html' || (0, $fRINz.default)(offsetParent) === 'body' && (0, $5lm85.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}

});
parcelRegister("KQ9YG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ccc1de57d53c59$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");
function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $fRINz.default)(element)) >= 0;
}

});


parcelRegister("1HbbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c27cceb4b24b2f$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");
function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $aHbEK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("aHbEK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $7c96f63dd602b579$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $7c96f63dd602b579$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $7c96f63dd602b579$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $7c96f63dd602b579$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $7c96f63dd602b579$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $7c96f63dd602b579$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $7c96f63dd602b579$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $7c96f63dd602b579$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $7c96f63dd602b579$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $7c96f63dd602b579$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $7c96f63dd602b579$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $7c96f63dd602b579$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $7c96f63dd602b579$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $7c96f63dd602b579$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $7c96f63dd602b579$export$d087d3878fdf71d5; });
var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];

});


parcelRegister("6zw26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8edc0cb4d5666b$export$2e2bcd8739ae039; });
function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4irPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e6f4d2835a922$export$2e2bcd8739ae039; });
function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1PRym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1564186ea0096528$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7LvDQ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};

});

parcelRegister("jh6oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0848fa64ca744df$export$2e2bcd8739ae039; });

var $gIQYz = parcelRequire("gIQYz");
function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gIQYz.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};

});
parcelRegister("gIQYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c9d9550c09d816$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $4p02M = parcelRequire("4p02M");

var $aHbEK = parcelRequire("aHbEK");
function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3ZGTg.default)(placement) : null;
    var variation = placement ? (0, $hD45i.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $aHbEK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $aHbEK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $aHbEK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $aHbEK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4p02M.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $aHbEK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $aHbEK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("3ZGTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8856bdb677ff8e$export$2e2bcd8739ae039; });

function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hD45i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd593f453867f36a$export$2e2bcd8739ae039; });
function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("4p02M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334987ecb6fc56c7$export$2e2bcd8739ae039; });
function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("eWblW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adff49e8d09ee1e5$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $9vuui = parcelRequire("9vuui");

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $hsTEw = parcelRequire("hsTEw");
var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hsTEw.round)(x * dpr) / dpr || 0,
        y: (0, $hsTEw.round)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $aHbEK.left);
    var sideY = (0, $aHbEK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9vuui.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7LvDQ.default)(popper)) {
            offsetParent = (0, $aMuSx.default)(popper);
            if ((0, $5lm85.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $aHbEK.top) || (placement === (0, $aHbEK.left) || placement === (0, $aHbEK.right)) && variation === (0, $aHbEK.end)) {
            sideY = (0, $aHbEK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $aHbEK.left) || (placement === (0, $aHbEK.top) || placement === (0, $aHbEK.bottom)) && variation === (0, $aHbEK.end)) {
            sideX = (0, $aHbEK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7LvDQ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3ZGTg.default)(state.placement),
        variation: (0, $hD45i.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};

});

parcelRegister("7TCz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfb95a331f35baa$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eylfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a984b8b647b41eeb$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aHbEK = parcelRequire("aHbEK");
function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3ZGTg.default)(placement);
    var invertDistance = [
        (0, $aHbEK.left),
        (0, $aHbEK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $aHbEK.placements).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};

});

parcelRegister("exXrj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97241372b70cd07$export$2e2bcd8739ae039; });

var $910or = parcelRequire("910or");

var $3ZGTg = parcelRequire("3ZGTg");

var $1EPiP = parcelRequire("1EPiP");

var $74FGG = parcelRequire("74FGG");

var $ewHfg = parcelRequire("ewHfg");

var $aHbEK = parcelRequire("aHbEK");

var $hD45i = parcelRequire("hD45i");
function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto)) return [];
    var oppositePlacement = (0, $910or.default)(placement);
    return [
        (0, $1EPiP.default)(placement),
        oppositePlacement,
        (0, $1EPiP.default)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3ZGTg.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $910or.default)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto) ? (0, $ewHfg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3ZGTg.default)(placement);
        var isStartVariation = (0, $hD45i.default)(placement) === (0, $aHbEK.start);
        var isVertical = [
            (0, $aHbEK.top),
            (0, $aHbEK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $aHbEK.right) : (0, $aHbEK.left) : isStartVariation ? (0, $aHbEK.bottom) : (0, $aHbEK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $910or.default)(mainVariationSide);
        var altVariationSide = (0, $910or.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("910or", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690483208b9a3207$export$2e2bcd8739ae039; });
var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}

});

parcelRegister("1EPiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13515282412eb271$export$2e2bcd8739ae039; });
var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}

});

parcelRegister("74FGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52693e6050d55014$export$2e2bcd8739ae039; });

var $bxNPU = parcelRequire("bxNPU");

var $aMuSx = parcelRequire("aMuSx");

var $jTgmx = parcelRequire("jTgmx");

var $gIQYz = parcelRequire("gIQYz");

var $245PV = parcelRequire("245PV");

var $aHbEK = parcelRequire("aHbEK");

var $kWkO0 = parcelRequire("kWkO0");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");
function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $aHbEK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $aHbEK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $aHbEK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
    var altContext = elementContext === (0, $aHbEK.popper) ? (0, $aHbEK.reference) : (0, $aHbEK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $bxNPU.default)((0, $kWkO0.isElement)(element) ? element : element.contextElement || (0, $aMuSx.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $jTgmx.default)(state.elements.reference);
    var popperOffsets = (0, $gIQYz.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $245PV.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $aHbEK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $aHbEK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $aHbEK.right),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $aHbEK.top),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("bxNPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86796f3d3717fc99$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $tIQGN = parcelRequire("tIQGN");

var $kNUmP = parcelRequire("kNUmP");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $jTgmx = parcelRequire("jTgmx");

var $d8xUD = parcelRequire("d8xUD");

var $ltVxa = parcelRequire("ltVxa");

var $fRINz = parcelRequire("fRINz");

var $245PV = parcelRequire("245PV");

var $hsTEw = parcelRequire("hsTEw");
function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $jTgmx.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $aHbEK.viewport) ? (0, $245PV.default)((0, $tIQGN.default)(element, strategy)) : (0, $kWkO0.isElement)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $245PV.default)((0, $kNUmP.default)((0, $aMuSx.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $5fhgl.default)((0, $d8xUD.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5lm85.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kWkO0.isHTMLElement)(element) ? (0, $9vuui.default)(element) : element;
    if (!(0, $kWkO0.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kWkO0.isElement)(clippingParent) && (0, $ltVxa.default)(clippingParent, clipperElement) && (0, $fRINz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hsTEw.max)(rect.top, accRect.top);
        accRect.right = (0, $hsTEw.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hsTEw.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hsTEw.max)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("tIQGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05957f974ad3b041$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $jhPl0 = parcelRequire("jhPl0");

var $fv6RK = parcelRequire("fv6RK");
function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7LvDQ.default)(element);
    var html = (0, $aMuSx.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fv6RK.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $jhPl0.default)(element),
        y: y
    };
}

});

parcelRegister("kNUmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2541b971d258cf0$export$2e2bcd8739ae039; });

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $jhPl0 = parcelRequire("jhPl0");

var $k28Ly = parcelRequire("k28Ly");

var $hsTEw = parcelRequire("hsTEw");
function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $aMuSx.default)(element);
    var winScroll = (0, $k28Ly.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hsTEw.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hsTEw.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $jhPl0.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5lm85.default)(body || html).direction === 'rtl') x += (0, $hsTEw.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ltVxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa38ef77d76834a0$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kWkO0.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("245PV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18107b7e48021ffa$export$2e2bcd8739ae039; });
function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("lVDOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6dcd1b0906e9b8$export$2e2bcd8739ae039; });

var $2CmeP = parcelRequire("2CmeP");
function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2CmeP.default)(), paddingObject);
}

});
parcelRegister("2CmeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e806166c2cdf48d$export$2e2bcd8739ae039; });
function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hf3yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d699eb93b3090c$export$2e2bcd8739ae039; });
function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("ewHfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a935996b3496591b$export$2e2bcd8739ae039; });

var $hD45i = parcelRequire("hD45i");

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");

var $3ZGTg = parcelRequire("3ZGTg");
function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $aHbEK.placements) : _options$allowedAutoP;
    var variation = (0, $hD45i.default)(placement);
    var placements = variation ? flipVariations ? (0, $aHbEK.variationPlacements) : (0, $aHbEK.variationPlacements).filter(function(placement) {
        return (0, $hD45i.default)(placement) === variation;
    }) : (0, $aHbEK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3ZGTg.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("hOZ6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf968237b9d7dd4a$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $3ZGTg = parcelRequire("3ZGTg");

var $4p02M = parcelRequire("4p02M");

var $c8xyK = parcelRequire("c8xyK");

var $1MeQS = parcelRequire("1MeQS");

var $aooBM = parcelRequire("aooBM");

var $9vuui = parcelRequire("9vuui");

var $74FGG = parcelRequire("74FGG");

var $hD45i = parcelRequire("hD45i");

var $2CmeP = parcelRequire("2CmeP");

var $hsTEw = parcelRequire("hsTEw");
function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $74FGG.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var variation = (0, $hD45i.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4p02M.default)(basePlacement);
    var altAxis = (0, $c8xyK.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var altSide = mainAxis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $aHbEK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $aHbEK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aooBM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2CmeP.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1MeQS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9vuui.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1MeQS.within)(tether ? (0, $hsTEw.min)(min, tetherMin) : min, offset, tether ? (0, $hsTEw.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var _altSide = mainAxis === 'x' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $aHbEK.top),
            (0, $aHbEK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1MeQS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1MeQS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("c8xyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d60439f259d6a8c$export$2e2bcd8739ae039; });
function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1MeQS", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $14b5cb667dce379f$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $14b5cb667dce379f$export$86c8af6d3ef0b4a; });

var $hsTEw = parcelRequire("hsTEw");
function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $hsTEw.max)(min, (0, $hsTEw.min)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("jUFYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f3cf13e0769248$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aooBM = parcelRequire("aooBM");

var $ltVxa = parcelRequire("ltVxa");

var $9vuui = parcelRequire("9vuui");

var $4p02M = parcelRequire("4p02M");

var $1MeQS = parcelRequire("1MeQS");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");

var $aHbEK = parcelRequire("aHbEK");
var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var axis = (0, $4p02M.default)(basePlacement);
    var isVertical = [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aooBM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
    var maxProp = axis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9vuui.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1MeQS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ltVxa.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("a2tLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f12d998f890694$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");
function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $aHbEK.top),
        (0, $aHbEK.right),
        (0, $aHbEK.bottom),
        (0, $aHbEK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $74FGG.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $74FGG.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};

});


parcelRegister("7lvIS", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $55931a0909067857$export$1b69b6cd0fa638a1; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $55931a0909067857$export$1b69b6cd0fa638a1(slot) {
    return (0, $k6RDS.default)('MuiPopper', slot);
}
const $55931a0909067857$var$popperClasses = (0, $4jzsB.default)('MuiPopper', [
    'root'
]);
var $55931a0909067857$export$2e2bcd8739ae039 = $55931a0909067857$var$popperClasses;

});



parcelRegister("laXAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6a8c189b782c624$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $HYnm5 = parcelRequire("HYnm5");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $f6a8c189b782c624$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $f6a8c189b782c624$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $b6UUh.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $HYnm5.getListSubheaderUtilityClass), classes);
};
const $f6a8c189b782c624$var$ListSubheaderRoot = (0, $kDBhE.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $f6a8c189b782c624$var$ListSubheader = /*#__PURE__*/ $7fPBF.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $cFLic.default)(props, $f6a8c189b782c624$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $f6a8c189b782c624$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($f6a8c189b782c624$var$ListSubheaderRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $9MRga.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$f6a8c189b782c624$var$ListSubheader.muiSkipListHighlight = true;
var $f6a8c189b782c624$export$2e2bcd8739ae039 = $f6a8c189b782c624$var$ListSubheader;

});
parcelRegister("HYnm5", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", function () { return $0842d99f651a305f$export$6816d4fc0981ec7; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0842d99f651a305f$export$6816d4fc0981ec7(slot) {
    return (0, $k6RDS.default)('MuiListSubheader', slot);
}
const $0842d99f651a305f$var$listSubheaderClasses = (0, $4jzsB.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $0842d99f651a305f$export$2e2bcd8739ae039 = $0842d99f651a305f$var$listSubheaderClasses;

});


parcelRegister("8TDId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a243c492197f3b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $10KNR = parcelRequire("10KNR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $b6UUh.default)(color)}`,
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $10KNR.getIconButtonUtilityClass), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kY3Ke.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $kY3Ke.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $kY3Ke.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $10KNR.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $cFLic.default)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;

});
parcelRegister("10KNR", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $0bca18aab596affa$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $0bca18aab596affa$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $k6RDS.default)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $4jzsB.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;

});


parcelRegister("2hGJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9e4fb2f535b4c3$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $aw34v = parcelRequire("aw34v");

var $6NwTb = parcelRequire("6NwTb");


var $b6UUh = parcelRequire("b6UUh");

var $3RNaF = parcelRequire("3RNaF");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $i8YSp = parcelRequire("i8YSp");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $1a9e4fb2f535b4c3$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $1a9e4fb2f535b4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $b6UUh.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $b6UUh.default)(color)}`,
            `${variant}${(0, $b6UUh.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $b6UUh.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $b6UUh.default)(size)}`,
            `avatarColor${(0, $b6UUh.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $b6UUh.default)(size)}`,
            `iconColor${(0, $b6UUh.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $b6UUh.default)(size)}`,
            `deleteIconColor${(0, $b6UUh.default)(color)}`,
            `deleteIcon${(0, $b6UUh.default)(variant)}Color${(0, $b6UUh.default)(color)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $i8YSp.getChipUtilityClass), classes);
};
const $1a9e4fb2f535b4c3$var$ChipRoot = (0, $kDBhE.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles[`avatar${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles[`avatarColor${(0, $b6UUh.default)(color)}`]
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles[`icon${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles[`iconColor${(0, $b6UUh.default)(iconColor)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIcon${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIconColor${(0, $b6UUh.default)(color)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIcon${(0, $b6UUh.default)(variant)}Color${(0, $b6UUh.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $b6UUh.default)(size)}`],
            styles[`color${(0, $b6UUh.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $b6UUh.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $b6UUh.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $b6UUh.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $kY3Ke.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $i8YSp.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $i8YSp.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $i8YSp.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $i8YSp.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $i8YSp.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $i8YSp.default).icon}`]: (0, $kY3Ke.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $kY3Ke.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $i8YSp.default).deleteIcon}`]: (0, $kY3Ke.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $7jL4F.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $7jL4F.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $i8YSp.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $i8YSp.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $i8YSp.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $i8YSp.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $i8YSp.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $i8YSp.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $i8YSp.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $i8YSp.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $i8YSp.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $1a9e4fb2f535b4c3$var$ChipLabel = (0, $kDBhE.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $b6UUh.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $1a9e4fb2f535b4c3$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $cFLic.default)(props, $1a9e4fb2f535b4c3$var$_excluded);
    const chipRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $3RNaF.default) : ComponentProp || 'div';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $1a9e4fb2f535b4c3$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $3RNaF.default) ? (0, $kY3Ke.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
        className: (0, $9MRga.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aw34v.default), {
        className: (0, $9MRga.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $9MRga.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $9MRga.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($1a9e4fb2f535b4c3$var$ChipRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $9MRga.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $bbzbN.jsx)($1a9e4fb2f535b4c3$var$ChipLabel, {
                className: (0, $9MRga.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $1a9e4fb2f535b4c3$export$2e2bcd8739ae039 = $1a9e4fb2f535b4c3$var$Chip;

});
parcelRegister("aw34v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7f4684365c8e73$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $7a7f4684365c8e73$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("i8YSp", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $d358322d03e9d644$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $d358322d03e9d644$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d358322d03e9d644$export$31444911e4ee6fdd(slot) {
    return (0, $k6RDS.default)('MuiChip', slot);
}
const $d358322d03e9d644$var$chipClasses = (0, $4jzsB.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $d358322d03e9d644$export$2e2bcd8739ae039 = $d358322d03e9d644$var$chipClasses;

});


parcelRegister("bVWI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b028f185c60f26d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $8b028f185c60f26d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("f75vu", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", function () { return $b00bc803f1d3305d$export$8ee01529667e66d9; });
$parcel$export(module.exports, "default", function () { return $b00bc803f1d3305d$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $b00bc803f1d3305d$export$8ee01529667e66d9(slot) {
    return (0, $k6RDS.default)('MuiAutocomplete', slot);
}
const $b00bc803f1d3305d$var$autocompleteClasses = (0, $4jzsB.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $b00bc803f1d3305d$export$2e2bcd8739ae039 = $b00bc803f1d3305d$var$autocompleteClasses;

});



parcelRegister("1m95Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fcee6b9b1c2f102$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");

var $58CWL = parcelRequire("58CWL");

var $3jMGu = parcelRequire("3jMGu");

var $jh0sD = parcelRequire("jh0sD");

var $aili3 = parcelRequire("aili3");

var $2hGJ2 = parcelRequire("2hGJ2");

var $lnx1Q = parcelRequire("lnx1Q");

var $aqd0z = parcelRequire("aqd0z");
const $0fcee6b9b1c2f102$var$ITEM_HEIGHT = 48;
const $0fcee6b9b1c2f102$var$ITEM_PADDING_TOP = 8;
const $0fcee6b9b1c2f102$var$MenuProps = {
    PaperProps: {
        style: {
            maxHeight: $0fcee6b9b1c2f102$var$ITEM_HEIGHT * 4.5 + $0fcee6b9b1c2f102$var$ITEM_PADDING_TOP,
            width: 250
        }
    }
};
const $0fcee6b9b1c2f102$var$ModifiedFormControl = (0, $kDBhE.default)((0, $3jMGu.default))(()=>({
        margin: "10px",
        padding: "0 8px",
        border: `1px solid ${0, $aqd0z.BORDER_GREY}`,
        borderRadius: (0, $aqd0z.BUTTON_BORDER_RADIUS),
        backgroundColor: (0, $aqd0z.WHITE),
        minWidth: 120
    }));
function $0fcee6b9b1c2f102$var$FilterContainer({ provider: provider, handleFilterChange: handleFilterChange }) {
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        style: {
            cursor: "pointer"
        },
        onClick: ()=>setIsOpen(!isOpen),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "d-flex",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            color: (0, $aqd0z.NAVBAR_BLUE)
                        },
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lnx1Q))), {
                        color: "primary"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "position-absolute align-items-center justify-content-end p-4",
                style: {
                    backgroundColor: "white",
                    width: "38rem",
                    height: "11.5rem",
                    boxShadow: (0, $aqd0z.BOX_SHADOW),
                    borderRadius: "10px",
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "d-flex align-items-center",
                                style: {
                                    color: (0, $aqd0z.NAVBAR_BLUE),
                                    fontSize: "16px",
                                    width: "7rem",
                                    height: "2rem"
                                },
                                children: "Claim Type"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($0fcee6b9b1c2f102$var$ModifiedFormControl, {
                                className: "mb-3 ms-5",
                                variant: "standard",
                                size: "small",
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    m: 0,
                                    width: "4rem",
                                    height: "2rem"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
                                    id: "claim-type",
                                    name: "claim-type",
                                    value: provider["claim-type"],
                                    onChange: handleFilterChange,
                                    disableUnderline: true,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "1",
                                            children: "Initial"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "2",
                                            children: "Resubmission"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "d-flex align-items-center",
                                style: {
                                    color: (0, $aqd0z.NAVBAR_BLUE),
                                    fontSize: "16px",
                                    width: "7rem",
                                    height: "2.5rem"
                                },
                                children: [
                                    " ",
                                    "Claim Status"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($0fcee6b9b1c2f102$var$ModifiedFormControl, {
                                className: "mb-3 p-1 ms-5",
                                variant: "standard",
                                sx: {
                                    width: 400,
                                    m: 0,
                                    height: "2.5rem"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
                                    id: "claim-status",
                                    name: "claim-status",
                                    multiple: true,
                                    value: provider["claim-status"],
                                    onChange: handleFilterChange,
                                    disableUnderline: true,
                                    renderValue: (selected)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                            sx: {
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 0.5,
                                                height: "90%"
                                            },
                                            children: selected.map((value)=>{
                                                let label;
                                                if (value === "open") label = "Open";
                                                else if (value === "paid") label = "Paid";
                                                else if (value === "partially_paid") label = "Partially Paid";
                                                else if (value === "rejected") label = "Rejected";
                                                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    sx: {
                                                        height: "90%"
                                                    },
                                                    label: label
                                                }, value);
                                            })
                                        }),
                                    MenuProps: $0fcee6b9b1c2f102$var$MenuProps,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "open",
                                            children: "Open"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "paid",
                                            children: "Paid"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "partially_paid",
                                            children: "Partially Paid"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "rejected",
                                            children: "Rejected"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "d-flex align-items-center",
                                style: {
                                    color: (0, $aqd0z.NAVBAR_BLUE),
                                    fontSize: "16px",
                                    width: "7rem",
                                    height: "2rem"
                                },
                                children: "Encounter"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($0fcee6b9b1c2f102$var$ModifiedFormControl, {
                                className: "mb-3 ms-5",
                                variant: "standard",
                                size: "small",
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    m: 0,
                                    width: 100,
                                    height: "2rem"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
                                    id: "encounter",
                                    name: "encounter",
                                    value: provider.encounter,
                                    onChange: handleFilterChange,
                                    disableUnderline: true,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "inpatient",
                                            children: "In Patient"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "outpatient",
                                            children: "Out Patient"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            value: "daycase",
                                            children: "Day Case"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $0fcee6b9b1c2f102$export$2e2bcd8739ae039 = $0fcee6b9b1c2f102$var$FilterContainer;

});
parcelRegister("lnx1Q", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9055dcc5dca7bca$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $f9055dcc5dca7bca$var$_default = module.exports.default = (0, $f9055dcc5dca7bca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("6oHM0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a86f072857dd23d$export$2e2bcd8739ae039; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");

var $3jMGu = parcelRequire("3jMGu");

var $f6ezL = parcelRequire("f6ezL");

var $k6wXp = parcelRequire("k6wXp");

var $4p6PS = parcelRequire("4p6PS");

var $8m4sd = parcelRequire("8m4sd");

var $aqd0z = parcelRequire("aqd0z");

var $9l0yE = parcelRequire("9l0yE");

var $6qwOn = parcelRequire("6qwOn");
const $4a86f072857dd23d$var$ModifiedFormControl = (0, $kDBhE.default)((0, $3jMGu.default))(()=>({
        margin: "10px",
        padding: "0 8px",
        border: `1px solid ${0, $aqd0z.BORDER_GREY}`,
        borderRadius: (0, $aqd0z.BUTTON_BORDER_RADIUS),
        backgroundColor: (0, $aqd0z.WHITE),
        minWidth: 120
    }));
function $4a86f072857dd23d$export$2e2bcd8739ae039({ provider: provider, handleDateChange: handleDateChange, displayDates: displayDates, setDisplayDates: setDisplayDates }) {
    const [customPeriod, setCustomPeriod] = (0, $7fPBF.useState)("");
    const [isFromDateOpen, setIsFromDateOpen] = (0, $7fPBF.useState)(false);
    const [isToDateOpen, setIsToDateOpen] = (0, $7fPBF.useState)(false);
    const [fromDate, setFromDate] = (0, $7fPBF.useState)(provider["transaction-fromdate"][0]);
    const [toDate, setToDate] = (0, $7fPBF.useState)(provider["transaction-todate"][0]);
    const [isDateFilterUsed, setDateFilterUsed] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "filter-container flex-wrap d-flex align-items-center ",
        style: {
            width: "35rem"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9l0yE.default), {
                    setDateFilterUsed: setDateFilterUsed,
                    isDateFilterUsed: isDateFilterUsed,
                    setCustomPeriod: setCustomPeriod,
                    handleDateChange: handleDateChange,
                    displayDates: displayDates,
                    setDisplayDates: setDisplayDates
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4p6PS.default), {
                dateAdapter: (0, $k6wXp.default),
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)($4a86f072857dd23d$var$ModifiedFormControl, {
                            variant: "standard",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8m4sd.default), {
                                open: isFromDateOpen,
                                openOnFocus: true,
                                onClose: ()=>{
                                    setIsFromDateOpen(false);
                                    setDateFilterUsed(true);
                                },
                                onOpen: ()=>{
                                    setIsFromDateOpen(true);
                                },
                                onAccept: (value)=>{
                                    const requiredFormat = value.toISOString().slice(0, 10);
                                    setFromDate(requiredFormat);
                                    handleDateChange({
                                        target: {
                                            name: "transaction-fromdate",
                                            value: requiredFormat
                                        }
                                    });
                                },
                                views: [
                                    "year",
                                    "month",
                                    "day"
                                ],
                                maxDate: new Date(),
                                id: "from-date",
                                okLabel: "Done",
                                value: displayDates.startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(displayDates.startDate).format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(provider["transaction-fromdate"][0], "DD-MM-YYYY").format("YYYY-MM-DD"),
                                allowSameDateSelection: true,
                                onChange: (value)=>{
                                    if (value != "Invalid Date") {
                                        const requiredFormat = value.toISOString().slice(0, 10);
                                        setFromDate(requiredFormat);
                                    }
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), (0, $2qxEV._)((0, $9tqwB._)({}, params), {
                                        helperText: null,
                                        variant: "standard",
                                        InputProps: (0, $2qxEV._)((0, $9tqwB._)({}, params.InputProps), {
                                            disableUnderline: true,
                                            style: {
                                                width: "10rem"
                                            }
                                        })
                                    }))
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                            children: " to"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($4a86f072857dd23d$var$ModifiedFormControl, {
                            variant: "standard",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8m4sd.default), {
                                open: isToDateOpen,
                                openOnFocus: true,
                                onClose: ()=>{
                                    setIsToDateOpen(false);
                                    setDateFilterUsed(true);
                                },
                                onOpen: ()=>{
                                    setIsToDateOpen(true);
                                },
                                onAccept: (value)=>{
                                    const requiredFormat = value.toISOString().slice(0, 10);
                                    setToDate(requiredFormat);
                                    handleDateChange({
                                        target: {
                                            name: "transaction-todate",
                                            value: requiredFormat
                                        }
                                    });
                                },
                                views: [
                                    "year",
                                    "month",
                                    "day"
                                ],
                                maxDate: new Date(),
                                id: "to-date",
                                okLabel: "Done",
                                autoOk: false,
                                value: displayDates.endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(displayDates.endDate).format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(provider["transaction-todate"][0], "DD-MM-YYYY").format("YYYY-MM-DD"),
                                allowSameDateSelection: true,
                                onChange: (value)=>{
                                    if (value != "Invalid Date") {
                                        const requiredFormat = value.toISOString().slice(0, 10);
                                        setFromDate(requiredFormat);
                                    }
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), (0, $2qxEV._)((0, $9tqwB._)({}, params), {
                                        helperText: null,
                                        variant: "standard",
                                        InputProps: (0, $2qxEV._)((0, $9tqwB._)({}, params.InputProps), {
                                            disableUnderline: true,
                                            style: {
                                                width: "10rem"
                                            }
                                        })
                                    }))
                            })
                        })
                    ]
                })
            })
        ]
    });
} //by default 12 month filter
 // import React, { useState, useEffect } from "react";
 // import { styled } from "@mui/material/styles";
 // import FormControl from "@mui/material/FormControl";
 // import TextField from "@mui/material/TextField";
 // import AdapterDateFns from "@mui/lab/AdapterDateFns";
 // import LocalizationProvider from "@mui/lab/LocalizationProvider";
 // import DatePicker from "@mui/lab/DatePicker";
 // import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";
 // import CustomDatesContainer from "./customDatesContainer";
 // import moment from "moment";
 // const ModifiedFormControl = styled(FormControl)(() => ({
 //   margin: "10px",
 //   padding: "0 8px",
 //   border: `1px solid ${BORDER_GREY}`,
 //   borderRadius: BUTTON_BORDER_RADIUS,
 //   backgroundColor: WHITE,
 //   minWidth: 120,
 // }));
 // export default function DateFilterContainer({
 //   provider,
 //   handleDateChange,
 //   displayDates,
 //   setDisplayDates,
 // }) {
 //   const [customPeriod, setCustomPeriod] = useState("last-12-months");
 //   const [isFromDateOpen, setIsFromDateOpen] = useState(false);
 //   const [isToDateOpen, setIsToDateOpen] = useState(false);
 //   const [fromDate, setFromDate] = useState(provider["transaction-fromdate"][0]);
 //   const [toDate, setToDate] = useState(provider["transaction-todate"][0]);
 //   const [isDateFilterUsed, setDateFilterUsed] = useState(false);
 //   // Initialize with Last 12 Months dates
 //   useEffect(() => {
 //     const currentDate = new Date();
 //     const calculatedFromDate = moment(currentDate)
 //       .subtract(12, "months")
 //       .startOf("month")
 //       .format("YYYY-MM-DD");
 //     const calculatedToDate = moment(currentDate)
 //       .subtract(1, "months")
 //       .endOf("month")
 //       .format("YYYY-MM-DD");
 //     // Set the initial display dates
 //     setDisplayDates({
 //       startDate: calculatedFromDate,
 //       endDate: calculatedToDate
 //     });
 //     // Update the provider values via handleDateChange
 //     handleDateChange({
 //       target: {
 //         name: "time-period",
 //         fromDate: calculatedFromDate,
 //         toDate: calculatedToDate,
 //       },
 //     });
 //   }, []);
 //   return (
 //     <div
 //       className="filter-container flex-wrap d-flex align-items-center "
 //       style={{ width: "35rem" }}
 //     >
 //       <div>
 //         <CustomDatesContainer
 //           setDateFilterUsed={setDateFilterUsed}
 //           isDateFilterUsed={isDateFilterUsed}
 //           setCustomPeriod={setCustomPeriod}
 //           handleDateChange={handleDateChange}
 //           displayDates={displayDates}
 //           setDisplayDates={setDisplayDates}
 //         />
 //       </div>
 //       <LocalizationProvider dateAdapter={AdapterDateFns}>
 //         <div className="d-flex align-items-center">
 //           <ModifiedFormControl variant="standard">
 //             <DatePicker
 //               open={isFromDateOpen}
 //               openOnFocus
 //               onClose={() => {
 //                 setIsFromDateOpen(false);
 //                 setDateFilterUsed(true);
 //               }}
 //               onOpen={() => {
 //                 setIsFromDateOpen(true);
 //               }}
 //               onAccept={(value) => {
 //                 const requiredFormat = value.toISOString().slice(0, 10);
 //                 setFromDate(requiredFormat);
 //                 handleDateChange({
 //                   target: {
 //                     name: "transaction-fromdate",
 //                     value: requiredFormat,
 //                   },
 //                 });
 //               }}
 //               views={["year", "month", "day"]}
 //               maxDate={new Date()}
 //               id="from-date"
 //               okLabel="Done"
 //               value={
 //                 displayDates.startDate
 //                   ? moment(displayDates.startDate).format("YYYY-MM-DD")
 //                   : moment(
 //                       provider["transaction-fromdate"][0],
 //                       "DD-MM-YYYY"
 //                     ).format("YYYY-MM-DD")
 //               }
 //               allowSameDateSelection
 //               onChange={(value) => {
 //                 if (value != "Invalid Date") {
 //                   const requiredFormat = value.toISOString().slice(0, 10);
 //                   setFromDate(requiredFormat);
 //                 }
 //               }}
 //               renderInput={(params) => (
 //                 <TextField
 //                   {...params}
 //                   helperText={null}
 //                   variant="standard"
 //                   InputProps={{
 //                     ...params.InputProps,
 //                     disableUnderline: true,
 //                     style: {
 //                       width: "10rem",
 //                     },
 //                   }}
 //                 />
 //               )}
 //             />
 //           </ModifiedFormControl>
 //           <span> to</span>
 //           <ModifiedFormControl variant="standard">
 //             <DatePicker
 //               open={isToDateOpen}
 //               openOnFocus
 //               onClose={() => {
 //                 setIsToDateOpen(false);
 //                 setDateFilterUsed(true);
 //               }}
 //               onOpen={() => {
 //                 setIsToDateOpen(true);
 //               }}
 //               onAccept={(value) => {
 //                 const requiredFormat = value.toISOString().slice(0, 10);
 //                 setToDate(requiredFormat);
 //                 handleDateChange({
 //                   target: { name: "transaction-todate", value: requiredFormat },
 //                 });
 //               }}
 //               views={["year", "month", "day"]}
 //               maxDate={new Date()}
 //               id="to-date"
 //               okLabel="Done"
 //               autoOk={false}
 //               value={
 //                 displayDates.endDate
 //                   ? moment(displayDates.endDate).format("YYYY-MM-DD")
 //                   : moment(
 //                       provider["transaction-todate"][0],
 //                       "DD-MM-YYYY"
 //                     ).format("YYYY-MM-DD")
 //               }
 //               allowSameDateSelection
 //               onChange={(value) => {
 //                 if (value != "Invalid Date") {
 //                   const requiredFormat = value.toISOString().slice(0, 10);
 //                   setToDate(requiredFormat);  // Fixed: this was incorrectly setting fromDate
 //                 }
 //               }}
 //               renderInput={(params) => (
 //                 <TextField
 //                   {...params}
 //                   helperText={null}
 //                   variant="standard"
 //                   InputProps={{
 //                     ...params.InputProps,
 //                     disableUnderline: true,
 //                     style: {
 //                       width: "10rem",
 //                     },
 //                   }}
 //                 />
 //               )}
 //             />
 //           </ModifiedFormControl>
 //         </div>
 //       </LocalizationProvider>
 //     </div>
 //   );
 // }

});
parcelRegister("k6wXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea2deec7f5afe484$export$2e2bcd8739ae039; });

var $g2qsw = parcelRequire("g2qsw");

var $7Fxxh = parcelRequire("7Fxxh");

var $9o4jv = parcelRequire("9o4jv");

var $ikvbb = parcelRequire("ikvbb");

var $kyhHe = parcelRequire("kyhHe");

var $fHB48 = parcelRequire("fHB48");

var $56MqC = parcelRequire("56MqC");

var $50m0v = parcelRequire("50m0v");

var $cKNJp = parcelRequire("cKNJp");

var $lbZaY = parcelRequire("lbZaY");

var $dX2Eq = parcelRequire("dX2Eq");

var $lHcXU = parcelRequire("lHcXU");

var $cmvc1 = parcelRequire("cmvc1");

var $dghIh = parcelRequire("dghIh");

var $4VSLZ = parcelRequire("4VSLZ");

var $8HQt3 = parcelRequire("8HQt3");

var $hJw9r = parcelRequire("hJw9r");

var $7YbDm = parcelRequire("7YbDm");

var $519j3 = parcelRequire("519j3");

var $h3NzX = parcelRequire("h3NzX");

var $MqaTG = parcelRequire("MqaTG");

var $6szzw = parcelRequire("6szzw");

var $7EB9n = parcelRequire("7EB9n");

var $2ndhV = parcelRequire("2ndhV");

var $hWihv = parcelRequire("hWihv");

var $9haxa = parcelRequire("9haxa");

var $5m1kc = parcelRequire("5m1kc");

var $1AHlB = parcelRequire("1AHlB");

var $bGmT1 = parcelRequire("bGmT1");

var $4uWbm = parcelRequire("4uWbm");

var $cj6VA = parcelRequire("cj6VA");

var $xNYKg = parcelRequire("xNYKg");

var $bnDdH = parcelRequire("bnDdH");

var $kW7J5 = parcelRequire("kW7J5");

var $8nupm = parcelRequire("8nupm");

var $bWlSD = parcelRequire("bWlSD");

var $4K8y5 = parcelRequire("4K8y5");

var $jqdd7 = parcelRequire("jqdd7");

var $6h5J1 = parcelRequire("6h5J1");

var $ks4l0 = parcelRequire("ks4l0");

var $gi6xd = parcelRequire("gi6xd");

var $81pra = parcelRequire("81pra");

var $bKtOQ = parcelRequire("bKtOQ");

var $eZ85K = parcelRequire("eZ85K");

var $jk6bs = parcelRequire("jk6bs");

var $jYJM6 = parcelRequire("jYJM6");

var $hoAlg = parcelRequire("hoAlg");

var $7yFGs = parcelRequire("7yFGs");

var $kb4zK = parcelRequire("kb4zK");

var $1RhTA = parcelRequire("1RhTA");

var $4HQ2L = parcelRequire("4HQ2L");

var $g7Fca = parcelRequire("g7Fca");

var $b1XYO = parcelRequire("b1XYO");

var $lBRFE = parcelRequire("lBRFE");
const $ea2deec7f5afe484$var$defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy"
};
class $ea2deec7f5afe484$export$2e2bcd8739ae039 {
    isBeforeMonth(value, comparing) {
        return (0, $cj6VA.default)(value, (0, $jYJM6.default)(comparing));
    }
    isAfterMonth(value, comparing) {
        return (0, $4uWbm.default)(value, (0, $jYJM6.default)(comparing));
    }
    constructor({ locale: locale, formats: formats } = {}){
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            var _a;
            if (this.locale) return /a/.test((_a = this.locale.formatLong) === null || _a === void 0 ? void 0 : _a.time());
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = (format)=>{
            var _a, _b;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            const locale = this.locale || (0, $lBRFE.default);
            return (_b = (_a = format.match(longFormatRegexp)) === null || _a === void 0 ? void 0 : _a.map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($b1XYO)))[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format;
        };
        this.parseISO = (isoString)=>{
            return (0, $1RhTA.default)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $4HQ2L.default)(value, {
                format: "extended"
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _a;
            return ((_a = this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = (value, count)=>{
            return (0, $7Fxxh.default)(value, count);
        };
        this.addMinutes = (value, count)=>{
            return (0, $9o4jv.default)(value, count);
        };
        this.addHours = (value, count)=>{
            return (0, $ikvbb.default)(value, count);
        };
        this.addDays = (value, count)=>{
            return (0, $g2qsw.default)(value, count);
        };
        this.addWeeks = (value, count)=>{
            return (0, $kyhHe.default)(value, count);
        };
        this.addMonths = (value, count)=>{
            return (0, $fHB48.default)(value, count);
        };
        this.addYears = (value, count)=>{
            return (0, $56MqC.default)(value, count);
        };
        this.isValid = (value)=>{
            return (0, $4K8y5.default)(this.date(value));
        };
        this.getDiff = (value, comparing, unit)=>{
            var _a;
            // we output 0 if the compare date is string and parsing is not valid
            const dateToCompare = (_a = this.date(comparing)) !== null && _a !== void 0 ? _a : value;
            if (!this.isValid(dateToCompare)) return 0;
            switch(unit){
                case "years":
                    return (0, $50m0v.default)(value, dateToCompare);
                case "quarters":
                    return (0, $cKNJp.default)(value, dateToCompare);
                case "months":
                    return (0, $lbZaY.default)(value, dateToCompare);
                case "weeks":
                    return (0, $dX2Eq.default)(value, dateToCompare);
                case "days":
                    return (0, $lHcXU.default)(value, dateToCompare);
                case "hours":
                    return (0, $cmvc1.default)(value, dateToCompare);
                case "minutes":
                    return (0, $dghIh.default)(value, dateToCompare);
                case "seconds":
                    return (0, $4VSLZ.default)(value, dateToCompare);
                default:
                    return (0, $8HQt3.default)(value, dateToCompare);
            }
        };
        this.isAfter = (value, comparing)=>{
            return (0, $4uWbm.default)(value, comparing);
        };
        this.isBefore = (value, comparing)=>{
            return (0, $cj6VA.default)(value, comparing);
        };
        this.startOfDay = (value)=>{
            return (0, $jk6bs.default)(value);
        };
        this.endOfDay = (value)=>{
            return (0, $7YbDm.default)(value);
        };
        this.getHours = (value)=>{
            return (0, $hWihv.default)(value);
        };
        this.setHours = (value, count)=>{
            return (0, $ks4l0.default)(value, count);
        };
        this.setMinutes = (value, count)=>{
            return (0, $gi6xd.default)(value, count);
        };
        this.getSeconds = (value)=>{
            return (0, $1AHlB.default)(value);
        };
        this.setSeconds = (value, count)=>{
            return (0, $bKtOQ.default)(value, count);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $bnDdH.default)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $8nupm.default)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $kW7J5.default)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $bWlSD.default)(value, comparing);
        };
        this.startOfYear = (value)=>{
            return (0, $kb4zK.default)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $h3NzX.default)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $jYJM6.default)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $hoAlg.default)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $7yFGs.default)(value, {
                locale: this.locale
            });
        };
        this.endOfWeek = (value)=>{
            return (0, $519j3.default)(value, {
                locale: this.locale
            });
        };
        this.getYear = (value)=>{
            return (0, $bGmT1.default)(value);
        };
        this.setYear = (value, count)=>{
            return (0, $eZ85K.default)(value, count);
        };
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, $jqdd7.default)(value, formatString, new Date(), {
                locale: this.locale
            });
        };
        this.format = (date, formatKey)=>{
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString)=>{
            return (0, $MqaTG.default)(date, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (date, comparing)=>{
            if (date === null && comparing === null) return true;
            return (0, $xNYKg.default)(date, comparing);
        };
        this.isNull = (date)=>{
            return date === null;
        };
        this.isAfterDay = (date, value)=>{
            return (0, $4uWbm.default)(date, (0, $7YbDm.default)(value));
        };
        this.isBeforeDay = (date, value)=>{
            return (0, $cj6VA.default)(date, (0, $jk6bs.default)(value));
        };
        this.isBeforeYear = (date, value)=>{
            return (0, $cj6VA.default)(date, (0, $kb4zK.default)(value));
        };
        this.isAfterYear = (date, value)=>{
            return (0, $4uWbm.default)(date, (0, $h3NzX.default)(value));
        };
        this.isWithinRange = (date, [start, end])=>{
            return (0, $g7Fca.default)(date, {
                start: start,
                end: end
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getMinutes = (date)=>{
            return (0, $9haxa.default)(date);
        };
        this.getDate = (date)=>{
            return (0, $6szzw.default)(date);
        };
        this.setDate = (date, count)=>{
            return (0, $6h5J1.default)(date, count);
        };
        this.getMonth = (date)=>{
            return (0, $5m1kc.default)(date);
        };
        this.getDaysInMonth = (date)=>{
            return (0, $2ndhV.default)(date);
        };
        this.setMonth = (date, count)=>{
            return (0, $81pra.default)(date, count);
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = (date)=>{
            return (0, $fHB48.default)(date, 1);
        };
        this.getPreviousMonth = (date)=>{
            return (0, $fHB48.default)(date, -1);
        };
        this.getMonthArray = (date)=>{
            const firstMonth = (0, $kb4zK.default)(date);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (date, time)=>{
            return this.setSeconds(this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time)), this.getSeconds(time));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $hJw9r.default)({
                start: (0, $7yFGs.default)(now, {
                    locale: this.locale
                }),
                end: (0, $519j3.default)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, "EEEEEE"));
        };
        this.getWeekArray = (date)=>{
            const start = (0, $7yFGs.default)((0, $jYJM6.default)(date), {
                locale: this.locale
            });
            const end = (0, $519j3.default)((0, $hoAlg.default)(date), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            let lastDay = null;
            while((0, $cj6VA.default)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                const day = (0, $7EB9n.default)(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = (0, $g2qsw.default)(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $kb4zK.default)(start);
            const endDate = (0, $h3NzX.default)(end);
            const years = [];
            let current = startDate;
            while((0, $cj6VA.default)(current, endDate)){
                years.push(current);
                current = (0, $56MqC.default)(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, $ea2deec7f5afe484$var$defaultFormats, formats);
    }
}

});
parcelRegister("g2qsw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bad15b7880e6f97c$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bad15b7880e6f97c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("gPRuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c41ae7eb91efecef$export$2e2bcd8739ae039; });
function $c41ae7eb91efecef$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("uikl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05b104d2fa74b1c7$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $l1IMy = parcelRequire("l1IMy");
function $05b104d2fa74b1c7$export$2e2bcd8739ae039(argument) {
    (0, $l1IMy.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $6TO5S.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("l1IMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ec6dc17078088c$export$2e2bcd8739ae039; });
function $f4ec6dc17078088c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});



parcelRegister("7Fxxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5956604521ea0197$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
function $5956604521ea0197$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, amount * 1000);
}

});
parcelRegister("ggoRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd716e10292c6930$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bd716e10292c6930$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var timestamp = (0, $uikl2.default)(dirtyDate).getTime();
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("9o4jv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d59b3906efd21bf$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
var $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE = 60000;
function $6d59b3906efd21bf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, amount * $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("ikvbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d58247d27eb0dbf7$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
var $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR = 3600000;
function $d58247d27eb0dbf7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, amount * $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("kyhHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef64b5b7aae137f5$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $g2qsw = parcelRequire("g2qsw");

var $l1IMy = parcelRequire("l1IMy");
function $ef64b5b7aae137f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $g2qsw.default)(dirtyDate, days);
}

});

parcelRegister("fHB48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6e79fa3dbe621a2$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $b6e79fa3dbe621a2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("56MqC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b831424db570743$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $fHB48 = parcelRequire("fHB48");

var $l1IMy = parcelRequire("l1IMy");
function $3b831424db570743$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $fHB48.default)(dirtyDate, amount * 12);
}

});

parcelRegister("50m0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a4e06016f5a1c64$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $5aOOs = parcelRequire("5aOOs");

var $4Hxgr = parcelRequire("4Hxgr");

var $l1IMy = parcelRequire("l1IMy");
function $3a4e06016f5a1c64$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var sign = (0, $4Hxgr.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $5aOOs.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $4Hxgr.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("5aOOs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c454d4799b2e5e2$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3c454d4799b2e5e2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("4Hxgr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36c4fb25c3bcff41$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $36c4fb25c3bcff41$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});


parcelRegister("cKNJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94905b8ecb1c8a63$export$2e2bcd8739ae039; });

var $lbZaY = parcelRequire("lbZaY");

var $l1IMy = parcelRequire("l1IMy");

var $7yRLl = parcelRequire("7yRLl");
function $94905b8ecb1c8a63$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $l1IMy.default)(2, arguments);
    var diff = (0, $lbZaY.default)(dateLeft, dateRight) / 3;
    return (0, $7yRLl.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("lbZaY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6da14512b9613dc$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $848HI = parcelRequire("848HI");

var $4Hxgr = parcelRequire("4Hxgr");

var $l1IMy = parcelRequire("l1IMy");

var $7zxMH = parcelRequire("7zxMH");
function $f6da14512b9613dc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var sign = (0, $4Hxgr.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $848HI.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $4Hxgr.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $7zxMH.default)((0, $uikl2.default)(dirtyDateLeft)) && difference === 1 && (0, $4Hxgr.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("848HI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df572e1c801b5e3$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $5df572e1c801b5e3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("7zxMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $583602322c3e1847$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $7YbDm = parcelRequire("7YbDm");

var $hoAlg = parcelRequire("hoAlg");

var $l1IMy = parcelRequire("l1IMy");
function $583602322c3e1847$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    return (0, $7YbDm.default)(date).getTime() === (0, $hoAlg.default)(date).getTime();
}

});
parcelRegister("7YbDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cd7293820fa2400$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $5cd7293820fa2400$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hoAlg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa0de56b1948e3d$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $caa0de56b1948e3d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("7yRLl", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $5815698037663c71$export$b6474a47258c1211; });
var $5815698037663c71$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $5815698037663c71$var$defaultRoundingMethod = 'trunc';
function $5815698037663c71$export$b6474a47258c1211(method) {
    return method ? $5815698037663c71$var$roundingMap[method] : $5815698037663c71$var$roundingMap[$5815698037663c71$var$defaultRoundingMethod];
}

});


parcelRegister("dX2Eq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a282d77fbef9d903$export$2e2bcd8739ae039; });

var $lHcXU = parcelRequire("lHcXU");

var $l1IMy = parcelRequire("l1IMy");

var $7yRLl = parcelRequire("7yRLl");
function $a282d77fbef9d903$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $l1IMy.default)(2, arguments);
    var diff = (0, $lHcXU.default)(dateLeft, dateRight) / 7;
    return (0, $7yRLl.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("lHcXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcb7abc0fe52d209$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $1n0nj = parcelRequire("1n0nj");

var $l1IMy = parcelRequire("l1IMy");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $fcb7abc0fe52d209$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var sign = $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $1n0nj.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("1n0nj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff83ae00b0d75a6$export$2e2bcd8739ae039; });

var $dS93T = parcelRequire("dS93T");

var $jk6bs = parcelRequire("jk6bs");

var $l1IMy = parcelRequire("l1IMy");
var $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY = 86400000;
function $0ff83ae00b0d75a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var startOfDayLeft = (0, $jk6bs.default)(dirtyDateLeft);
    var startOfDayRight = (0, $jk6bs.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $dS93T.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $dS93T.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("dS93T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a197590075b6aa6e$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a197590075b6aa6e$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("jk6bs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e114ae87b2fb4d54$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $e114ae87b2fb4d54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});




parcelRegister("cmvc1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fffbc588a798f57$export$2e2bcd8739ae039; });

var $fiiUx = parcelRequire("fiiUx");

var $8HQt3 = parcelRequire("8HQt3");

var $l1IMy = parcelRequire("l1IMy");

var $7yRLl = parcelRequire("7yRLl");
function $8fffbc588a798f57$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $l1IMy.default)(2, arguments);
    var diff = (0, $8HQt3.default)(dateLeft, dateRight) / (0, $fiiUx.millisecondsInHour);
    return (0, $7yRLl.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("fiiUx", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $b22734c988ed96b7$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $b22734c988ed96b7$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $b22734c988ed96b7$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b22734c988ed96b7$export$dfd9b671c89acc8e = 7;
var $b22734c988ed96b7$export$3913210603d8e9ae = 365.2425;
var $b22734c988ed96b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b22734c988ed96b7$export$91246f0b9bd9beff = 60000;
var $b22734c988ed96b7$export$7f72910d6dfd237a = 3600000;
var $b22734c988ed96b7$export$397c2d5776aa9055 = 1000;
var $b22734c988ed96b7$export$4dec998e48f9c246 = -$b22734c988ed96b7$export$81caae6e1cc7a622;
var $b22734c988ed96b7$export$f2f5ae5a8e2d8f9f = 60;
var $b22734c988ed96b7$export$3c58128db900d44e = 3;
var $b22734c988ed96b7$export$80d7e435f744f319 = 12;
var $b22734c988ed96b7$export$4db7641526e3241f = 4;
var $b22734c988ed96b7$export$698aec755e92c695 = 3600;
var $b22734c988ed96b7$export$a77c1a7ebebe2a5a = 60;
var $b22734c988ed96b7$export$815a9362476d2fe3 = $b22734c988ed96b7$export$698aec755e92c695 * 24;
var $b22734c988ed96b7$export$34804a017b31e2fe = $b22734c988ed96b7$export$815a9362476d2fe3 * 7;
var $b22734c988ed96b7$export$7271e9e3478110d1 = $b22734c988ed96b7$export$815a9362476d2fe3 * $b22734c988ed96b7$export$3913210603d8e9ae;
var $b22734c988ed96b7$export$8e6600bbdee7dabb = $b22734c988ed96b7$export$7271e9e3478110d1 / 12;
var $b22734c988ed96b7$export$be1dccf2de902d31 = $b22734c988ed96b7$export$8e6600bbdee7dabb * 3;

});

parcelRegister("8HQt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $656b09e1b179d990$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $656b09e1b179d990$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $l1IMy.default)(2, arguments);
    return (0, $uikl2.default)(dateLeft).getTime() - (0, $uikl2.default)(dateRight).getTime();
}

});


parcelRegister("dghIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7a827aa3d7f832$export$2e2bcd8739ae039; });

var $fiiUx = parcelRequire("fiiUx");

var $8HQt3 = parcelRequire("8HQt3");

var $l1IMy = parcelRequire("l1IMy");

var $7yRLl = parcelRequire("7yRLl");
function $9a7a827aa3d7f832$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $l1IMy.default)(2, arguments);
    var diff = (0, $8HQt3.default)(dateLeft, dateRight) / (0, $fiiUx.millisecondsInMinute);
    return (0, $7yRLl.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("4VSLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3976f91395cc9929$export$2e2bcd8739ae039; });

var $8HQt3 = parcelRequire("8HQt3");

var $l1IMy = parcelRequire("l1IMy");

var $7yRLl = parcelRequire("7yRLl");
function $3976f91395cc9929$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $l1IMy.default)(2, arguments);
    var diff = (0, $8HQt3.default)(dateLeft, dateRight) / 1000;
    return (0, $7yRLl.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hJw9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8f943b2f1f7b6a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $ce8f943b2f1f7b6a$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $l1IMy.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $uikl2.default)(interval.start);
    var endDate = (0, $uikl2.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $uikl2.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("519j3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7443c6796c86d0$export$2e2bcd8739ae039; });

var $8SGaf = parcelRequire("8SGaf");

var $uikl2 = parcelRequire("uikl2");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");
function $3a7443c6796c86d0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(1, arguments);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var weekStartsOn = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("8SGaf", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $677412d78fecbb8b$export$430a3269e24b912e; });
var $677412d78fecbb8b$var$defaultOptions = {};
function $677412d78fecbb8b$export$430a3269e24b912e() {
    return $677412d78fecbb8b$var$defaultOptions;
}
function $677412d78fecbb8b$export$95365be1b0704abc(newOptions) {
    $677412d78fecbb8b$var$defaultOptions = newOptions;
}

});


parcelRegister("h3NzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6b92cd202ceada3$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $c6b92cd202ceada3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("MqaTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0918c9925a326e99$export$2e2bcd8739ae039; });

var $4K8y5 = parcelRequire("4K8y5");

var $4tT1o = parcelRequire("4tT1o");

var $uikl2 = parcelRequire("uikl2");

var $9KRld = parcelRequire("9KRld");

var $kvQ3g = parcelRequire("kvQ3g");

var $dS93T = parcelRequire("dS93T");

var $1BdKP = parcelRequire("1BdKP");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");

var $8SGaf = parcelRequire("8SGaf");

var $k1SOI = parcelRequire("k1SOI");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0918c9925a326e99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0918c9925a326e99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0918c9925a326e99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0918c9925a326e99$var$doubleQuoteRegExp = /''/g;
var $0918c9925a326e99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0918c9925a326e99$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $l1IMy.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $k1SOI.default);
    var firstWeekContainsDate = (0, $gPRuN.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gPRuN.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $uikl2.default)(dirtyDate);
    if (!(0, $4K8y5.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $dS93T.default)(originalDate);
    var utcDate = (0, $4tT1o.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0918c9925a326e99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $kvQ3g.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($0918c9925a326e99$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0918c9925a326e99$var$cleanEscapedString(substring);
        var formatter = (0, $9KRld.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $1BdKP.isProtectedWeekYearToken)(substring)) (0, $1BdKP.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $1BdKP.isProtectedDayOfYearToken)(substring)) (0, $1BdKP.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0918c9925a326e99$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0918c9925a326e99$var$cleanEscapedString(input) {
    var matched = input.match($0918c9925a326e99$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($0918c9925a326e99$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("4K8y5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $374216e389d08fec$export$2e2bcd8739ae039; });

var $a5Tnv = parcelRequire("a5Tnv");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $374216e389d08fec$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    if (!(0, $a5Tnv.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $uikl2.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("a5Tnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $759553f6ee74cd0d$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $l1IMy = parcelRequire("l1IMy");
function $759553f6ee74cd0d$export$2e2bcd8739ae039(value) {
    (0, $l1IMy.default)(1, arguments);
    return value instanceof Date || (0, $6TO5S.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("4tT1o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34348cf8fa5b62a4$export$2e2bcd8739ae039; });

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $34348cf8fa5b62a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, -amount);
}

});

parcelRegister("9KRld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71a1c96437171265$export$2e2bcd8739ae039; });

var $f5iZj = parcelRequire("f5iZj");

var $faNbH = parcelRequire("faNbH");

var $707Yy = parcelRequire("707Yy");

var $7xu1W = parcelRequire("7xu1W");

var $gqKyl = parcelRequire("gqKyl");

var $7GG93 = parcelRequire("7GG93");

var $bHnlP = parcelRequire("bHnlP");
var $71a1c96437171265$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $71a1c96437171265$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $bHnlP.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $gqKyl.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $7GG93.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $7GG93.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $707Yy.default)(date);
        // Padding
        return (0, $7GG93.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $7GG93.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $7GG93.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $7GG93.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $bHnlP.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $7GG93.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $7xu1W.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $7GG93.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $faNbH.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $7GG93.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $bHnlP.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $f5iZj.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $7GG93.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $7GG93.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $7GG93.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $7GG93.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $bHnlP.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $bHnlP.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $7GG93.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $7GG93.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $bHnlP.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $bHnlP.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $bHnlP.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $7GG93.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $7GG93.default)(timestamp, token.length);
    }
};
function $71a1c96437171265$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $7GG93.default)(minutes, 2);
}
function $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $7GG93.default)(Math.abs(offset) / 60, 2);
    }
    return $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter);
}
function $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $7GG93.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $7GG93.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $71a1c96437171265$export$2e2bcd8739ae039 = $71a1c96437171265$var$formatters;

});
parcelRegister("f5iZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb60d42de991571$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
var $afb60d42de991571$var$MILLISECONDS_IN_DAY = 86400000;
function $afb60d42de991571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $afb60d42de991571$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("faNbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0bdf1d2df59ff38$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $4FakD = parcelRequire("4FakD");

var $5A4VE = parcelRequire("5A4VE");

var $l1IMy = parcelRequire("l1IMy");
var $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK = 604800000;
function $b0bdf1d2df59ff38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var diff = (0, $4FakD.default)(date).getTime() - (0, $5A4VE.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("4FakD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365301764998b714$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $365301764998b714$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("5A4VE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41042352236130d1$export$2e2bcd8739ae039; });

var $707Yy = parcelRequire("707Yy");

var $4FakD = parcelRequire("4FakD");

var $l1IMy = parcelRequire("l1IMy");
function $41042352236130d1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var year = (0, $707Yy.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $4FakD.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("707Yy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $518eb844f291f762$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $4FakD = parcelRequire("4FakD");
function $518eb844f291f762$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4FakD.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4FakD.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("7xu1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d2e8e06c23527b$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $8M8d4 = parcelRequire("8M8d4");

var $4Nge6 = parcelRequire("4Nge6");

var $l1IMy = parcelRequire("l1IMy");
var $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK = 604800000;
function $57d2e8e06c23527b$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var diff = (0, $8M8d4.default)(date, options).getTime() - (0, $4Nge6.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("8M8d4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66392cbb34f04ad9$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");

var $8SGaf = parcelRequire("8SGaf");
function $66392cbb34f04ad9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(1, arguments);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var weekStartsOn = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("4Nge6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d853466602e505$export$2e2bcd8739ae039; });

var $gqKyl = parcelRequire("gqKyl");

var $l1IMy = parcelRequire("l1IMy");

var $8M8d4 = parcelRequire("8M8d4");

var $gPRuN = parcelRequire("gPRuN");

var $8SGaf = parcelRequire("8SGaf");
function $37d853466602e505$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(1, arguments);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $gqKyl.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8M8d4.default)(firstWeek, options);
    return date;
}

});
parcelRegister("gqKyl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf632f7e6fcf0087$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $8M8d4 = parcelRequire("8M8d4");

var $gPRuN = parcelRequire("gPRuN");

var $8SGaf = parcelRequire("8SGaf");
function $bf632f7e6fcf0087$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8M8d4.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8M8d4.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("7GG93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $598d25c1f2e4f194$export$2e2bcd8739ae039; });
function $598d25c1f2e4f194$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("bHnlP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8845d2e14e26c506$export$2e2bcd8739ae039; });

var $7GG93 = parcelRequire("7GG93");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8845d2e14e26c506$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $7GG93.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $7GG93.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $7GG93.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $7GG93.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $7GG93.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $7GG93.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $7GG93.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $7GG93.default)(fractionalSeconds, token.length);
    }
};
var $8845d2e14e26c506$export$2e2bcd8739ae039 = $8845d2e14e26c506$var$formatters;

});


parcelRegister("kvQ3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeef144218f64d7d$export$2e2bcd8739ae039; });
var $eeef144218f64d7d$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $eeef144218f64d7d$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $eeef144218f64d7d$var$timeLongFormatter(timePattern, formatLong));
};
var $eeef144218f64d7d$var$longFormatters = {
    p: $eeef144218f64d7d$var$timeLongFormatter,
    P: $eeef144218f64d7d$var$dateTimeLongFormatter
};
var $eeef144218f64d7d$export$2e2bcd8739ae039 = $eeef144218f64d7d$var$longFormatters;

});

parcelRegister("1BdKP", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $12a3ea762b495ad3$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $12a3ea762b495ad3$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $12a3ea762b495ad3$export$8073c1ae88f0e727; });
var $12a3ea762b495ad3$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $12a3ea762b495ad3$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $12a3ea762b495ad3$export$c6cc36aa33304772(token) {
    return $12a3ea762b495ad3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$c6b49d6dceb604a1(token) {
    return $12a3ea762b495ad3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("k1SOI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94e6c2283c04dc4$export$2e2bcd8739ae039; });

var $lBRFE = parcelRequire("lBRFE");
var $e94e6c2283c04dc4$export$2e2bcd8739ae039 = (0, $lBRFE.default);

});
parcelRegister("lBRFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb6af908147d006$export$2e2bcd8739ae039; });

var $3EDEV = parcelRequire("3EDEV");

var $ekOFl = parcelRequire("ekOFl");

var $8cIKN = parcelRequire("8cIKN");

var $1mS6E = parcelRequire("1mS6E");

var $aHHAy = parcelRequire("aHHAy");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $fbb6af908147d006$var$locale = {
    code: 'en-US',
    formatDistance: (0, $3EDEV.default),
    formatLong: (0, $ekOFl.default),
    formatRelative: (0, $8cIKN.default),
    localize: (0, $1mS6E.default),
    match: (0, $aHHAy.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fbb6af908147d006$export$2e2bcd8739ae039 = $fbb6af908147d006$var$locale;

});
parcelRegister("3EDEV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a93defe0440ad2b$export$2e2bcd8739ae039; });
var $2a93defe0440ad2b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2a93defe0440ad2b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2a93defe0440ad2b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2a93defe0440ad2b$export$2e2bcd8739ae039 = $2a93defe0440ad2b$var$formatDistance;

});

parcelRegister("ekOFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fa3c1fbba4fd67$export$2e2bcd8739ae039; });

var $7n9p6 = parcelRequire("7n9p6");
var $a6fa3c1fbba4fd67$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a6fa3c1fbba4fd67$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a6fa3c1fbba4fd67$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a6fa3c1fbba4fd67$var$formatLong = {
    date: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a6fa3c1fbba4fd67$export$2e2bcd8739ae039 = $a6fa3c1fbba4fd67$var$formatLong;

});
parcelRegister("7n9p6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e1f9cf760fc530$export$2e2bcd8739ae039; });
function $55e1f9cf760fc530$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("8cIKN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f9228dede0d6aa7$export$2e2bcd8739ae039; });
var $5f9228dede0d6aa7$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $5f9228dede0d6aa7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5f9228dede0d6aa7$var$formatRelativeLocale[token];
};
var $5f9228dede0d6aa7$export$2e2bcd8739ae039 = $5f9228dede0d6aa7$var$formatRelative;

});

parcelRegister("1mS6E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff1d0e06551a5c1$export$2e2bcd8739ae039; });

var $5XK0Y = parcelRequire("5XK0Y");
var $0ff1d0e06551a5c1$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $0ff1d0e06551a5c1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0ff1d0e06551a5c1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $0ff1d0e06551a5c1$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $0ff1d0e06551a5c1$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $0ff1d0e06551a5c1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $0ff1d0e06551a5c1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $0ff1d0e06551a5c1$var$localize = {
    ordinalNumber: $0ff1d0e06551a5c1$var$ordinalNumber,
    era: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0ff1d0e06551a5c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0ff1d0e06551a5c1$export$2e2bcd8739ae039 = $0ff1d0e06551a5c1$var$localize;

});
parcelRegister("5XK0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457628062959e556$export$2e2bcd8739ae039; });
function $457628062959e556$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aHHAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cafbb556cfb2776$export$2e2bcd8739ae039; });

var $l56pp = parcelRequire("l56pp");

var $knfbR = parcelRequire("knfbR");
var $7cafbb556cfb2776$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7cafbb556cfb2776$var$parseOrdinalNumberPattern = /\d+/i;
var $7cafbb556cfb2776$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7cafbb556cfb2776$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7cafbb556cfb2776$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7cafbb556cfb2776$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7cafbb556cfb2776$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7cafbb556cfb2776$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7cafbb556cfb2776$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7cafbb556cfb2776$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7cafbb556cfb2776$var$match = {
    ordinalNumber: (0, $knfbR.default)({
        matchPattern: $7cafbb556cfb2776$var$matchOrdinalNumberPattern,
        parsePattern: $7cafbb556cfb2776$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7cafbb556cfb2776$export$2e2bcd8739ae039 = $7cafbb556cfb2776$var$match;

});
parcelRegister("l56pp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f58f09468deb70ae$export$2e2bcd8739ae039; });
function $f58f09468deb70ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f58f09468deb70ae$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f58f09468deb70ae$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f58f09468deb70ae$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f58f09468deb70ae$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("knfbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed51bd2201b1ffe0$export$2e2bcd8739ae039; });
function $ed51bd2201b1ffe0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("6szzw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b40f36c6c4e8120$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $4b40f36c6c4e8120$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("7EB9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59291611c6d37351$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $59291611c6d37351$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("2ndhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba80981c4aaa361$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $1ba80981c4aaa361$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("hWihv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0f608c42e15b075$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $d0f608c42e15b075$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("9haxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c0ddf6f2e376b6f$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $6c0ddf6f2e376b6f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("5m1kc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e6008e0d859cbde$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3e6008e0d859cbde$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("1AHlB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $128ac71efb3a2f51$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $128ac71efb3a2f51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("bGmT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88155eb6456a8ca8$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $88155eb6456a8ca8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    return (0, $uikl2.default)(dirtyDate).getFullYear();
}

});

parcelRegister("4uWbm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3467188658b165bd$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3467188658b165bd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dateToCompare = (0, $uikl2.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("cj6VA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f5ca214877b2a80$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $8f5ca214877b2a80$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dateToCompare = (0, $uikl2.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("xNYKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0659d9ec4d7dbbf0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $0659d9ec4d7dbbf0$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyLeftDate);
    var dateRight = (0, $uikl2.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("bnDdH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $849043f97da8598e$export$2e2bcd8739ae039; });

var $jk6bs = parcelRequire("jk6bs");

var $l1IMy = parcelRequire("l1IMy");
function $849043f97da8598e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeftStartOfDay = (0, $jk6bs.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $jk6bs.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("kW7J5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3df37b4dec5127a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $f3df37b4dec5127a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("8nupm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61980f1dae65c9e0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $61980f1dae65c9e0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("bWlSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b16156dc6f0bfd4$export$2e2bcd8739ae039; });

var $4FreH = parcelRequire("4FreH");

var $l1IMy = parcelRequire("l1IMy");
function $8b16156dc6f0bfd4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeftStartOfHour = (0, $4FreH.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $4FreH.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

});
parcelRegister("4FreH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36601e4381c8841a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $36601e4381c8841a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

});


parcelRegister("jqdd7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e23ab16419322690$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $jqm5D = parcelRequire("jqm5D");

var $k1SOI = parcelRequire("k1SOI");

var $4tT1o = parcelRequire("4tT1o");

var $uikl2 = parcelRequire("uikl2");

var $9x9mK = parcelRequire("9x9mK");

var $kvQ3g = parcelRequire("kvQ3g");

var $dS93T = parcelRequire("dS93T");

var $1BdKP = parcelRequire("1BdKP");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");

var $lncct = parcelRequire("lncct");

var $eyVcr = parcelRequire("eyVcr");

var $8SGaf = parcelRequire("8SGaf");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e23ab16419322690$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e23ab16419322690$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e23ab16419322690$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e23ab16419322690$var$doubleQuoteRegExp = /''/g;
var $e23ab16419322690$var$notWhitespaceRegExp = /\S/;
var $e23ab16419322690$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e23ab16419322690$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $l1IMy.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $k1SOI.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $gPRuN.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gPRuN.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $uikl2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $lncct.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($e23ab16419322690$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $kvQ3g.default)) {
            var longFormatter = (0, $kvQ3g.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e23ab16419322690$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $jqm5D.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $1BdKP.isProtectedWeekYearToken)(token)) (0, $1BdKP.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $1BdKP.isProtectedDayOfYearToken)(token)) (0, $1BdKP.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $eyVcr.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($e23ab16419322690$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $e23ab16419322690$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $6TO5S.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $e23ab16419322690$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $uikl2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $4tT1o.default)(date, (0, $dS93T.default)(date));
    var flags = {};
    var _iterator2 = (0, $jqm5D.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $9x9mK.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $e23ab16419322690$var$cleanEscapedString(input) {
    return input.match($e23ab16419322690$var$escapedStringRegExp)[1].replace($e23ab16419322690$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("jqm5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e24194a208e52c1b$export$2e2bcd8739ae039; });

var $6A22e = parcelRequire("6A22e");
function $e24194a208e52c1b$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $6A22e.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});

parcelRegister("9x9mK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f0e75fc27c44afd$export$2e2bcd8739ae039; });
function $6f0e75fc27c44afd$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("lncct", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $f8f535a8fee12b58$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee; });

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $dQMrF = parcelRequire("dQMrF");
var $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f8f535a8fee12b58$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $03dWn.default)(this, Setter);
        (0, $dQMrF.default)(this, "priority", void 0);
        (0, $dQMrF.default)(this, "subPriority", 0);
    }
    (0, $4OFm0.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f8f535a8fee12b58$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $73CuG.default)(ValueSetter, _Setter);
    var _super = (0, $gJzKg.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $03dWn.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $4OFm0.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);
var $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $73CuG.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $gJzKg.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $03dWn.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this2), "priority", $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $4OFm0.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);

});
parcelRegister("73CuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5236ac5195402c05$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $5236ac5195402c05$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iJeDO.default)(t, e);
}

});

parcelRegister("gJzKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ec9395872a8e53$export$2e2bcd8739ae039; });

var $fv7Xh = parcelRequire("fv7Xh");

var $hqIEE = parcelRequire("hqIEE");

var $91d37 = parcelRequire("91d37");
function $c2ec9395872a8e53$export$2e2bcd8739ae039(t) {
    var r = (0, $hqIEE.default)();
    return function() {
        var e, o = (0, $fv7Xh.default)(t);
        if (r) {
            var s = (0, $fv7Xh.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $91d37.default)(this, e);
    };
}

});
parcelRegister("fv7Xh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48febf76cf3d138$export$2e2bcd8739ae039; });
function $b48febf76cf3d138$export$2e2bcd8739ae039(t) {
    return $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $b48febf76cf3d138$export$2e2bcd8739ae039(t);
}

});

parcelRegister("hqIEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0780e1471bbfb2$export$2e2bcd8739ae039; });
function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cb0780e1471bbfb2$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("91d37", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690e545d5a200a90$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $3zeAJ = parcelRequire("3zeAJ");
function $690e545d5a200a90$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6TO5S.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3zeAJ.default)(t);
}

});


parcelRegister("03dWn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009b183922525d46$export$2e2bcd8739ae039; });
function $009b183922525d46$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dQMrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a155b5e75cfe9a4d$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $aYCSV.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("eyVcr", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $a9a09c5462def3d7$export$19131010e7fd8373; });

var $5WzIi = parcelRequire("5WzIi");

var $gD34c = parcelRequire("gD34c");

var $lLAzf = parcelRequire("lLAzf");

var $fLpOz = parcelRequire("fLpOz");

var $i4Fnw = parcelRequire("i4Fnw");

var $kJGWU = parcelRequire("kJGWU");

var $32dRC = parcelRequire("32dRC");

var $c6osa = parcelRequire("c6osa");

var $jt7ZP = parcelRequire("jt7ZP");

var $1G8RR = parcelRequire("1G8RR");

var $70LNy = parcelRequire("70LNy");

var $jSPkl = parcelRequire("jSPkl");

var $jai5s = parcelRequire("jai5s");

var $7IN67 = parcelRequire("7IN67");

var $dHKqg = parcelRequire("dHKqg");

var $1s2eX = parcelRequire("1s2eX");

var $dI0uf = parcelRequire("dI0uf");

var $kBwtf = parcelRequire("kBwtf");

var $enJ2b = parcelRequire("enJ2b");

var $KfNjv = parcelRequire("KfNjv");

var $6uhQq = parcelRequire("6uhQq");

var $lJX2d = parcelRequire("lJX2d");

var $6WR7p = parcelRequire("6WR7p");

var $2GrfI = parcelRequire("2GrfI");

var $cpRGI = parcelRequire("cpRGI");

var $7zXt4 = parcelRequire("7zXt4");

var $eT1Bs = parcelRequire("eT1Bs");

var $kLKUr = parcelRequire("kLKUr");

var $dFZ7T = parcelRequire("dFZ7T");

var $i0YRh = parcelRequire("i0YRh");

var $jEVPW = parcelRequire("jEVPW");
var $a9a09c5462def3d7$export$19131010e7fd8373 = {
    G: new (0, $5WzIi.EraParser)(),
    y: new (0, $gD34c.YearParser)(),
    Y: new (0, $lLAzf.LocalWeekYearParser)(),
    R: new (0, $fLpOz.ISOWeekYearParser)(),
    u: new (0, $i4Fnw.ExtendedYearParser)(),
    Q: new (0, $kJGWU.QuarterParser)(),
    q: new (0, $32dRC.StandAloneQuarterParser)(),
    M: new (0, $c6osa.MonthParser)(),
    L: new (0, $jt7ZP.StandAloneMonthParser)(),
    w: new (0, $1G8RR.LocalWeekParser)(),
    I: new (0, $70LNy.ISOWeekParser)(),
    d: new (0, $jSPkl.DateParser)(),
    D: new (0, $jai5s.DayOfYearParser)(),
    E: new (0, $7IN67.DayParser)(),
    e: new (0, $dHKqg.LocalDayParser)(),
    c: new (0, $1s2eX.StandAloneLocalDayParser)(),
    i: new (0, $dI0uf.ISODayParser)(),
    a: new (0, $kBwtf.AMPMParser)(),
    b: new (0, $enJ2b.AMPMMidnightParser)(),
    B: new (0, $KfNjv.DayPeriodParser)(),
    h: new (0, $6uhQq.Hour1to12Parser)(),
    H: new (0, $lJX2d.Hour0to23Parser)(),
    K: new (0, $6WR7p.Hour0To11Parser)(),
    k: new (0, $2GrfI.Hour1To24Parser)(),
    m: new (0, $cpRGI.MinuteParser)(),
    s: new (0, $7zXt4.SecondParser)(),
    S: new (0, $eT1Bs.FractionOfSecondParser)(),
    X: new (0, $kLKUr.ISOTimezoneWithZParser)(),
    x: new (0, $dFZ7T.ISOTimezoneParser)(),
    t: new (0, $i0YRh.TimestampSecondsParser)(),
    T: new (0, $jEVPW.TimestampMillisecondsParser)()
};

});
parcelRegister("5WzIi", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $453e127a2cb59433$export$8e5a1d3f85a9688; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");
var $453e127a2cb59433$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(EraParser, _Parser);
    var _super = (0, $gJzKg.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $03dWn.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 140);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $il0m3.Parser));

});
parcelRegister("il0m3", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $d59a769c05ef4f32$export$7acfa6ed01010e37; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $dQMrF = parcelRequire("dQMrF");

var $lncct = parcelRequire("lncct");
var $d59a769c05ef4f32$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $03dWn.default)(this, Parser);
        (0, $dQMrF.default)(this, "incompatibleTokens", void 0);
        (0, $dQMrF.default)(this, "priority", void 0);
        (0, $dQMrF.default)(this, "subPriority", void 0);
    }
    (0, $4OFm0.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $lncct.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("gD34c", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $c1b2aad30ed081d9$export$48d352de7cd4a988; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $c1b2aad30ed081d9$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(YearParser, _Parser);
    var _super = (0, $gJzKg.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $03dWn.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $hpfY6.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $il0m3.Parser));

});
parcelRegister("hpfY6", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $cac12873b21a7f06$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $cac12873b21a7f06$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $cac12873b21a7f06$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $cac12873b21a7f06$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $cac12873b21a7f06$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $cac12873b21a7f06$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $cac12873b21a7f06$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $cac12873b21a7f06$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $cac12873b21a7f06$export$3d50627710b84d75; });

var $fiiUx = parcelRequire("fiiUx");

var $435hr = parcelRequire("435hr");
function $cac12873b21a7f06$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cac12873b21a7f06$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $fiiUx.millisecondsInHour) + minutes * (0, $fiiUx.millisecondsInMinute) + seconds * (0, $fiiUx.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$d931c43c4608a164(dateString) {
    return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).anyDigitsSigned, dateString);
}
function $cac12873b21a7f06$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).singleDigit, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).twoDigits, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).threeDigits, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).fourDigits, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $435hr.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $cac12873b21a7f06$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cac12873b21a7f06$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("435hr", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $2f2b89d1b907546d$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $2f2b89d1b907546d$export$a7ee192b982af9c1; });
var $2f2b89d1b907546d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $2f2b89d1b907546d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("lLAzf", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $fd8a5a4d27b95514$export$b8ef38dfcf05d5db; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");

var $gqKyl = parcelRequire("gqKyl");

var $8M8d4 = parcelRequire("8M8d4");
var $fd8a5a4d27b95514$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $gJzKg.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $03dWn.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $gqKyl.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $hpfY6.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $8M8d4.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $8M8d4.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $il0m3.Parser));

});

parcelRegister("fLpOz", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $b79f45105f4fc5bf$export$951d1df011fde06f; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");

var $4FakD = parcelRequire("4FakD");
var $b79f45105f4fc5bf$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $gJzKg.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $03dWn.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $hpfY6.parseNDigitsSigned)(4, dateString);
                return (0, $hpfY6.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $4FakD.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $il0m3.Parser));

});

parcelRegister("i4Fnw", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $d288b29c63f12ba7$export$bad9d2ea38e8f1a; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $d288b29c63f12ba7$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ExtendedYearParser, _Parser);
    var _super = (0, $gJzKg.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $03dWn.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $hpfY6.parseNDigitsSigned)(4, dateString);
                return (0, $hpfY6.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $il0m3.Parser));

});

parcelRegister("kJGWU", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $f189536e19579fc7$export$5cb0f701186dde1d; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $f189536e19579fc7$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(QuarterParser, _Parser);
    var _super = (0, $gJzKg.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $03dWn.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $il0m3.Parser));

});

parcelRegister("32dRC", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $235c501771f8f2c8$export$300c0c2990e20e6d; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $235c501771f8f2c8$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $gJzKg.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $il0m3.Parser));

});

parcelRegister("c6osa", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $8cf9037af5c80a6b$export$400dd8b40ef138a3; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $hpfY6 = parcelRequire("hpfY6");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");
var $8cf9037af5c80a6b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(MonthParser, _Parser);
    var _super = (0, $gJzKg.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $03dWn.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 110);
        return _this;
    }
    (0, $4OFm0.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $il0m3.Parser));

});

parcelRegister("jt7ZP", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $e2c6ed9eece38c05$export$1d7eaa53eaa5deba; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $e2c6ed9eece38c05$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $gJzKg.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 110);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $il0m3.Parser));

});

parcelRegister("1G8RR", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $1390979b933b1e35$export$c4005ffc174e07c0; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");

var $dFIau = parcelRequire("dFIau");

var $8M8d4 = parcelRequire("8M8d4");
var $1390979b933b1e35$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(LocalWeekParser, _Parser);
    var _super = (0, $gJzKg.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $03dWn.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $8M8d4.default)((0, $dFIau.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $il0m3.Parser));

});
parcelRegister("dFIau", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f415d9aa929cb5f$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $7xu1W = parcelRequire("7xu1W");

var $l1IMy = parcelRequire("l1IMy");
function $9f415d9aa929cb5f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var week = (0, $gPRuN.default)(dirtyWeek);
    var diff = (0, $7xu1W.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("70LNy", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $51ad9c3a7ea45056$export$6fc8dbedd560a6af; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");

var $gFYW2 = parcelRequire("gFYW2");

var $4FakD = parcelRequire("4FakD");
var $51ad9c3a7ea45056$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ISOWeekParser, _Parser);
    var _super = (0, $gJzKg.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $03dWn.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $4FakD.default)((0, $gFYW2.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $il0m3.Parser));

});
parcelRegister("gFYW2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c23fbe21a3e9d7ec$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $faNbH = parcelRequire("faNbH");

var $l1IMy = parcelRequire("l1IMy");
function $c23fbe21a3e9d7ec$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var isoWeek = (0, $gPRuN.default)(dirtyISOWeek);
    var diff = (0, $faNbH.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("jSPkl", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $e79adff529ff7d87$export$e8d4b28a20981dd2; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $hpfY6 = parcelRequire("hpfY6");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");
var $e79adff529ff7d87$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(DateParser, _Parser);
    var _super = (0, $gJzKg.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $03dWn.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "subPriority", 1);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $hpfY6.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $il0m3.Parser));

});

parcelRegister("jai5s", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $df3cfb3868b5f2d9$export$6cfe0d613455f615; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $df3cfb3868b5f2d9$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(DayOfYearParser, _Parser);
    var _super = (0, $gJzKg.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $03dWn.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "subpriority", 1);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $hpfY6.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $il0m3.Parser));

});

parcelRegister("7IN67", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $59f2ba411bffa594$export$1b03c8b76262f7bd; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $iMSzR = parcelRequire("iMSzR");
var $59f2ba411bffa594$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(DayParser, _Parser);
    var _super = (0, $gJzKg.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $03dWn.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $iMSzR.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $il0m3.Parser));

});
parcelRegister("iMSzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dad70b9d49228da0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");

var $8SGaf = parcelRequire("8SGaf");
function $dad70b9d49228da0$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(2, arguments);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var weekStartsOn = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = (0, $gPRuN.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("dHKqg", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $9fa34d129085f38e$export$44d1c127ab42c480; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");

var $iMSzR = parcelRequire("iMSzR");
var $9fa34d129085f38e$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(LocalDayParser, _Parser);
    var _super = (0, $gJzKg.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $03dWn.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $iMSzR.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $il0m3.Parser));

});

parcelRegister("1s2eX", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $10ea24d6b77d76b5$export$e447a647caaaec1d; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");

var $iMSzR = parcelRequire("iMSzR");
var $10ea24d6b77d76b5$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $gJzKg.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $hpfY6.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $iMSzR.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $il0m3.Parser));

});

parcelRegister("dI0uf", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $9fafc31a4201a6f4$export$693fb1e525095b2a; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");

var $ajDLz = parcelRequire("ajDLz");
var $9fafc31a4201a6f4$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ISODayParser, _Parser);
    var _super = (0, $gJzKg.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $03dWn.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $hpfY6.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $hpfY6.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $hpfY6.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $hpfY6.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $ajDLz.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $il0m3.Parser));

});
parcelRegister("ajDLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $782a867d325da60d$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $782a867d325da60d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $l1IMy.default)(2, arguments);
    var day = (0, $gPRuN.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $uikl2.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("kBwtf", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $f000735938cd3f06$export$8d1e08492351df91; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $f000735938cd3f06$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(AMPMParser, _Parser);
    var _super = (0, $gJzKg.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $03dWn.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hpfY6.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $il0m3.Parser));

});

parcelRegister("enJ2b", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $a786258bf503f7be$export$73ca2bd0a17d273; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $a786258bf503f7be$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $gJzKg.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $03dWn.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hpfY6.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $il0m3.Parser));

});

parcelRegister("KfNjv", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $08b08c6d5753cdfd$export$bb9212adf05373db; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $08b08c6d5753cdfd$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(DayPeriodParser, _Parser);
    var _super = (0, $gJzKg.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $03dWn.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $hpfY6.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $il0m3.Parser));

});

parcelRegister("6uhQq", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $4b936300b1515974$export$8a04050a727a1756; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $4b936300b1515974$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(Hour1to12Parser, _Parser);
    var _super = (0, $gJzKg.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $il0m3.Parser));

});

parcelRegister("lJX2d", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $fd3b98057917a9cb$export$e56f4dea2c3e56dd; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $fd3b98057917a9cb$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(Hour0to23Parser, _Parser);
    var _super = (0, $gJzKg.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $il0m3.Parser));

});

parcelRegister("6WR7p", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $50f15d1a322aa483$export$cbbe855312f87d77; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $50f15d1a322aa483$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(Hour0To11Parser, _Parser);
    var _super = (0, $gJzKg.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $il0m3.Parser));

});

parcelRegister("2GrfI", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $1f44a4cabb386e21$export$6008046d2b34b6a5; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $1f44a4cabb386e21$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(Hour1To24Parser, _Parser);
    var _super = (0, $gJzKg.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $il0m3.Parser));

});

parcelRegister("cpRGI", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $90a17725cd6a5e78$export$2b52670d9e2be53; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $90a17725cd6a5e78$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(MinuteParser, _Parser);
    var _super = (0, $gJzKg.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $03dWn.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 60);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $il0m3.Parser));

});

parcelRegister("7zXt4", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $5849ee64b8145759$export$94d46d540cf1366a; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $5849ee64b8145759$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(SecondParser, _Parser);
    var _super = (0, $gJzKg.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $03dWn.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 50);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $hpfY6.parseNumericPattern)((0, $435hr.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $hpfY6.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $il0m3.Parser));

});

parcelRegister("eT1Bs", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $ad67721c76585871$export$b8e6f8b2d70893b1; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $ad67721c76585871$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $gJzKg.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $03dWn.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 30);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $hpfY6.mapValue)((0, $hpfY6.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $il0m3.Parser));

});

parcelRegister("kLKUr", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $f1ec95a2e92c6a8e$export$104d901d49fea29b; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $f1ec95a2e92c6a8e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $gJzKg.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $03dWn.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $il0m3.Parser));

});

parcelRegister("dFZ7T", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $9f4e851982e313bd$export$12910e5204b52b9; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $435hr = parcelRequire("435hr");

var $hpfY6 = parcelRequire("hpfY6");
var $9f4e851982e313bd$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $gJzKg.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $03dWn.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $hpfY6.parseTimezonePattern)((0, $435hr.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $il0m3.Parser));

});

parcelRegister("i0YRh", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $d1d76f4ee5cb7969$export$2cd8bf877a05e96; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $d1d76f4ee5cb7969$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $gJzKg.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $03dWn.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 40);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $4OFm0.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $hpfY6.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $il0m3.Parser));

});

parcelRegister("jEVPW", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $e4fe9dee5db1b18a$export$6d8f69c6906d6368; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $gJzKg = parcelRequire("gJzKg");

var $dQMrF = parcelRequire("dQMrF");

var $il0m3 = parcelRequire("il0m3");

var $hpfY6 = parcelRequire("hpfY6");
var $e4fe9dee5db1b18a$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $73CuG.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $gJzKg.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $03dWn.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 20);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $4OFm0.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $hpfY6.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $il0m3.Parser));

});



parcelRegister("6h5J1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4918c57fb0877934$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $4918c57fb0877934$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dayOfMonth = (0, $gPRuN.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}

});

parcelRegister("ks4l0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee39c98c5378a0a6$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $ee39c98c5378a0a6$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var hours = (0, $gPRuN.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("gi6xd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdc3656b920d564d$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bdc3656b920d564d$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var minutes = (0, $gPRuN.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("81pra", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d7226012cddb1a9$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $2ndhV = parcelRequire("2ndhV");

var $l1IMy = parcelRequire("l1IMy");
function $5d7226012cddb1a9$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = (0, $gPRuN.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $2ndhV.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});

parcelRegister("bKtOQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88db1f07d3462e3c$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $88db1f07d3462e3c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var seconds = (0, $gPRuN.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("eZ85K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae8d0a047d9558ed$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $ae8d0a047d9558ed$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = (0, $gPRuN.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("jYJM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8b720dd7751e2f7$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $e8b720dd7751e2f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7yFGs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $580c0aebe042d20a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");

var $8SGaf = parcelRequire("8SGaf");
function $580c0aebe042d20a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $l1IMy.default)(1, arguments);
    var defaultOptions = (0, $8SGaf.getDefaultOptions)();
    var weekStartsOn = (0, $gPRuN.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kb4zK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb08625b8e4078ad$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $eb08625b8e4078ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var cleanDate = (0, $uikl2.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1RhTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15a89f5e74b8913f$export$2e2bcd8739ae039; });

var $fiiUx = parcelRequire("fiiUx");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $15a89f5e74b8913f$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $l1IMy.default)(1, arguments);
    var additionalDigits = (0, $gPRuN.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $15a89f5e74b8913f$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $15a89f5e74b8913f$var$parseYear(dateStrings.date, additionalDigits);
        date = $15a89f5e74b8913f$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $15a89f5e74b8913f$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $15a89f5e74b8913f$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $15a89f5e74b8913f$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $15a89f5e74b8913f$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $15a89f5e74b8913f$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $15a89f5e74b8913f$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $15a89f5e74b8913f$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($15a89f5e74b8913f$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($15a89f5e74b8913f$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($15a89f5e74b8913f$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $15a89f5e74b8913f$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $15a89f5e74b8913f$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $15a89f5e74b8913f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($15a89f5e74b8913f$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $15a89f5e74b8913f$var$parseDateUnit(captures[1]);
    var month = $15a89f5e74b8913f$var$parseDateUnit(captures[2]) - 1;
    var day = $15a89f5e74b8913f$var$parseDateUnit(captures[3]);
    var week = $15a89f5e74b8913f$var$parseDateUnit(captures[4]);
    var dayOfWeek = $15a89f5e74b8913f$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$15a89f5e74b8913f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $15a89f5e74b8913f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$15a89f5e74b8913f$var$validateDate(year, month, day) || !$15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $15a89f5e74b8913f$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $15a89f5e74b8913f$var$parseTime(timeString) {
    var captures = timeString.match($15a89f5e74b8913f$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $15a89f5e74b8913f$var$parseTimeUnit(captures[1]);
    var minutes = $15a89f5e74b8913f$var$parseTimeUnit(captures[2]);
    var seconds = $15a89f5e74b8913f$var$parseTimeUnit(captures[3]);
    if (!$15a89f5e74b8913f$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $fiiUx.millisecondsInHour) + minutes * (0, $fiiUx.millisecondsInMinute) + seconds * 1000;
}
function $15a89f5e74b8913f$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $15a89f5e74b8913f$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($15a89f5e74b8913f$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$15a89f5e74b8913f$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $fiiUx.millisecondsInHour) + minutes * (0, $fiiUx.millisecondsInMinute));
}
function $15a89f5e74b8913f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $15a89f5e74b8913f$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $15a89f5e74b8913f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $15a89f5e74b8913f$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($15a89f5e74b8913f$var$daysInMonths[month] || ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 29 : 28));
}
function $15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 366 : 365);
}
function $15a89f5e74b8913f$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $15a89f5e74b8913f$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $15a89f5e74b8913f$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("4HQ2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36d38c5e1565f0a6$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $7GG93 = parcelRequire("7GG93");

var $l1IMy = parcelRequire("l1IMy");
function $36d38c5e1565f0a6$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $l1IMy.default)(1, arguments);
    var originalDate = (0, $uikl2.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7GG93.default)(originalDate.getDate(), 2);
        var month = (0, $7GG93.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7GG93.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7GG93.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7GG93.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7GG93.default)(originalDate.getHours(), 2);
        var minute = (0, $7GG93.default)(originalDate.getMinutes(), 2);
        var second = (0, $7GG93.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("g7Fca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbcd414b3c303484$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bbcd414b3c303484$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $l1IMy.default)(2, arguments);
    var time = (0, $uikl2.default)(dirtyDate).getTime();
    var startTime = (0, $uikl2.default)(interval.start).getTime();
    var endTime = (0, $uikl2.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("b1XYO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $807e5074bec33cce$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $807e5074bec33cce$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $807e5074bec33cce$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $807e5074bec33cce$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $807e5074bec33cce$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $807e5074bec33cce$var$timeLongFormatter(timePattern, formatLong));
};
var $807e5074bec33cce$var$longFormatters = {
    p: $807e5074bec33cce$var$timeLongFormatter,
    P: $807e5074bec33cce$var$dateTimeLongFormatter
};
var $807e5074bec33cce$var$_default = $807e5074bec33cce$var$longFormatters;
module.exports.default = $807e5074bec33cce$var$_default;
module.exports = module.exports.default;

});


parcelRegister("4p6PS", function(module, exports) {

$parcel$export(module.exports, "MuiPickersAdapterContext", function () { return $334eccad7a4571c0$export$544976378534cf9; });
$parcel$export(module.exports, "default", function () { return $334eccad7a4571c0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
const $334eccad7a4571c0$export$544976378534cf9 = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * @ignore - do not document.
 */ function $334eccad7a4571c0$var$LocalizationProvider(props) {
    const { children: children, dateAdapter: Utils, dateFormats: dateFormats, dateLibInstance: dateLibInstance, locale: locale } = props;
    const utils = $7fPBF.useMemo(()=>new Utils({
            locale: locale,
            formats: dateFormats,
            instance: dateLibInstance
        }), [
        Utils,
        locale,
        dateFormats,
        dateLibInstance
    ]);
    const defaultDates = $7fPBF.useMemo(()=>{
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $7fPBF.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates
        };
    }, [
        defaultDates,
        utils
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($334eccad7a4571c0$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
}
var $334eccad7a4571c0$export$2e2bcd8739ae039 = $334eccad7a4571c0$var$LocalizationProvider;

});

parcelRegister("8m4sd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6153d5517a7887fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $5j2OD = parcelRequire("5j2OD");

var $i1dYO = parcelRequire("i1dYO");


var $63o9t = parcelRequire("63o9t");

var $dMpT3 = parcelRequire("dMpT3");

var $bbzbN = parcelRequire("bbzbN");
const $6153d5517a7887fa$var$_excluded = [
    "cancelText",
    "clearable",
    "clearText",
    "desktopModeMediaQuery",
    "DialogProps",
    "okText",
    "PopperProps",
    "showTodayButton",
    "todayText",
    "TransitionComponent"
];
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 * - [Pickers](https://mui.com/components/pickers/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/api/date-picker/)
 */ const $6153d5517a7887fa$var$DatePicker = /*#__PURE__*/ $7fPBF.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { cancelText: cancelText, clearable: clearable, clearText: clearText, desktopModeMediaQuery: desktopModeMediaQuery = '@media (pointer: fine)', DialogProps: DialogProps, okText: okText, PopperProps: PopperProps, showTodayButton: showTodayButton, todayText: todayText, TransitionComponent: TransitionComponent } = props, other = (0, $cFLic.default)(props, $6153d5517a7887fa$var$_excluded);
    const isDesktop = (0, $i1dYO.default)(desktopModeMediaQuery);
    return isDesktop ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $63o9t.default), (0, $kY3Ke.default)({
        ref: ref,
        PopperProps: PopperProps,
        TransitionComponent: TransitionComponent,
        clearText: clearText,
        clearable: clearable
    }, other)) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dMpT3.default), (0, $kY3Ke.default)({
        ref: ref,
        cancelText: cancelText,
        clearable: clearable,
        clearText: clearText,
        DialogProps: DialogProps,
        okText: okText,
        showTodayButton: showTodayButton,
        todayText: todayText
    }, other));
});
var $6153d5517a7887fa$export$2e2bcd8739ae039 = $6153d5517a7887fa$var$DatePicker;

});
parcelRegister("5j2OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd0e9417d40119e$export$2e2bcd8739ae039; });

var $9HPC7 = parcelRequire("9HPC7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
'use client';
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9HPC7.default)({
        props: props,
        name: name,
        defaultTheme: $9P91Y.default,
        themeId: (0, $jwhZE.default)
    });
}

});
parcelRegister("9HPC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71102aa90e2b2620$export$2e2bcd8739ae039; });

var $38WAi = parcelRequire("38WAi");

var $4kWyf = parcelRequire("4kWyf");
'use client';
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $4kWyf.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $38WAi.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("38WAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249f9015c4a2303b$export$2e2bcd8739ae039; });

var $gjk5S = parcelRequire("gjk5S");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $gjk5S.default)(theme.components[name].defaultProps, props);
}

});



parcelRegister("i1dYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e32a1d75e60036$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $38WAi = parcelRequire("38WAi");

var $84PRT = parcelRequire("84PRT");
'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $d1e32a1d75e60036$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $lJRRs.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore = $7fPBF.useSyncExternalStore;
function $d1e32a1d75e60036$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $d1e32a1d75e60036$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $84PRT.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $38WAi.default)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $d1e32a1d75e60036$var$maybeReactUseSyncExternalStore !== undefined ? $d1e32a1d75e60036$var$useMediaQueryNew : $d1e32a1d75e60036$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});

parcelRegister("63o9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4685c1f3b9a8a3d6$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9tuGI = parcelRequire("9tuGI");

var $6kuGy = parcelRequire("6kuGy");

var $8STIk = parcelRequire("8STIk");

var $a4Xf8 = parcelRequire("a4Xf8");

var $2Jx0Z = parcelRequire("2Jx0Z");

var $99YKv = parcelRequire("99YKv");

var $73rDW = parcelRequire("73rDW");

var $1PhMQ = parcelRequire("1PhMQ");

var $bbzbN = parcelRequire("bbzbN");
const $4685c1f3b9a8a3d6$var$_excluded = [
    "onChange",
    "PopperProps",
    "PaperProps",
    "ToolbarComponent",
    "TransitionComponent",
    "value",
    "clearText",
    "clearable"
];
const $4685c1f3b9a8a3d6$var$valueManager = {
    emptyValue: null,
    parseInput: (0, $99YKv.parsePickerInputValue),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b)
};
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/api/desktop-date-picker/)
 */ const $4685c1f3b9a8a3d6$var$DesktopDatePicker = /*#__PURE__*/ $7fPBF.forwardRef(function DesktopDatePicker(inProps, ref) {
    // TODO: TDate needs to be instantiated at every usage.
    const props = (0, $9tuGI.useDatePickerDefaultizedProps)(inProps, 'MuiDesktopDatePicker');
    const validationError = (0, $2Jx0Z.useDateValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $1PhMQ.usePickerState)(props, $4685c1f3b9a8a3d6$var$valueManager);
    const { PopperProps: PopperProps, PaperProps: PaperProps, ToolbarComponent: ToolbarComponent = (0, $6kuGy.default), TransitionComponent: TransitionComponent, clearText: clearText, clearable: clearable } = props, other = (0, $cFLic.default)(props, $4685c1f3b9a8a3d6$var$_excluded);
    const AllDateInputProps = (0, $kY3Ke.default)({}, inputProps, other, {
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8STIk.default), (0, $kY3Ke.default)({}, wrapperProps, {
        DateInputProps: AllDateInputProps,
        KeyboardDateInputComponent: (0, $73rDW.KeyboardDateInput),
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        TransitionComponent: TransitionComponent,
        clearText: clearText,
        clearable: clearable,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a4Xf8.default), (0, $kY3Ke.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: AllDateInputProps
        }, other))
    }));
});
var $4685c1f3b9a8a3d6$export$2e2bcd8739ae039 = $4685c1f3b9a8a3d6$var$DesktopDatePicker;

});
parcelRegister("9tuGI", function(module, exports) {

$parcel$export(module.exports, "isYearOnlyView", function () { return $6e5ea075057c2881$export$eb577c89cfdd574a; });
$parcel$export(module.exports, "isYearAndMonthViews", function () { return $6e5ea075057c2881$export$2d2db6dbaaf33a55; });
$parcel$export(module.exports, "useDatePickerDefaultizedProps", function () { return $6e5ea075057c2881$export$a552c17ed3587731; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $5j2OD = parcelRequire("5j2OD");

var $ebhFP = parcelRequire("ebhFP");
const $6e5ea075057c2881$var$_excluded = [
    "openTo",
    "views",
    "minDate",
    "maxDate"
];
const $6e5ea075057c2881$export$eb577c89cfdd574a = (views)=>views.length === 1 && views[0] === 'year';
const $6e5ea075057c2881$export$2d2db6dbaaf33a55 = (views)=>views.length === 2 && views.indexOf('month') !== -1 && views.indexOf('year') !== -1;
const $6e5ea075057c2881$var$getFormatAndMaskByViews = (views, utils)=>{
    if ($6e5ea075057c2881$export$eb577c89cfdd574a(views)) return {
        mask: '____',
        inputFormat: utils.formats.year
    };
    if ($6e5ea075057c2881$export$2d2db6dbaaf33a55(views)) return {
        disableMaskedInput: true,
        inputFormat: utils.formats.monthAndYear
    };
    return {
        mask: '__/__/____',
        inputFormat: utils.formats.keyboardDate
    };
};
function $6e5ea075057c2881$export$a552c17ed3587731(_ref, name) {
    let { openTo: openTo = 'day', views: views = [
        'year',
        'day'
    ], minDate: minDateProp, maxDate: maxDateProp } = _ref, other = (0, $cFLic.default)(_ref, $6e5ea075057c2881$var$_excluded);
    const utils = (0, $ebhFP.useUtils)();
    const defaultDates = (0, $ebhFP.useDefaultDates)();
    const minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
    const maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate; // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    return (0, $5j2OD.default)({
        props: (0, $kY3Ke.default)({
            views: views,
            openTo: openTo,
            minDate: minDate,
            maxDate: maxDate
        }, $6e5ea075057c2881$var$getFormatAndMaskByViews(views, utils), other),
        name: name
    });
}

});
parcelRegister("ebhFP", function(module, exports) {

$parcel$export(module.exports, "useUtils", function () { return $a52fcd66eaf11433$export$1163b47e39508a46; });
$parcel$export(module.exports, "useDefaultDates", function () { return $a52fcd66eaf11433$export$7c38da3a2e90fa83; });
$parcel$export(module.exports, "useNow", function () { return $a52fcd66eaf11433$export$3a404aece3dff2fa; });

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");

var $4p6PS = parcelRequire("4p6PS");
function $a52fcd66eaf11433$var$useLocalizationContext() {
    const localization = $7fPBF.useContext((0, $4p6PS.MuiPickersAdapterContext));
    if (localization === null) throw new Error((0, $diYUK.default)(13));
    return localization;
}
function $a52fcd66eaf11433$export$1163b47e39508a46() {
    return $a52fcd66eaf11433$var$useLocalizationContext().utils;
}
function $a52fcd66eaf11433$export$7c38da3a2e90fa83() {
    return $a52fcd66eaf11433$var$useLocalizationContext().defaultDates;
}
function $a52fcd66eaf11433$export$3a404aece3dff2fa() {
    const utils = $a52fcd66eaf11433$export$1163b47e39508a46();
    const now = $7fPBF.useRef(utils.date());
    return now.current;
}

});


parcelRegister("6kuGy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49bc69d2097e27da$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $i4DJJ = parcelRequire("i4DJJ");

var $ebhFP = parcelRequire("ebhFP");

var $9tuGI = parcelRequire("9tuGI");

var $bbzbN = parcelRequire("bbzbN");
const $49bc69d2097e27da$var$_excluded = [
    "date",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "toggleMobileKeyboardView",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views"
];
const $49bc69d2097e27da$var$classes = (0, $k9tw4.default)('PrivateDatePickerToolbar', [
    'penIcon'
]);
const $49bc69d2097e27da$var$DatePickerToolbarRoot = (0, $kDBhE.default)((0, $i4DJJ.default))({
    [`& .${$49bc69d2097e27da$var$classes.penIcon}`]: {
        position: 'relative',
        top: 4
    }
});
const $49bc69d2097e27da$var$DatePickerToolbarTitle = (0, $kDBhE.default)((0, $3loMv.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
/**
 * @ignore - internal component.
 */ const $49bc69d2097e27da$var$DatePickerToolbar = /*#__PURE__*/ $7fPBF.forwardRef(function DatePickerToolbar(props, ref) {
    const { date: date, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: toolbarTitle = 'Select date', views: views } = props, other = (0, $cFLic.default)(props, $49bc69d2097e27da$var$_excluded);
    const utils = (0, $ebhFP.useUtils)();
    const dateText = $7fPBF.useMemo(()=>{
        if (!date) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(date, toolbarFormat);
        if ((0, $9tuGI.isYearOnlyView)(views)) return utils.format(date, 'year');
        if ((0, $9tuGI.isYearAndMonthViews)(views)) return utils.format(date, 'month');
         // Little localization hack (Google is doing the same for android native pickers):
        // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
        // For other locales using strings like "June 1", without weekday.
        return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(date, 'normalDateWithWeekday') : utils.format(date, 'normalDate');
    }, [
        date,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($49bc69d2097e27da$var$DatePickerToolbarRoot, (0, $kY3Ke.default)({
        ref: ref,
        toolbarTitle: toolbarTitle,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        isLandscape: isLandscape,
        penIconClassName: $49bc69d2097e27da$var$classes.penIcon,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($49bc69d2097e27da$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            children: dateText
        })
    }));
});
var $49bc69d2097e27da$export$2e2bcd8739ae039 = $49bc69d2097e27da$var$DatePickerToolbar;

});
parcelRegister("k9tw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eabb8b3f8d9461c4$export$2e2bcd8739ae039; });

var $4kwOy = parcelRequire("4kwOy");
function $eabb8b3f8d9461c4$export$2e2bcd8739ae039(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4kwOy.default)(componentName, slot);
    });
    return result;
}

});
parcelRegister("4kwOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32727bee94d4b454$export$2e2bcd8739ae039; });

var $72eMT = parcelRequire("72eMT");
const $32727bee94d4b454$var$globalStateClassesMapping = {
    active: 'Mui-active',
    checked: 'Mui-checked',
    completed: 'Mui-completed',
    disabled: 'Mui-disabled',
    error: 'Mui-error',
    expanded: 'Mui-expanded',
    focused: 'Mui-focused',
    focusVisible: 'Mui-focusVisible',
    required: 'Mui-required',
    selected: 'Mui-selected'
};
function $32727bee94d4b454$export$2e2bcd8739ae039(componentName, slot) {
    const globalStateClass = $32727bee94d4b454$var$globalStateClassesMapping[slot];
    return globalStateClass || `${(0, $72eMT.default).generate(componentName)}-${slot}`;
}

});
parcelRegister("72eMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51f430cd6cc38b2d$export$2e2bcd8739ae039; });
const $51f430cd6cc38b2d$var$defaultGenerator = (componentName)=>componentName;
const $51f430cd6cc38b2d$var$createClassNameGenerator = ()=>{
    let generate = $51f430cd6cc38b2d$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $51f430cd6cc38b2d$var$defaultGenerator;
        }
    };
};
const $51f430cd6cc38b2d$var$ClassNameGenerator = $51f430cd6cc38b2d$var$createClassNameGenerator();
var $51f430cd6cc38b2d$export$2e2bcd8739ae039 = $51f430cd6cc38b2d$var$ClassNameGenerator;

});



parcelRegister("i4DJJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2876c91014c2cf0$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $aXrmT = parcelRequire("aXrmT");

var $3loMv = parcelRequire("3loMv");

var $8TDId = parcelRequire("8TDId");

var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $apenM = parcelRequire("apenM");

var $lIvj9 = parcelRequire("lIvj9");

var $aiga2 = parcelRequire("aiga2");

var $bbzbN = parcelRequire("bbzbN");
var $d2876c91014c2cf0$var$_ClockIcon, $d2876c91014c2cf0$var$_CalendarIcon, $d2876c91014c2cf0$var$_PenIcon;
const $d2876c91014c2cf0$var$classes = (0, $k9tw4.default)('PrivatePickersToolbar', [
    'root',
    'dateTitleContainer'
]);
const $d2876c91014c2cf0$var$PickersToolbarRoot = (0, $kDBhE.default)('div')(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $d2876c91014c2cf0$var$PickersToolbarGrid = (0, $kDBhE.default)((0, $aXrmT.default))({
    flex: 1
});
const $d2876c91014c2cf0$var$getViewTypeIcon = (viewType)=>viewType === 'clock' ? $d2876c91014c2cf0$var$_ClockIcon || ($d2876c91014c2cf0$var$_ClockIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aiga2.default), {
        color: "inherit"
    })) : $d2876c91014c2cf0$var$_CalendarIcon || ($d2876c91014c2cf0$var$_CalendarIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lIvj9.default), {
        color: "inherit"
    }));
function $d2876c91014c2cf0$var$defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen, viewType) {
    return isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`;
}
const $d2876c91014c2cf0$var$PickersToolbar = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbar(props, ref) {
    const { children: children, className: className, getMobileKeyboardInputViewButtonText: getMobileKeyboardInputViewButtonText = $d2876c91014c2cf0$var$defaultGetKeyboardInputSwitchingButtonText, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, landscapeDirection: landscapeDirection = 'column', penIconClassName: penIconClassName, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarTitle: toolbarTitle, viewType: viewType = 'calendar' } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($d2876c91014c2cf0$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $jtRae.default)($d2876c91014c2cf0$var$classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                color: "text.secondary",
                variant: "overline",
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)($d2876c91014c2cf0$var$PickersToolbarGrid, {
                container: true,
                justifyContent: "space-between",
                className: $d2876c91014c2cf0$var$classes.dateTitleContainer,
                direction: isLandscape ? landscapeDirection : 'row',
                alignItems: isLandscape ? 'flex-start' : 'flex-end',
                children: [
                    children,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                        onClick: toggleMobileKeyboardView,
                        className: penIconClassName,
                        color: "inherit",
                        "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType),
                        children: isMobileKeyboardViewOpen ? $d2876c91014c2cf0$var$getViewTypeIcon(viewType) : $d2876c91014c2cf0$var$_PenIcon || ($d2876c91014c2cf0$var$_PenIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $apenM.default), {
                            color: "inherit"
                        }))
                    })
                ]
            })
        ]
    });
});
var $d2876c91014c2cf0$export$2e2bcd8739ae039 = $d2876c91014c2cf0$var$PickersToolbar;

});
parcelRegister("jtRae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $e2e9f7015a5aa268$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $e2e9f7015a5aa268$export$2e2bcd8739ae039; });
function $e2e9f7015a5aa268$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e2e9f7015a5aa268$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e2e9f7015a5aa268$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e2e9f7015a5aa268$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e2e9f7015a5aa268$export$2e2bcd8739ae039 = $e2e9f7015a5aa268$export$4f5d2d50c9deca37;

});

parcelRegister("aXrmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa4a4d669bc53fb$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cvrkU = parcelRequire("cvrkU");

var $mqrnX = parcelRequire("mqrnX");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $g9bTP = parcelRequire("g9bTP");

var $5d7YT = parcelRequire("5d7YT");

var $jY428 = parcelRequire("jY428");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7fa4a4d669bc53fb$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $7fa4a4d669bc53fb$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $7fa4a4d669bc53fb$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $cvrkU.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $kY3Ke.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $7fa4a4d669bc53fb$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $jY428.default).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $7fa4a4d669bc53fb$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingTop: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingLeft: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $7fa4a4d669bc53fb$var$GridRoot = (0, $kDBhE.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $7fa4a4d669bc53fb$export$71d4225eeb1bc13e, $7fa4a4d669bc53fb$export$380604d7c79f9e8f, $7fa4a4d669bc53fb$export$4315fba5128fb4a1, $7fa4a4d669bc53fb$export$ca2a698f6020fda);
function $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $7fa4a4d669bc53fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $jY428.getGridUtilityClass), classes);
};
const $7fa4a4d669bc53fb$var$Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $g9bTP.default)();
    const props = (0, $mqrnX.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $cFLic.default)(props, $7fa4a4d669bc53fb$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $7fPBF.useContext((0, $5d7YT.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $kY3Ke.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $7fa4a4d669bc53fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5d7YT.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($7fa4a4d669bc53fb$var$GridRoot, (0, $kY3Ke.default)({
            ownerState: ownerState,
            className: (0, $9MRga.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $7fa4a4d669bc53fb$export$2e2bcd8739ae039 = $7fa4a4d669bc53fb$var$Grid;

});
parcelRegister("5d7YT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cb45b8a02634c3b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $3cb45b8a02634c3b$var$GridContext = /*#__PURE__*/ $7fPBF.createContext();
var $3cb45b8a02634c3b$export$2e2bcd8739ae039 = $3cb45b8a02634c3b$var$GridContext;

});

parcelRegister("jY428", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $e896bfd9730b7f7a$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $e896bfd9730b7f7a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e896bfd9730b7f7a$export$9973ac5fd0181f33(slot) {
    return (0, $k6RDS.default)('MuiGrid', slot);
}
const $e896bfd9730b7f7a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e896bfd9730b7f7a$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $e896bfd9730b7f7a$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $e896bfd9730b7f7a$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $e896bfd9730b7f7a$var$gridClasses = (0, $4jzsB.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$e896bfd9730b7f7a$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$e896bfd9730b7f7a$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$e896bfd9730b7f7a$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $e896bfd9730b7f7a$export$2e2bcd8739ae039 = $e896bfd9730b7f7a$var$gridClasses;

});


parcelRegister("apenM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7937653cb17916b4$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $7937653cb17916b4$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');

});

parcelRegister("lIvj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04147bd7275ab9e5$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $04147bd7275ab9e5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');

});

parcelRegister("aiga2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e81f113cdc8c45$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $77e81f113cdc8c45$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');

});



parcelRegister("8STIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $677e9584de2073f2$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $6NwTb = parcelRequire("6NwTb");

var $jGysp = parcelRequire("jGysp");

var $i1VEB = parcelRequire("i1VEB");

var $bbzbN = parcelRequire("bbzbN");
function $677e9584de2073f2$var$DesktopWrapper(props) {
    const { children: children, DateInputProps: DateInputProps, KeyboardDateInputComponent: KeyboardDateInputComponent, onDismiss: onDismiss, open: open, PopperProps: PopperProps, PaperProps: PaperProps, TransitionComponent: TransitionComponent, onClear: onClear, clearText: clearText, clearable: clearable } = props;
    const ownInputRef = $7fPBF.useRef(null);
    const inputRef = (0, $6NwTb.default)(DateInputProps.inputRef, ownInputRef);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jGysp.WrapperVariantContext).Provider, {
        value: "desktop",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)(KeyboardDateInputComponent, (0, $kY3Ke.default)({}, DateInputProps, {
                inputRef: inputRef
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i1VEB.default), {
                role: "dialog",
                open: open,
                anchorEl: ownInputRef.current,
                TransitionComponent: TransitionComponent,
                PopperProps: PopperProps,
                PaperProps: PaperProps,
                onClose: onDismiss,
                onClear: onClear,
                clearText: clearText,
                clearable: clearable,
                children: children
            })
        ]
    });
}
var $677e9584de2073f2$export$2e2bcd8739ae039 = $677e9584de2073f2$var$DesktopWrapper;

});
parcelRegister("jGysp", function(module, exports) {

$parcel$export(module.exports, "WrapperVariantContext", function () { return $e54cab08d2ea69ec$export$b4ddd57e25df14cc; });

var $7fPBF = parcelRequire("7fPBF");
const $e54cab08d2ea69ec$export$b4ddd57e25df14cc = /*#__PURE__*/ $7fPBF.createContext(null);
const $e54cab08d2ea69ec$export$3e622b150e6b0bcc = /*#__PURE__*/ $7fPBF.createContext(false);

});

parcelRegister("i1VEB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2050adf65c7026c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $aSK9T = parcelRequire("aSK9T");

var $a2ay0 = parcelRequire("a2ay0");

var $41bfV = parcelRequire("41bfV");

var $cbZpX = parcelRequire("cbZpX");

var $cNbkS = parcelRequire("cNbkS");
var $1XFnq = parcelRequire("1XFnq");
var $6NwTb = parcelRequire("6NwTb");

var $kDBhE = parcelRequire("kDBhE");

var $5ZeKC = parcelRequire("5ZeKC");

var $8smOS = parcelRequire("8smOS");

var $bbzbN = parcelRequire("bbzbN");
const $d2050adf65c7026c$var$_excluded = [
    "onClick",
    "onTouchStart"
];
const $d2050adf65c7026c$var$PickersPopperRoot = (0, $kDBhE.default)((0, $41bfV.default))(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $d2050adf65c7026c$var$PickersPopperPaper = (0, $kDBhE.default)((0, $a2ay0.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        transformOrigin: 'top center',
        outline: 0
    }, ownerState.placement === 'top' && {
        transformOrigin: 'bottom center'
    }));
const $d2050adf65c7026c$var$PickersPopperAction = (0, $kDBhE.default)((0, $8smOS.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.clearable ? {
        justifyContent: 'flex-start',
        '& > *:first-of-type': {
            marginRight: 'auto'
        }
    } : {
        padding: 0
    }));
function $d2050adf65c7026c$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param onClickAway
 * @param onClick
 * @param onTouchStart
 */ function $d2050adf65c7026c$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (!active) return undefined;
         // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $1XFnq.default)((event)=>{
        if (!activatedRef.current) return;
         // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $cNbkS.default)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $d2050adf65c7026c$var$clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $7fPBF.useEffect(()=>{
        if (active) {
            const doc = (0, $cNbkS.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $7fPBF.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $cNbkS.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway); // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $d2050adf65c7026c$var$PickersPopper = (props)=>{
    var _Button;
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, onClose: onClose, onClear: onClear, clearable: clearable = false, clearText: clearText = 'Clear', open: open, PopperProps: PopperProps, role: role, TransitionComponent: TransitionComponent = (0, $aSK9T.default), TrapFocusProps: TrapFocusProps, PaperProps: PaperProps = {} } = props;
    $7fPBF.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') onClose();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onClose
    ]);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (role === 'tooltip') return;
        if (open) lastFocusedElementRef.current = document.activeElement;
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
    }, [
        open,
        role
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $d2050adf65c7026c$var$useClickAwayListener(open, onClose);
    const paperRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(paperRef, containerRef);
    const handlePaperRef = (0, $6NwTb.default)(handleRef, clickAwayRef);
    const ownerState = props;
    const { onClick: onPaperClickProp, onTouchStart: onPaperTouchStartProp } = PaperProps, otherPaperProps = (0, $cFLic.default)(PaperProps, $d2050adf65c7026c$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d2050adf65c7026c$var$PickersPopperRoot, (0, $kY3Ke.default)({
        transition: true,
        role: role,
        open: open,
        anchorEl: anchorEl,
        ownerState: ownerState
    }, PopperProps, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $cbZpX.default), (0, $kY3Ke.default)({
                open: open,
                disableAutoFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, TrapFocusProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({}, TransitionProps, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)($d2050adf65c7026c$var$PickersPopperPaper, (0, $kY3Ke.default)({
                        tabIndex: -1,
                        elevation: 8,
                        ref: handlePaperRef,
                        onClick: (event)=>{
                            onPaperClick(event);
                            if (onPaperClickProp) onPaperClickProp(event);
                        },
                        onTouchStart: (event)=>{
                            onPaperTouchStart(event);
                            if (onPaperTouchStartProp) onPaperTouchStartProp(event);
                        },
                        ownerState: (0, $kY3Ke.default)({}, ownerState, {
                            placement: placement
                        })
                    }, otherPaperProps, {
                        children: [
                            children,
                            /*#__PURE__*/ (0, $bbzbN.jsx)($d2050adf65c7026c$var$PickersPopperAction, {
                                ownerState: ownerState,
                                children: clearable && (_Button || (_Button = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                    onClick: onClear,
                                    children: clearText
                                })))
                            })
                        ]
                    }))
                }))
            }))
    }));
};
var $d2050adf65c7026c$export$2e2bcd8739ae039 = $d2050adf65c7026c$var$PickersPopper;

});


parcelRegister("a4Xf8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75683b88423001e7$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");

var $bg7ke = parcelRequire("bg7ke");

var $7Lu08 = parcelRequire("7Lu08");

var $03xzD = parcelRequire("03xzD");

var $73rDW = parcelRequire("73rDW");

var $baEix = parcelRequire("baEix");

var $jGysp = parcelRequire("jGysp");

var $d2gno = parcelRequire("d2gno");

var $bbzbN = parcelRequire("bbzbN");
const $75683b88423001e7$var$_excluded = [
    "autoFocus",
    "className",
    "date",
    "DateInputProps",
    "isMobileKeyboardViewOpen",
    "onDateChange",
    "onViewChange",
    "openTo",
    "orientation",
    "showToolbar",
    "toggleMobileKeyboardView",
    "ToolbarComponent",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views"
];
const $75683b88423001e7$export$739a903982fd73c9 = (0, $kDBhE.default)('div')({
    padding: '16px 24px'
});
const $75683b88423001e7$var$PickerRoot = (0, $kDBhE.default)('div')(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        flexDirection: 'column'
    }, ownerState.isLandscape && {
        flexDirection: 'row'
    }));
const $75683b88423001e7$var$MobileKeyboardTextFieldProps = {
    fullWidth: true
};
const $75683b88423001e7$var$isDatePickerView = (view)=>view === 'year' || view === 'month' || view === 'day';
const $75683b88423001e7$var$isTimePickerView = (view)=>view === 'hours' || view === 'minutes' || view === 'seconds';
function $75683b88423001e7$var$Picker(props) {
    const { autoFocus: autoFocus, date: date, DateInputProps: DateInputProps, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, onDateChange: onDateChange, onViewChange: onViewChange, openTo: openTo, orientation: orientation, showToolbar: showToolbar, toggleMobileKeyboardView: toggleMobileKeyboardView, ToolbarComponent: ToolbarComponent = ()=>null, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder, toolbarTitle: toolbarTitle, views: views } = props, other = (0, $cFLic.default)(props, $75683b88423001e7$var$_excluded);
    const isLandscape = (0, $baEix.useIsLandscape)(views, orientation);
    const wrapperVariant = $7fPBF.useContext((0, $jGysp.WrapperVariantContext));
    const toShowToolbar = typeof showToolbar === 'undefined' ? wrapperVariant !== 'desktop' : showToolbar;
    const handleDateChange = $7fPBF.useCallback((newDate, selectionState)=>{
        onDateChange(newDate, wrapperVariant, selectionState);
    }, [
        onDateChange,
        wrapperVariant
    ]);
    const handleViewChange = $7fPBF.useCallback((newView)=>{
        if (isMobileKeyboardViewOpen) toggleMobileKeyboardView();
        if (onViewChange) onViewChange(newView);
    }, [
        isMobileKeyboardViewOpen,
        onViewChange,
        toggleMobileKeyboardView
    ]);
    const { openView: openView, nextView: nextView, previousView: previousView, setOpenView: setOpenView, handleChangeAndOpenNext: handleChangeAndOpenNext } = (0, $bg7ke.useViews)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: handleDateChange,
        onViewChange: handleViewChange
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($75683b88423001e7$var$PickerRoot, {
        ownerState: {
            isLandscape: isLandscape
        },
        children: [
            toShowToolbar && /*#__PURE__*/ (0, $bbzbN.jsx)(ToolbarComponent, (0, $kY3Ke.default)({}, other, {
                views: views,
                isLandscape: isLandscape,
                date: date,
                onChange: handleDateChange,
                setOpenView: setOpenView,
                openView: openView,
                toolbarTitle: toolbarTitle,
                toolbarFormat: toolbarFormat,
                toolbarPlaceholder: toolbarPlaceholder,
                isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
                toggleMobileKeyboardView: toggleMobileKeyboardView
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d2gno.default), {
                children: isMobileKeyboardViewOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)($75683b88423001e7$export$739a903982fd73c9, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $73rDW.KeyboardDateInput), (0, $kY3Ke.default)({}, DateInputProps, {
                        ignoreInvalidInputs: true,
                        disableOpenPicker: true,
                        TextFieldProps: $75683b88423001e7$var$MobileKeyboardTextFieldProps
                    }))
                }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        $75683b88423001e7$var$isDatePickerView(openView) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $03xzD.default), (0, $kY3Ke.default)({
                            autoFocus: autoFocus,
                            date: date,
                            onViewChange: setOpenView,
                            onChange: handleChangeAndOpenNext,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter($75683b88423001e7$var$isDatePickerView)
                        }, other)),
                        $75683b88423001e7$var$isTimePickerView(openView) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Lu08.default), (0, $kY3Ke.default)({}, other, {
                            autoFocus: autoFocus,
                            date: date,
                            view: openView,
                            onChange: handleChangeAndOpenNext,
                            openNextView: ()=>setOpenView(nextView),
                            openPreviousView: ()=>setOpenView(previousView),
                            nextViewAvailable: !nextView,
                            previousViewAvailable: !previousView || $75683b88423001e7$var$isDatePickerView(previousView),
                            showViewSwitcher: wrapperVariant === 'desktop'
                        }))
                    ]
                })
            })
        ]
    });
}
var $75683b88423001e7$export$2e2bcd8739ae039 = $75683b88423001e7$var$Picker;

});
parcelRegister("bg7ke", function(module, exports) {

$parcel$export(module.exports, "useViews", function () { return $8326defc8ed84994$export$9b46cba8f8ccd954; });

var $7fPBF = parcelRequire("7fPBF");

var $568MF = parcelRequire("568MF");

var $c3NLh = parcelRequire("c3NLh");
function $8326defc8ed84994$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: view, views: views }) {
    var _views, _views2;
    const [openView, setOpenView] = (0, $568MF.default)({
        name: 'Picker',
        state: 'view',
        controlled: view,
        default: openTo && (0, $c3NLh.arrayIncludes)(views, openTo) ? openTo : views[0]
    });
    const previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
    const nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
    const changeView = $7fPBF.useCallback((newView)=>{
        setOpenView(newView);
        if (onViewChange) onViewChange(newView);
    }, [
        setOpenView,
        onViewChange
    ]);
    const openNext = $7fPBF.useCallback(()=>{
        if (nextView) changeView(nextView);
    }, [
        nextView,
        changeView
    ]);
    const handleChangeAndOpenNext = $7fPBF.useCallback((date, currentViewSelectionState)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
        onChange(date, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) openNext();
    }, [
        nextView,
        onChange,
        openNext
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        nextView: nextView,
        previousView: previousView,
        openNext: openNext,
        openView: openView,
        setOpenView: changeView
    };
}

});
parcelRegister("c3NLh", function(module, exports) {

$parcel$export(module.exports, "arrayIncludes", function () { return $8c7c5d70932fe03f$export$22012a5c726bef55; });
$parcel$export(module.exports, "onSpaceOrEnter", function () { return $8c7c5d70932fe03f$export$4467fe8634707c85; });
$parcel$export(module.exports, "pipe", function () { return $8c7c5d70932fe03f$export$a4627e546088548d; });
$parcel$export(module.exports, "createDelegatedEventHandler", function () { return $8c7c5d70932fe03f$export$50344ea800f236f2; });
/* Use it instead of .includes method for IE support */ function $8c7c5d70932fe03f$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $8c7c5d70932fe03f$export$4467fe8634707c85 = (innerFn, onFocus)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(); // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (onFocus) onFocus(event);
    };
const $8c7c5d70932fe03f$export$a4627e546088548d = (...fns)=>fns.reduceRight((prevFn, nextFn)=>(...args)=>nextFn(prevFn(...args)), (value)=>value);
const $8c7c5d70932fe03f$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
function $8c7c5d70932fe03f$export$50344ea800f236f2(fn, onEvent) {
    return (event)=>{
        fn(event);
        if (onEvent) onEvent(event);
    };
}
const $8c7c5d70932fe03f$export$b3007168329c29c7 = ()=>{};

});


parcelRegister("7Lu08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7431d1e56503fe$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $65Itt = parcelRequire("65Itt");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
var $9om19 = parcelRequire("9om19");

var $a3Aa0 = parcelRequire("a3Aa0");

var $c3NLh = parcelRequire("c3NLh");

var $ebhFP = parcelRequire("ebhFP");

var $eaRbM = parcelRequire("eaRbM");

var $5EAgU = parcelRequire("5EAgU");

var $wrXWf = parcelRequire("wrXWf");

var $9XnpK = parcelRequire("9XnpK");

var $bbzbN = parcelRequire("bbzbN");
function $5a7431d1e56503fe$export$f8da5e3552abcf0a(slot) {
    return (0, $4kwOy.default)('MuiClockPicker', slot);
}
const $5a7431d1e56503fe$export$355e4a5f94c2b5f = (0, $k9tw4.default)('MuiClockPicker', [
    'arrowSwitcher'
]);
const $5a7431d1e56503fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $9om19.default)(slots, $5a7431d1e56503fe$export$f8da5e3552abcf0a, classes);
};
const $5a7431d1e56503fe$var$ClockPickerArrowSwitcher = (0, $kDBhE.default)((0, $5EAgU.default), {
    name: 'MuiClockPicker',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $5a7431d1e56503fe$var$defaultGetClockLabelText = (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`;
const $5a7431d1e56503fe$var$defaultGetMinutesClockNumberText = (minutes)=>`${minutes} minutes`;
const $5a7431d1e56503fe$var$defaultGetHoursClockNumberText = (hours)=>`${hours} hours`;
const $5a7431d1e56503fe$var$defaultGetSecondsClockNumberText = (seconds)=>`${seconds} seconds`;
/**
 *
 * API:
 *
 * - [ClockPicker API](https://mui.com/api/clock-picker/)
 */ function $5a7431d1e56503fe$var$ClockPicker(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiClockPicker'
    });
    const { ampm: ampm = false, ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, date: date, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, getClockLabelText: getClockLabelText = $5a7431d1e56503fe$var$defaultGetClockLabelText, getHoursClockNumberText: getHoursClockNumberText = $5a7431d1e56503fe$var$defaultGetHoursClockNumberText, getMinutesClockNumberText: getMinutesClockNumberText = $5a7431d1e56503fe$var$defaultGetMinutesClockNumberText, getSecondsClockNumberText: getSecondsClockNumberText = $5a7431d1e56503fe$var$defaultGetSecondsClockNumberText, leftArrowButtonText: leftArrowButtonText = 'open previous view', maxTime: maxTime, minTime: minTime, minutesStep: minutesStep = 1, nextViewAvailable: nextViewAvailable, onChange: onChange, openNextView: openNextView, openPreviousView: openPreviousView, previousViewAvailable: previousViewAvailable, rightArrowButtonText: rightArrowButtonText = 'open next view', shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, view: view } = props;
    const now = (0, $ebhFP.useNow)();
    const utils = (0, $ebhFP.useUtils)();
    const midnight = utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0);
    const dateOrMidnight = date || midnight;
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $9XnpK.useMeridiemMode)(dateOrMidnight, ampm, onChange);
    const isTimeDisabled = $7fPBF.useCallback((rawValue, viewType)=>{
        if (date === null) return false;
        const validateTimeValue = (getRequestedTimePoint)=>{
            const isAfterComparingFn = (0, $wrXWf.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
            return Boolean(minTime && isAfterComparingFn(minTime, getRequestedTimePoint('end')) || maxTime && isAfterComparingFn(getRequestedTimePoint('start'), maxTime) || shouldDisableTime && shouldDisableTime(rawValue, viewType));
        };
        switch(viewType){
            case 'hours':
                {
                    const hoursWithMeridiem = (0, $wrXWf.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    return validateTimeValue((when)=>(0, $c3NLh.pipe)((currentDate)=>utils.setHours(currentDate, hoursWithMeridiem), (dateWithHours)=>utils.setMinutes(dateWithHours, when === 'start' ? 0 : 59), (dateWithMinutes)=>utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59))(date));
                }
            case 'minutes':
                return validateTimeValue((when)=>(0, $c3NLh.pipe)((currentDate)=>utils.setMinutes(currentDate, rawValue), (dateWithMinutes)=>utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59))(date));
            case 'seconds':
                return validateTimeValue(()=>utils.setSeconds(date, rawValue));
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        date,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        shouldDisableTime,
        utils
    ]);
    const selectedId = (0, $65Itt.default)();
    const viewProps = $7fPBF.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (value, isFinish)=>{
                        const valueWithMeridiem = (0, $wrXWf.convertValueToMeridiem)(value, meridiemMode, ampm);
                        onChange(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        value: utils.getHours(dateOrMidnight),
                        children: (0, $eaRbM.getHourNumbers)({
                            date: date,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: getHoursClockNumberText,
                            isDisabled: (value)=>isTimeDisabled(value, 'hours'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(dateOrMidnight);
                    const handleMinutesChange = (value, isFinish)=>{
                        onChange(utils.setMinutes(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $eaRbM.getMinutesNumbers)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: getMinutesClockNumberText,
                            isDisabled: (value)=>isTimeDisabled(value, 'minutes'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(dateOrMidnight);
                    const handleSecondsChange = (value, isFinish)=>{
                        onChange(utils.setSeconds(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $eaRbM.getMinutesNumbers)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: getSecondsClockNumberText,
                            isDisabled: (value)=>isTimeDisabled(value, 'seconds'),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        date,
        ampm,
        getHoursClockNumberText,
        getMinutesClockNumberText,
        getSecondsClockNumberText,
        meridiemMode,
        onChange,
        dateOrMidnight,
        isTimeDisabled,
        selectedId
    ]);
    const ownerState = props;
    const classes = $5a7431d1e56503fe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            showViewSwitcher && /*#__PURE__*/ (0, $bbzbN.jsx)($5a7431d1e56503fe$var$ClockPickerArrowSwitcher, {
                className: classes.arrowSwitcher,
                leftArrowButtonText: leftArrowButtonText,
                rightArrowButtonText: rightArrowButtonText,
                components: components,
                componentsProps: componentsProps,
                onLeftClick: openPreviousView,
                onRightClick: openNextView,
                isLeftDisabled: previousViewAvailable,
                isRightDisabled: nextViewAvailable,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3Aa0.default), (0, $kY3Ke.default)({
                autoFocus: autoFocus,
                date: date,
                ampmInClock: ampmInClock,
                type: view,
                ampm: ampm,
                getClockLabelText: getClockLabelText,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId
            }, viewProps))
        ]
    });
}
var /**
 *
 * Demos:
 *
 * - [Time Picker](https://mui.com/components/time-picker/)
 *
 * API:
 *
 * - [ClockPicker API](https://mui.com/api/clock-picker/)
 */ $5a7431d1e56503fe$export$2e2bcd8739ae039 = $5a7431d1e56503fe$var$ClockPicker;

});
parcelRegister("9om19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d676f31acc8c18f$export$2e2bcd8739ae039; });
function $6d676f31acc8c18f$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                if (classes && classes[key]) acc.push(classes[key]);
                acc.push(getUtilityClass(key));
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("a3Aa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75263be67dac7386$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $8TDId = parcelRequire("8TDId");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");

var $lJRRs = parcelRequire("lJRRs");

var $kUoYD = parcelRequire("kUoYD");

var $ebhFP = parcelRequire("ebhFP");

var $jGysp = parcelRequire("jGysp");

var $6VVPx = parcelRequire("6VVPx");

var $bbzbN = parcelRequire("bbzbN");
var $75263be67dac7386$var$_ClockPin, $75263be67dac7386$var$_Typography, $75263be67dac7386$var$_Typography2;
const $75263be67dac7386$var$ClockRoot = (0, $kDBhE.default)('div')(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $75263be67dac7386$var$ClockClock = (0, $kDBhE.default)('div')({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $75263be67dac7386$var$ClockSquareMask = (0, $kDBhE.default)('div')({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    '@media (pointer: fine)': {
        cursor: 'pointer',
        borderRadius: '50%'
    },
    '&:active': {
        cursor: 'move'
    }
});
const $75263be67dac7386$var$ClockPin = (0, $kDBhE.default)('div')(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $75263be67dac7386$var$ClockAmButton = (0, $kDBhE.default)((0, $8TDId.default))(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: ownerState.ampmInClock ? 64 : 8,
        left: 8
    }, ownerState.meridiemMode === 'am' && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        }
    }));
const $75263be67dac7386$var$ClockPmButton = (0, $kDBhE.default)((0, $8TDId.default))(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: ownerState.ampmInClock ? 64 : 8,
        right: 8
    }, ownerState.meridiemMode === 'pm' && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        }
    }));
/**
 * @ignore - internal component.
 */ function $75263be67dac7386$var$Clock(props) {
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, date: date, getClockLabelText: getClockLabelText, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, value: value } = props;
    const ownerState = props;
    const utils = (0, $ebhFP.useUtils)();
    const wrapperVariant = $7fPBF.useContext((0, $jGysp.WrapperVariantContext));
    const isMoving = $7fPBF.useRef(false);
    const isSelectedTimeDisabled = isTimeDisabled(value, type);
    const isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $6VVPx.getMinutes)(offsetX, offsetY, minutesStep) : (0, $6VVPx.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = $7fPBF.useMemo(()=>{
        if (type === 'hours') return true;
        return value % 5 === 0;
    }, [
        type,
        value
    ]);
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $7fPBF.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $lJRRs.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // annulate both hours and minutes
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(value + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(value - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($75263be67dac7386$var$ClockRoot, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($75263be67dac7386$var$ClockClock, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($75263be67dac7386$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                        children: [
                            $75263be67dac7386$var$_ClockPin || ($75263be67dac7386$var$_ClockPin = /*#__PURE__*/ (0, $bbzbN.jsx)($75263be67dac7386$var$ClockPin, {})),
                            date && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kUoYD.default), {
                                type: type,
                                value: value,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        "aria-activedescendant": selectedId,
                        "aria-label": getClockLabelText(type, date, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        children: children
                    })
                ]
            }),
            ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($75263be67dac7386$var$ClockAmButton, {
                        onClick: ()=>handleMeridiemChange('am'),
                        disabled: meridiemMode === null,
                        ownerState: ownerState,
                        children: $75263be67dac7386$var$_Typography || ($75263be67dac7386$var$_Typography = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: "AM"
                        }))
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($75263be67dac7386$var$ClockPmButton, {
                        disabled: meridiemMode === null,
                        onClick: ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        children: $75263be67dac7386$var$_Typography2 || ($75263be67dac7386$var$_Typography2 = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: "PM"
                        }))
                    })
                ]
            })
        ]
    });
}
var $75263be67dac7386$export$2e2bcd8739ae039 = $75263be67dac7386$var$Clock;

});
parcelRegister("kUoYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f38c698960f8ced9$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");

var $6VVPx = parcelRequire("6VVPx");

var $bbzbN = parcelRequire("bbzbN");
const $f38c698960f8ced9$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "value"
];
const $f38c698960f8ced9$var$ClockPointerRoot = (0, $kDBhE.default)('div')(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 2,
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px'
    }, ownerState.toAnimateTransform && {
        transition: theme.transitions.create([
            'transform',
            'height'
        ])
    }));
const $f38c698960f8ced9$var$ClockPointerThumb = (0, $kDBhE.default)('div')(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 4,
        height: 4,
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $6VVPx.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, $6VVPx.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${theme.palette.primary.main}`,
        boxSizing: 'content-box'
    }, ownerState.hasSelected && {
        backgroundColor: theme.palette.primary.main
    }));
/**
 * @ignore - internal component.
 */ class $f38c698960f8ced9$var$ClockPointer extends $7fPBF.Component {
    render() {
        const _this$props = this.props, { className: className, isInner: isInner, type: type, value: value } = _this$props, other = (0, $cFLic.default)(_this$props, $f38c698960f8ced9$var$_excluded);
        const ownerState = (0, $kY3Ke.default)({}, this.props, this.state);
        const getAngleStyle = ()=>{
            const max = type === 'hours' ? 12 : 60;
            let angle = 360 / max * value;
            if (type === 'hours' && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: Math.round((isInner ? 0.26 : 0.4) * (0, $6VVPx.CLOCK_WIDTH)),
                transform: `rotateZ(${angle}deg)`
            };
        };
        return /*#__PURE__*/ (0, $bbzbN.jsx)($f38c698960f8ced9$var$ClockPointerRoot, (0, $kY3Ke.default)({
            style: getAngleStyle(),
            className: className,
            ownerState: ownerState
        }, other, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($f38c698960f8ced9$var$ClockPointerThumb, {
                ownerState: ownerState
            })
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
    }
}
$f38c698960f8ced9$var$ClockPointer.getDerivedStateFromProps = (nextProps, state)=>{
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $f38c698960f8ced9$export$2e2bcd8739ae039 = $f38c698960f8ced9$var$ClockPointer;

});
parcelRegister("6VVPx", function(module, exports) {

$parcel$export(module.exports, "CLOCK_WIDTH", function () { return $50c4ecd280f69212$export$8c8ec20d3854d7e6; });
$parcel$export(module.exports, "CLOCK_HOUR_WIDTH", function () { return $50c4ecd280f69212$export$729c0e543e4dc21d; });
$parcel$export(module.exports, "getMinutes", function () { return $50c4ecd280f69212$export$b7f1bc3ea3ac4145; });
$parcel$export(module.exports, "getHours", function () { return $50c4ecd280f69212$export$257b40f71c07d58f; });
const $50c4ecd280f69212$export$8c8ec20d3854d7e6 = 220;
const $50c4ecd280f69212$export$729c0e543e4dc21d = 36;
const $50c4ecd280f69212$var$clockCenter = {
    x: $50c4ecd280f69212$export$8c8ec20d3854d7e6 / 2,
    y: $50c4ecd280f69212$export$8c8ec20d3854d7e6 / 2
};
const $50c4ecd280f69212$var$baseClockPoint = {
    x: $50c4ecd280f69212$var$clockCenter.x,
    y: 0
};
const $50c4ecd280f69212$var$cx = $50c4ecd280f69212$var$baseClockPoint.x - $50c4ecd280f69212$var$clockCenter.x;
const $50c4ecd280f69212$var$cy = $50c4ecd280f69212$var$baseClockPoint.y - $50c4ecd280f69212$var$clockCenter.y;
const $50c4ecd280f69212$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $50c4ecd280f69212$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $50c4ecd280f69212$var$clockCenter.x;
    const y = offsetY - $50c4ecd280f69212$var$clockCenter.y;
    const atan = Math.atan2($50c4ecd280f69212$var$cx, $50c4ecd280f69212$var$cy) - Math.atan2(x, y);
    let deg = $50c4ecd280f69212$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $50c4ecd280f69212$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $50c4ecd280f69212$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $50c4ecd280f69212$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $50c4ecd280f69212$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $50c4ecd280f69212$export$8c8ec20d3854d7e6 / 2 - $50c4ecd280f69212$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

});



parcelRegister("eaRbM", function(module, exports) {

$parcel$export(module.exports, "getHourNumbers", function () { return $a51b421bae82458b$export$10850582eda9a8c7; });
$parcel$export(module.exports, "getMinutesNumbers", function () { return $a51b421bae82458b$export$2c440057d7a731e4; });
parcelRequire("7fPBF");

var $gPeLY = parcelRequire("gPeLY");

var $bbzbN = parcelRequire("bbzbN");
const $a51b421bae82458b$export$10850582eda9a8c7 = ({ ampm: ampm, date: date, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = date ? utils.getHours(date) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gPeLY.default), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $a51b421bae82458b$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gPeLY.default), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

});
parcelRegister("gPeLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3fcde4ddb7210c2$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $6VVPx = parcelRequire("6VVPx");

var $bbzbN = parcelRequire("bbzbN");
const $c3fcde4ddb7210c2$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $c3fcde4ddb7210c2$export$188d75d71883854a = (0, $k9tw4.default)('PrivateClockNumber', [
    'selected',
    'disabled'
]);
const $c3fcde4ddb7210c2$var$ClockNumberRoot = (0, $kDBhE.default)('span')(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: (0, $6VVPx.CLOCK_HOUR_WIDTH),
        width: (0, $6VVPx.CLOCK_HOUR_WIDTH),
        position: 'absolute',
        left: `calc((100% - ${(0, $6VVPx.CLOCK_HOUR_WIDTH)}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: theme.palette.background.paper
        },
        [`&.${$c3fcde4ddb7210c2$export$188d75d71883854a.selected}`]: {
            color: theme.palette.primary.contrastText
        },
        [`&.${$c3fcde4ddb7210c2$export$188d75d71883854a.disabled}`]: {
            pointerEvents: 'none',
            color: theme.palette.text.disabled
        }
    }, ownerState.inner && (0, $kY3Ke.default)({}, theme.typography.body2, {
        color: theme.palette.text.secondary
    })));
/**
 * @ignore - internal component.
 */ function $c3fcde4ddb7210c2$var$ClockNumber(props) {
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $cFLic.default)(props, $c3fcde4ddb7210c2$var$_excluded);
    const ownerState = props;
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $6VVPx.CLOCK_WIDTH) - (0, $6VVPx.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c3fcde4ddb7210c2$var$ClockNumberRoot, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(className, selected && $c3fcde4ddb7210c2$export$188d75d71883854a.selected, disabled && $c3fcde4ddb7210c2$export$188d75d71883854a.disabled),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $6VVPx.CLOCK_WIDTH) - (0, $6VVPx.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}
var $c3fcde4ddb7210c2$export$2e2bcd8739ae039 = $c3fcde4ddb7210c2$var$ClockNumber;

});


parcelRegister("5EAgU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41dcd2fdac1f7d7f$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");

var $8TDId = parcelRequire("8TDId");

var $eUw8w = parcelRequire("eUw8w");

var $jFKwx = parcelRequire("jFKwx");

var $bbzbN = parcelRequire("bbzbN");
const $41dcd2fdac1f7d7f$var$_excluded = [
    "children",
    "className",
    "components",
    "componentsProps",
    "isLeftDisabled",
    "isLeftHidden",
    "isRightDisabled",
    "isRightHidden",
    "leftArrowButtonText",
    "onLeftClick",
    "onRightClick",
    "rightArrowButtonText"
];
const $41dcd2fdac1f7d7f$var$PickersArrowSwitcherRoot = (0, $kDBhE.default)('div')({
    display: 'flex'
});
const $41dcd2fdac1f7d7f$var$PickersArrowSwitcherSpacer = (0, $kDBhE.default)('div')(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $41dcd2fdac1f7d7f$var$PickersArrowSwitcherButton = (0, $kDBhE.default)((0, $8TDId.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $41dcd2fdac1f7d7f$var$PickersArrowSwitcher = /*#__PURE__*/ $7fPBF.forwardRef(function PickersArrowSwitcher(props, ref) {
    const { children: children, className: className, components: components = {}, componentsProps: componentsProps = {}, isLeftDisabled: isLeftDisabled, isLeftHidden: isLeftHidden, isRightDisabled: isRightDisabled, isRightHidden: isRightHidden, leftArrowButtonText: leftArrowButtonText, onLeftClick: onLeftClick, onRightClick: onRightClick, rightArrowButtonText: rightArrowButtonText } = props, other = (0, $cFLic.default)(props, $41dcd2fdac1f7d7f$var$_excluded);
    const theme = (0, $g9bTP.default)();
    const isRtl = theme.direction === 'rtl';
    const leftArrowButtonProps = componentsProps.leftArrowButton || {};
    const LeftArrowIcon = components.LeftArrowIcon || (0, $eUw8w.default);
    const rightArrowButtonProps = componentsProps.rightArrowButton || {};
    const RightArrowIcon = components.RightArrowIcon || (0, $jFKwx.default);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($41dcd2fdac1f7d7f$var$PickersArrowSwitcherRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: className,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($41dcd2fdac1f7d7f$var$PickersArrowSwitcherButton, (0, $kY3Ke.default)({
                as: components.LeftArrowButton,
                size: "small",
                "aria-label": leftArrowButtonText,
                title: leftArrowButtonText,
                disabled: isLeftDisabled,
                edge: "end",
                onClick: onLeftClick
            }, leftArrowButtonProps, {
                className: leftArrowButtonProps.className,
                ownerState: (0, $kY3Ke.default)({}, ownerState, leftArrowButtonProps, {
                    hidden: isLeftHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $bbzbN.jsx)(RightArrowIcon, {}) : /*#__PURE__*/ (0, $bbzbN.jsx)(LeftArrowIcon, {})
            })),
            children ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)($41dcd2fdac1f7d7f$var$PickersArrowSwitcherSpacer, {
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($41dcd2fdac1f7d7f$var$PickersArrowSwitcherButton, (0, $kY3Ke.default)({
                as: components.RightArrowButton,
                size: "small",
                "aria-label": rightArrowButtonText,
                title: rightArrowButtonText,
                edge: "start",
                disabled: isRightDisabled,
                onClick: onRightClick
            }, rightArrowButtonProps, {
                className: rightArrowButtonProps.className,
                ownerState: (0, $kY3Ke.default)({}, ownerState, rightArrowButtonProps, {
                    hidden: isRightHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $bbzbN.jsx)(LeftArrowIcon, {}) : /*#__PURE__*/ (0, $bbzbN.jsx)(RightArrowIcon, {})
            }))
        ]
    }));
});
var $41dcd2fdac1f7d7f$export$2e2bcd8739ae039 = $41dcd2fdac1f7d7f$var$PickersArrowSwitcher;

});
parcelRegister("eUw8w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adaf394ddf092e9e$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $adaf394ddf092e9e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');

});

parcelRegister("jFKwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e525ef4fe481bbaf$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $e525ef4fe481bbaf$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');

});


parcelRegister("wrXWf", function(module, exports) {

$parcel$export(module.exports, "getMeridiem", function () { return $0618aeb07a0cb895$export$c3352ead7b032236; });
$parcel$export(module.exports, "convertValueToMeridiem", function () { return $0618aeb07a0cb895$export$4159dc823695870e; });
$parcel$export(module.exports, "convertToMeridiem", function () { return $0618aeb07a0cb895$export$c368d4ff66779998; });
$parcel$export(module.exports, "createIsAfterIgnoreDatePart", function () { return $0618aeb07a0cb895$export$fb87c80b35a46b89; });
$parcel$export(module.exports, "validateTime", function () { return $0618aeb07a0cb895$export$7bd013ac69eb590c; });
const $0618aeb07a0cb895$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $0618aeb07a0cb895$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $0618aeb07a0cb895$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $0618aeb07a0cb895$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
function $0618aeb07a0cb895$export$888a1ce13aa61986(date, utils) {
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
}
const $0618aeb07a0cb895$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $0618aeb07a0cb895$export$888a1ce13aa61986(dateLeft, utils) > $0618aeb07a0cb895$export$888a1ce13aa61986(dateRight, utils);
    };
const $0618aeb07a0cb895$export$7bd013ac69eb590c = (utils, value, { minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation })=>{
    const date = utils.date(value);
    const isAfterComparingFn = $0618aeb07a0cb895$export$fb87c80b35a46b89(Boolean(disableIgnoringDatePartForTimeValidation), utils);
    if (value === null) return null;
    switch(true){
        case !utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfterComparingFn(minTime, date)):
            return 'minTime';
        case Boolean(maxTime && isAfterComparingFn(date, maxTime)):
            return 'maxTime';
        case Boolean(shouldDisableTime && shouldDisableTime(utils.getHours(date), 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(utils.getMinutes(date), 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(utils.getSeconds(date), 'seconds')):
            return 'shouldDisableTime-seconds';
        default:
            return null;
    }
};

});

parcelRegister("9XnpK", function(module, exports) {

$parcel$export(module.exports, "useNextMonthDisabled", function () { return $73fbc95a252c64d0$export$923e8cc135843169; });
$parcel$export(module.exports, "usePreviousMonthDisabled", function () { return $73fbc95a252c64d0$export$3b46d38ff4932cf7; });
$parcel$export(module.exports, "useMeridiemMode", function () { return $73fbc95a252c64d0$export$6aaabc31cb076d17; });

var $7fPBF = parcelRequire("7fPBF");

var $ebhFP = parcelRequire("ebhFP");

var $wrXWf = parcelRequire("wrXWf");
function $73fbc95a252c64d0$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate }) {
    const utils = (0, $ebhFP.useUtils)();
    return $7fPBF.useMemo(()=>{
        const now = utils.date();
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils
    ]);
}
function $73fbc95a252c64d0$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate }) {
    const utils = (0, $ebhFP.useUtils)();
    return $7fPBF.useMemo(()=>{
        const now = utils.date();
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils
    ]);
}
function $73fbc95a252c64d0$export$6aaabc31cb076d17(date, ampm, onChange) {
    const utils = (0, $ebhFP.useUtils)();
    const meridiemMode = (0, $wrXWf.getMeridiem)(date, utils);
    const handleMeridiemChange = $7fPBF.useCallback((mode)=>{
        const timeWithMeridiem = (0, $wrXWf.convertToMeridiem)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, 'partial');
    }, [
        ampm,
        date,
        onChange,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});


parcelRegister("03xzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00aa52f53b1c32d2$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
var $9om19 = parcelRequire("9om19");

var $fHpOV = parcelRequire("fHpOV");

var $bPswB = parcelRequire("bPswB");

var $ebhFP = parcelRequire("ebhFP");

var $hA8ff = parcelRequire("hA8ff");

var $7Yjfb = parcelRequire("7Yjfb");

var $bg7ke = parcelRequire("bg7ke");

var $3lTD4 = parcelRequire("3lTD4");

var $8ApP6 = parcelRequire("8ApP6");

var $99YKv = parcelRequire("99YKv");

var $d2gno = parcelRequire("d2gno");

var $bbzbN = parcelRequire("bbzbN");
var $00aa52f53b1c32d2$var$_span;
const $00aa52f53b1c32d2$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "date",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "loading",
    "maxDate",
    "minDate",
    "onChange",
    "onMonthChange",
    "reduceAnimations",
    "renderLoading",
    "shouldDisableDate",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className"
];
function $00aa52f53b1c32d2$export$e590ef7d5266b255(slot) {
    return (0, $4kwOy.default)('MuiCalendarPicker', slot);
}
const $00aa52f53b1c32d2$export$54d6b142efe8f412 = (0, $k9tw4.default)('MuiCalendarPicker', [
    'root',
    'viewTransitionContainer'
]);
const $00aa52f53b1c32d2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $9om19.default)(slots, $00aa52f53b1c32d2$export$e590ef7d5266b255, classes);
};
const $00aa52f53b1c32d2$var$CalendarPickerRoot = (0, $kDBhE.default)((0, $d2gno.default), {
    name: 'MuiCalendarPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column'
});
const $00aa52f53b1c32d2$var$CalendarPickerViewTransitionContainer = (0, $kDBhE.default)((0, $hA8ff.default), {
    name: 'MuiCalendarPicker',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({
    overflowY: 'auto'
});
const $00aa52f53b1c32d2$export$96ab2969580bcdae = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);
const $00aa52f53b1c32d2$var$CalendarPicker = /*#__PURE__*/ $7fPBF.forwardRef(function CalendarPicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiCalendarPicker'
    });
    const { autoFocus: autoFocus, onViewChange: onViewChange, date: date, disableFuture: disableFuture = false, disablePast: disablePast = false, defaultCalendarMonth: defaultCalendarMonth, loading: loading = false, maxDate: maxDateProp, minDate: minDateProp, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations = $00aa52f53b1c32d2$export$96ab2969580bcdae, renderLoading: renderLoading = ()=>$00aa52f53b1c32d2$var$_span || ($00aa52f53b1c32d2$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            children: "..."
        })), shouldDisableDate: shouldDisableDate, shouldDisableYear: shouldDisableYear, view: view, views: views = [
        'year',
        'day'
    ], openTo: openTo = 'day', className: className } = props, other = (0, $cFLic.default)(props, $00aa52f53b1c32d2$var$_excluded);
    const utils = (0, $ebhFP.useUtils)();
    const defaultDates = (0, $ebhFP.useDefaultDates)();
    const minDate = minDateProp != null ? minDateProp : defaultDates.minDate;
    const maxDate = maxDateProp != null ? maxDateProp : defaultDates.maxDate;
    const { openView: openView, setOpenView: setOpenView } = (0, $bg7ke.useViews)({
        view: view,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange
    });
    const { calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, isDateDisabled: isDateDisabled, handleChangeMonth: handleChangeMonth, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $bPswB.useCalendarState)({
        date: date,
        defaultCalendarMonth: defaultCalendarMonth,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture
    });
    $7fPBF.useEffect(()=>{
        if (date && isDateDisabled(date)) {
            const closestEnabledDate = (0, $99YKv.findClosestEnabledDate)({
                utils: utils,
                date: date,
                minDate: minDate,
                maxDate: maxDate,
                disablePast: disablePast,
                disableFuture: disableFuture,
                shouldDisableDate: isDateDisabled
            });
            onChange(closestEnabledDate, 'partial');
        } // This call is too expensive to run it on each prop change.
    // So just ensure that we are not rendering disabled as selected on mount.
    }, []); // eslint-disable-line
    $7fPBF.useEffect(()=>{
        if (date) changeMonth(date);
    }, [
        date
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $00aa52f53b1c32d2$var$useUtilityClasses(ownerState);
    const monthPickerProps = {
        className: className,
        date: date,
        disabled: other.disabled,
        disablePast: disablePast,
        disableFuture: disableFuture,
        onChange: onChange,
        minDate: minDate,
        maxDate: maxDate,
        onMonthChange: onMonthChange,
        readOnly: other.readOnly
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($00aa52f53b1c32d2$var$CalendarPickerRoot, {
        ref: ref,
        className: (0, $jtRae.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3lTD4.default), (0, $kY3Ke.default)({}, other, {
                views: views,
                openView: openView,
                currentMonth: calendarState.currentMonth,
                onViewChange: setOpenView,
                onMonthChange: (newMonth, direction)=>handleChangeMonth({
                        newMonth: newMonth,
                        direction: direction
                    }),
                minDate: minDate,
                maxDate: maxDate,
                disablePast: disablePast,
                disableFuture: disableFuture,
                reduceAnimations: reduceAnimations
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($00aa52f53b1c32d2$var$CalendarPickerViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: openView,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        openView === 'year' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8ApP6.default), (0, $kY3Ke.default)({}, other, {
                            autoFocus: autoFocus,
                            date: date,
                            onChange: onChange,
                            minDate: minDate,
                            maxDate: maxDate,
                            disableFuture: disableFuture,
                            disablePast: disablePast,
                            isDateDisabled: isDateDisabled,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedDayChange: changeFocusedDay
                        })),
                        openView === 'month' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fHpOV.default), (0, $kY3Ke.default)({}, monthPickerProps)),
                        openView === 'day' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Yjfb.default), (0, $kY3Ke.default)({}, other, calendarState, {
                            autoFocus: autoFocus,
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            date: date,
                            onChange: onChange,
                            isDateDisabled: isDateDisabled,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    });
});
var /**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [CalendarPicker API](https://mui.com/api/calendar-picker/)
 */ $00aa52f53b1c32d2$export$2e2bcd8739ae039 = $00aa52f53b1c32d2$var$CalendarPicker;

});
parcelRegister("fHpOV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6dee694b316891c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
var $9om19 = parcelRequire("9om19");

var $bZiX6 = parcelRequire("bZiX6");

var $ebhFP = parcelRequire("ebhFP");

var $bbzbN = parcelRequire("bbzbN");
const $b6dee694b316891c$var$_excluded = [
    "className",
    "date",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "onMonthChange",
    "readOnly"
];
function $b6dee694b316891c$export$c42c06ed5a8e405(slot) {
    return (0, $4kwOy.default)('MuiMonthPicker', slot);
}
const $b6dee694b316891c$export$9dafc1a6d475c4d8 = (0, $k9tw4.default)('MuiMonthPicker', [
    'root'
]);
const $b6dee694b316891c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $9om19.default)(slots, $b6dee694b316891c$export$c42c06ed5a8e405, classes);
};
const $b6dee694b316891c$var$MonthPickerRoot = (0, $kDBhE.default)('div', {
    name: 'MuiMonthPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    margin: '0 4px'
});
const $b6dee694b316891c$var$MonthPicker = /*#__PURE__*/ $7fPBF.forwardRef(function MonthPicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiMonthPicker'
    });
    const { className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, onMonthChange: onMonthChange, readOnly: readOnly } = props, other = (0, $cFLic.default)(props, $b6dee694b316891c$var$_excluded);
    const ownerState = props;
    const classes = $b6dee694b316891c$var$useUtilityClasses(ownerState);
    const utils = (0, $ebhFP.useUtils)();
    const now = (0, $ebhFP.useNow)();
    const currentMonth = utils.getMonth(date || now);
    const shouldDisableMonth = (month)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        const isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    const onMonthSelect = (month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(date || now, month);
        onChange(newDate, 'finish');
        if (onMonthChange) onMonthChange(newDate);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($b6dee694b316891c$var$MonthPickerRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $jtRae.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: utils.getMonthArray(date || now).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bZiX6.default), {
                value: monthNumber,
                selected: monthNumber === currentMonth,
                onSelect: onMonthSelect,
                disabled: disabled || shouldDisableMonth(month),
                children: monthText
            }, monthText);
        })
    }));
});
var /**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [MonthPicker API](https://mui.com/api/month-picker/)
 */ $b6dee694b316891c$export$2e2bcd8739ae039 = $b6dee694b316891c$var$MonthPicker;

});
parcelRegister("bZiX6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba417bf53ccb898$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $3loMv = parcelRequire("3loMv");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $c3NLh = parcelRequire("c3NLh");

var $bbzbN = parcelRequire("bbzbN");
const $8ba417bf53ccb898$var$_excluded = [
    "disabled",
    "onSelect",
    "selected",
    "value"
];
const $8ba417bf53ccb898$var$classes = (0, $k9tw4.default)('PrivatePickersMonth', [
    'root',
    'selected'
]);
const $8ba417bf53ccb898$var$PickersMonthRoot = (0, $kDBhE.default)((0, $3loMv.default))(({ theme: theme })=>(0, $kY3Ke.default)({
        flex: '1 0 33.33%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            pointerEvents: 'none',
            color: theme.palette.text.secondary
        },
        [`&.${$8ba417bf53ccb898$var$classes.selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
/**
 * @ignore - do not document.
 */ const $8ba417bf53ccb898$var$PickersMonth = (props)=>{
    const { disabled: disabled, onSelect: onSelect, selected: selected, value: value } = props, other = (0, $cFLic.default)(props, $8ba417bf53ccb898$var$_excluded);
    const handleSelection = ()=>{
        onSelect(value);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8ba417bf53ccb898$var$PickersMonthRoot, (0, $kY3Ke.default)({
        component: "button",
        className: (0, $jtRae.default)($8ba417bf53ccb898$var$classes.root, selected && $8ba417bf53ccb898$var$classes.selected),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyDown: (0, $c3NLh.onSpaceOrEnter)(handleSelection),
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        disabled: disabled
    }, other));
};
var $8ba417bf53ccb898$export$2e2bcd8739ae039 = $8ba417bf53ccb898$var$PickersMonth;

});
parcelRegister("cxeT8", function(module, exports) {

$parcel$export(module.exports, "alpha", function () { return $92041da11764723e$export$58f0f39f63f3cf42; });

var $diYUK = parcelRequire("diYUK");

var $5mrJy = parcelRequire("5mrJy");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $92041da11764723e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $5mrJy.default)(value, min, max);
}
function $92041da11764723e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $92041da11764723e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $92041da11764723e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $92041da11764723e$export$677b39864803984e($92041da11764723e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $diYUK.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $diYUK.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $92041da11764723e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $92041da11764723e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $92041da11764723e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $92041da11764723e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $92041da11764723e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $92041da11764723e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $92041da11764723e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$92041da11764723e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $92041da11764723e$export$29fb7152bd3f781a(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $92041da11764723e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $92041da11764723e$export$c852d90bf7403b62(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $92041da11764723e$export$677b39864803984e($92041da11764723e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $92041da11764723e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $92041da11764723e$export$c852d90bf7403b62(foreground);
    const lumB = $92041da11764723e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $92041da11764723e$export$58f0f39f63f3cf42(color, value) {
    color = $92041da11764723e$export$677b39864803984e(color);
    value = $92041da11764723e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $92041da11764723e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$4b073707ff63303(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$c0816ed86df316af(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $92041da11764723e$export$c852d90bf7403b62(color) > 0.5 ? $92041da11764723e$export$4b073707ff63303(color, coefficient) : $92041da11764723e$export$c0816ed86df316af(color, coefficient);
}
function $92041da11764723e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $92041da11764723e$export$677b39864803984e(background);
    const overlayColor = $92041da11764723e$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $92041da11764723e$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});



parcelRegister("bPswB", function(module, exports) {

$parcel$export(module.exports, "useCalendarState", function () { return $89ca958ea3e43a5c$export$6d095e787d2b5e1f; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $99YKv = parcelRequire("99YKv");

var $ebhFP = parcelRequire("ebhFP");
const $89ca958ea3e43a5c$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $kY3Ke.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $kY3Ke.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay !== null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = Boolean(action.focusedDay) && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $kY3Ke.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
function $89ca958ea3e43a5c$export$6d095e787d2b5e1f({ date: date, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate }) {
    var _ref;
    const now = (0, $ebhFP.useNow)();
    const utils = (0, $ebhFP.useUtils)();
    const reducerFn = $7fPBF.useRef($89ca958ea3e43a5c$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const [calendarState, dispatch] = $7fPBF.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: date || now,
        currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
        slideDirection: 'left'
    });
    const handleChangeMonth = $7fPBF.useCallback((payload)=>{
        dispatch((0, $kY3Ke.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $7fPBF.useCallback((newDate)=>{
        const newDateRequested = newDate != null ? newDate : now;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        now,
        utils
    ]);
    const isDateDisabled = $7fPBF.useCallback((day)=>(0, $99YKv.validateDate)(utils, day, {
            disablePast: disablePast,
            disableFuture: disableFuture,
            minDate: minDate,
            maxDate: maxDate,
            shouldDisableDate: shouldDisableDate
        }) !== null, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        shouldDisableDate,
        utils
    ]);
    const onMonthSwitchingAnimationEnd = $7fPBF.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = $7fPBF.useCallback((newFocusedDate)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate
        });
    }, [
        isDateDisabled
    ]);
    return {
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
}

});
parcelRegister("99YKv", function(module, exports) {

$parcel$export(module.exports, "findClosestEnabledDate", function () { return $6ab413d27552b179$export$ca1f317ae8db2ee8; });
$parcel$export(module.exports, "parsePickerInputValue", function () { return $6ab413d27552b179$export$ec1af8323095accb; });
$parcel$export(module.exports, "validateDate", function () { return $6ab413d27552b179$export$ffb3d0046ef3a2; });
$parcel$export(module.exports, "validateDateRange", function () { return $6ab413d27552b179$export$b3e10550232e39db; });
const $6ab413d27552b179$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, shouldDisableDate: shouldDisableDate, utils: utils })=>{
    const today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return today;
};
function $6ab413d27552b179$export$ec1af8323095accb(utils, value) {
    const parsedValue = utils.date(value);
    return utils.isValid(parsedValue) ? parsedValue : null;
}
function $6ab413d27552b179$export$30d06998cb72a6b7(utils, value = [
    null,
    null
]) {
    return value.map((date)=>!utils.isValid(date) || date === null ? null : utils.startOfDay(utils.date(date)));
}
const $6ab413d27552b179$export$c7f604e63318fb66 = (utils, range)=>{
    return Boolean(range && range[0] && range[1] && !utils.isBefore(range[1], range[0]));
};
const $6ab413d27552b179$export$6a645c07cf2dc9cc = (utils, day, range)=>{
    return $6ab413d27552b179$export$c7f604e63318fb66(utils, range) && utils.isWithinRange(day, range);
};
const $6ab413d27552b179$export$d63c3232b6730bf6 = (utils, day, range)=>{
    return $6ab413d27552b179$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[0]);
};
const $6ab413d27552b179$export$ee65fa37269ed1c8 = (utils, day, range)=>{
    return $6ab413d27552b179$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[1]);
};
const $6ab413d27552b179$export$ffb3d0046ef3a2 = (utils, value, { disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate })=>{
    const now = utils.date();
    const date = utils.date(value);
    if (date === null) return null;
    switch(true){
        case !utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(date)):
            return 'shouldDisableDate';
        case Boolean(disableFuture && utils.isAfterDay(date, now)):
            return 'disableFuture';
        case Boolean(disablePast && utils.isBeforeDay(date, now)):
            return 'disablePast';
        case Boolean(minDate && utils.isBeforeDay(date, minDate)):
            return 'minDate';
        case Boolean(maxDate && utils.isAfterDay(date, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
const $6ab413d27552b179$export$b3e10550232e39db = (utils, value, dateValidationProps)=>{
    const [start, end] = value; // for partial input
    if (start === null || end === null) return [
        null,
        null
    ];
    const dateValidations = [
        $6ab413d27552b179$export$ffb3d0046ef3a2(utils, start, dateValidationProps),
        $6ab413d27552b179$export$ffb3d0046ef3a2(utils, end, dateValidationProps)
    ];
    if (dateValidations[0] || dateValidations[1]) return dateValidations;
    if (!$6ab413d27552b179$export$c7f604e63318fb66(utils, [
        utils.date(start),
        utils.date(end)
    ])) return [
        'invalidRange',
        'invalidRange'
    ];
    return [
        null,
        null
    ];
};

});


parcelRegister("hA8ff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccc31bc00b6451a$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $8WhtA = parcelRequire("8WhtA");

var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $4axyc = parcelRequire("4axyc");

var $bbzbN = parcelRequire("bbzbN");
const $cccc31bc00b6451a$var$classes = (0, $k9tw4.default)('PrivatePickersFadeTransitionGroup', [
    'root'
]);
const $cccc31bc00b6451a$var$animationDuration = 500;
const $cccc31bc00b6451a$var$PickersFadeTransitionGroupRoot = (0, $kDBhE.default)((0, $4axyc.default))({
    display: 'block',
    position: 'relative'
});
/**
 * @ignore - do not document.
 */ const $cccc31bc00b6451a$var$PickersFadeTransitionGroup = ({ children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey })=>{
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($cccc31bc00b6451a$var$PickersFadeTransitionGroupRoot, {
        className: (0, $jtRae.default)($cccc31bc00b6451a$var$classes.root, className),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8WhtA.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $cccc31bc00b6451a$var$animationDuration,
                enter: $cccc31bc00b6451a$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
};
var $cccc31bc00b6451a$export$2e2bcd8739ae039 = $cccc31bc00b6451a$var$PickersFadeTransitionGroup;

});

parcelRegister("7Yjfb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cdd106db64f87c2$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");

var $b1czd = parcelRequire("b1czd");

var $ebhFP = parcelRequire("ebhFP");

var $hZUAF = parcelRequire("hZUAF");

var $3jj7g = parcelRequire("3jj7g");

var $bbzbN = parcelRequire("bbzbN");
var $5cdd106db64f87c2$var$_span;
const $5cdd106db64f87c2$var$weeksContainerHeight = ((0, $hZUAF.DAY_SIZE) + (0, $hZUAF.DAY_MARGIN) * 4) * 6;
const $5cdd106db64f87c2$var$PickersCalendarDayHeader = (0, $kDBhE.default)('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $5cdd106db64f87c2$var$PickersCalendarWeekDayLabel = (0, $kDBhE.default)((0, $3loMv.default))(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.secondary
    }));
const $5cdd106db64f87c2$var$PickersCalendarLoadingContainer = (0, $kDBhE.default)('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $5cdd106db64f87c2$var$weeksContainerHeight
});
const $5cdd106db64f87c2$var$PickersCalendarSlideTransition = (0, $kDBhE.default)((0, $3jj7g.default))({
    minHeight: $5cdd106db64f87c2$var$weeksContainerHeight
});
const $5cdd106db64f87c2$var$PickersCalendarWeekContainer = (0, $kDBhE.default)('div')({
    overflow: 'hidden'
});
const $5cdd106db64f87c2$var$PickersCalendarWeek = (0, $kDBhE.default)('div')({
    margin: `${(0, $hZUAF.DAY_MARGIN)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
/**
 * @ignore - do not document.
 */ function $5cdd106db64f87c2$var$PickersCalendar(props) {
    const { allowSameDateSelection: allowSameDateSelection, autoFocus: autoFocus, onFocusedDayChange: changeFocusedDay, className: className, currentMonth: currentMonth, date: date, disabled: disabled, disableHighlightToday: disableHighlightToday, focusedDay: focusedDay, isDateDisabled: isDateDisabled, isMonthSwitchingAnimating: isMonthSwitchingAnimating, loading: loading, onChange: onChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderDay: renderDay, renderLoading: renderLoading = ()=>$5cdd106db64f87c2$var$_span || ($5cdd106db64f87c2$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            children: "..."
        })), showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slideDirection: slideDirection, TransitionProps: TransitionProps } = props;
    const now = (0, $ebhFP.useNow)();
    const utils = (0, $ebhFP.useUtils)();
    const handleDaySelect = $7fPBF.useCallback((day, isFinish = 'finish')=>{
        if (readOnly) return;
         // TODO possibly buggy line figure out and add tests
        const finalDate = Array.isArray(date) ? day : utils.mergeDateAndTime(day, date || now);
        onChange(finalDate, isFinish);
    }, [
        date,
        now,
        onChange,
        readOnly,
        utils
    ]);
    const currentMonthNumber = utils.getMonth(currentMonth);
    const selectedDates = (Array.isArray(date) ? date : [
        date
    ]).filter(Boolean).map((selectedDateItem)=>selectedDateItem && utils.startOfDay(selectedDateItem)); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $7fPBF.useMemo(()=>/*#__PURE__*/ $7fPBF.createRef(), [
        transitionKey
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarDayHeader, {
                children: utils.getWeekdays().map((day, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarWeekDayLabel, {
                        "aria-hidden": true,
                        variant: "caption",
                        children: day.charAt(0).toUpperCase()
                    }, day + i.toString()))
            }),
            loading ? /*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarLoadingContainer, {
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarSlideTransition, (0, $kY3Ke.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: className
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "grid",
                    children: utils.getWeekArray(currentMonth).map((week)=>/*#__PURE__*/ (0, $bbzbN.jsx)($5cdd106db64f87c2$var$PickersCalendarWeek, {
                            role: "row",
                            children: week.map((day)=>{
                                const pickersDayProps = {
                                    key: day == null ? void 0 : day.toString(),
                                    day: day,
                                    isAnimating: isMonthSwitchingAnimating,
                                    disabled: disabled || isDateDisabled(day),
                                    allowSameDateSelection: allowSameDateSelection,
                                    autoFocus: autoFocus && focusedDay !== null && utils.isSameDay(day, focusedDay),
                                    today: utils.isSameDay(day, now),
                                    outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                                    selected: selectedDates.some((selectedDate)=>selectedDate && utils.isSameDay(selectedDate, day)),
                                    disableHighlightToday: disableHighlightToday,
                                    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                                    onDayFocus: changeFocusedDay,
                                    onDaySelect: handleDaySelect
                                };
                                return renderDay ? renderDay(day, selectedDates, pickersDayProps) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    role: "cell",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b1czd.default), (0, $kY3Ke.default)({}, pickersDayProps))
                                }, pickersDayProps.key);
                            })
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}
var $5cdd106db64f87c2$export$2e2bcd8739ae039 = $5cdd106db64f87c2$var$PickersCalendar;

});
parcelRegister("b1czd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8059894138208187$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3RNaF = parcelRequire("3RNaF");

var $lJRRs = parcelRequire("lJRRs");

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
var $9om19 = parcelRequire("9om19");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");
var $5j2OD = parcelRequire("5j2OD");

var $6NwTb = parcelRequire("6NwTb");

var $ebhFP = parcelRequire("ebhFP");

var $hZUAF = parcelRequire("hZUAF");

var $bbzbN = parcelRequire("bbzbN");
const $8059894138208187$var$_excluded = [
    "allowSameDateSelection",
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDayFocus",
    "onDaySelect",
    "onFocus",
    "onKeyDown",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today"
];
function $8059894138208187$export$4b25deb0350d3e53(slot) {
    return (0, $4kwOy.default)('MuiPickersDay', slot);
}
const $8059894138208187$export$68b221ad3c35e288 = (0, $k9tw4.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);
const $8059894138208187$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $9om19.default)(slots, $8059894138208187$export$4b25deb0350d3e53, classes);
};
const $8059894138208187$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.caption, {
        width: (0, $hZUAF.DAY_SIZE),
        height: (0, $hZUAF.DAY_SIZE),
        borderRadius: '50%',
        padding: 0,
        // background required here to prevent collides with the other days when animating with transition group
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        '&:hover': {
            backgroundColor: (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:focus': {
            backgroundColor: (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            [`&.${$8059894138208187$export$68b221ad3c35e288.selected}`]: {
                willChange: 'background-color',
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${$8059894138208187$export$68b221ad3c35e288.selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${$8059894138208187$export$68b221ad3c35e288.disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $hZUAF.DAY_MARGIN}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: theme.palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${$8059894138208187$export$68b221ad3c35e288.selected})`]: {
            border: `1px solid ${theme.palette.text.secondary}`
        }
    });
const $8059894138208187$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $8059894138208187$var$PickersDayRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $8059894138208187$var$overridesResolver
})($8059894138208187$var$styleArg);
const $8059894138208187$var$PickersDayFiller = (0, $kDBhE.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $8059894138208187$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, $8059894138208187$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        visibility: 'hidden'
    }));
const $8059894138208187$var$noop = ()=>{};
const $8059894138208187$var$PickersDay = /*#__PURE__*/ $7fPBF.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { allowSameDateSelection: allowSameDateSelection = false, autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDayFocus: onDayFocus = $8059894138208187$var$noop, onDaySelect: onDaySelect, onFocus: onFocus, onKeyDown: onKeyDown, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $cFLic.default)(props, $8059894138208187$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        allowSameDateSelection: allowSameDateSelection,
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $8059894138208187$var$useUtilityClasses(ownerState);
    const utils = (0, $ebhFP.useUtils)();
    const ref = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $lJRRs.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    const handleFocus = (event)=>{
        if (onDayFocus) onDayFocus(day);
        if (onFocus) onFocus(event);
    };
    const handleClick = (event)=>{
        if (!allowSameDateSelection && selected) return;
        if (!disabled) onDaySelect(day, 'finish');
        if (onClick) onClick(event);
    };
    const theme = (0, $g9bTP.default)();
    function handleKeyDown(event) {
        if (onKeyDown !== undefined) onKeyDown(event);
        switch(event.key){
            case 'ArrowUp':
                onDayFocus(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                onDayFocus(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                onDayFocus(utils.addDays(day, theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            case 'Home':
                onDayFocus(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                onDayFocus(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                onDayFocus(utils.getNextMonth(day));
                event.preventDefault();
                break;
            case 'PageDown':
                onDayFocus(utils.getPreviousMonth(day));
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $bbzbN.jsx)($8059894138208187$var$PickersDayFiller, {
        className: (0, $jtRae.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8059894138208187$var$PickersDayRoot, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ownerState: ownerState,
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        "aria-label": !children ? utils.format(day, 'fullDate') : undefined,
        tabIndex: selected ? 0 : -1,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }, other, {
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $8059894138208187$export$1fa4d5e98414e66a = (prevProps, nextProps)=>{
    return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
};
var /**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [PickersDay API](https://mui.com/api/pickers-day/)
 */ $8059894138208187$export$2e2bcd8739ae039 = /*#__PURE__*/ $7fPBF.memo($8059894138208187$var$PickersDay, $8059894138208187$export$1fa4d5e98414e66a);

});
parcelRegister("hZUAF", function(module, exports) {

$parcel$export(module.exports, "DAY_SIZE", function () { return $03619d07a254dc73$export$3f0060ce4cc8f4d0; });
$parcel$export(module.exports, "DAY_MARGIN", function () { return $03619d07a254dc73$export$dde58b009b497666; });
$parcel$export(module.exports, "DIALOG_WIDTH", function () { return $03619d07a254dc73$export$ee46b8a74d6c94d3; });
$parcel$export(module.exports, "VIEW_HEIGHT", function () { return $03619d07a254dc73$export$f2fef360e2df0cb7; });
const $03619d07a254dc73$export$3f0060ce4cc8f4d0 = 36;
const $03619d07a254dc73$export$dde58b009b497666 = 2;
const $03619d07a254dc73$export$ee46b8a74d6c94d3 = 320;
const $03619d07a254dc73$export$f2fef360e2df0cb7 = 358;

});


parcelRegister("3jj7g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2691f987032d02b3$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $kDBhE = parcelRequire("kDBhE");

var $k9tw4 = parcelRequire("k9tw4");

var $lsaFT = parcelRequire("lsaFT");
var $4axyc = parcelRequire("4axyc");

var $bbzbN = parcelRequire("bbzbN");
const $2691f987032d02b3$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey"
];
const $2691f987032d02b3$var$classes = (0, $k9tw4.default)('PrivatePickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);
const $2691f987032d02b3$export$ee7cc8ee8a5215ec = 350;
const $2691f987032d02b3$var$PickersSlideTransitionRoot = (0, $kDBhE.default)((0, $4axyc.default))(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: $2691f987032d02b3$export$ee7cc8ee8a5215ec,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${$2691f987032d02b3$var$classes['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${$2691f987032d02b3$var$classes['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${$2691f987032d02b3$var$classes.slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${$2691f987032d02b3$var$classes.slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${$2691f987032d02b3$var$classes['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${$2691f987032d02b3$var$classes['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
/**
 * @ignore - do not document.
 */ const $2691f987032d02b3$var$PickersSlideTransition = (_ref)=>{
    let { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey } = _ref, other = (0, $cFLic.default)(_ref, $2691f987032d02b3$var$_excluded);
    if (reduceAnimations) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $jtRae.default)($2691f987032d02b3$var$classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: $2691f987032d02b3$var$classes.slideExit,
        enterActive: $2691f987032d02b3$var$classes.slideEnterActive,
        enter: $2691f987032d02b3$var$classes[`slideEnter-${slideDirection}`],
        exitActive: $2691f987032d02b3$var$classes[`slideExitActiveLeft-${slideDirection}`]
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($2691f987032d02b3$var$PickersSlideTransitionRoot, {
        className: (0, $jtRae.default)($2691f987032d02b3$var$classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $7fPBF.cloneElement(element, {
                classNames: transitionClasses
            }),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lsaFT.default), (0, $kY3Ke.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $2691f987032d02b3$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
};
var $2691f987032d02b3$export$2e2bcd8739ae039 = $2691f987032d02b3$var$PickersSlideTransition;

});
parcelRegister("lsaFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9e47e451b39ae9f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $2B0G6 = parcelRequire("2B0G6");

var $bQbU1 = parcelRequire("bQbU1");

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");


var $kKJSm = parcelRequire("kKJSm");
var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $2B0G6.default)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $bQbU1.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $kKJSm.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cFLic.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8qMCX.default), (0, $kY3Ke.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;

});
parcelRegister("2B0G6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3f901d29816e8c$export$2e2bcd8739ae039; });

var $85lB0 = parcelRequire("85lB0");
function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $85lB0.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("85lB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("bQbU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89edc8a1840ff9c1$export$2e2bcd8739ae039; });
function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});




parcelRegister("3lTD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $270e7c0fda767e62$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $8WhtA = parcelRequire("8WhtA");

var $kDBhE = parcelRequire("kDBhE");

var $8TDId = parcelRequire("8TDId");

var $ebhFP = parcelRequire("ebhFP");

var $hA8ff = parcelRequire("hA8ff");

var $aadxH = parcelRequire("aadxH");

var $5EAgU = parcelRequire("5EAgU");

var $9XnpK = parcelRequire("9XnpK");

var $bbzbN = parcelRequire("bbzbN");
const $270e7c0fda767e62$var$PickersCalendarHeaderRoot = (0, $kDBhE.default)('div')({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $270e7c0fda767e62$var$PickersCalendarHeaderLabel = (0, $kDBhE.default)('div')(({ theme: theme })=>(0, $kY3Ke.default)({
        display: 'flex',
        maxHeight: 30,
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $270e7c0fda767e62$var$PickersCalendarHeaderLabelItem = (0, $kDBhE.default)('div')({
    marginRight: 6
});
const $270e7c0fda767e62$var$PickersCalendarHeaderSwitchViewButton = (0, $kDBhE.default)((0, $8TDId.default))({
    marginRight: 'auto'
});
const $270e7c0fda767e62$var$PickersCalendarHeaderSwitchView = (0, $kDBhE.default)((0, $aadxH.default))(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }, ownerState.openView === 'year' && {
        transform: 'rotate(180deg)'
    }));
function $270e7c0fda767e62$var$getSwitchingViewAriaText(view) {
    return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
}
/**
 * @ignore - do not document.
 */ function $270e7c0fda767e62$var$PickersCalendarHeader(props) {
    const { components: components = {}, componentsProps: componentsProps = {}, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, getViewSwitchingButtonText: getViewSwitchingButtonText = $270e7c0fda767e62$var$getSwitchingViewAriaText, leftArrowButtonText: leftArrowButtonText = 'Previous month', maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, openView: currentView, reduceAnimations: reduceAnimations, rightArrowButtonText: rightArrowButtonText = 'Next month', views: views } = props;
    const utils = (0, $ebhFP.useUtils)();
    const switchViewButtonProps = componentsProps.switchViewButton || {};
    const selectNextMonth = ()=>onMonthChange(utils.getNextMonth(month), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.getPreviousMonth(month), 'right');
    const isNextMonthDisabled = (0, $9XnpK.useNextMonthDisabled)(month, {
        disableFuture: disableFuture || disabled,
        maxDate: maxDate
    });
    const isPreviousMonthDisabled = (0, $9XnpK.usePreviousMonthDisabled)(month, {
        disablePast: disablePast || disabled,
        minDate: minDate
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((view)=>view !== currentView) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    }; // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($270e7c0fda767e62$var$PickersCalendarHeaderRoot, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($270e7c0fda767e62$var$PickersCalendarHeaderLabel, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hA8ff.default), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'month'),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($270e7c0fda767e62$var$PickersCalendarHeaderLabelItem, {
                            "aria-live": "polite",
                            ownerState: ownerState,
                            children: utils.format(month, 'month')
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hA8ff.default), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'year'),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($270e7c0fda767e62$var$PickersCalendarHeaderLabelItem, {
                            "aria-live": "polite",
                            ownerState: ownerState,
                            children: utils.format(month, 'year')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $bbzbN.jsx)($270e7c0fda767e62$var$PickersCalendarHeaderSwitchViewButton, (0, $kY3Ke.default)({
                        size: "small",
                        as: components.SwitchViewButton,
                        "aria-label": getViewSwitchingButtonText(currentView)
                    }, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($270e7c0fda767e62$var$PickersCalendarHeaderSwitchView, {
                            as: components.SwitchViewIcon,
                            ownerState: ownerState
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8WhtA.default), {
                in: currentView === 'day',
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5EAgU.default), {
                    leftArrowButtonText: leftArrowButtonText,
                    rightArrowButtonText: rightArrowButtonText,
                    components: components,
                    componentsProps: componentsProps,
                    onLeftClick: selectPreviousMonth,
                    onRightClick: selectNextMonth,
                    isLeftDisabled: isPreviousMonthDisabled,
                    isRightDisabled: isNextMonthDisabled
                })
            })
        ]
    });
}
var $270e7c0fda767e62$export$2e2bcd8739ae039 = $270e7c0fda767e62$var$PickersCalendarHeader;

});
parcelRegister("aadxH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766557cc4cbe6b8a$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $766557cc4cbe6b8a$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("8ApP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6405b777ec219704$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");
var $5j2OD = parcelRequire("5j2OD");

var $9om19 = parcelRequire("9om19");

var $jtRae = parcelRequire("jtRae");

var $wrAgV = parcelRequire("wrAgV");

var $ebhFP = parcelRequire("ebhFP");

var $99YKv = parcelRequire("99YKv");

var $jGysp = parcelRequire("jGysp");

var $lJuo3 = parcelRequire("lJuo3");

var $bbzbN = parcelRequire("bbzbN");
const $6405b777ec219704$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $9om19.default)(slots, (0, $lJuo3.getYearPickerUtilityClass), classes);
};
const $6405b777ec219704$var$YearPickerRoot = (0, $kDBhE.default)('div', {
    name: 'MuiYearPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    margin: '0 4px'
});
const $6405b777ec219704$var$YearPicker = /*#__PURE__*/ $7fPBF.forwardRef(function YearPicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: 'MuiYearPicker'
    });
    const { autoFocus: autoFocus, className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, isDateDisabled: isDateDisabled, maxDate: maxDate, minDate: minDate, onChange: onChange, onFocusedDayChange: onFocusedDayChange, onYearChange: onYearChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear } = props;
    const ownerState = props;
    const classes = $6405b777ec219704$var$useUtilityClasses(ownerState);
    const now = (0, $ebhFP.useNow)();
    const theme = (0, $g9bTP.default)();
    const utils = (0, $ebhFP.useUtils)();
    const selectedDate = date || now;
    const currentYear = utils.getYear(selectedDate);
    const wrapperVariant = $7fPBF.useContext((0, $jGysp.WrapperVariantContext));
    const selectedYearRef = $7fPBF.useRef(null);
    const [focusedYear, setFocusedYear] = $7fPBF.useState(currentYear);
    const handleYearSelection = (event, year, isFinish = 'finish')=>{
        if (readOnly) return;
        const submitDate = (newDate)=>{
            onChange(newDate, isFinish);
            if (onFocusedDayChange) onFocusedDayChange(newDate || now);
            if (onYearChange) onYearChange(newDate);
        };
        const newDate = utils.setYear(selectedDate, year);
        if (isDateDisabled(newDate)) {
            const closestEnabledDate = (0, $99YKv.findClosestEnabledDate)({
                utils: utils,
                date: newDate,
                minDate: minDate,
                maxDate: maxDate,
                disablePast: Boolean(disablePast),
                disableFuture: Boolean(disableFuture),
                shouldDisableDate: isDateDisabled
            });
            submitDate(closestEnabledDate || now);
        } else submitDate(newDate);
    };
    const focusYear = $7fPBF.useCallback((year)=>{
        if (!isDateDisabled(utils.setYear(selectedDate, year))) setFocusedYear(year);
    }, [
        selectedDate,
        isDateDisabled,
        utils
    ]);
    const yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;
    const handleKeyDown = (event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsInRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsInRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6405b777ec219704$var$YearPickerRoot, {
        ref: ref,
        className: (0, $jtRae.default)(classes.root, className),
        ownerState: ownerState,
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const selected = yearNumber === currentYear;
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $wrAgV.default), {
                selected: selected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: autoFocus && yearNumber === focusedYear,
                ref: selected ? selectedYearRef : undefined,
                disabled: disabled || disablePast && utils.isBeforeYear(year, now) || disableFuture && utils.isAfterYear(year, now) || shouldDisableYear && shouldDisableYear(year),
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    });
});
var /**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [YearPicker API](https://mui.com/api/year-picker/)
 */ $6405b777ec219704$export$2e2bcd8739ae039 = $6405b777ec219704$var$YearPicker;

});
parcelRegister("wrAgV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061862e32fa49243$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $b6UUh = parcelRequire("b6UUh");
var $6NwTb = parcelRequire("6NwTb");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
var $9om19 = parcelRequire("9om19");

var $jGysp = parcelRequire("jGysp");

var $bbzbN = parcelRequire("bbzbN");
function $061862e32fa49243$export$183c9f339a61cd79(slot) {
    return (0, $4kwOy.default)('PrivatePickersYear', slot);
}
const $061862e32fa49243$export$4ef58a3d9c6f4296 = (0, $k9tw4.default)('PrivatePickersYear', [
    'root',
    'modeMobile',
    'modeDesktop',
    'yearButton',
    'disabled',
    'selected'
]);
const $061862e32fa49243$var$useUtilityClasses = (ownerState)=>{
    const { wrapperVariant: wrapperVariant, disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            wrapperVariant && `mode${(0, $b6UUh.default)(wrapperVariant)}`
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $9om19.default)(slots, $061862e32fa49243$export$183c9f339a61cd79, classes);
};
const $061862e32fa49243$var$PickersYearRoot = (0, $kDBhE.default)('div')(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        flexBasis: '33.3%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === 'desktop' && {
        flexBasis: '25%'
    }));
const $061862e32fa49243$var$PickersYearButton = (0, $kDBhE.default)('button')(({ theme: theme })=>(0, $kY3Ke.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        [`&.${$061862e32fa49243$export$4ef58a3d9c6f4296.disabled}`]: {
            color: theme.palette.text.secondary
        },
        [`&.${$061862e32fa49243$export$4ef58a3d9c6f4296.selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
/**
 * @ignore - internal component.
 */ const $061862e32fa49243$var$PickersYear = /*#__PURE__*/ $7fPBF.forwardRef(function PickersYear(props, forwardedRef) {
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, selected: selected, value: value } = props;
    const ref = $7fPBF.useRef(null);
    const refHandle = (0, $6NwTb.default)(ref, forwardedRef);
    const wrapperVariant = $7fPBF.useContext((0, $jGysp.WrapperVariantContext));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        wrapperVariant: wrapperVariant
    });
    const classes = $061862e32fa49243$var$useUtilityClasses(ownerState); // TODO: Can we just forward this to the button?
    $7fPBF.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUIu
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($061862e32fa49243$var$PickersYearRoot, {
        className: (0, $jtRae.default)(classes.root, className),
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($061862e32fa49243$var$PickersYearButton, {
            ref: refHandle,
            disabled: disabled,
            type: "button",
            tabIndex: selected ? 0 : -1,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            className: classes.yearButton,
            ownerState: ownerState,
            children: children
        })
    });
});
var $061862e32fa49243$export$2e2bcd8739ae039 = $061862e32fa49243$var$PickersYear;

});

parcelRegister("lJuo3", function(module, exports) {

$parcel$export(module.exports, "getYearPickerUtilityClass", function () { return $fd255f2fce0055c1$export$f2ff97d66516573; });

var $4kwOy = parcelRequire("4kwOy");
var $k9tw4 = parcelRequire("k9tw4");
function $fd255f2fce0055c1$export$f2ff97d66516573(slot) {
    return (0, $4kwOy.default)('MuiYearPicker', slot);
}
const $fd255f2fce0055c1$var$yearPickerClasses = (0, $k9tw4.default)('MuiYearPicker', [
    'root'
]);
var $fd255f2fce0055c1$export$2e2bcd8739ae039 = $fd255f2fce0055c1$var$yearPickerClasses;

});


parcelRegister("d2gno", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97d82a44378a0a3f$export$2e2bcd8739ae039; });

var $kDBhE = parcelRequire("kDBhE");

var $hZUAF = parcelRequire("hZUAF");
const $97d82a44378a0a3f$var$PickerView = (0, $kDBhE.default)('div')({
    overflowX: 'hidden',
    width: (0, $hZUAF.DIALOG_WIDTH),
    maxHeight: (0, $hZUAF.VIEW_HEIGHT),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});
var $97d82a44378a0a3f$export$2e2bcd8739ae039 = $97d82a44378a0a3f$var$PickerView;

});


parcelRegister("73rDW", function(module, exports) {

$parcel$export(module.exports, "KeyboardDateInput", function () { return $522e419154e98f09$export$aa5e86c6cf7f6de8; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $8TDId = parcelRequire("8TDId");

var $dQarR = parcelRequire("dQarR");

var $ebhFP = parcelRequire("ebhFP");

var $lIvj9 = parcelRequire("lIvj9");

var $9at2v = parcelRequire("9at2v");

var $9Hnow = parcelRequire("9Hnow");

var $bbzbN = parcelRequire("bbzbN");
const $522e419154e98f09$var$_excluded = [
    "components",
    "disableOpenPicker",
    "getOpenDialogAriaText",
    "InputAdornmentProps",
    "InputProps",
    "inputRef",
    "openPicker",
    "OpenPickerButtonProps",
    "renderInput"
];
const $522e419154e98f09$export$aa5e86c6cf7f6de8 = /*#__PURE__*/ $7fPBF.forwardRef(function KeyboardDateInput(props, ref) {
    const { components: components = {}, disableOpenPicker: disableOpenPicker, getOpenDialogAriaText: getOpenDialogAriaText = (0, $9Hnow.getTextFieldAriaText), InputAdornmentProps: InputAdornmentProps, InputProps: InputProps, inputRef: inputRef, openPicker: openPicker, OpenPickerButtonProps: OpenPickerButtonProps, renderInput: renderInput } = props, other = (0, $cFLic.default)(props, $522e419154e98f09$var$_excluded);
    const utils = (0, $ebhFP.useUtils)();
    const textFieldProps = (0, $9at2v.useMaskedInput)(other);
    const adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || 'end';
    const OpenPickerIcon = components.OpenPickerIcon || (0, $lIvj9.default);
    return renderInput((0, $kY3Ke.default)({
        ref: ref,
        inputRef: inputRef
    }, textFieldProps, {
        InputProps: (0, $kY3Ke.default)({}, InputProps, {
            [`${adornmentPosition}Adornment`]: disableOpenPicker ? undefined : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dQarR.default), (0, $kY3Ke.default)({
                position: adornmentPosition
            }, InputAdornmentProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), (0, $kY3Ke.default)({
                    edge: adornmentPosition,
                    disabled: other.disabled || other.readOnly,
                    "aria-label": getOpenDialogAriaText(other.rawValue, utils)
                }, OpenPickerButtonProps, {
                    onClick: openPicker,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(OpenPickerIcon, {})
                }))
            }))
        })
    }));
});
var $522e419154e98f09$export$2e2bcd8739ae039 = $522e419154e98f09$export$aa5e86c6cf7f6de8;

});
parcelRegister("dQarR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1383c8904b71ac9$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $3loMv = parcelRequire("3loMv");

var $kPqR2 = parcelRequire("kPqR2");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $4oXX1 = parcelRequire("4oXX1");

var $iVAEr = parcelRequire("iVAEr");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $b6UUh.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4oXX1.getInputAdornmentUtilityClass), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $kDBhE.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $4oXX1.default).positionStart}&:not(.${(0, $4oXX1.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cFLic.default)(props, $a1383c8904b71ac9$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9MRga.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;

});
parcelRegister("4oXX1", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", function () { return $3347e858a7e1bb40$export$4b135a4b3a6c4550; });
$parcel$export(module.exports, "default", function () { return $3347e858a7e1bb40$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $k6RDS.default)('MuiInputAdornment', slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $4jzsB.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;

});


parcelRegister("9at2v", function(module, exports) {

$parcel$export(module.exports, "useMaskedInput", function () { return $6acb92de5a69dbcb$export$3be87d890b5aa1ad; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $1P9BF = parcelRequire("1P9BF");

var $ebhFP = parcelRequire("ebhFP");

var $c3NLh = parcelRequire("c3NLh");

var $9Hnow = parcelRequire("9Hnow");
function $6acb92de5a69dbcb$export$3be87d890b5aa1ad({ acceptRegex: acceptRegex = /[\d]/gi, disabled: disabled, disableMaskedInput: disableMaskedInput, ignoreInvalidInputs: ignoreInvalidInputs, inputFormat: inputFormat, inputProps: inputProps, label: label, mask: mask, onChange: onChange, rawValue: rawValue, readOnly: readOnly, rifmFormatter: rifmFormatter, TextFieldProps: TextFieldProps, validationError: validationError }) {
    const utils = (0, $ebhFP.useUtils)();
    const [isFocused, setIsFocused] = $7fPBF.useState(false);
    const formatHelperText = utils.getFormatHelperText(inputFormat);
    const shouldUseMaskedInput = $7fPBF.useMemo(()=>{
        // formatting of dates is a quite slow thing, so do not make useless .format calls
        if (!mask || disableMaskedInput) return false;
        return (0, $9Hnow.checkMaskIsValidForCurrentFormat)(mask, inputFormat, acceptRegex, utils);
    }, [
        acceptRegex,
        disableMaskedInput,
        inputFormat,
        mask,
        utils
    ]);
    const formatter = $7fPBF.useMemo(()=>shouldUseMaskedInput && mask ? (0, $9Hnow.maskedDateFormatter)(mask, acceptRegex) : (st)=>st, [
        acceptRegex,
        mask,
        shouldUseMaskedInput
    ]); // TODO: Implement with controlled vs unctrolled `rawValue`
    const currentInputValue = (0, $9Hnow.getDisplayDate)(utils, rawValue, inputFormat);
    const [innerInputValue, setInnerInputValue] = $7fPBF.useState(currentInputValue);
    const previousInputValueRef = $7fPBF.useRef(currentInputValue);
    $7fPBF.useEffect(()=>{
        previousInputValueRef.current = currentInputValue;
    }, [
        currentInputValue
    ]);
    const notTyping = !isFocused;
    const valueChanged = previousInputValueRef.current !== currentInputValue; // Update the input value only if the value changed outside of typing
    if (notTyping && valueChanged && (rawValue === null || utils.isValid(rawValue))) {
        if (currentInputValue !== innerInputValue) setInnerInputValue(currentInputValue);
    }
    const handleChange = (text)=>{
        const finalString = text === '' || text === mask ? '' : text;
        setInnerInputValue(finalString);
        const date = finalString === null ? null : utils.parse(finalString, inputFormat);
        if (ignoreInvalidInputs && !utils.isValid(date)) return;
        onChange(date, finalString || undefined);
    };
    const rifmProps = (0, $1P9BF.useRifm)({
        value: innerInputValue,
        onChange: handleChange,
        format: rifmFormatter || formatter
    });
    const inputStateArgs = shouldUseMaskedInput ? rifmProps : {
        value: innerInputValue,
        onChange: (event)=>{
            handleChange(event.currentTarget.value);
        }
    };
    return (0, $kY3Ke.default)({
        label: label,
        disabled: disabled,
        error: validationError,
        inputProps: (0, $kY3Ke.default)({}, inputStateArgs, {
            disabled: disabled,
            placeholder: formatHelperText,
            readOnly: readOnly,
            type: shouldUseMaskedInput ? 'tel' : 'text'
        }, inputProps, {
            onFocus: (0, $c3NLh.createDelegatedEventHandler)(()=>{
                setIsFocused(true);
            }, inputProps == null ? void 0 : inputProps.onFocus),
            onBlur: (0, $c3NLh.createDelegatedEventHandler)(()=>{
                setIsFocused(false);
            }, inputProps == null ? void 0 : inputProps.onBlur)
        })
    }, TextFieldProps);
}
var $6acb92de5a69dbcb$export$2e2bcd8739ae039 = $6acb92de5a69dbcb$export$3be87d890b5aa1ad;

});
parcelRegister("1P9BF", function(module, exports) {

$parcel$export(module.exports, "useRifm", function () { return $1542018035baed54$export$9a2620970bbf44b7; });

var $7fPBF = parcelRequire("7fPBF");
const $1542018035baed54$export$9a2620970bbf44b7 = (props)=>{
    const [, refresh] = (0, $7fPBF.useReducer)((c)=>c + 1, 0);
    const valueRef = (0, $7fPBF.useRef)(null);
    const { replace: replace, append: append } = props;
    const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support
    const isDeleleteButtonDownRef = (0, $7fPBF.useRef)(false);
    const onChange = (evt)=>{
        const eventValue = evt.target.value;
        valueRef.current = [
            eventValue,
            evt.target,
            eventValue.length > userValue.length,
            isDeleleteButtonDownRef.current,
            userValue === props.format(eventValue) // isNoOperation
        ];
        // that allows us to calculate right cursor position after formatting (see getCursorPosition)
        // then we format new value and call props.onChange with masked/formatted value
        // and finally we are able to set cursor position into right place
        refresh();
    }; // React prints warn on server in non production mode about useLayoutEffect usage
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (valueRef.current == null) return;
        let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, isNoOperation] = valueRef.current;
        valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
        // in case of isDeleleteButtonDown cursor should move differently vs backspace
        const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
        const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
        const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
        const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols
        const clean = (str)=>(str.match(props.accept || /\d/g) || []).join('');
        const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
        // This works because we assume that format doesn't change the order of accepted symbols.
        // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
        // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
        // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
        // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
        // so for formatting just this function to determine cursor position after formatting is enough
        // with masking we need to do some additional checks see `mask` below
        const getCursorPosition = (val)=>{
            let start = 0;
            let cleanPos = 0;
            for(let i = 0; i !== valueBeforeSelectionStart.length; ++i){
                let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
                let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
                // For example fixes edge case with fixed point numbers:
                // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
                // that order of accepted symbols is not changed after format,
                // so here we don't update start position if other accepted symbols was inbetween current and new position
                if (newCleanPos - cleanPos > 1) {
                    newPos = start;
                    newCleanPos = cleanPos;
                }
                cleanPos = Math.max(newCleanPos, cleanPos);
                start = Math.max(start, newPos);
            }
            return start;
        }; // Masking part, for masks if size of mask is above some value
        // we need to replace symbols instead of do nothing as like in format
        if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
            let start = getCursorPosition(eventValue);
            const c = clean(eventValue.substr(start))[0];
            start = eventValue.indexOf(c, start);
            eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
        }
        let formattedValue = props.format(eventValue);
        if (append != null && // cursor at the end
        input.selectionStart === eventValue.length && !isNoOperation) {
            if (isSizeIncreaseOperation) formattedValue = append(formattedValue);
            else // If after delete last char is special character and we use append
            // delete it too
            // was: "12-3|" backspace pressed, then should be "12|"
            if (clean(formattedValue.slice(-1)) === '') formattedValue = formattedValue.slice(0, -1);
        }
        const replacedValue = replace ? replace(formattedValue) : formattedValue;
        if (userValue === replacedValue) // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
        else props.onChange(replacedValue);
        return ()=>{
            let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
            // like cursor jumping over refused symbols
            // as an example date mask: was "5|1-24-3" then user pressed "6"
            // it becomes "56-|12-43" with this code, and "56|-12-43" without
            if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) while(formattedValue[start] && clean(formattedValue[start]) === '')start += 1;
            input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
        };
    });
    (0, $7fPBF.useEffect)(()=>{
        // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
        // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
        // there is no way I found to distinguish in onChange
        // backspace or delete was called in some situations
        // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
        const handleKeyDown = (evt)=>{
            if (evt.code === 'Delete') isDeleleteButtonDownRef.current = true;
        };
        const handleKeyUp = (evt)=>{
            if (evt.code === 'Delete') isDeleleteButtonDownRef.current = false;
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return {
        value: valueRef.current != null ? valueRef.current[0] : userValue,
        onChange: onChange
    };
};
const $1542018035baed54$export$5519909ee832c7c = (props)=>{
    const renderProps = $1542018035baed54$export$9a2620970bbf44b7(props);
    return props.children(renderProps);
};

});

parcelRegister("9Hnow", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAriaText", function () { return $70fa46d9a9bcc3a4$export$80fca2759b657ac7; });
$parcel$export(module.exports, "getDisplayDate", function () { return $70fa46d9a9bcc3a4$export$61abca328afe490a; });
$parcel$export(module.exports, "checkMaskIsValidForCurrentFormat", function () { return $70fa46d9a9bcc3a4$export$17b3b67b7ed6b51d; });
$parcel$export(module.exports, "maskedDateFormatter", function () { return $70fa46d9a9bcc3a4$export$bd2dd9a8014709bf; });
function $70fa46d9a9bcc3a4$export$80fca2759b657ac7(rawValue, utils) {
    // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
    // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    return rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), 'fullDate')}` : 'Choose date';
}
const $70fa46d9a9bcc3a4$export$61abca328afe490a = (utils, value, inputFormat)=>{
    const date = utils.date(value);
    const isEmpty = value === null;
    if (isEmpty) return '';
    return utils.isValid(date) ? utils.formatByString(// Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    date, inputFormat) : '';
};
function $70fa46d9a9bcc3a4$export$7ffee057229ac48(userFormat, ampm, formats) {
    if (userFormat) return userFormat;
    if (typeof ampm === 'undefined') return formats.localized;
    return ampm ? formats['12h'] : formats['24h'];
}
const $70fa46d9a9bcc3a4$var$MASK_USER_INPUT_SYMBOL = '_';
const $70fa46d9a9bcc3a4$var$staticDateWith2DigitTokens = '2019-11-21T22:30:00.000';
const $70fa46d9a9bcc3a4$var$staticDateWith1DigitTokens = '2019-01-01T09:00:00.000';
function $70fa46d9a9bcc3a4$export$17b3b67b7ed6b51d(mask, format, acceptRegex, utils) {
    const formattedDateWith1Digit = utils.formatByString(utils.date($70fa46d9a9bcc3a4$var$staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, $70fa46d9a9bcc3a4$var$MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date($70fa46d9a9bcc3a4$var$staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
    const isMaskValid = inferredFormatPatternWith2Digits === mask && inferredFormatPatternWith1Digits === mask;
    !isMaskValid && utils.lib;
    return isMaskValid;
}
const $70fa46d9a9bcc3a4$export$bd2dd9a8014709bf = (mask, acceptRegexp)=>(value)=>{
        return value.split('').map((char, i)=>{
            acceptRegexp.lastIndex = 0;
            if (i > mask.length - 1) return '';
            const maskChar = mask[i];
            const nextMaskChar = mask[i + 1];
            const acceptedChar = acceptRegexp.test(char) ? char : '';
            const formattedChar = maskChar === $70fa46d9a9bcc3a4$var$MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;
            if (i === value.length - 1 && nextMaskChar && nextMaskChar !== $70fa46d9a9bcc3a4$var$MASK_USER_INPUT_SYMBOL) // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
            return formattedChar ? formattedChar + nextMaskChar : '';
            return formattedChar;
        }).join('');
    };

});



parcelRegister("baEix", function(module, exports) {

$parcel$export(module.exports, "useIsLandscape", function () { return $821fe33d4ed73228$export$6f60b24e37af6448; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $c3NLh = parcelRequire("c3NLh");
function $821fe33d4ed73228$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $821fe33d4ed73228$export$6f60b24e37af6448(views, customOrientation) {
    const [orientation, setOrientation] = $7fPBF.useState($821fe33d4ed73228$var$getOrientation);
    (0, $lJRRs.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($821fe33d4ed73228$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $c3NLh.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
var $821fe33d4ed73228$export$2e2bcd8739ae039 = $821fe33d4ed73228$export$6f60b24e37af6448;

});


parcelRegister("2Jx0Z", function(module, exports) {

$parcel$export(module.exports, "useDateValidation", function () { return $1fd964d592d0e17b$export$23305e90c90aec3f; });

var $7fPBF = parcelRequire("7fPBF");

var $ebhFP = parcelRequire("ebhFP");

var $99YKv = parcelRequire("99YKv");

var $kmNwt = parcelRequire("kmNwt");

var $wrXWf = parcelRequire("wrXWf");
function $1fd964d592d0e17b$var$isSameDateOrTimeError(a, b) {
    return a === b;
}
function $1fd964d592d0e17b$var$isSameDateRangeError(a, b) {
    return b !== null && a[1] === b[1] && a[0] === b[0];
}
function $1fd964d592d0e17b$var$useValidation(props, validate, isSameError = $1fd964d592d0e17b$var$isSameDateOrTimeError) {
    const { value: value, onError: onError } = props;
    const utils = (0, $ebhFP.useUtils)();
    const previousValidationErrorRef = $7fPBF.useRef(null);
    const validationError = validate(utils, value, props);
    $7fPBF.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}
function $1fd964d592d0e17b$export$6913080731fabed9(props) {
    return $1fd964d592d0e17b$var$useValidation(props, (0, $wrXWf.validateTime), $1fd964d592d0e17b$var$isSameDateOrTimeError);
}
function $1fd964d592d0e17b$export$23305e90c90aec3f(props) {
    return $1fd964d592d0e17b$var$useValidation(props, (0, $99YKv.validateDate), $1fd964d592d0e17b$var$isSameDateOrTimeError);
}
function $1fd964d592d0e17b$export$3bd0e1c3554d3506(props) {
    return $1fd964d592d0e17b$var$useValidation(props, (0, $kmNwt.validateDateTime), $1fd964d592d0e17b$var$isSameDateOrTimeError);
}
function $1fd964d592d0e17b$export$92cdad2f63a7ec1e(props) {
    return $1fd964d592d0e17b$var$useValidation(props, (0, $99YKv.validateDateRange), $1fd964d592d0e17b$var$isSameDateRangeError);
}

});
parcelRegister("kmNwt", function(module, exports) {

$parcel$export(module.exports, "validateDateTime", function () { return $ed3c46efa3ecfef1$export$ed94a8ff1f54c4f; });

var $cFLic = parcelRequire("cFLic");

var $99YKv = parcelRequire("99YKv");

var $wrXWf = parcelRequire("wrXWf");
const $ed3c46efa3ecfef1$var$_excluded = [
    "minDate",
    "maxDate",
    "disableFuture",
    "shouldDisableDate",
    "disablePast"
];
function $ed3c46efa3ecfef1$export$ed94a8ff1f54c4f(utils, value, _ref) {
    let { minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, shouldDisableDate: shouldDisableDate, disablePast: disablePast } = _ref, timeValidationProps = (0, $cFLic.default)(_ref, $ed3c46efa3ecfef1$var$_excluded);
    const dateValidationResult = (0, $99YKv.validateDate)(utils, value, {
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $wrXWf.validateTime)(utils, value, timeValidationProps);
}

});


parcelRegister("1PhMQ", function(module, exports) {

$parcel$export(module.exports, "usePickerState", function () { return $154859f7b1117100$export$68b76ad63c1c3f8f; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $V5NmB = parcelRequire("V5NmB");

var $ebhFP = parcelRequire("ebhFP");
function $154859f7b1117100$export$68b76ad63c1c3f8f(props, valueManager) {
    const { disableCloseOnSelect: disableCloseOnSelect, onAccept: onAccept, onChange: onChange, value: value } = props;
    const utils = (0, $ebhFP.useUtils)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $V5NmB.useOpenState)(props);
    function initDraftableDate(date) {
        return {
            committed: date,
            draft: date
        };
    }
    const parsedDateValue = valueManager.parseInput(utils, value);
    const [draftState, dispatch] = $7fPBF.useReducer((state, action)=>{
        switch(action.type){
            case 'reset':
                return initDraftableDate(action.payload);
            case 'update':
                return (0, $kY3Ke.default)({}, state, {
                    draft: action.payload
                });
            default:
                return state;
        }
    }, parsedDateValue, initDraftableDate);
    if (!valueManager.areValuesEqual(utils, draftState.committed, parsedDateValue)) dispatch({
        type: 'reset',
        payload: parsedDateValue
    });
    const [initialDate, setInitialDate] = $7fPBF.useState(draftState.committed); // Mobile keyboard view is a special case.
    // When it's open picker should work like closed, cause we are just showing text field
    const [isMobileKeyboardViewOpen, setMobileKeyboardViewOpen] = $7fPBF.useState(false);
    const acceptDate = $7fPBF.useCallback((acceptedDate, needClosePicker)=>{
        onChange(acceptedDate);
        if (needClosePicker) {
            setIsOpen(false);
            setInitialDate(acceptedDate);
            if (onAccept) onAccept(acceptedDate);
        }
    }, [
        onAccept,
        onChange,
        setIsOpen
    ]);
    const wrapperProps = $7fPBF.useMemo(()=>({
            open: isOpen,
            onClear: ()=>acceptDate(valueManager.emptyValue, true),
            onAccept: ()=>acceptDate(draftState.draft, true),
            onDismiss: ()=>acceptDate(initialDate, true),
            onSetToday: ()=>{
                const now = utils.date();
                dispatch({
                    type: 'update',
                    payload: now
                });
                acceptDate(now, !disableCloseOnSelect);
            }
        }), [
        acceptDate,
        disableCloseOnSelect,
        isOpen,
        utils,
        draftState.draft,
        valueManager.emptyValue,
        initialDate
    ]);
    const pickerProps = $7fPBF.useMemo(()=>({
            date: draftState.draft,
            isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
            toggleMobileKeyboardView: ()=>setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen),
            onDateChange: (newDate, wrapperVariant, selectionState = 'partial')=>{
                dispatch({
                    type: 'update',
                    payload: newDate
                });
                if (selectionState === 'partial') acceptDate(newDate, false);
                if (selectionState === 'finish') {
                    const shouldCloseOnSelect = !(disableCloseOnSelect != null ? disableCloseOnSelect : wrapperVariant === 'mobile');
                    acceptDate(newDate, shouldCloseOnSelect);
                } // if selectionState === "shallow" do nothing (we already update the draft state)
            }
        }), [
        acceptDate,
        disableCloseOnSelect,
        isMobileKeyboardViewOpen,
        draftState.draft
    ]);
    const inputProps = $7fPBF.useMemo(()=>({
            onChange: onChange,
            open: isOpen,
            rawValue: value,
            openPicker: ()=>setIsOpen(true)
        }), [
        onChange,
        isOpen,
        value,
        setIsOpen
    ]);
    const pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    $7fPBF.useDebugValue(pickerState, ()=>({
            MuiPickerState: {
                pickerDraft: draftState,
                other: pickerState
            }
        }));
    return pickerState;
}

});
parcelRegister("V5NmB", function(module, exports) {

$parcel$export(module.exports, "useOpenState", function () { return $0ab9d1ca158f930b$export$7d3a09d5141ab1f4; });

var $7fPBF = parcelRequire("7fPBF");
function $0ab9d1ca158f930b$export$7d3a09d5141ab1f4({ open: open, onOpen: onOpen, onClose: onClose }) {
    const isControllingOpenProp = $7fPBF.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $7fPBF.useState(false); // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $7fPBF.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $7fPBF.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
}
var $0ab9d1ca158f930b$export$2e2bcd8739ae039 = $0ab9d1ca158f930b$export$7d3a09d5141ab1f4;

});



parcelRegister("dMpT3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a083d6aaf46a355d$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $9tuGI = parcelRequire("9tuGI");

var $6kuGy = parcelRequire("6kuGy");

var $bqzFH = parcelRequire("bqzFH");

var $a4Xf8 = parcelRequire("a4Xf8");

var $2Jx0Z = parcelRequire("2Jx0Z");

var $99YKv = parcelRequire("99YKv");

var $dL8nw = parcelRequire("dL8nw");

var $1PhMQ = parcelRequire("1PhMQ");

var $bbzbN = parcelRequire("bbzbN");
const $a083d6aaf46a355d$var$_excluded = [
    "ToolbarComponent",
    "value",
    "onChange"
];
const $a083d6aaf46a355d$var$valueManager = {
    emptyValue: null,
    parseInput: (0, $99YKv.parsePickerInputValue),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b)
};
/**
 *
 * Demos:
 *
 * - [Date Picker](https://mui.com/components/date-picker/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/api/mobile-date-picker/)
 */ const $a083d6aaf46a355d$var$MobileDatePicker = /*#__PURE__*/ $7fPBF.forwardRef(function MobileDatePicker(inProps, ref) {
    // TODO: TDate needs to be instantiated at every usage.
    const props = (0, $9tuGI.useDatePickerDefaultizedProps)(inProps, 'MuiMobileDatePicker');
    const validationError = (0, $2Jx0Z.useDateValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $1PhMQ.usePickerState)(props, $a083d6aaf46a355d$var$valueManager); // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.
    const { ToolbarComponent: ToolbarComponent = (0, $6kuGy.default) } = props, other = (0, $cFLic.default)(props, $a083d6aaf46a355d$var$_excluded);
    const DateInputProps = (0, $kY3Ke.default)({}, inputProps, other, {
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bqzFH.default), (0, $kY3Ke.default)({}, other, wrapperProps, {
        DateInputProps: DateInputProps,
        PureDateInputComponent: (0, $dL8nw.PureDateInput),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a4Xf8.default), (0, $kY3Ke.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps
        }, other))
    }));
});
var $a083d6aaf46a355d$export$2e2bcd8739ae039 = $a083d6aaf46a355d$var$MobileDatePicker;

});
parcelRegister("bqzFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $851dcb097f317b64$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");

var $jGysp = parcelRequire("jGysp");

var $7XS2E = parcelRequire("7XS2E");

var $bbzbN = parcelRequire("bbzbN");
const $851dcb097f317b64$var$_excluded = [
    "cancelText",
    "children",
    "clearable",
    "clearText",
    "DateInputProps",
    "DialogProps",
    "okText",
    "onAccept",
    "onClear",
    "onDismiss",
    "onSetToday",
    "open",
    "PureDateInputComponent",
    "showTodayButton",
    "todayText"
];
function $851dcb097f317b64$var$MobileWrapper(props) {
    const { cancelText: cancelText, children: children, clearable: clearable, clearText: clearText, DateInputProps: DateInputProps, DialogProps: DialogProps, okText: okText, onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onSetToday: onSetToday, open: open, PureDateInputComponent: PureDateInputComponent, showTodayButton: showTodayButton, todayText: todayText } = props, other = (0, $cFLic.default)(props, $851dcb097f317b64$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jGysp.WrapperVariantContext).Provider, {
        value: "mobile",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)(PureDateInputComponent, (0, $kY3Ke.default)({}, other, DateInputProps)),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7XS2E.default), {
                cancelText: cancelText,
                clearable: clearable,
                clearText: clearText,
                DialogProps: DialogProps,
                okText: okText,
                onAccept: onAccept,
                onClear: onClear,
                onDismiss: onDismiss,
                onSetToday: onSetToday,
                open: open,
                showTodayButton: showTodayButton,
                todayText: todayText,
                children: children
            })
        ]
    });
}
var $851dcb097f317b64$export$2e2bcd8739ae039 = $851dcb097f317b64$var$MobileWrapper;

});
parcelRegister("7XS2E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cc7f6a7352336c5$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $5ZeKC = parcelRequire("5ZeKC");

var $8smOS = parcelRequire("8smOS");

var $8wwTv = parcelRequire("8wwTv");

var $aUdfW = parcelRequire("aUdfW");
var $bqHow = parcelRequire("bqHow");

var $kDBhE = parcelRequire("kDBhE");

var $hZUAF = parcelRequire("hZUAF");

var $bbzbN = parcelRequire("bbzbN");
const $5cc7f6a7352336c5$var$PickersModalDialogRoot = (0, $kDBhE.default)((0, $aUdfW.default))({
    [`& .${(0, $bqHow.default).container}`]: {
        outline: 0
    },
    [`& .${(0, $bqHow.default).paper}`]: {
        outline: 0,
        minWidth: (0, $hZUAF.DIALOG_WIDTH)
    }
});
const $5cc7f6a7352336c5$var$PickersModalDialogContent = (0, $kDBhE.default)((0, $8wwTv.default))({
    '&:first-of-type': {
        padding: 0
    }
});
const $5cc7f6a7352336c5$var$PickersModalDialogActions = (0, $kDBhE.default)((0, $8smOS.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, (ownerState.clearable || ownerState.showTodayButton) && {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/mui/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-of-type': {
            marginRight: 'auto'
        }
    }));
const $5cc7f6a7352336c5$var$PickersModalDialog = (props)=>{
    const { cancelText: cancelText = 'Cancel', children: children, clearable: clearable = false, clearText: clearText = 'Clear', DialogProps: DialogProps = {}, okText: okText = 'OK', onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onSetToday: onSetToday, open: open, showTodayButton: showTodayButton = false, todayText: todayText = 'Today' } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($5cc7f6a7352336c5$var$PickersModalDialogRoot, (0, $kY3Ke.default)({
        open: open,
        onClose: onDismiss
    }, DialogProps, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($5cc7f6a7352336c5$var$PickersModalDialogContent, {
                children: children
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)($5cc7f6a7352336c5$var$PickersModalDialogActions, {
                ownerState: ownerState,
                children: [
                    clearable && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                        onClick: onClear,
                        children: clearText
                    }),
                    showTodayButton && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                        onClick: onSetToday,
                        children: todayText
                    }),
                    cancelText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                        onClick: onDismiss,
                        children: cancelText
                    }),
                    okText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                        onClick: onAccept,
                        children: okText
                    })
                ]
            })
        ]
    }));
};
var $5cc7f6a7352336c5$export$2e2bcd8739ae039 = $5cc7f6a7352336c5$var$PickersModalDialog;

});


parcelRegister("dL8nw", function(module, exports) {

$parcel$export(module.exports, "PureDateInput", function () { return $a04629e91b23c960$export$b6fcc7785a24bca1; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $c3NLh = parcelRequire("c3NLh");

var $ebhFP = parcelRequire("ebhFP");

var $9Hnow = parcelRequire("9Hnow");
const $a04629e91b23c960$export$b6fcc7785a24bca1 = /*#__PURE__*/ $7fPBF.forwardRef(function PureDateInput(props, ref) {
    const { disabled: disabled, getOpenDialogAriaText: getOpenDialogAriaText = (0, $9Hnow.getTextFieldAriaText), inputFormat: inputFormat, InputProps: InputProps, inputRef: inputRef, label: label, openPicker: onOpen, rawValue: rawValue, renderInput: renderInput, TextFieldProps: TextFieldProps = {}, validationError: validationError } = props;
    const utils = (0, $ebhFP.useUtils)();
    const PureDateInputProps = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, InputProps, {
            readOnly: true
        }), [
        InputProps
    ]);
    const inputValue = (0, $9Hnow.getDisplayDate)(utils, rawValue, inputFormat);
    return renderInput((0, $kY3Ke.default)({
        label: label,
        disabled: disabled,
        ref: ref,
        inputRef: inputRef,
        error: validationError,
        InputProps: PureDateInputProps,
        inputProps: (0, $kY3Ke.default)({
            disabled: disabled,
            readOnly: true,
            'aria-readonly': true,
            'aria-label': getOpenDialogAriaText(rawValue, utils),
            value: inputValue
        }, !props.readOnly && {
            onClick: onOpen
        }, {
            onKeyDown: (0, $c3NLh.onSpaceOrEnter)(onOpen)
        })
    }, TextFieldProps));
});
$a04629e91b23c960$export$b6fcc7785a24bca1.propTypes = {
    getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};

});



parcelRegister("9l0yE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c12320f703b693$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6qwOn = parcelRequire("6qwOn");

var $kDBhE = parcelRequire("kDBhE");

var $3jMGu = parcelRequire("3jMGu");

var $58CWL = parcelRequire("58CWL");
var $jh0sD = parcelRequire("jh0sD");

var $aqd0z = parcelRequire("aqd0z");
const $01c12320f703b693$var$ModifiedFormControl = (0, $kDBhE.default)((0, $3jMGu.default))(()=>({
        margin: "10px",
        padding: "0 8px",
        border: `1px solid ${0, $aqd0z.BORDER_GREY}`,
        borderRadius: (0, $aqd0z.BUTTON_BORDER_RADIUS),
        backgroundColor: (0, $aqd0z.WHITE),
        minWidth: 120
    }));
const $01c12320f703b693$var$handleChange = (handleDateChange, calculatedFromDate, calculatedToDate)=>{
    handleDateChange({
        target: {
            name: "time-period",
            fromDate: calculatedFromDate,
            toDate: calculatedToDate
        }
    });
};
function $01c12320f703b693$export$2e2bcd8739ae039({ setDateFilterUsed: setDateFilterUsed, isDateFilterUsed: isDateFilterUsed, setCustomPeriod: setCustomPeriod, handleDateChange: handleDateChange, setDisplayDates: setDisplayDates }) {
    const [dateDropdown, setDateDropdown] = (0, $7fPBF.useState)("last-calender-year");
    const handleDateDropDownChange = (event)=>{
        setDisplayDates(()=>({
                startDate: null,
                endDate: null
            }));
        const currentDate = new Date();
        const fieldValue = event.target.value;
        setCustomPeriod(fieldValue);
        if (fieldValue === "this-month") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).startOf("month").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        } else if (fieldValue === "last-month") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "months").startOf("month").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "months").endOf("month").format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        } else if (fieldValue === "last-3-months") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(3, "months").startOf("month").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "months").endOf("month").format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        } else if (fieldValue === "year-to-last-month") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(0, "year").startOf("year").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "months").endOf("month").format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        } else if (fieldValue === "last-12-months") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(12, "months").startOf("month").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "months").endOf("month").format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        } else if (fieldValue === "last-calender-year") {
            const calculatedFromDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "year").startOf("year").format("YYYY-MM-DD");
            const calculatedToDate = (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(currentDate).subtract(1, "year").endOf("year").format("YYYY-MM-DD");
            $01c12320f703b693$var$handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
        }
        setDateDropdown(fieldValue);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (dateDropdown !== "custom-date") {
            setDateFilterUsed(false);
            handleDateDropDownChange({
                target: {
                    value: "custom-date"
                }
            });
        }
    }, [
        isDateFilterUsed
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($01c12320f703b693$var$ModifiedFormControl, {
        variant: "standard",
        size: "small",
        sx: {
            display: "flex",
            justifyContent: "center",
            m: 1,
            width: 100,
            height: "90%"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jh0sD.default), {
            id: "dateDropdown",
            name: "dateDropdown",
            value: dateDropdown,
            onChange: handleDateDropDownChange,
            disableUnderline: true,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    disabled: true,
                    default: true,
                    value: "custom-date",
                    children: "Custom Date"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "this-month",
                    children: "This Month"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "last-month",
                    children: "Last Month"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "last-3-months",
                    children: "Last 3 Months"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "year-to-last-month",
                    children: "Year to Last Month"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "last-12-months",
                    children: "Last 12 Months"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                    value: "last-calender-year",
                    children: "Last Calender Year"
                })
            ]
        })
    });
} //by default 12 months data here
 // import React, { useEffect, useState } from "react";
 // import moment from "moment";
 // import { styled } from "@mui/material/styles";
 // import FormControl from "@mui/material/FormControl";
 // import { MenuItem, Select } from "@mui/material";
 // import { BORDER_GREY, BUTTON_BORDER_RADIUS, WHITE } from "~src/data/constant";
 // const ModifiedFormControl = styled(FormControl)(() => ({
 //   margin: "10px",
 //   padding: "0 8px",
 //   border: `1px solid ${BORDER_GREY}`,
 //   borderRadius: BUTTON_BORDER_RADIUS,
 //   backgroundColor: WHITE,
 //   minWidth: 120,
 // }));
 // const handleChange = (
 //   handleDateChange,
 //   calculatedFromDate,
 //   calculatedToDate
 // ) => {
 //   handleDateChange({
 //     target: {
 //       name: "time-period",
 //       fromDate: calculatedFromDate,
 //       toDate: calculatedToDate,
 //     },
 //   });
 // };
 // export default function CustomDatesContainer({
 //   setDateFilterUsed,
 //   isDateFilterUsed,
 //   setCustomPeriod,
 //   handleDateChange,
 //   setDisplayDates,
 // }) {
 //   const [dateDropdown, setDateDropdown] = useState("last-12-months");
 //   const handleDateDropDownChange = (event) => {
 //     setDisplayDates(() => ({
 //       startDate: null,
 //       endDate: null,
 //     }));
 //     const currentDate = new Date();
 //     const fieldValue = event.target.value;
 //     setCustomPeriod(fieldValue);
 //     if (fieldValue === "this-month") {
 //       const calculatedFromDate = moment(currentDate)
 //         .startOf("month")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate).format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     } else if (fieldValue === "last-month") {
 //       const calculatedFromDate = moment(currentDate)
 //         .subtract(1, "months")
 //         .startOf("month")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate)
 //         .subtract(1, "months")
 //         .endOf("month")
 //         .format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     } else if (fieldValue === "last-3-months") {
 //       const calculatedFromDate = moment(currentDate)
 //         .subtract(3, "months")
 //         .startOf("month")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate)
 //         .subtract(1, "months")
 //         .endOf("month")
 //         .format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     } else if (fieldValue === "year-to-last-month") {
 //       const calculatedFromDate = moment(currentDate)
 //         .subtract(0, "year")
 //         .startOf("year")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate)
 //         .subtract(1, "months")
 //         .endOf("month")
 //         .format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     } else if (fieldValue === "last-12-months") {
 //       const calculatedFromDate = moment(currentDate)
 //         .subtract(12, "months")
 //         .startOf("month")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate)
 //         .subtract(1, "months")
 //         .endOf("month")
 //         .format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     } else if (fieldValue === "last-calender-year") {
 //       const calculatedFromDate = moment(currentDate)
 //         .subtract(1, "year")
 //         .startOf("year")
 //         .format("YYYY-MM-DD");
 //       const calculatedToDate = moment(currentDate)
 //         .subtract(1, "year")
 //         .endOf("year")
 //         .format("YYYY-MM-DD");
 //       handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //     }
 //     setDateDropdown(fieldValue);
 //   };
 //   useEffect(() => {
 //     if (dateDropdown !== "custom-date") {
 //       setDateFilterUsed(false);
 //       handleDateDropDownChange({ target: { value: "custom-date" } });
 //     }
 //   }, [isDateFilterUsed]);
 //   // Set the default selection to "last-12-months" on initial load
 //   useEffect(() => {
 //     const currentDate = new Date();
 //     const calculatedFromDate = moment(currentDate)
 //       .subtract(12, "months")
 //       .startOf("month")
 //       .format("YYYY-MM-DD");
 //     const calculatedToDate = moment(currentDate)
 //       .subtract(1, "months")
 //       .endOf("month")
 //       .format("YYYY-MM-DD");
 //     handleChange(handleDateChange, calculatedFromDate, calculatedToDate);
 //   }, []);
 //   return (
 //     <ModifiedFormControl
 //       variant="standard"
 //       size="small"
 //       sx={{
 //         display: "flex",
 //         justifyContent: "center",
 //         m: 1,
 //         width: 100,
 //         height: "90%",
 //       }}
 //     >
 //       <Select
 //         id="dateDropdown"
 //         name="dateDropdown"
 //         value={dateDropdown}
 //         onChange={handleDateDropDownChange}
 //         disableUnderline
 //       >
 //         <MenuItem disabled default value="custom-date">
 //           Custom Date
 //         </MenuItem>
 //         <MenuItem value="this-month">This Month</MenuItem>
 //         <MenuItem value="last-month">Last Month</MenuItem>
 //         <MenuItem value="last-3-months">Last 3 Months</MenuItem>
 //         <MenuItem value="year-to-last-month">Year to Last Month</MenuItem>
 //         <MenuItem value="last-12-months">Last 12 Months</MenuItem>
 //         <MenuItem value="last-calender-year">Last Calender Year</MenuItem>
 //       </Select>
 //     </ModifiedFormControl>
 //   );
 // }

});
parcelRegister("6qwOn", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});



parcelRegister("bjG5Z", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d21f62d7ce0c79$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $83d21f62d7ce0c79$var$_default = module.exports.default = (0, $83d21f62d7ce0c79$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');

});

parcelRegister("exavO", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a94c4d3b84a30d2f$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $a94c4d3b84a30d2f$var$_default = module.exports.default = (0, $a94c4d3b84a30d2f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

});


parcelRegister("6mEEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a24563b2da55e17$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $inqfx = parcelRequire("inqfx");
parcelRequire("iLOu9");


var $535LO = parcelRequire("535LO");
var $54b5b = parcelRequire("54b5b");
var $fsprv = parcelRequire("fsprv");
var $aAzxA = parcelRequire("aAzxA");

var $kzScq = parcelRequire("kzScq");

var $gsokU = parcelRequire("gsokU");

var $5nUae = parcelRequire("5nUae");

var $4eU7y = parcelRequire("4eU7y");
let $4a24563b2da55e17$var$_ = (t)=>t, $4a24563b2da55e17$var$t;
const $4a24563b2da55e17$var$placeIcon = new $inqfx.Icon({
    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kzScq))),
    iconSize: [
        45,
        45
    ],
    iconAnchor: [
        16,
        32
    ]
});
const $4a24563b2da55e17$var$MapVisualization = ({ mapRef: mapRef })=>{
    const useStyles = (0, $4eU7y.default)({
        root: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "20px"
        }
    });
    const override = (0, $5nUae.css)($4a24563b2da55e17$var$t || ($4a24563b2da55e17$var$t = $4a24563b2da55e17$var$_`
    display: block;
    margin: auto;
  `));
    const classes = useStyles();
    const mapContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const geoData = [
        {
            latitude: 25.2048,
            longitude: 55.2708,
            name: "Dubai",
            Analysis: "40,000",
            prediction: "43,000"
        },
        {
            latitude: 25.8007,
            longitude: 55.9762,
            name: "Ras Al-Khaimah",
            Analysis: "41,000",
            prediction: "49,000"
        },
        {
            latitude: 24.7136,
            longitude: 46.6753,
            name: "Riyadh",
            Analysis: "41,000",
            prediction: "49,000"
        },
        {
            latitude: 23.8859,
            longitude: 45.0792,
            name: "Saudi Arabia",
            Analysis: "40,000",
            prediction: "41,000"
        }
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (mapRef.current) {
            const map = mapRef.current.leafletElement;
            // Update map container size on drag
            map.on("drag", ()=>{
                mapContainerRef.current.style.height = "100%";
                mapContainerRef.current.style.width = "100%";
                map.invalidateSize();
            });
        }
    }, [
        mapRef
    ]);
    const handleMarkerClick = (e)=>{
        var _mapRef_current;
        const popup = $inqfx.popup({
            closeOnClick: false
        }).setContent(e.target.options.name);
        popup.setLatLng(e.latlng).openOn((_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.leafletElement);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gsokU.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    className: "text-xl",
                    children: "Emirates Claim Trends"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "chart-box h-80",
                    style: {
                        marginBottom: "10px",
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        ref: mapContainerRef,
                        style: {
                            height: "100%",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $535LO.MapContainer), {
                            center: [
                                25.2048,
                                55.97
                            ],
                            zoom: 8,
                            ref: mapRef,
                            style: {
                                height: "100%",
                                width: "100%"
                            },
                            scrollWheelZoom: false,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aAzxA.TileLayer), {
                                    url: "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
                                    maxZoom: 20,
                                    subdomains: [
                                        "mt0",
                                        "mt1",
                                        "mt2",
                                        "mt3"
                                    ],
                                    detectRetina: true,
                                    attribution: "\xa9 Google Maps"
                                }),
                                geoData.map((location)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $54b5b.Marker), {
                                        position: [
                                            location.latitude,
                                            location.longitude
                                        ],
                                        onClick: handleMarkerClick,
                                        icon: $4a24563b2da55e17$var$placeIcon,
                                        riseOnHover: true,
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fsprv.Popup), {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("ul", {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("li", {
                                                    children: [
                                                        `Emirates: ${location.name}`,
                                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("li", {
                                                                    children: [
                                                                        "Predicted Claims:",
                                                                        location.Analysis
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("li", {
                                                                    children: [
                                                                        "Predicted Amounts:",
                                                                        location.prediction
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, location.latitude))
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $4a24563b2da55e17$export$2e2bcd8739ae039 = $4a24563b2da55e17$var$MapVisualization;

});
parcelRegister("inqfx", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("iLOu9", function(module, exports) {

(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        'leaflet'
    ], factory);
    else if (typeof modules === 'object' && module.exports) // define a Common JS module that relies on 'leaflet'
    module.exports = factory((parcelRequire("inqfx")));
    else // Assume Leaflet is loaded into global object L already
    factory(L);
})(module.exports, function(L1) {
    'use strict';
    L1.TileLayer.Provider = L1.TileLayer.extend({
        initialize: function(arg, options) {
            var providers = L1.TileLayer.Provider.providers;
            var parts = arg.split('.');
            var providerName = parts[0];
            var variantName = parts[1];
            if (!providers[providerName]) throw 'No such provider (' + providerName + ')';
            var provider = {
                url: providers[providerName].url,
                options: providers[providerName].options
            };
            // overwrite values in provider from variant.
            if (variantName && 'variants' in providers[providerName]) {
                if (!(variantName in providers[providerName].variants)) throw 'No such variant of ' + providerName + ' (' + variantName + ')';
                var variant = providers[providerName].variants[variantName];
                var variantOptions;
                if (typeof variant === 'string') variantOptions = {
                    variant: variant
                };
                else variantOptions = variant.options;
                provider = {
                    url: variant.url || provider.url,
                    options: L1.Util.extend({}, provider.options, variantOptions)
                };
            }
            // replace attribution placeholders with their values from toplevel provider attribution,
            // recursively
            var attributionReplacer = function(attr) {
                if (attr.indexOf('{attribution.') === -1) return attr;
                return attr.replace(/\{attribution.(\w*)\}/g, function(match, attributionName) {
                    return attributionReplacer(providers[attributionName].options.attribution);
                });
            };
            provider.options.attribution = attributionReplacer(provider.options.attribution);
            // Compute final options combining provider options with any user overrides
            var layerOpts = L1.Util.extend({}, provider.options, options);
            L1.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
        }
    });
    /**
	 * Definition of providers.
	 * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
	 */ L1.TileLayer.Provider.providers = {
        OpenStreetMap: {
            url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            },
            variants: {
                Mapnik: {},
                DE: {
                    url: 'https://tile.openstreetmap.de/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 18
                    }
                },
                CH: {
                    url: 'https://tile.osm.ch/switzerland/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 18,
                        bounds: [
                            [
                                45,
                                5
                            ],
                            [
                                48,
                                11
                            ]
                        ]
                    }
                },
                France: {
                    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
                    options: {
                        maxZoom: 20,
                        attribution: '&copy; OpenStreetMap France | {attribution.OpenStreetMap}'
                    }
                },
                HOT: {
                    url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
                    options: {
                        attribution: '{attribution.OpenStreetMap}, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
                    }
                },
                BZH: {
                    url: 'https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png',
                    options: {
                        attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
                        bounds: [
                            [
                                46.2,
                                -5.5
                            ],
                            [
                                50,
                                0.7
                            ]
                        ]
                    }
                }
            }
        },
        MapTilesAPI: {
            url: 'https://maptiles.p.rapidapi.com/{variant}/{z}/{x}/{y}.png?rapidapi-key={apikey}',
            options: {
                attribution: '&copy; <a href="http://www.maptilesapi.com/">MapTiles API</a>, {attribution.OpenStreetMap}',
                variant: 'en/map/v1',
                // Get your own MapTiles API access token here : https://www.maptilesapi.com/
                // NB : this is a demonstration key that comes with no guarantee and not to be used in production
                apikey: '<insert your api key here>',
                maxZoom: 19
            },
            variants: {
                OSMEnglish: {
                    options: {
                        variant: 'en/map/v1'
                    }
                },
                OSMFrancais: {
                    options: {
                        variant: 'fr/map/v1'
                    }
                },
                OSMEspagnol: {
                    options: {
                        variant: 'es/map/v1'
                    }
                }
            }
        },
        OpenSeaMap: {
            url: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
            options: {
                attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
            }
        },
        OPNVKarte: {
            url: 'https://tileserver.memomaps.de/tilegen/{z}/{x}/{y}.png',
            options: {
                maxZoom: 18,
                attribution: 'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data {attribution.OpenStreetMap}'
            }
        },
        OpenTopoMap: {
            url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 17,
                attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenRailwayMap: {
            url: 'https://{s}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://www.OpenRailwayMap.org">OpenRailwayMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenFireMap: {
            url: 'http://openfiremap.org/hytiles/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="http://www.openfiremap.org">OpenFireMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        SafeCast: {
            url: 'https://s3.amazonaws.com/te512.safecast.org/{z}/{x}/{y}.png',
            options: {
                maxZoom: 16,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://blog.safecast.org/about/">SafeCast</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        Stadia: {
            url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}{r}.{ext}',
            options: {
                minZoom: 0,
                maxZoom: 20,
                attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                variant: 'alidade_smooth',
                ext: 'png'
            },
            variants: {
                AlidadeSmooth: 'alidade_smooth',
                AlidadeSmoothDark: 'alidade_smooth_dark',
                OSMBright: 'osm_bright',
                Outdoors: 'outdoors',
                StamenToner: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_toner'
                    }
                },
                StamenTonerBackground: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_toner_background'
                    }
                },
                StamenTonerLines: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_toner_lines'
                    }
                },
                StamenTonerLabels: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_toner_labels'
                    }
                },
                StamenTonerLite: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_toner_lite'
                    }
                },
                StamenWatercolor: {
                    url: 'https://tiles.stadiamaps.com/tiles/{variant}/{z}/{x}/{y}.{ext}',
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_watercolor',
                        ext: 'jpg',
                        minZoom: 1,
                        maxZoom: 16
                    }
                },
                StamenTerrain: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_terrain',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainBackground: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_background',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainLabels: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_labels',
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                StamenTerrainLines: {
                    options: {
                        attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> {attribution.OpenStreetMap}',
                        variant: 'stamen_terrain_lines',
                        minZoom: 0,
                        maxZoom: 18
                    }
                }
            }
        },
        Thunderforest: {
            url: 'https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
            options: {
                attribution: '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
                variant: 'cycle',
                apikey: '<insert your api key here>',
                maxZoom: 22
            },
            variants: {
                OpenCycleMap: 'cycle',
                Transport: {
                    options: {
                        variant: 'transport'
                    }
                },
                TransportDark: {
                    options: {
                        variant: 'transport-dark'
                    }
                },
                SpinalMap: {
                    options: {
                        variant: 'spinal-map'
                    }
                },
                Landscape: 'landscape',
                Outdoors: 'outdoors',
                Pioneer: 'pioneer',
                MobileAtlas: 'mobile-atlas',
                Neighbourhood: 'neighbourhood'
            }
        },
        CyclOSM: {
            url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
            options: {
                maxZoom: 20,
                attribution: '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: {attribution.OpenStreetMap}'
            }
        },
        Jawg: {
            url: 'https://{s}.tile.jawg.io/{variant}/{z}/{x}/{y}{r}.png?access-token={accessToken}',
            options: {
                attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> {attribution.OpenStreetMap}',
                minZoom: 0,
                maxZoom: 22,
                subdomains: 'abcd',
                variant: 'jawg-terrain',
                // Get your own Jawg access token here : https://www.jawg.io/lab/
                // NB : this is a demonstration key that comes with no guarantee
                accessToken: '<insert your access token here>'
            },
            variants: {
                Streets: 'jawg-streets',
                Terrain: 'jawg-terrain',
                Sunny: 'jawg-sunny',
                Dark: 'jawg-dark',
                Light: 'jawg-light',
                Matrix: 'jawg-matrix'
            }
        },
        MapBox: {
            url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}',
            options: {
                attribution: '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> {attribution.OpenStreetMap} <a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
                tileSize: 512,
                maxZoom: 18,
                zoomOffset: -1,
                id: 'mapbox/streets-v11',
                accessToken: '<insert your access token here>'
            }
        },
        MapTiler: {
            url: 'https://api.maptiler.com/maps/{variant}/{z}/{x}/{y}{r}.{ext}?key={key}',
            options: {
                attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
                variant: 'streets',
                ext: 'png',
                key: '<insert your MapTiler Cloud API key here>',
                tileSize: 512,
                zoomOffset: -1,
                minZoom: 0,
                maxZoom: 21
            },
            variants: {
                Streets: 'streets',
                Basic: 'basic',
                Bright: 'bright',
                Pastel: 'pastel',
                Positron: 'positron',
                Hybrid: {
                    options: {
                        variant: 'hybrid',
                        ext: 'jpg'
                    }
                },
                Toner: 'toner',
                Topo: 'topo',
                Voyager: 'voyager'
            }
        },
        TomTom: {
            url: 'https://{s}.api.tomtom.com/map/1/tile/{variant}/{style}/{z}/{x}/{y}.{ext}?key={apikey}',
            options: {
                variant: 'basic',
                maxZoom: 22,
                attribution: '<a href="https://tomtom.com" target="_blank">&copy;  1992 - ' + new Date().getFullYear() + ' TomTom.</a> ',
                subdomains: 'abcd',
                style: 'main',
                ext: 'png',
                apikey: '<insert your API key here>'
            },
            variants: {
                Basic: 'basic',
                Hybrid: 'hybrid',
                Labels: 'labels'
            }
        },
        Esri: {
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
            options: {
                variant: 'World_Street_Map',
                attribution: 'Tiles &copy; Esri'
            },
            variants: {
                WorldStreetMap: {
                    options: {
                        attribution: "{attribution.Esri} &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
                    }
                },
                DeLorme: {
                    options: {
                        variant: 'Specialty/DeLorme_World_Base_Map',
                        minZoom: 1,
                        maxZoom: 11,
                        attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
                    }
                },
                WorldTopoMap: {
                    options: {
                        variant: 'World_Topo_Map',
                        attribution: "{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community"
                    }
                },
                WorldImagery: {
                    options: {
                        variant: 'World_Imagery',
                        attribution: "{attribution.Esri} &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
                    }
                },
                WorldTerrain: {
                    options: {
                        variant: 'World_Terrain_Base',
                        maxZoom: 13,
                        attribution: "{attribution.Esri} &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS"
                    }
                },
                WorldShadedRelief: {
                    options: {
                        variant: 'World_Shaded_Relief',
                        maxZoom: 13,
                        attribution: '{attribution.Esri} &mdash; Source: Esri'
                    }
                },
                WorldPhysical: {
                    options: {
                        variant: 'World_Physical_Map',
                        maxZoom: 8,
                        attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
                    }
                },
                OceanBasemap: {
                    options: {
                        variant: 'Ocean/World_Ocean_Base',
                        maxZoom: 13,
                        attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
                    }
                },
                NatGeoWorldMap: {
                    options: {
                        variant: 'NatGeo_World_Map',
                        maxZoom: 16,
                        attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
                    }
                },
                WorldGrayCanvas: {
                    options: {
                        variant: 'Canvas/World_Light_Gray_Base',
                        maxZoom: 16,
                        attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
                    }
                }
            }
        },
        OpenWeatherMap: {
            url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}',
            options: {
                maxZoom: 19,
                attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
                apiKey: '<insert your api key here>',
                opacity: 0.5
            },
            variants: {
                Clouds: 'clouds',
                CloudsClassic: 'clouds_cls',
                Precipitation: 'precipitation',
                PrecipitationClassic: 'precipitation_cls',
                Rain: 'rain',
                RainClassic: 'rain_cls',
                Pressure: 'pressure',
                PressureContour: 'pressure_cntr',
                Wind: 'wind',
                Temperature: 'temp',
                Snow: 'snow'
            }
        },
        HERE: {
            /*
			 * HERE maps, formerly Nokia maps.
			 * These basemaps are free, but you need an api id and app key. Please sign up at
			 * https://developer.here.com/plans
			 */ url: "https://{s}.{base}.maps.api.here.com/maptile/2.1/{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}",
            options: {
                attribution: 'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: '1234',
                mapID: 'newest',
                'app_id': '<insert your app_id here>',
                'app_code': '<insert your app_code here>',
                base: 'base',
                variant: 'normal.day',
                maxZoom: 20,
                type: 'maptile',
                language: 'eng',
                format: 'png8',
                size: '256'
            },
            variants: {
                normalDay: 'normal.day',
                normalDayCustom: 'normal.day.custom',
                normalDayGrey: 'normal.day.grey',
                normalDayMobile: 'normal.day.mobile',
                normalDayGreyMobile: 'normal.day.grey.mobile',
                normalDayTransit: 'normal.day.transit',
                normalDayTransitMobile: 'normal.day.transit.mobile',
                normalDayTraffic: {
                    options: {
                        variant: 'normal.traffic.day',
                        base: 'traffic',
                        type: 'traffictile'
                    }
                },
                normalNight: 'normal.night',
                normalNightMobile: 'normal.night.mobile',
                normalNightGrey: 'normal.night.grey',
                normalNightGreyMobile: 'normal.night.grey.mobile',
                normalNightTransit: 'normal.night.transit',
                normalNightTransitMobile: 'normal.night.transit.mobile',
                reducedDay: 'reduced.day',
                reducedNight: 'reduced.night',
                basicMap: {
                    options: {
                        type: 'basetile'
                    }
                },
                mapLabels: {
                    options: {
                        type: 'labeltile',
                        format: 'png'
                    }
                },
                trafficFlow: {
                    options: {
                        base: 'traffic',
                        type: 'flowtile'
                    }
                },
                carnavDayGrey: 'carnav.day.grey',
                hybridDay: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day'
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.mobile'
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.transit'
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.grey.day'
                    }
                },
                hybridDayTraffic: {
                    options: {
                        variant: 'hybrid.traffic.day',
                        base: 'traffic',
                        type: 'traffictile'
                    }
                },
                pedestrianDay: 'pedestrian.day',
                pedestrianNight: 'pedestrian.night',
                satelliteDay: {
                    options: {
                        base: 'aerial',
                        variant: 'satellite.day'
                    }
                },
                terrainDay: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day'
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day.mobile'
                    }
                }
            }
        },
        HEREv3: {
            /*
			 * HERE maps API Version 3.
			 * These basemaps are free, but you need an API key. Please sign up at
			 * https://developer.here.com/plans
			 * Version 3 deprecates the app_id and app_code access in favor of apiKey
			 *
			 * Supported access methods as of 2019/12/21:
			 * @see https://developer.here.com/faqs#access-control-1--how-do-you-control-access-to-here-location-services
			 */ url: "https://{s}.{base}.maps.ls.hereapi.com/maptile/2.1/{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?apiKey={apiKey}&lg={language}",
            options: {
                attribution: 'Map &copy; 1987-' + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: '1234',
                mapID: 'newest',
                apiKey: '<insert your apiKey here>',
                base: 'base',
                variant: 'normal.day',
                maxZoom: 20,
                type: 'maptile',
                language: 'eng',
                format: 'png8',
                size: '256'
            },
            variants: {
                normalDay: 'normal.day',
                normalDayCustom: 'normal.day.custom',
                normalDayGrey: 'normal.day.grey',
                normalDayMobile: 'normal.day.mobile',
                normalDayGreyMobile: 'normal.day.grey.mobile',
                normalDayTransit: 'normal.day.transit',
                normalDayTransitMobile: 'normal.day.transit.mobile',
                normalNight: 'normal.night',
                normalNightMobile: 'normal.night.mobile',
                normalNightGrey: 'normal.night.grey',
                normalNightGreyMobile: 'normal.night.grey.mobile',
                normalNightTransit: 'normal.night.transit',
                normalNightTransitMobile: 'normal.night.transit.mobile',
                reducedDay: 'reduced.day',
                reducedNight: 'reduced.night',
                basicMap: {
                    options: {
                        type: 'basetile'
                    }
                },
                mapLabels: {
                    options: {
                        type: 'labeltile',
                        format: 'png'
                    }
                },
                trafficFlow: {
                    options: {
                        base: 'traffic',
                        type: 'flowtile'
                    }
                },
                carnavDayGrey: 'carnav.day.grey',
                hybridDay: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day'
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.mobile'
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.day.transit'
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: 'aerial',
                        variant: 'hybrid.grey.day'
                    }
                },
                pedestrianDay: 'pedestrian.day',
                pedestrianNight: 'pedestrian.night',
                satelliteDay: {
                    options: {
                        base: 'aerial',
                        variant: 'satellite.day'
                    }
                },
                terrainDay: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day'
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: 'aerial',
                        variant: 'terrain.day.mobile'
                    }
                }
            }
        },
        FreeMapSK: {
            url: 'https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
            options: {
                minZoom: 8,
                maxZoom: 16,
                subdomains: 'abcd',
                bounds: [
                    [
                        47.204642,
                        15.996093
                    ],
                    [
                        49.830896,
                        22.576904
                    ]
                ],
                attribution: '{attribution.OpenStreetMap}, visualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
            }
        },
        MtbMap: {
            url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
            options: {
                attribution: '{attribution.OpenStreetMap} &amp; USGS'
            }
        },
        CartoDB: {
            url: 'https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png',
            options: {
                attribution: '{attribution.OpenStreetMap} &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: 'abcd',
                maxZoom: 20,
                variant: 'light_all'
            },
            variants: {
                Positron: 'light_all',
                PositronNoLabels: 'light_nolabels',
                PositronOnlyLabels: 'light_only_labels',
                DarkMatter: 'dark_all',
                DarkMatterNoLabels: 'dark_nolabels',
                DarkMatterOnlyLabels: 'dark_only_labels',
                Voyager: 'rastertiles/voyager',
                VoyagerNoLabels: 'rastertiles/voyager_nolabels',
                VoyagerOnlyLabels: 'rastertiles/voyager_only_labels',
                VoyagerLabelsUnder: 'rastertiles/voyager_labels_under'
            }
        },
        HikeBike: {
            url: 'https://tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
            options: {
                maxZoom: 19,
                attribution: '{attribution.OpenStreetMap}',
                variant: 'hikebike'
            },
            variants: {
                HikeBike: {},
                HillShading: {
                    options: {
                        maxZoom: 15,
                        variant: 'hillshading'
                    }
                }
            }
        },
        BasemapAT: {
            url: 'https://mapsneu.wien.gv.at/basemap/{variant}/{type}/google3857/{z}/{y}/{x}.{format}',
            options: {
                maxZoom: 19,
                attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
                type: 'normal',
                format: 'png',
                bounds: [
                    [
                        46.358770,
                        8.782379
                    ],
                    [
                        49.037872,
                        17.189532
                    ]
                ],
                variant: 'geolandbasemap'
            },
            variants: {
                basemap: {
                    options: {
                        maxZoom: 20,
                        variant: 'geolandbasemap'
                    }
                },
                grau: 'bmapgrau',
                overlay: 'bmapoverlay',
                terrain: {
                    options: {
                        variant: 'bmapgelaende',
                        type: 'grau',
                        format: 'jpeg'
                    }
                },
                surface: {
                    options: {
                        variant: 'bmapoberflaeche',
                        type: 'grau',
                        format: 'jpeg'
                    }
                },
                highdpi: {
                    options: {
                        variant: 'bmaphidpi',
                        format: 'jpeg'
                    }
                },
                orthofoto: {
                    options: {
                        maxZoom: 20,
                        variant: 'bmaporthofoto30cm',
                        format: 'jpeg'
                    }
                }
            }
        },
        nlmaps: {
            url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/{variant}/EPSG:3857/{z}/{x}/{y}.png',
            options: {
                minZoom: 6,
                maxZoom: 19,
                bounds: [
                    [
                        50.5,
                        3.25
                    ],
                    [
                        54,
                        7.6
                    ]
                ],
                attribution: 'Kaartgegevens &copy; <a href="https://www.kadaster.nl">Kadaster</a>'
            },
            variants: {
                'standaard': 'standaard',
                'pastel': 'pastel',
                'grijs': 'grijs',
                'water': 'water',
                'luchtfoto': {
                    'url': 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg'
                }
            }
        },
        NASAGIBS: {
            url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
            options: {
                attribution: 'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System (<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
                bounds: [
                    [
                        -85.0511287776,
                        -179.999999975
                    ],
                    [
                        85.0511287776,
                        179.999999975
                    ]
                ],
                minZoom: 1,
                maxZoom: 9,
                format: 'jpg',
                time: '',
                tilematrixset: 'GoogleMapsCompatible_Level'
            },
            variants: {
                ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
                ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
                ViirsEarthAtNight2012: {
                    options: {
                        variant: 'VIIRS_CityLights_2012',
                        maxZoom: 8
                    }
                },
                ModisTerraLSTDay: {
                    options: {
                        variant: 'MODIS_Terra_Land_Surface_Temp_Day',
                        format: 'png',
                        maxZoom: 7,
                        opacity: 0.75
                    }
                },
                ModisTerraSnowCover: {
                    options: {
                        variant: 'MODIS_Terra_NDSI_Snow_Cover',
                        format: 'png',
                        maxZoom: 8,
                        opacity: 0.75
                    }
                },
                ModisTerraAOD: {
                    options: {
                        variant: 'MODIS_Terra_Aerosol',
                        format: 'png',
                        maxZoom: 6,
                        opacity: 0.75
                    }
                },
                ModisTerraChlorophyll: {
                    options: {
                        variant: 'MODIS_Terra_Chlorophyll_A',
                        format: 'png',
                        maxZoom: 7,
                        opacity: 0.75
                    }
                }
            }
        },
        NLS: {
            // NLS maps are copyright National library of Scotland.
            // http://maps.nls.uk/projects/api/index.html
            // Please contact NLS for anything other than non-commercial low volume usage
            //
            // Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
            //   z0-9  - 1:1m
            //  z10-11 - quarter inch (1:253440)
            //  z12-18 - one inch (1:63360)
            url: 'https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
            options: {
                attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
                bounds: [
                    [
                        49.6,
                        -12
                    ],
                    [
                        61.7,
                        3
                    ]
                ],
                minZoom: 1,
                maxZoom: 18,
                subdomains: '0123'
            }
        },
        JusticeMap: {
            // Justice Map (http://www.justicemap.org/)
            // Visualize race and income data for your community, county and country.
            // Includes tools for data journalists, bloggers and community activists.
            url: 'https://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
            options: {
                attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
                // one of 'county', 'tract', 'block'
                size: 'county',
                // Bounds for USA, including Alaska and Hawaii
                bounds: [
                    [
                        14,
                        -180
                    ],
                    [
                        72,
                        -56
                    ]
                ]
            },
            variants: {
                income: 'income',
                americanIndian: 'indian',
                asian: 'asian',
                black: 'black',
                hispanic: 'hispanic',
                multi: 'multi',
                nonWhite: 'nonwhite',
                white: 'white',
                plurality: 'plural'
            }
        },
        GeoportailFrance: {
            url: 'https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER={variant}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
            options: {
                attribution: '<a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>',
                bounds: [
                    [
                        -75,
                        -180
                    ],
                    [
                        81,
                        180
                    ]
                ],
                minZoom: 2,
                maxZoom: 18,
                // Get your own geoportail apikey here : http://professionnels.ign.fr/ign/contrats/
                // NB : 'choisirgeoportail' is a demonstration key that comes with no guarantee
                apikey: 'choisirgeoportail',
                format: 'image/png',
                style: 'normal',
                variant: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
            },
            variants: {
                plan: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
                parcels: {
                    options: {
                        variant: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS',
                        style: 'PCI vecteur',
                        maxZoom: 20
                    }
                },
                orthos: {
                    options: {
                        maxZoom: 19,
                        format: 'image/jpeg',
                        variant: 'ORTHOIMAGERY.ORTHOPHOTOS'
                    }
                }
            }
        },
        OneMapSG: {
            url: 'https://maps-{s}.onemap.sg/v3/{variant}/{z}/{x}/{y}.png',
            options: {
                variant: 'Default',
                minZoom: 11,
                maxZoom: 18,
                bounds: [
                    [
                        1.56073,
                        104.11475
                    ],
                    [
                        1.16,
                        103.502
                    ]
                ],
                attribution: '<img src="https://docs.onemap.sg/maps/images/oneMap64-01.png" style="height:20px;width:20px;"/> New OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>'
            },
            variants: {
                Default: 'Default',
                Night: 'Night',
                Original: 'Original',
                Grey: 'Grey',
                LandLot: 'LandLot'
            }
        },
        USGS: {
            url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}',
            options: {
                maxZoom: 20,
                attribution: 'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'
            },
            variants: {
                USTopo: {},
                USImagery: {
                    url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}'
                },
                USImageryTopo: {
                    url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'
                }
            }
        },
        WaymarkedTrails: {
            url: 'https://tile.waymarkedtrails.org/{variant}/{z}/{x}/{y}.png',
            options: {
                maxZoom: 18,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://waymarkedtrails.org">waymarkedtrails.org</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            },
            variants: {
                hiking: 'hiking',
                cycling: 'cycling',
                mtb: 'mtb',
                slopes: 'slopes',
                riding: 'riding',
                skating: 'skating'
            }
        },
        OpenAIP: {
            url: 'https://{s}.tile.maps.openaip.net/geowebcache/service/tms/1.0.0/openaip_basemap@EPSG%3A900913@png/{z}/{x}/{y}.{ext}',
            options: {
                attribution: '<a href="https://www.openaip.net/">openAIP Data</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-NC-SA</a>)',
                ext: 'png',
                minZoom: 4,
                maxZoom: 14,
                tms: true,
                detectRetina: true,
                subdomains: '12'
            }
        },
        OpenSnowMap: {
            url: 'https://tiles.opensnowmap.org/{variant}/{z}/{x}/{y}.png',
            options: {
                minZoom: 9,
                maxZoom: 18,
                attribution: 'Map data: {attribution.OpenStreetMap} & ODbL, &copy; <a href="https://www.opensnowmap.org/iframes/data.html">www.opensnowmap.org</a> <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'
            },
            variants: {
                pistes: 'pistes'
            }
        },
        AzureMaps: {
            url: "https://atlas.microsoft.com/map/tile?api-version={apiVersion}&tilesetId={variant}&x={x}&y={y}&zoom={z}&language={language}&subscription-key={subscriptionKey}",
            options: {
                attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile for details.',
                apiVersion: '2.0',
                variant: 'microsoft.imagery',
                subscriptionKey: '<insert your subscription key here>',
                language: 'en-US'
            },
            variants: {
                MicrosoftImagery: 'microsoft.imagery',
                MicrosoftBaseDarkGrey: 'microsoft.base.darkgrey',
                MicrosoftBaseRoad: 'microsoft.base.road',
                MicrosoftBaseHybridRoad: 'microsoft.base.hybrid.road',
                MicrosoftTerraMain: 'microsoft.terra.main',
                MicrosoftWeatherInfraredMain: {
                    url: "https://atlas.microsoft.com/map/tile?api-version={apiVersion}&tilesetId={variant}&x={x}&y={y}&zoom={z}&timeStamp={timeStamp}&language={language}&subscription-key={subscriptionKey}",
                    options: {
                        timeStamp: '2021-05-08T09:03:00Z',
                        attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
                        variant: 'microsoft.weather.infrared.main'
                    }
                },
                MicrosoftWeatherRadarMain: {
                    url: "https://atlas.microsoft.com/map/tile?api-version={apiVersion}&tilesetId={variant}&x={x}&y={y}&zoom={z}&timeStamp={timeStamp}&language={language}&subscription-key={subscriptionKey}",
                    options: {
                        timeStamp: '2021-05-08T09:03:00Z',
                        attribution: 'See https://docs.microsoft.com/en-us/rest/api/maps/render-v2/get-map-tile#uri-parameters for details.',
                        variant: 'microsoft.weather.radar.main'
                    }
                }
            }
        },
        SwissFederalGeoportal: {
            url: 'https://wmts.geo.admin.ch/1.0.0/{variant}/default/current/3857/{z}/{x}/{y}.jpeg',
            options: {
                attribution: '&copy; <a href="https://www.swisstopo.admin.ch/">swisstopo</a>',
                minZoom: 2,
                maxZoom: 18,
                bounds: [
                    [
                        45.398181,
                        5.140242
                    ],
                    [
                        48.230651,
                        11.47757
                    ]
                ]
            },
            variants: {
                NationalMapColor: 'ch.swisstopo.pixelkarte-farbe',
                NationalMapGrey: 'ch.swisstopo.pixelkarte-grau',
                SWISSIMAGE: {
                    options: {
                        variant: 'ch.swisstopo.swissimage',
                        maxZoom: 19
                    }
                }
            }
        }
    };
    L1.tileLayer.provider = function(provider, options) {
        return new L1.TileLayer.Provider(provider, options);
    };
    return L1;
});

});

parcelRegister("535LO", function(module, exports) {

$parcel$export(module.exports, "MapContainer", function () { return $3ad1b5687fa9ac8b$export$23f3dfd47374502b; });

var $bLhVg = parcelRequire("bLhVg");

var $9EKH1 = parcelRequire("9EKH1");

var $inqfx = parcelRequire("inqfx");

var $7fPBF = parcelRequire("7fPBF");
function $3ad1b5687fa9ac8b$var$_extends() {
    $3ad1b5687fa9ac8b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ad1b5687fa9ac8b$var$_extends.apply(this, arguments);
}
function $3ad1b5687fa9ac8b$export$54c1e9a8bb896c95(mapRef, props) {
    const [map, setMap] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (mapRef.current !== null && map === null) {
            const instance = new (0, $inqfx.Map)(mapRef.current, props);
            if (props.center != null && props.zoom != null) instance.setView(props.center, props.zoom);
            else if (props.bounds != null) instance.fitBounds(props.bounds, props.boundsOptions);
            if (props.whenReady != null) instance.whenReady(props.whenReady);
            setMap(instance);
        }
    }, [
        mapRef,
        map,
        props
    ]);
    return map;
}
function $3ad1b5687fa9ac8b$export$23f3dfd47374502b(_ref) {
    let { children: children, className: className, id: id, placeholder: placeholder, style: style, whenCreated: whenCreated } = _ref, options = (0, $bLhVg._)(_ref, [
        "children",
        "className",
        "id",
        "placeholder",
        "style",
        "whenCreated"
    ]);
    const mapRef = (0, $7fPBF.useRef)(null);
    const map = $3ad1b5687fa9ac8b$export$54c1e9a8bb896c95(mapRef, options);
    const createdRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (map != null && createdRef.current === false && whenCreated != null) {
            createdRef.current = true;
            whenCreated(map);
        }
    }, [
        map,
        whenCreated
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            map == null || map.remove();
        };
    }, [
        map
    ]);
    const [props] = (0, $7fPBF.useState)({
        className: className,
        id: id,
        style: style
    });
    const context = (0, $7fPBF.useMemo)(()=>map ? {
            __version: (0, $9EKH1.CONTEXT_VERSION),
            map: map
        } : null, [
        map
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9EKH1.LeafletProvider), {
        value: context
    }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", $3ad1b5687fa9ac8b$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}

});
parcelRegister("9EKH1", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_VERSION", function () { return $707c11b6aeee5f26$export$b8efcc4bff45e15b; });
$parcel$export(module.exports, "LeafletProvider", function () { return $707c11b6aeee5f26$export$a24c9fc2f87814b2; });
$parcel$export(module.exports, "useLeafletContext", function () { return $707c11b6aeee5f26$export$ea59151b8430a4e9; });

var $7fPBF = parcelRequire("7fPBF");
const $707c11b6aeee5f26$export$b8efcc4bff45e15b = 1;
const $707c11b6aeee5f26$export$7de1b54b0142048f = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $707c11b6aeee5f26$export$a24c9fc2f87814b2 = $707c11b6aeee5f26$export$7de1b54b0142048f.Provider;
function $707c11b6aeee5f26$export$ea59151b8430a4e9() {
    const context = (0, $7fPBF.useContext)($707c11b6aeee5f26$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}

});


parcelRegister("54b5b", function(module, exports) {

$parcel$export(module.exports, "Marker", function () { return $3b05ec41bbfc91f8$export$e98856a975cab58e; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $P8rzn = parcelRequire("P8rzn");

var $inqfx = parcelRequire("inqfx");
const $3b05ec41bbfc91f8$export$e98856a975cab58e = (0, $P8rzn.createLayerComponent)(function createMarker(_ref, ctx) {
    let { position: position } = _ref, options = (0, $bLhVg._)(_ref, [
        "position"
    ]);
    const instance = new (0, $inqfx.Marker)(position, options);
    return {
        instance: instance,
        context: (0, $2qxEV._)((0, $9tqwB._)({}, ctx), {
            overlayContainer: instance
        })
    };
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

});
parcelRegister("P8rzn", function(module, exports) {

$parcel$export(module.exports, "createLayerComponent", function () { return $099b5045aae171b4$export$8a4d5778bce4c3ac; });
$parcel$export(module.exports, "createOverlayComponent", function () { return $099b5045aae171b4$export$7d18e209be943d7d; });
$parcel$export(module.exports, "createTileLayerComponent", function () { return $099b5045aae171b4$export$4f432c6de5c4ddb8; });

var $ju6pk = parcelRequire("ju6pk");

var $dNADI = parcelRequire("dNADI");

var $uP07s = parcelRequire("uP07s");

var $5UP0q = parcelRequire("5UP0q");

var $8IGb1 = parcelRequire("8IGb1");

var $8BvQm = parcelRequire("8BvQm");
function $099b5045aae171b4$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return {
            instance: createInstance(props),
            context: context
        };
    }
    const useElement = (0, $uP07s.createElementHook)(createElement);
    const useControl = (0, $dNADI.createControlHook)(useElement);
    return (0, $ju6pk.createLeafComponent)(useControl);
}
function $099b5045aae171b4$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $uP07s.createElementHook)(createElement, updateElement);
    const useLayer = (0, $5UP0q.createLayerHook)(useElement);
    return (0, $ju6pk.createContainerComponent)(useLayer);
}
function $099b5045aae171b4$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $uP07s.createElementHook)(createElement);
    const useOverlay = (0, $8IGb1.createDivOverlayHook)(useElement, useLifecycle);
    return (0, $ju6pk.createDivOverlayComponent)(useOverlay);
}
function $099b5045aae171b4$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $uP07s.createElementHook)(createElement, updateElement);
    const usePath = (0, $8BvQm.createPathHook)(useElement);
    return (0, $ju6pk.createContainerComponent)(usePath);
}
function $099b5045aae171b4$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $uP07s.createElementHook)(createElement, updateElement);
    const useLayer = (0, $5UP0q.createLayerHook)(useElement);
    return (0, $ju6pk.createLeafComponent)(useLayer);
}

});
parcelRegister("ju6pk", function(module, exports) {

$parcel$export(module.exports, "createContainerComponent", function () { return $e2f5ca0fc05d2659$export$96eac748c3f41e82; });
$parcel$export(module.exports, "createDivOverlayComponent", function () { return $e2f5ca0fc05d2659$export$bc37ddc24ed05446; });
$parcel$export(module.exports, "createLeafComponent", function () { return $e2f5ca0fc05d2659$export$18af5c7a9e9b3664; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $9EKH1 = parcelRequire("9EKH1");
function $e2f5ca0fc05d2659$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, ref) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $7fPBF.useImperativeHandle)(ref, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9EKH1.LeafletProvider), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(ContainerComponent);
}
function $e2f5ca0fc05d2659$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, ref) {
        const [isOpen, setOpen] = (0, $7fPBF.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $7fPBF.useImperativeHandle)(ref, ()=>instance);
        (0, $7fPBF.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]); // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $fw0lo.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(OverlayComponent);
}
function $e2f5ca0fc05d2659$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, ref) {
        const { instance: instance } = useElement(props).current;
        (0, $7fPBF.useImperativeHandle)(ref, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(LeafComponent);
}

});

parcelRegister("dNADI", function(module, exports) {

$parcel$export(module.exports, "createControlHook", function () { return $a0bc45d09ef88f1c$export$28d24ab3914549cd; });

var $7fPBF = parcelRequire("7fPBF");

var $9EKH1 = parcelRequire("9EKH1");
function $a0bc45d09ef88f1c$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $9EKH1.useLeafletContext)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $7fPBF.useRef)(props.position);
        const { position: position } = props;
        (0, $7fPBF.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $7fPBF.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

});

parcelRegister("uP07s", function(module, exports) {

$parcel$export(module.exports, "createElementHook", function () { return $05ca5d2d6d547c85$export$2e66ec8a7fb1892f; });

var $7fPBF = parcelRequire("7fPBF");
function $05ca5d2d6d547c85$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        return (0, $7fPBF.useRef)(createElement(props, context));
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $7fPBF.useRef)(createElement(props, context));
        const propsRef = (0, $7fPBF.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $7fPBF.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

});

parcelRegister("5UP0q", function(module, exports) {

$parcel$export(module.exports, "useLayerLifecycle", function () { return $44e9bf656d66f511$export$cd00a227f8cfb2c2; });
$parcel$export(module.exports, "createLayerHook", function () { return $44e9bf656d66f511$export$73f852c6a5abdefa; });

var $7fPBF = parcelRequire("7fPBF");

var $d5KRm = parcelRequire("d5KRm");

var $9EKH1 = parcelRequire("9EKH1");

var $2o07D = parcelRequire("2o07D");

var $j16Zt = parcelRequire("j16Zt");
function $44e9bf656d66f511$export$cd00a227f8cfb2c2(element, context) {
    (0, $7fPBF.useEffect)(function addLayer() {
        var _context_layerContainer;
        const container = (_context_layerContainer = context.layerContainer) !== null && _context_layerContainer !== void 0 ? _context_layerContainer : context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            var _context$layerContain;
            (_context$layerContain = context.layerContainer) == null || _context$layerContain.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $44e9bf656d66f511$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $9EKH1.useLeafletContext)();
        const elementRef = useElement((0, $j16Zt.withPane)(props, context), context);
        (0, $d5KRm.useAttribution)(context.map, props.attribution);
        (0, $2o07D.useEventHandlers)(elementRef.current, props.eventHandlers);
        $44e9bf656d66f511$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}

});
parcelRegister("d5KRm", function(module, exports) {

$parcel$export(module.exports, "useAttribution", function () { return $9880175232b7cf2a$export$46b870813daca3d4; });

var $7fPBF = parcelRequire("7fPBF");
function $9880175232b7cf2a$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $7fPBF.useRef)(attribution);
    (0, $7fPBF.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

});

parcelRegister("2o07D", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", function () { return $1bcdeae53720353c$export$8ce912bc34d0dbea; });

var $7fPBF = parcelRequire("7fPBF");
function $1bcdeae53720353c$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

});

parcelRegister("j16Zt", function(module, exports) {

$parcel$export(module.exports, "withPane", function () { return $dd838877fc0fc5e2$export$6ee5d263358f5c0e; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $dd838877fc0fc5e2$export$6ee5d263358f5c0e(props, context) {
    var _props_pane;
    const pane = (_props_pane = props.pane) !== null && _props_pane !== void 0 ? _props_pane : context.pane;
    return pane ? (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        pane: pane
    }) : props;
}

});


parcelRegister("8IGb1", function(module, exports) {

$parcel$export(module.exports, "createDivOverlayHook", function () { return $6593263b287aabdb$export$d5eca53b0accc0e0; });

var $d5KRm = parcelRequire("d5KRm");

var $9EKH1 = parcelRequire("9EKH1");

var $2o07D = parcelRequire("2o07D");

var $j16Zt = parcelRequire("j16Zt");
function $6593263b287aabdb$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $9EKH1.useLeafletContext)();
        const elementRef = useElement((0, $j16Zt.withPane)(props, context), context);
        (0, $d5KRm.useAttribution)(context.map, props.attribution);
        (0, $2o07D.useEventHandlers)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

});

parcelRegister("8BvQm", function(module, exports) {

$parcel$export(module.exports, "createPathHook", function () { return $019dd8b130df8ae2$export$5fea2fe6048fc3db; });

var $7fPBF = parcelRequire("7fPBF");

var $9EKH1 = parcelRequire("9EKH1");

var $2o07D = parcelRequire("2o07D");

var $5UP0q = parcelRequire("5UP0q");

var $j16Zt = parcelRequire("j16Zt");
function $019dd8b130df8ae2$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            var _props_pathOptions;
            const options = (_props_pathOptions = props.pathOptions) !== null && _props_pathOptions !== void 0 ? _props_pathOptions : {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $019dd8b130df8ae2$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $9EKH1.useLeafletContext)();
        const elementRef = useElement((0, $j16Zt.withPane)(props, context), context);
        (0, $2o07D.useEventHandlers)(elementRef.current, props.eventHandlers);
        (0, $5UP0q.useLayerLifecycle)(elementRef.current, context);
        $019dd8b130df8ae2$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}

});



parcelRegister("fsprv", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $b40d34efbd41a480$export$129a32eedafa97c5; });

var $P8rzn = parcelRequire("P8rzn");

var $inqfx = parcelRequire("inqfx");

var $7fPBF = parcelRequire("7fPBF");
const $b40d34efbd41a480$export$129a32eedafa97c5 = (0, $P8rzn.createOverlayComponent)(function createPopup(props, context) {
    return {
        instance: new (0, $inqfx.Popup)(props, context.overlayContainer),
        context: context
    };
}, function usePopupLifecycle(element, context, props, setOpen) {
    const { onClose: onClose, onOpen: onOpen, position: position } = props;
    (0, $7fPBF.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
                onOpen == null || onOpen();
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) {
                setOpen(false);
                onClose == null || onClose();
            }
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            var _context$overlayConta;
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            (_context$overlayConta = context.overlayContainer) == null || _context$overlayConta.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        onClose,
        onOpen,
        position
    ]);
});

});

parcelRegister("aAzxA", function(module, exports) {

$parcel$export(module.exports, "TileLayer", function () { return $7b58d5d3f46e25ac$export$f52ee31d61d0b27b; });

var $bLhVg = parcelRequire("bLhVg");

var $P8rzn = parcelRequire("P8rzn");
var $BdHAp = parcelRequire("BdHAp");
var $j16Zt = parcelRequire("j16Zt");

var $inqfx = parcelRequire("inqfx");
const $7b58d5d3f46e25ac$export$f52ee31d61d0b27b = (0, $P8rzn.createTileLayerComponent)(function createTileLayer(_ref, context) {
    let { url: url } = _ref, options = (0, $bLhVg._)(_ref, [
        "url"
    ]);
    return {
        instance: new (0, $inqfx.TileLayer)(url, (0, $j16Zt.withPane)(options, context)),
        context: context
    };
}, (0, $BdHAp.updateGridLayer));

});
parcelRegister("BdHAp", function(module, exports) {

$parcel$export(module.exports, "updateGridLayer", function () { return $06fe15bfb80fee75$export$b39104a5f1b9296f; });
function $06fe15bfb80fee75$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}

});


parcelRegister("kzScq", function(module, exports) {

module.exports = (parcelRequire("dfCPr")).getBundleURL('5rDGr') + "hospital.1b4d9a78.png";

});


parcelRegister("awsKY", function(module, exports) {

module.exports = (parcelRequire("lgu6L")).default;

module.exports.utils = (parcelRequire("9ZwFU"));

module.exports.calculateUtils = (parcelRequire("9cUF9"));

module.exports.Responsive = (parcelRequire("d1a2h")).default;

module.exports.Responsive.utils = (parcelRequire("bcpRL"));

module.exports.WidthProvider = (parcelRequire("huUaE")).default;

});
parcelRegister("lgu6L", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7b2726d4d434caa$var$React = $f7b2726d4d434caa$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $cQwKx = parcelRequire("cQwKx");

var $f7b2726d4d434caa$var$_clsx = $f7b2726d4d434caa$var$_interopRequireDefault((parcelRequire("1CnAf")));

var $9ZwFU = parcelRequire("9ZwFU");

var $9cUF9 = parcelRequire("9cUF9");

var $f7b2726d4d434caa$var$_GridItem = $f7b2726d4d434caa$var$_interopRequireDefault((parcelRequire("h7bPL")));

var $f7b2726d4d434caa$var$_ReactGridLayoutPropTypes = $f7b2726d4d434caa$var$_interopRequireDefault((parcelRequire("4zYf2")));
function $f7b2726d4d434caa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7b2726d4d434caa$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f7b2726d4d434caa$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f7b2726d4d434caa$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f7b2726d4d434caa$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f7b2726d4d434caa$var$_defineProperty(obj, key, value) {
    key = $f7b2726d4d434caa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f7b2726d4d434caa$var$_toPropertyKey(arg) {
    var key = $f7b2726d4d434caa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f7b2726d4d434caa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const $f7b2726d4d434caa$var$layoutClassName = "react-grid-layout";
let $f7b2726d4d434caa$var$isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $f7b2726d4d434caa$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class $f7b2726d4d434caa$var$ReactGridLayout extends $f7b2726d4d434caa$var$React.Component /*:: <Props, State>*/  {
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, $cQwKx.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, $9ZwFU.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, $9ZwFU.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $9ZwFU.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, $9ZwFU.fastRGLPropsEqual)(this.props, nextProps, $cQwKx.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, $9ZwFU.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, $cQwKx.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag: activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, useCSSTransforms: useCSSTransforms, transformScale: transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ $f7b2726d4d434caa$var$React.createElement($f7b2726d4d434caa$var$_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ $f7b2726d4d434caa$var$React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, $9ZwFU.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, isDraggable: isDraggable, isResizable: isResizable, isBounded: isBounded, useCSSTransforms: useCSSTransforms, transformScale: transformScale, draggableCancel: draggableCancel, draggableHandle: draggableHandle, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const { mounted: mounted, droppingPosition: droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ $f7b2726d4d434caa$var$React.createElement($f7b2726d4d434caa$var$_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className: className, style: style, isDroppable: isDroppable, innerRef: innerRef } = this.props;
        const mergedClassName = (0, $f7b2726d4d434caa$var$_clsx.default)($f7b2726d4d434caa$var$layoutClassName, className);
        const mergedStyle = (0, $9tqwB._)({
            height: this.containerHeight()
        }, style);
        return /*#__PURE__*/ $f7b2726d4d434caa$var$React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : $9ZwFU.noop,
            onDragLeave: isDroppable ? this.onDragLeave : $9ZwFU.noop,
            onDragEnter: isDroppable ? this.onDragEnter : $9ZwFU.noop,
            onDragOver: isDroppable ? this.onDragOver : $9ZwFU.noop
        }, $f7b2726d4d434caa$var$React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
    constructor(){
        super(...arguments);
        $f7b2726d4d434caa$var$_defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, $9ZwFU.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, $9ZwFU.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $f7b2726d4d434caa$var$_defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e: e, node: node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout: layout } = this.state;
            const l = (0, $9ZwFU.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, $9ZwFU.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $f7b2726d4d434caa$var$_defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e: e, node: node } = _ref2;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, allowOverlap: allowOverlap, preventCollision: preventCollision } = this.props;
            const l = (0, $9ZwFU.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, $9ZwFU.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $9ZwFU.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, $9ZwFU.compact)(layout, (0, $9ZwFU.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $f7b2726d4d434caa$var$_defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e: e, node: node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            const l = (0, $9ZwFU.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, $9ZwFU.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $9ZwFU.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $9ZwFU.compact)(layout, (0, $9ZwFU.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e: e, node: node } = _ref4;
            const { layout: layout } = this.state;
            const l = (0, $9ZwFU.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, $9ZwFU.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e: e, node: node, size: size, handle: handle } = _ref5;
            const { oldResizeItem: oldResizeItem } = this.state;
            const { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, $9ZwFU.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, $9ZwFU.getAllCollisions)(layout, (0, $2qxEV._)((0, $9tqwB._)({}, l), {
                        w: w,
                        h: h,
                        x: x,
                        y: y
                    })).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, $9ZwFU.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, $9ZwFU.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, $9ZwFU.compact)(finalLayout, (0, $9ZwFU.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e: e, node: node } = _ref6;
            const { layout: layout, oldResizeItem: oldResizeItem } = this.state;
            const { cols: cols, allowOverlap: allowOverlap } = this.props;
            const l = (0, $9ZwFU.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $9ZwFU.compact)(layout, (0, $9ZwFU.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        $f7b2726d4d434caa$var$_defineProperty(this, "onDragOver", (e)=>{
            var _e_nativeEvent_target;
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($f7b2726d4d434caa$var$isFirefox && // $FlowIgnore can't figure this out
            !((_e_nativeEvent_target = e.nativeEvent.target) === null || _e_nativeEvent_target === void 0 ? void 0 : _e_nativeEvent_target.classList.contains($f7b2726d4d434caa$var$layoutClassName))) return false;
            const { droppingItem: droppingItem, onDropDragOver: onDropDragOver, margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows, width: width, containerPadding: containerPadding, transformScale: transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver === null || onDropDragOver === void 0 ? void 0 : onDropDragOver(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = (0, $9tqwB._)({}, droppingItem, onDragOverResult);
            const { layout: layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, $9cUF9.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ $f7b2726d4d434caa$var$React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [
                        ...layout,
                        (0, $2qxEV._)((0, $9tqwB._)({}, finalDroppingItem), {
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        })
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left: left, top: top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem: droppingItem, cols: cols } = this.props;
            const { layout: layout } = this.state;
            const newLayout = (0, $9ZwFU.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, $9ZwFU.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        $f7b2726d4d434caa$var$_defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem: droppingItem } = this.props;
            const { layout: layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
}
module.exports.default = $f7b2726d4d434caa$var$ReactGridLayout;
// TODO publish internal ReactClass displayName transform
$f7b2726d4d434caa$var$_defineProperty($f7b2726d4d434caa$var$ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
$f7b2726d4d434caa$var$_defineProperty($f7b2726d4d434caa$var$ReactGridLayout, "propTypes", $f7b2726d4d434caa$var$_ReactGridLayoutPropTypes.default);
$f7b2726d4d434caa$var$_defineProperty($f7b2726d4d434caa$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $9ZwFU.noop,
    onDragStart: $9ZwFU.noop,
    onDrag: $9ZwFU.noop,
    onDragStop: $9ZwFU.noop,
    onResizeStart: $9ZwFU.noop,
    onResize: $9ZwFU.noop,
    onResizeStop: $9ZwFU.noop,
    onDrop: $9ZwFU.noop,
    onDropDragOver: $9ZwFU.noop
});

});
parcelRegister("cQwKx", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === 'function';
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var REG_EXP_TAG = '[object RegExp]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = '_owner';
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("1CnAf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $1d2eb558f9d4a373$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $1d2eb558f9d4a373$export$2e2bcd8739ae039; });
function $1d2eb558f9d4a373$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $1d2eb558f9d4a373$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $1d2eb558f9d4a373$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $1d2eb558f9d4a373$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $1d2eb558f9d4a373$export$2e2bcd8739ae039 = $1d2eb558f9d4a373$export$4f5d2d50c9deca37;

});

parcelRegister("9ZwFU", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $7463281c07b7e1f9$var$bottom;
module.exports.childrenEqual = $7463281c07b7e1f9$var$childrenEqual;
module.exports.cloneLayout = $7463281c07b7e1f9$var$cloneLayout;
module.exports.cloneLayoutItem = $7463281c07b7e1f9$var$cloneLayoutItem;
module.exports.collides = $7463281c07b7e1f9$var$collides;
module.exports.compact = $7463281c07b7e1f9$var$compact;
module.exports.compactItem = $7463281c07b7e1f9$var$compactItem;
module.exports.compactType = $7463281c07b7e1f9$var$compactType;
module.exports.correctBounds = $7463281c07b7e1f9$var$correctBounds;
module.exports.fastPositionEqual = $7463281c07b7e1f9$var$fastPositionEqual;
module.exports.fastRGLPropsEqual = void 0;
module.exports.getAllCollisions = $7463281c07b7e1f9$var$getAllCollisions;
module.exports.getFirstCollision = $7463281c07b7e1f9$var$getFirstCollision;
module.exports.getLayoutItem = $7463281c07b7e1f9$var$getLayoutItem;
module.exports.getStatics = $7463281c07b7e1f9$var$getStatics;
module.exports.modifyLayout = $7463281c07b7e1f9$var$modifyLayout;
module.exports.moveElement = $7463281c07b7e1f9$var$moveElement;
module.exports.moveElementAwayFromCollision = $7463281c07b7e1f9$var$moveElementAwayFromCollision;
module.exports.noop = void 0;
module.exports.perc = $7463281c07b7e1f9$var$perc;
module.exports.resizeItemInDirection = $7463281c07b7e1f9$var$resizeItemInDirection;
module.exports.setTopLeft = $7463281c07b7e1f9$var$setTopLeft;
module.exports.setTransform = $7463281c07b7e1f9$var$setTransform;
module.exports.sortLayoutItems = $7463281c07b7e1f9$var$sortLayoutItems;
module.exports.sortLayoutItemsByColRow = $7463281c07b7e1f9$var$sortLayoutItemsByColRow;
module.exports.sortLayoutItemsByRowCol = $7463281c07b7e1f9$var$sortLayoutItemsByRowCol;
module.exports.synchronizeLayoutWithChildren = $7463281c07b7e1f9$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $7463281c07b7e1f9$var$validateLayout;
module.exports.withLayoutItem = $7463281c07b7e1f9$var$withLayoutItem;

var $cQwKx = parcelRequire("cQwKx");

var $7463281c07b7e1f9$var$_react = $7463281c07b7e1f9$var$_interopRequireDefault((parcelRequire("7fPBF")));
function $7463281c07b7e1f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const $7463281c07b7e1f9$var$isProduction = true;
const $7463281c07b7e1f9$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $7463281c07b7e1f9$var$bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $7463281c07b7e1f9$var$cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = $7463281c07b7e1f9$var$cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $7463281c07b7e1f9$var$modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $7463281c07b7e1f9$var$withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = $7463281c07b7e1f9$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($7463281c07b7e1f9$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $7463281c07b7e1f9$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function $7463281c07b7e1f9$var$cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $7463281c07b7e1f9$var$childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, $cQwKx.deepEqual)($7463281c07b7e1f9$var$_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.key), $7463281c07b7e1f9$var$_react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.key)) && (0, $cQwKx.deepEqual)($7463281c07b7e1f9$var$_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]), $7463281c07b7e1f9$var$_react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]));
}

/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const $7463281c07b7e1f9$var$fastRGLPropsEqual /*: FastRGLPropsEqual*/  = module.exports.fastRGLPropsEqual = (parcelRequire("iigOU"));
// Like the above, but a lot simpler.
function $7463281c07b7e1f9$var$fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $7463281c07b7e1f9$var$collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function $7463281c07b7e1f9$var$compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = $7463281c07b7e1f9$var$getStatics(layout);
    // We go through the items by row and column.
    const sorted = $7463281c07b7e1f9$var$sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = $7463281c07b7e1f9$var$cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = $7463281c07b7e1f9$var$compactItem(compareWith, l, compactType, cols, sorted, allowOverlap);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const $7463281c07b7e1f9$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $7463281c07b7e1f9$var$resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = $7463281c07b7e1f9$var$heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($7463281c07b7e1f9$var$collides(item, otherItem)) $7463281c07b7e1f9$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $7463281c07b7e1f9$var$compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min($7463281c07b7e1f9$var$bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$7463281c07b7e1f9$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$7463281c07b7e1f9$var$getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = $7463281c07b7e1f9$var$getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) $7463281c07b7e1f9$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $7463281c07b7e1f9$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !$7463281c07b7e1f9$var$getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $7463281c07b7e1f9$var$correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = $7463281c07b7e1f9$var$getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($7463281c07b7e1f9$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $7463281c07b7e1f9$var$getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $7463281c07b7e1f9$var$getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if ($7463281c07b7e1f9$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $7463281c07b7e1f9$var$getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>$7463281c07b7e1f9$var$collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $7463281c07b7e1f9$var$getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $7463281c07b7e1f9$var$moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $7463281c07b7e1f9$var$log(`Moving element ${l.i} to [${String(x)},${String(y)}] from [${l.x},${l.y}]`);
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = $7463281c07b7e1f9$var$sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = $7463281c07b7e1f9$var$getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return $7463281c07b7e1f9$var$cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        $7463281c07b7e1f9$var$log(`Collision prevented on ${l.i}, reverting.`);
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        $7463281c07b7e1f9$var$log(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $7463281c07b7e1f9$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $7463281c07b7e1f9$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $7463281c07b7e1f9$var$moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = $7463281c07b7e1f9$var$getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            $7463281c07b7e1f9$var$log(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
            return $7463281c07b7e1f9$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return $7463281c07b7e1f9$var$moveElement(layout, itemToMove, undefined, collidesWith.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return $7463281c07b7e1f9$var$moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return $7463281c07b7e1f9$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $7463281c07b7e1f9$var$perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const $7463281c07b7e1f9$var$constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const $7463281c07b7e1f9$var$constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const $7463281c07b7e1f9$var$constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const $7463281c07b7e1f9$var$constrainTop = (top /*: number*/ )=>Math.max(0, top);
const $7463281c07b7e1f9$var$resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left: left, height: height, width: width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left: left,
        width: width,
        height: $7463281c07b7e1f9$var$constrainHeight(top, currentSize.height, height),
        top: $7463281c07b7e1f9$var$constrainTop(top)
    };
};
const $7463281c07b7e1f9$var$resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref2;
    return {
        top: top,
        height: height,
        width: $7463281c07b7e1f9$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: $7463281c07b7e1f9$var$constrainLeft(left)
    };
};
const $7463281c07b7e1f9$var$resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top: top, height: height, width: width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height: height,
        width: left < 0 ? currentSize.width : $7463281c07b7e1f9$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: $7463281c07b7e1f9$var$constrainTop(top),
        left: $7463281c07b7e1f9$var$constrainLeft(left)
    };
};
const $7463281c07b7e1f9$var$resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref4;
    return {
        width: width,
        left: left,
        height: $7463281c07b7e1f9$var$constrainHeight(top, currentSize.height, height),
        top: $7463281c07b7e1f9$var$constrainTop(top)
    };
};
const $7463281c07b7e1f9$var$resizeNorthEast = function() {
    return $7463281c07b7e1f9$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $7463281c07b7e1f9$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $7463281c07b7e1f9$var$resizeNorthWest = function() {
    return $7463281c07b7e1f9$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $7463281c07b7e1f9$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $7463281c07b7e1f9$var$resizeSouthEast = function() {
    return $7463281c07b7e1f9$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $7463281c07b7e1f9$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $7463281c07b7e1f9$var$resizeSouthWest = function() {
    return $7463281c07b7e1f9$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $7463281c07b7e1f9$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $7463281c07b7e1f9$var$ordinalResizeHandlerMap = {
    n: $7463281c07b7e1f9$var$resizeNorth,
    ne: $7463281c07b7e1f9$var$resizeNorthEast,
    e: $7463281c07b7e1f9$var$resizeEast,
    se: $7463281c07b7e1f9$var$resizeSouthEast,
    s: $7463281c07b7e1f9$var$resizeSouth,
    sw: $7463281c07b7e1f9$var$resizeSouthWest,
    w: $7463281c07b7e1f9$var$resizeWest,
    nw: $7463281c07b7e1f9$var$resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function $7463281c07b7e1f9$var$resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = $7463281c07b7e1f9$var$ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, (0, $9tqwB._)({}, currentSize, newSize), containerWidth);
}
function $7463281c07b7e1f9$var$setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = `translate(${left}px,${top}px)`;
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
function $7463281c07b7e1f9$var$setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $7463281c07b7e1f9$var$sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return $7463281c07b7e1f9$var$sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return $7463281c07b7e1f9$var$sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $7463281c07b7e1f9$var$sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $7463281c07b7e1f9$var$sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $7463281c07b7e1f9$var$synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    $7463281c07b7e1f9$var$_react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
        const exists = $7463281c07b7e1f9$var$getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push($7463281c07b7e1f9$var$cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!$7463281c07b7e1f9$var$isProduction) $7463281c07b7e1f9$var$validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push($7463281c07b7e1f9$var$cloneLayoutItem((0, $2qxEV._)((0, $9tqwB._)({}, g), {
                i: child.key
            })));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push($7463281c07b7e1f9$var$cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: $7463281c07b7e1f9$var$bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = $7463281c07b7e1f9$var$correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : $7463281c07b7e1f9$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $7463281c07b7e1f9$var$validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            const key = subProps[j];
            const value = item[key];
            if (typeof value !== "number" || Number.isNaN(value)) throw new Error(`ReactGridLayout: ${contextName}[${i}].${key} must be a number! Received: ${value} (${typeof value})`);
        }
        if (typeof item.i !== "undefined" && typeof item.i !== "string") throw new Error(`ReactGridLayout: ${contextName}[${i}].i must be a string! Received: ${item.i} (${typeof item.i})`);
    }
}
// Legacy support for verticalCompact: false
function $7463281c07b7e1f9$var$compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact: verticalCompact, compactType: compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function $7463281c07b7e1f9$var$log() {
    if (!$7463281c07b7e1f9$var$DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const $7463281c07b7e1f9$var$noop = ()=>{};
module.exports.noop = $7463281c07b7e1f9$var$noop;

});
parcelRegister("iigOU", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("9cUF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $6b41301864790706$var$calcGridColWidth;
module.exports.calcGridItemPosition = $6b41301864790706$var$calcGridItemPosition;
module.exports.calcGridItemWHPx = $6b41301864790706$var$calcGridItemWHPx;
module.exports.calcWH = $6b41301864790706$var$calcWH;
module.exports.calcXY = $6b41301864790706$var$calcXY;
module.exports.clamp = $6b41301864790706$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $6b41301864790706$var$calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin: margin, containerPadding: containerPadding, containerWidth: containerWidth, cols: cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $6b41301864790706$var$calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $6b41301864790706$var$calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin: margin, containerPadding: containerPadding, rowHeight: rowHeight } = positionParams;
    const colWidth = $6b41301864790706$var$calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $6b41301864790706$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $6b41301864790706$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $6b41301864790706$var$calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin: margin, containerPadding: containerPadding, cols: cols, rowHeight: rowHeight, maxRows: maxRows } = positionParams;
    const colWidth = $6b41301864790706$var$calcGridColWidth(positionParams);
    // left = containerPaddingX + x * (colWidth + marginX)
    // x * (colWidth + marginX) = left - containerPaddingX
    // x = (left - containerPaddingX) / (colWidth + marginX)
    let x = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
    let y = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
    // Capping
    x = $6b41301864790706$var$clamp(x, 0, cols - w);
    y = $6b41301864790706$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function $6b41301864790706$var$calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin: margin, maxRows: maxRows, cols: cols, rowHeight: rowHeight } = positionParams;
    const colWidth = $6b41301864790706$var$calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = $6b41301864790706$var$clamp(w, 0, cols - x);
    let _h = $6b41301864790706$var$clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = $6b41301864790706$var$clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = $6b41301864790706$var$clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function $6b41301864790706$var$clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("h7bPL", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c75c451988111979$var$_react = $c75c451988111979$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $fw0lo = parcelRequire("fw0lo");

var $c75c451988111979$var$_propTypes = $c75c451988111979$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $gbBOk = parcelRequire("gbBOk");

var $e8nhN = parcelRequire("e8nhN");

var $9ZwFU = parcelRequire("9ZwFU");

var $9cUF9 = parcelRequire("9cUF9");

var $4zYf2 = parcelRequire("4zYf2");

var $c75c451988111979$var$_clsx = $c75c451988111979$var$_interopRequireDefault((parcelRequire("1CnAf")));
function $c75c451988111979$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c75c451988111979$var$_defineProperty(obj, key, value) {
    key = $c75c451988111979$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c75c451988111979$var$_toPropertyKey(arg) {
    var key = $c75c451988111979$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c75c451988111979$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class $c75c451988111979$var$GridItem extends $c75c451988111979$var$_react.default.Component /*:: <Props, State>*/  {
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, $9cUF9.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, $9cUF9.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, $9ZwFU.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition: droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging: dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node: node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node: node,
                deltaX: deltaX,
                deltaY: deltaY
            }, true // dontFLush: avoid flushSync to temper warnings
            );
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages: usePercentages, containerWidth: containerWidth, useCSSTransforms: useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, $9ZwFU.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, $9ZwFU.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, $9ZwFU.perc)(pos.left / containerWidth);
                style.width = (0, $9ZwFU.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ $c75c451988111979$var$_react.default.createElement($gbBOk.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols: cols, minW: minW, minH: minH, maxW: maxW, maxH: maxH, transformScale: transformScale, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, $9cUF9.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, $9cUF9.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, $9cUF9.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ $c75c451988111979$var$_react.default.createElement($e8nhN.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node: node, size: size, handle: handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x: x, y: y, i: i, maxH: maxH, minH: minH, containerWidth: containerWidth } = this.props;
        const { minW: minW, maxW: maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, $9ZwFU.resizeItemInDirection)(handle, position, size, containerWidth);
            (0, $fw0lo.flushSync)(()=>{
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : updatedSize
                });
            });
        }
        // Get new XY based on pixel size
        let { w: w, h: h } = (0, $9cUF9.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, $9cUF9.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, $9cUF9.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e: e,
            node: node,
            size: updatedSize,
            handle: handle
        });
    }
    render() /*: ReactNode*/ {
        const { x: x, y: y, w: w, h: h, isDraggable: isDraggable, isResizable: isResizable, droppingPosition: droppingPosition, useCSSTransforms: useCSSTransforms } = this.props;
        const pos = (0, $9cUF9.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = $c75c451988111979$var$_react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ $c75c451988111979$var$_react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, $c75c451988111979$var$_clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: (0, $9tqwB._)({}, this.props.style, child.props.style, this.createStyle(pos))
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
    constructor(){
        super(...arguments);
        $c75c451988111979$var$_defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $c75c451988111979$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $c75c451988111979$var$_react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $c75c451988111979$var$_defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node: node } = _ref;
            const { onDragStart: onDragStart, transformScale: transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent: offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $9cUF9.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     * @param  {boolean} dontFlush    if true, will not call flushSync
     */ $c75c451988111979$var$_defineProperty(this, "onDrag", (e, _ref2, dontFlush)=>{
            let { node: node, deltaX: deltaX, deltaY: deltaY } = _ref2;
            const { onDrag: onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded: isBounded, i: i, w: w, h: h, containerWidth: containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent: offsetParent } = node;
                if (offsetParent) {
                    const { margin: margin, rowHeight: rowHeight, containerPadding: containerPadding } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, $9cUF9.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $9cUF9.clamp)(top - containerPadding[1], 0, bottomBoundary);
                    const colWidth = (0, $9cUF9.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, $9cUF9.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $9cUF9.clamp)(left - containerPadding[0], 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            // dontFlush is set if we're calling from inside
            if (dontFlush) this.setState({
                dragging: newPosition
            });
            else (0, $fw0lo.flushSync)(()=>{
                this.setState({
                    dragging: newPosition
                });
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $9cUF9.calcXY)(positionParams, top, left, w, h);
            return onDrag.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $c75c451988111979$var$_defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node: node } = _ref3;
            const { onDragStop: onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w: w, h: h, i: i } = this.props;
            const { left: left, top: top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: null
            });
            const { x: x, y: y } = (0, $9cUF9.calcXY)(this.getPositionParams(), top, left, w, h);
            return onDragStop.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ $c75c451988111979$var$_defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        $c75c451988111979$var$_defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        $c75c451988111979$var$_defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
}
module.exports.default = $c75c451988111979$var$GridItem;
$c75c451988111979$var$_defineProperty($c75c451988111979$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $c75c451988111979$var$_propTypes.default.element,
    // General grid attributes
    cols: $c75c451988111979$var$_propTypes.default.number.isRequired,
    containerWidth: $c75c451988111979$var$_propTypes.default.number.isRequired,
    rowHeight: $c75c451988111979$var$_propTypes.default.number.isRequired,
    margin: $c75c451988111979$var$_propTypes.default.array.isRequired,
    maxRows: $c75c451988111979$var$_propTypes.default.number.isRequired,
    containerPadding: $c75c451988111979$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $c75c451988111979$var$_propTypes.default.number.isRequired,
    y: $c75c451988111979$var$_propTypes.default.number.isRequired,
    w: $c75c451988111979$var$_propTypes.default.number.isRequired,
    h: $c75c451988111979$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $c75c451988111979$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $4zYf2.resizeHandleAxesType,
    resizeHandle: $4zYf2.resizeHandleType,
    // Functions
    onDragStop: $c75c451988111979$var$_propTypes.default.func,
    onDragStart: $c75c451988111979$var$_propTypes.default.func,
    onDrag: $c75c451988111979$var$_propTypes.default.func,
    onResizeStop: $c75c451988111979$var$_propTypes.default.func,
    onResizeStart: $c75c451988111979$var$_propTypes.default.func,
    onResize: $c75c451988111979$var$_propTypes.default.func,
    // Flags
    isDraggable: $c75c451988111979$var$_propTypes.default.bool.isRequired,
    isResizable: $c75c451988111979$var$_propTypes.default.bool.isRequired,
    isBounded: $c75c451988111979$var$_propTypes.default.bool.isRequired,
    static: $c75c451988111979$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $c75c451988111979$var$_propTypes.default.bool.isRequired,
    transformScale: $c75c451988111979$var$_propTypes.default.number,
    // Others
    className: $c75c451988111979$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $c75c451988111979$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $c75c451988111979$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $c75c451988111979$var$_propTypes.default.shape({
        e: $c75c451988111979$var$_propTypes.default.object.isRequired,
        left: $c75c451988111979$var$_propTypes.default.number.isRequired,
        top: $c75c451988111979$var$_propTypes.default.number.isRequired
    })
});
$c75c451988111979$var$_defineProperty($c75c451988111979$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("gbBOk", function(module, exports) {
"use strict";

var $ao04A = parcelRequire("ao04A");
var $bc8b00d69f88d04a$require$Draggable = $ao04A.default;
var $bc8b00d69f88d04a$require$DraggableCore = $ao04A.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $bc8b00d69f88d04a$require$Draggable;
module.exports.default = $bc8b00d69f88d04a$require$Draggable;
module.exports.DraggableCore = $bc8b00d69f88d04a$require$DraggableCore;

});
parcelRegister("ao04A", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $78fc33c95a2ba9a9$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $78fc33c95a2ba9a9$var$React = $78fc33c95a2ba9a9$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $78fc33c95a2ba9a9$var$_propTypes = $78fc33c95a2ba9a9$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $78fc33c95a2ba9a9$var$_reactDom = $78fc33c95a2ba9a9$var$_interopRequireDefault((parcelRequire("fw0lo")));

var $78fc33c95a2ba9a9$var$_clsx = $78fc33c95a2ba9a9$var$_interopRequireDefault((parcelRequire("jtRae")));

var $iokIG = parcelRequire("iokIG");

var $92l0r = parcelRequire("92l0r");

var $bStHW = parcelRequire("bStHW");

var $78fc33c95a2ba9a9$var$_DraggableCore = $78fc33c95a2ba9a9$var$_interopRequireDefault((parcelRequire("lb94I")));

var $78fc33c95a2ba9a9$var$_log = $78fc33c95a2ba9a9$var$_interopRequireDefault((parcelRequire("cASdE")));
function $78fc33c95a2ba9a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78fc33c95a2ba9a9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($78fc33c95a2ba9a9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $78fc33c95a2ba9a9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $78fc33c95a2ba9a9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $78fc33c95a2ba9a9$var$_extends() {
    $78fc33c95a2ba9a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78fc33c95a2ba9a9$var$_extends.apply(this, arguments);
}
function $78fc33c95a2ba9a9$var$_defineProperty(obj, key, value) {
    key = $78fc33c95a2ba9a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $78fc33c95a2ba9a9$var$_toPropertyKey(arg) {
    var key = $78fc33c95a2ba9a9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $78fc33c95a2ba9a9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $78fc33c95a2ba9a9$var$Draggable extends $78fc33c95a2ba9a9$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $78fc33c95a2ba9a9$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: (0, $9tqwB._)({}, position)
            };
        }
        return null;
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $78fc33c95a2ba9a9$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const _this_props = this.props, { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale } = _this_props, draggableCoreProps = (0, $bLhVg._)(_this_props, [
            "axis",
            "bounds",
            "children",
            "defaultPosition",
            "defaultClassName",
            "defaultClassNameDragging",
            "defaultClassNameDragged",
            "position",
            "positionOffset",
            "scale"
        ]);
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $92l0r.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $92l0r.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $iokIG.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $iokIG.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $78fc33c95a2ba9a9$var$_clsx.default)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $78fc33c95a2ba9a9$var$React.createElement($78fc33c95a2ba9a9$var$_DraggableCore.default, $78fc33c95a2ba9a9$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $78fc33c95a2ba9a9$var$React.cloneElement($78fc33c95a2ba9a9$var$React.Children.only(children), {
            className: className,
            style: (0, $9tqwB._)({}, children.props.style, style),
            transform: svgTransform
        }));
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $78fc33c95a2ba9a9$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $78fc33c95a2ba9a9$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $92l0r.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $78fc33c95a2ba9a9$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $78fc33c95a2ba9a9$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $92l0r.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $92l0r.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $78fc33c95a2ba9a9$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $92l0r.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $78fc33c95a2ba9a9$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: (0, $9tqwB._)({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
}
module.exports.default = $78fc33c95a2ba9a9$var$Draggable;
$78fc33c95a2ba9a9$var$_defineProperty($78fc33c95a2ba9a9$var$Draggable, "displayName", 'Draggable');
$78fc33c95a2ba9a9$var$_defineProperty($78fc33c95a2ba9a9$var$Draggable, "propTypes", (0, $2qxEV._)((0, $9tqwB._)({}, $78fc33c95a2ba9a9$var$_DraggableCore.default.propTypes), {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $78fc33c95a2ba9a9$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $78fc33c95a2ba9a9$var$_propTypes.default.oneOfType([
        $78fc33c95a2ba9a9$var$_propTypes.default.shape({
            left: $78fc33c95a2ba9a9$var$_propTypes.default.number,
            right: $78fc33c95a2ba9a9$var$_propTypes.default.number,
            top: $78fc33c95a2ba9a9$var$_propTypes.default.number,
            bottom: $78fc33c95a2ba9a9$var$_propTypes.default.number
        }),
        $78fc33c95a2ba9a9$var$_propTypes.default.string,
        $78fc33c95a2ba9a9$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $78fc33c95a2ba9a9$var$_propTypes.default.string,
    defaultClassNameDragging: $78fc33c95a2ba9a9$var$_propTypes.default.string,
    defaultClassNameDragged: $78fc33c95a2ba9a9$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $78fc33c95a2ba9a9$var$_propTypes.default.shape({
        x: $78fc33c95a2ba9a9$var$_propTypes.default.number,
        y: $78fc33c95a2ba9a9$var$_propTypes.default.number
    }),
    positionOffset: $78fc33c95a2ba9a9$var$_propTypes.default.shape({
        x: $78fc33c95a2ba9a9$var$_propTypes.default.oneOfType([
            $78fc33c95a2ba9a9$var$_propTypes.default.number,
            $78fc33c95a2ba9a9$var$_propTypes.default.string
        ]),
        y: $78fc33c95a2ba9a9$var$_propTypes.default.oneOfType([
            $78fc33c95a2ba9a9$var$_propTypes.default.number,
            $78fc33c95a2ba9a9$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $78fc33c95a2ba9a9$var$_propTypes.default.shape({
        x: $78fc33c95a2ba9a9$var$_propTypes.default.number,
        y: $78fc33c95a2ba9a9$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $bStHW.dontSetMe,
    style: $bStHW.dontSetMe,
    transform: $bStHW.dontSetMe
}));
$78fc33c95a2ba9a9$var$_defineProperty($78fc33c95a2ba9a9$var$Draggable, "defaultProps", (0, $2qxEV._)((0, $9tqwB._)({}, $78fc33c95a2ba9a9$var$_DraggableCore.default.defaultProps), {
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));

});
parcelRegister("iokIG", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $d63a8a62d0495184$var$addClassName;
module.exports.addEvent = $d63a8a62d0495184$var$addEvent;
module.exports.addUserSelectStyles = $d63a8a62d0495184$var$addUserSelectStyles;
module.exports.createCSSTransform = $d63a8a62d0495184$var$createCSSTransform;
module.exports.createSVGTransform = $d63a8a62d0495184$var$createSVGTransform;
module.exports.getTouch = $d63a8a62d0495184$var$getTouch;
module.exports.getTouchIdentifier = $d63a8a62d0495184$var$getTouchIdentifier;
module.exports.getTranslation = $d63a8a62d0495184$var$getTranslation;
module.exports.innerHeight = $d63a8a62d0495184$var$innerHeight;
module.exports.innerWidth = $d63a8a62d0495184$var$innerWidth;
module.exports.matchesSelector = $d63a8a62d0495184$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $d63a8a62d0495184$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $d63a8a62d0495184$var$offsetXYFromParent;
module.exports.outerHeight = $d63a8a62d0495184$var$outerHeight;
module.exports.outerWidth = $d63a8a62d0495184$var$outerWidth;
module.exports.removeClassName = $d63a8a62d0495184$var$removeClassName;
module.exports.removeEvent = $d63a8a62d0495184$var$removeEvent;
module.exports.removeUserSelectStyles = $d63a8a62d0495184$var$removeUserSelectStyles;

var $bStHW = parcelRequire("bStHW");

var $d63a8a62d0495184$var$_getPrefix = $d63a8a62d0495184$var$_interopRequireWildcard((parcelRequire("atnwS")));
function $d63a8a62d0495184$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d63a8a62d0495184$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d63a8a62d0495184$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d63a8a62d0495184$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $d63a8a62d0495184$var$matchesSelectorFunc = '';
function $d63a8a62d0495184$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$d63a8a62d0495184$var$matchesSelectorFunc) $d63a8a62d0495184$var$matchesSelectorFunc = (0, $bStHW.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $bStHW.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $bStHW.isFunction)(el[$d63a8a62d0495184$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$d63a8a62d0495184$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $d63a8a62d0495184$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($d63a8a62d0495184$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $d63a8a62d0495184$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = (0, $9tqwB._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $d63a8a62d0495184$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = (0, $9tqwB._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $d63a8a62d0495184$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $bStHW.int)(computedStyle.borderTopWidth);
    height += (0, $bStHW.int)(computedStyle.borderBottomWidth);
    return height;
}
function $d63a8a62d0495184$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $bStHW.int)(computedStyle.borderLeftWidth);
    width += (0, $bStHW.int)(computedStyle.borderRightWidth);
    return width;
}
function $d63a8a62d0495184$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $bStHW.int)(computedStyle.paddingTop);
    height -= (0, $bStHW.int)(computedStyle.paddingBottom);
    return height;
}
function $d63a8a62d0495184$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $bStHW.int)(computedStyle.paddingLeft);
    width -= (0, $bStHW.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $d63a8a62d0495184$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $d63a8a62d0495184$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $d63a8a62d0495184$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $d63a8a62d0495184$var$_getPrefix.browserPrefixToKey)('transform', $d63a8a62d0495184$var$_getPrefix.default)]: translation
    };
}
function $d63a8a62d0495184$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $d63a8a62d0495184$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $d63a8a62d0495184$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $d63a8a62d0495184$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $bStHW.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $bStHW.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $d63a8a62d0495184$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $d63a8a62d0495184$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $d63a8a62d0495184$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $d63a8a62d0495184$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $d63a8a62d0495184$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $d63a8a62d0495184$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $d63a8a62d0495184$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

});
parcelRegister("bStHW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $8a5bc832be734096$var$dontSetMe;
module.exports.findInArray = $8a5bc832be734096$var$findInArray;
module.exports.int = $8a5bc832be734096$var$int;
module.exports.isFunction = $8a5bc832be734096$var$isFunction;
module.exports.isNum = $8a5bc832be734096$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $8a5bc832be734096$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $8a5bc832be734096$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $8a5bc832be734096$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $8a5bc832be734096$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $8a5bc832be734096$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("atnwS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $79fedd39b6abc638$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $79fedd39b6abc638$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $79fedd39b6abc638$var$getPrefix;
const $79fedd39b6abc638$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $79fedd39b6abc638$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $79fedd39b6abc638$var$prefixes.length; i++){
        if ($79fedd39b6abc638$var$browserPrefixToKey(prop, $79fedd39b6abc638$var$prefixes[i]) in style) return $79fedd39b6abc638$var$prefixes[i];
    }
    return '';
}
function $79fedd39b6abc638$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($79fedd39b6abc638$var$kebabToTitleCase(prop)) : prop;
}
function $79fedd39b6abc638$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $79fedd39b6abc638$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $79fedd39b6abc638$var$_default = module.exports.default = $79fedd39b6abc638$var$getPrefix();

});


parcelRegister("92l0r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $69449859d822c84b$var$canDragX;
module.exports.canDragY = $69449859d822c84b$var$canDragY;
module.exports.createCoreData = $69449859d822c84b$var$createCoreData;
module.exports.createDraggableData = $69449859d822c84b$var$createDraggableData;
module.exports.getBoundPosition = $69449859d822c84b$var$getBoundPosition;
module.exports.getControlPosition = $69449859d822c84b$var$getControlPosition;
module.exports.snapToGrid = $69449859d822c84b$var$snapToGrid;

var $bStHW = parcelRequire("bStHW");

var $iokIG = parcelRequire("iokIG");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $69449859d822c84b$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $69449859d822c84b$var$cloneBounds(bounds);
    const node = $69449859d822c84b$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $bStHW.int)(boundNodeStyle.paddingLeft) + (0, $bStHW.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $bStHW.int)(boundNodeStyle.paddingTop) + (0, $bStHW.int)(nodeStyle.marginTop),
            right: (0, $iokIG.innerWidth)(boundNodeEl) - (0, $iokIG.outerWidth)(node) - node.offsetLeft + (0, $bStHW.int)(boundNodeStyle.paddingRight) - (0, $bStHW.int)(nodeStyle.marginRight),
            bottom: (0, $iokIG.innerHeight)(boundNodeEl) - (0, $iokIG.outerHeight)(node) - node.offsetTop + (0, $bStHW.int)(boundNodeStyle.paddingBottom) - (0, $bStHW.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $bStHW.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $bStHW.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $bStHW.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $bStHW.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $69449859d822c84b$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $69449859d822c84b$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $69449859d822c84b$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $69449859d822c84b$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $iokIG.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $69449859d822c84b$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $iokIG.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $69449859d822c84b$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $bStHW.isNum)(draggable.lastX);
    const node = $69449859d822c84b$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $69449859d822c84b$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $69449859d822c84b$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $69449859d822c84b$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("lb94I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6b1aa2c7b2f5069$var$React = $f6b1aa2c7b2f5069$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $f6b1aa2c7b2f5069$var$_propTypes = $f6b1aa2c7b2f5069$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $f6b1aa2c7b2f5069$var$_reactDom = $f6b1aa2c7b2f5069$var$_interopRequireDefault((parcelRequire("fw0lo")));

var $iokIG = parcelRequire("iokIG");

var $92l0r = parcelRequire("92l0r");

var $bStHW = parcelRequire("bStHW");

var $f6b1aa2c7b2f5069$var$_log = $f6b1aa2c7b2f5069$var$_interopRequireDefault((parcelRequire("cASdE")));
function $f6b1aa2c7b2f5069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6b1aa2c7b2f5069$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f6b1aa2c7b2f5069$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f6b1aa2c7b2f5069$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f6b1aa2c7b2f5069$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f6b1aa2c7b2f5069$var$_defineProperty(obj, key, value) {
    key = $f6b1aa2c7b2f5069$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f6b1aa2c7b2f5069$var$_toPropertyKey(arg) {
    var key = $f6b1aa2c7b2f5069$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f6b1aa2c7b2f5069$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $f6b1aa2c7b2f5069$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $f6b1aa2c7b2f5069$var$dragEventFor = $f6b1aa2c7b2f5069$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $f6b1aa2c7b2f5069$var$DraggableCore extends $f6b1aa2c7b2f5069$var$React.Component /*:: <DraggableCoreProps>*/  {
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $iokIG.addEvent)(thisNode, $f6b1aa2c7b2f5069$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $iokIG.removeEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$eventsFor.mouse.move, this.handleDrag);
            (0, $iokIG.removeEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$eventsFor.touch.move, this.handleDrag);
            (0, $iokIG.removeEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $iokIG.removeEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $iokIG.removeEvent)(thisNode, $f6b1aa2c7b2f5069$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $iokIG.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $f6b1aa2c7b2f5069$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $f6b1aa2c7b2f5069$var$React.cloneElement($f6b1aa2c7b2f5069$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
    constructor(){
        super(...arguments);
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "lastX", NaN);
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "lastY", NaN);
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "touchIdentifier", null);
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "mounted", false);
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $iokIG.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $iokIG.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $iokIG.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $92l0r.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $92l0r.createCoreData)(this, x, y);
            (0, $f6b1aa2c7b2f5069$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $f6b1aa2c7b2f5069$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $iokIG.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $iokIG.addEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$dragEventFor.move, this.handleDrag);
            (0, $iokIG.addEvent)(ownerDocument, $f6b1aa2c7b2f5069$var$dragEventFor.stop, this.handleDragStop);
        });
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $92l0r.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $92l0r.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $92l0r.createCoreData)(this, x, y);
            (0, $f6b1aa2c7b2f5069$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $92l0r.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $92l0r.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $92l0r.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $iokIG.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $f6b1aa2c7b2f5069$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $f6b1aa2c7b2f5069$var$_log.default)('DraggableCore: Removing handlers');
                (0, $iokIG.removeEvent)(thisNode.ownerDocument, $f6b1aa2c7b2f5069$var$dragEventFor.move, this.handleDrag);
                (0, $iokIG.removeEvent)(thisNode.ownerDocument, $f6b1aa2c7b2f5069$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "onMouseDown", (e)=>{
            $f6b1aa2c7b2f5069$var$dragEventFor = $f6b1aa2c7b2f5069$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "onMouseUp", (e)=>{
            $f6b1aa2c7b2f5069$var$dragEventFor = $f6b1aa2c7b2f5069$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $f6b1aa2c7b2f5069$var$dragEventFor = $f6b1aa2c7b2f5069$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $f6b1aa2c7b2f5069$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $f6b1aa2c7b2f5069$var$dragEventFor = $f6b1aa2c7b2f5069$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
}
module.exports.default = $f6b1aa2c7b2f5069$var$DraggableCore;
$f6b1aa2c7b2f5069$var$_defineProperty($f6b1aa2c7b2f5069$var$DraggableCore, "displayName", 'DraggableCore');
$f6b1aa2c7b2f5069$var$_defineProperty($f6b1aa2c7b2f5069$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $f6b1aa2c7b2f5069$var$_propTypes.default.bool,
    children: $f6b1aa2c7b2f5069$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $f6b1aa2c7b2f5069$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $f6b1aa2c7b2f5069$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $f6b1aa2c7b2f5069$var$_propTypes.default.arrayOf($f6b1aa2c7b2f5069$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $f6b1aa2c7b2f5069$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $f6b1aa2c7b2f5069$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $f6b1aa2c7b2f5069$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $f6b1aa2c7b2f5069$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $f6b1aa2c7b2f5069$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $f6b1aa2c7b2f5069$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $f6b1aa2c7b2f5069$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $f6b1aa2c7b2f5069$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $bStHW.dontSetMe,
    style: $bStHW.dontSetMe,
    transform: $bStHW.dontSetMe
});
$f6b1aa2c7b2f5069$var$_defineProperty($f6b1aa2c7b2f5069$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("cASdE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92b2e79c7881a693$var$log;
/*eslint no-console:0*/ function $92b2e79c7881a693$var$log() {}

});




parcelRegister("e8nhN", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("cVMgB")).default;

module.exports.ResizableBox = (parcelRequire("llwci")).default;

});
parcelRegister("cVMgB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $96a03fabcf055e02$export$1e511d4a378977f5; }, function (v) { return $96a03fabcf055e02$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $96a03fabcf055e02$export$2e2bcd8739ae039; }, function (v) { return $96a03fabcf055e02$export$2e2bcd8739ae039 = v; });
var $96a03fabcf055e02$export$1e511d4a378977f5;
var $96a03fabcf055e02$export$2e2bcd8739ae039;
"use strict";
$96a03fabcf055e02$export$1e511d4a378977f5 = true;
$96a03fabcf055e02$export$2e2bcd8739ae039 = void 0;

var $96a03fabcf055e02$var$React = $96a03fabcf055e02$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $gbBOk = parcelRequire("gbBOk");

var $iL59K = parcelRequire("iL59K");

var $dDj7W = parcelRequire("dDj7W");
var $96a03fabcf055e02$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $96a03fabcf055e02$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($96a03fabcf055e02$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $96a03fabcf055e02$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $96a03fabcf055e02$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $96a03fabcf055e02$var$_extends() {
    $96a03fabcf055e02$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96a03fabcf055e02$var$_extends.apply(this, arguments);
}
function $96a03fabcf055e02$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $96a03fabcf055e02$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $96a03fabcf055e02$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $96a03fabcf055e02$var$ownKeys(Object(source), !0).forEach(function(key) {
            $96a03fabcf055e02$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $96a03fabcf055e02$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $96a03fabcf055e02$var$_defineProperty(obj, key, value) {
    key = $96a03fabcf055e02$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96a03fabcf055e02$var$_toPropertyKey(arg) {
    var key = $96a03fabcf055e02$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $96a03fabcf055e02$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $96a03fabcf055e02$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $96a03fabcf055e02$var$_setPrototypeOf(subClass, superClass);
}
function $96a03fabcf055e02$var$_setPrototypeOf(o, p) {
    $96a03fabcf055e02$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $96a03fabcf055e02$var$_setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var $96a03fabcf055e02$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $96a03fabcf055e02$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    } /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */ ;
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
            var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w';
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === 'onResizeStop') _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $96a03fabcf055e02$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === 'function') return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === 'string';
        var props = $96a03fabcf055e02$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $96a03fabcf055e02$var$React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $96a03fabcf055e02$var$_objectWithoutPropertiesLoose(_this$props2, $96a03fabcf055e02$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $iL59K.cloneElement)(children, $96a03fabcf055e02$var$_objectSpread($96a03fabcf055e02$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ $96a03fabcf055e02$var$React.createRef();
                return /*#__PURE__*/ $96a03fabcf055e02$var$React.createElement($gbBOk.DraggableCore, $96a03fabcf055e02$var$_extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler('onResizeStop', handleAxis),
                    onStart: _this3.resizeHandler('onResizeStart', handleAxis),
                    onDrag: _this3.resizeHandler('onResize', handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}($96a03fabcf055e02$var$React.Component);
$96a03fabcf055e02$export$2e2bcd8739ae039 = $96a03fabcf055e02$var$Resizable;
$96a03fabcf055e02$var$Resizable.propTypes = $dDj7W.resizableProps;
$96a03fabcf055e02$var$Resizable.defaultProps = {
    axis: 'both',
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
};

});
parcelRegister("iL59K", function(module, exports) {

$parcel$export(module.exports, "cloneElement", function () { return $da809dad530ba81f$export$e530037191fcd5d7; }, function (v) { return $da809dad530ba81f$export$e530037191fcd5d7 = v; });
var $da809dad530ba81f$export$1e511d4a378977f5;
var $da809dad530ba81f$export$e530037191fcd5d7;
"use strict";
$da809dad530ba81f$export$1e511d4a378977f5 = true;
$da809dad530ba81f$export$e530037191fcd5d7 = $da809dad530ba81f$var$cloneElement;

var $da809dad530ba81f$var$_react = $da809dad530ba81f$var$_interopRequireDefault((parcelRequire("7fPBF")));
function $da809dad530ba81f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da809dad530ba81f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $da809dad530ba81f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $da809dad530ba81f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $da809dad530ba81f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $da809dad530ba81f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $da809dad530ba81f$var$_defineProperty(obj, key, value) {
    key = $da809dad530ba81f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da809dad530ba81f$var$_toPropertyKey(arg) {
    var key = $da809dad530ba81f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $da809dad530ba81f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $da809dad530ba81f$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $da809dad530ba81f$var$_objectSpread($da809dad530ba81f$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $da809dad530ba81f$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("dDj7W", function(module, exports) {

$parcel$export(module.exports, "resizableProps", function () { return $9ecdc124cd7be9f8$export$32a002ec6a601762; }, function (v) { return $9ecdc124cd7be9f8$export$32a002ec6a601762 = v; });
var $9ecdc124cd7be9f8$export$1e511d4a378977f5;
var $9ecdc124cd7be9f8$export$32a002ec6a601762;
"use strict";
$9ecdc124cd7be9f8$export$1e511d4a378977f5 = true;
$9ecdc124cd7be9f8$export$32a002ec6a601762 = void 0;

var $9ecdc124cd7be9f8$var$_propTypes = $9ecdc124cd7be9f8$var$_interopRequireDefault((parcelRequire("2oXYc")));
parcelRequire("gbBOk");
function $9ecdc124cd7be9f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9ecdc124cd7be9f8$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $9ecdc124cd7be9f8$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: $9ecdc124cd7be9f8$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $9ecdc124cd7be9f8$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $9ecdc124cd7be9f8$var$_propTypes.default.shape({
        allowAnyClick: $9ecdc124cd7be9f8$var$_propTypes.default.bool,
        cancel: $9ecdc124cd7be9f8$var$_propTypes.default.string,
        children: $9ecdc124cd7be9f8$var$_propTypes.default.node,
        disabled: $9ecdc124cd7be9f8$var$_propTypes.default.bool,
        enableUserSelectHack: $9ecdc124cd7be9f8$var$_propTypes.default.bool,
        offsetParent: $9ecdc124cd7be9f8$var$_propTypes.default.node,
        grid: $9ecdc124cd7be9f8$var$_propTypes.default.arrayOf($9ecdc124cd7be9f8$var$_propTypes.default.number),
        handle: $9ecdc124cd7be9f8$var$_propTypes.default.string,
        nodeRef: $9ecdc124cd7be9f8$var$_propTypes.default.object,
        onStart: $9ecdc124cd7be9f8$var$_propTypes.default.func,
        onDrag: $9ecdc124cd7be9f8$var$_propTypes.default.func,
        onStop: $9ecdc124cd7be9f8$var$_propTypes.default.func,
        onMouseDown: $9ecdc124cd7be9f8$var$_propTypes.default.func,
        scale: $9ecdc124cd7be9f8$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === 'both' || props.axis === 'y') {
            var _PropTypes$number;
            return (_PropTypes$number = $9ecdc124cd7be9f8$var$_propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return $9ecdc124cd7be9f8$var$_propTypes.default.number.apply($9ecdc124cd7be9f8$var$_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $9ecdc124cd7be9f8$var$_propTypes.default.oneOfType([
        $9ecdc124cd7be9f8$var$_propTypes.default.node,
        $9ecdc124cd7be9f8$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $9ecdc124cd7be9f8$var$_propTypes.default.arrayOf($9ecdc124cd7be9f8$var$_propTypes.default.number),
    lockAspectRatio: $9ecdc124cd7be9f8$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $9ecdc124cd7be9f8$var$_propTypes.default.arrayOf($9ecdc124cd7be9f8$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $9ecdc124cd7be9f8$var$_propTypes.default.arrayOf($9ecdc124cd7be9f8$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $9ecdc124cd7be9f8$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $9ecdc124cd7be9f8$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $9ecdc124cd7be9f8$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $9ecdc124cd7be9f8$var$_propTypes.default.arrayOf($9ecdc124cd7be9f8$var$_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $9ecdc124cd7be9f8$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === 'both' || props.axis === 'x') {
            var _PropTypes$number2;
            return (_PropTypes$number2 = $9ecdc124cd7be9f8$var$_propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return $9ecdc124cd7be9f8$var$_propTypes.default.number.apply($9ecdc124cd7be9f8$var$_propTypes.default, args);
    }
};
$9ecdc124cd7be9f8$export$32a002ec6a601762 = $9ecdc124cd7be9f8$var$resizableProps;

});


parcelRegister("llwci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8a488dff43aa65c$export$2e2bcd8739ae039; }, function (v) { return $f8a488dff43aa65c$export$2e2bcd8739ae039 = v; });
var $f8a488dff43aa65c$export$1e511d4a378977f5;
var $f8a488dff43aa65c$export$2e2bcd8739ae039;
"use strict";
$f8a488dff43aa65c$export$1e511d4a378977f5 = true;
$f8a488dff43aa65c$export$2e2bcd8739ae039 = void 0;

var $f8a488dff43aa65c$var$React = $f8a488dff43aa65c$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $f8a488dff43aa65c$var$_propTypes = $f8a488dff43aa65c$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $f8a488dff43aa65c$var$_Resizable = $f8a488dff43aa65c$var$_interopRequireDefault((parcelRequire("cVMgB")));

var $dDj7W = parcelRequire("dDj7W");
var $f8a488dff43aa65c$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $f8a488dff43aa65c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8a488dff43aa65c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f8a488dff43aa65c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f8a488dff43aa65c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f8a488dff43aa65c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f8a488dff43aa65c$var$_extends() {
    $f8a488dff43aa65c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8a488dff43aa65c$var$_extends.apply(this, arguments);
}
function $f8a488dff43aa65c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f8a488dff43aa65c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f8a488dff43aa65c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f8a488dff43aa65c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f8a488dff43aa65c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f8a488dff43aa65c$var$_defineProperty(obj, key, value) {
    key = $f8a488dff43aa65c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f8a488dff43aa65c$var$_toPropertyKey(arg) {
    var key = $f8a488dff43aa65c$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f8a488dff43aa65c$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f8a488dff43aa65c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f8a488dff43aa65c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $f8a488dff43aa65c$var$_setPrototypeOf(subClass, superClass);
}
function $f8a488dff43aa65c$var$_setPrototypeOf(o, p) {
    $f8a488dff43aa65c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f8a488dff43aa65c$var$_setPrototypeOf(o, p);
}
var $f8a488dff43aa65c$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $f8a488dff43aa65c$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $f8a488dff43aa65c$var$_objectWithoutPropertiesLoose(_this$props, $f8a488dff43aa65c$var$_excluded);
        return /*#__PURE__*/ $f8a488dff43aa65c$var$React.createElement($f8a488dff43aa65c$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $f8a488dff43aa65c$var$React.createElement("div", $f8a488dff43aa65c$var$_extends({}, props, {
            style: $f8a488dff43aa65c$var$_objectSpread($f8a488dff43aa65c$var$_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    };
    return ResizableBox;
}($f8a488dff43aa65c$var$React.Component);
$f8a488dff43aa65c$export$2e2bcd8739ae039 = $f8a488dff43aa65c$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$f8a488dff43aa65c$var$ResizableBox.propTypes = $f8a488dff43aa65c$var$_objectSpread($f8a488dff43aa65c$var$_objectSpread({}, $dDj7W.resizableProps), {}, {
    children: $f8a488dff43aa65c$var$_propTypes.default.element
});

});


parcelRegister("4zYf2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resizeHandleType = module.exports.resizeHandleAxesType = module.exports.default = void 0;

var $35592901747c62a1$var$_propTypes = $35592901747c62a1$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $35592901747c62a1$var$_react = $35592901747c62a1$var$_interopRequireDefault((parcelRequire("7fPBF")));
function $35592901747c62a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const $35592901747c62a1$var$resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleAxesType = $35592901747c62a1$var$_propTypes.default.arrayOf($35592901747c62a1$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const $35592901747c62a1$var$resizeHandleType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleType = $35592901747c62a1$var$_propTypes.default.oneOfType([
    $35592901747c62a1$var$_propTypes.default.node,
    $35592901747c62a1$var$_propTypes.default.func
]);

/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var $35592901747c62a1$var$_default = module.exports.default = {
    //
    // Basic props
    //
    className: $35592901747c62a1$var$_propTypes.default.string,
    style: $35592901747c62a1$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $35592901747c62a1$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $35592901747c62a1$var$_propTypes.default.bool,
    // # of cols.
    cols: $35592901747c62a1$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $35592901747c62a1$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $35592901747c62a1$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $35592901747c62a1$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("9ZwFU")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $35592901747c62a1$var$_propTypes.default.arrayOf($35592901747c62a1$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $35592901747c62a1$var$_propTypes.default.arrayOf($35592901747c62a1$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $35592901747c62a1$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $35592901747c62a1$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $35592901747c62a1$var$_propTypes.default.bool,
    isDraggable: $35592901747c62a1$var$_propTypes.default.bool,
    isResizable: $35592901747c62a1$var$_propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: $35592901747c62a1$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $35592901747c62a1$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $35592901747c62a1$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $35592901747c62a1$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $35592901747c62a1$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $35592901747c62a1$var$resizeHandleAxesType,
    resizeHandle: $35592901747c62a1$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $35592901747c62a1$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $35592901747c62a1$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $35592901747c62a1$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $35592901747c62a1$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $35592901747c62a1$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $35592901747c62a1$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $35592901747c62a1$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $35592901747c62a1$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $35592901747c62a1$var$_propTypes.default.shape({
        i: $35592901747c62a1$var$_propTypes.default.string.isRequired,
        w: $35592901747c62a1$var$_propTypes.default.number.isRequired,
        h: $35592901747c62a1$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        $35592901747c62a1$var$_react.default.Children.forEach(children, function(child) {
            if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $35592901747c62a1$var$_propTypes.default.any
};

});



parcelRegister("d1a2h", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97a32746a0ab7e12$var$React = $97a32746a0ab7e12$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $97a32746a0ab7e12$var$_propTypes = $97a32746a0ab7e12$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $cQwKx = parcelRequire("cQwKx");

var $9ZwFU = parcelRequire("9ZwFU");

var $bcpRL = parcelRequire("bcpRL");

var $97a32746a0ab7e12$var$_ReactGridLayout = $97a32746a0ab7e12$var$_interopRequireDefault((parcelRequire("lgu6L")));
function $97a32746a0ab7e12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $97a32746a0ab7e12$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($97a32746a0ab7e12$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $97a32746a0ab7e12$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $97a32746a0ab7e12$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $97a32746a0ab7e12$var$_extends() {
    $97a32746a0ab7e12$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97a32746a0ab7e12$var$_extends.apply(this, arguments);
}
function $97a32746a0ab7e12$var$_defineProperty(obj, key, value) {
    key = $97a32746a0ab7e12$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $97a32746a0ab7e12$var$_toPropertyKey(arg) {
    var key = $97a32746a0ab7e12$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $97a32746a0ab7e12$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const $97a32746a0ab7e12$var$type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $97a32746a0ab7e12$var$getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class $97a32746a0ab7e12$var$ResponsiveReactGridLayout extends $97a32746a0ab7e12$var$React.Component {
    generateInitialState() /*: State*/ {
        const { width: width, breakpoints: breakpoints, layouts: layouts, cols: cols } = this.props;
        const breakpoint = (0, $bcpRL.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, $bcpRL.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, $bcpRL.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, $cQwKx.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint: breakpoint, cols: cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, $bcpRL.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $cQwKx.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, $cQwKx.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints: breakpoints, cols: cols, layouts: layouts, compactType: compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, $bcpRL.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, $bcpRL.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = (0, $9tqwB._)({}, layouts);
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $9ZwFU.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, $bcpRL.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, $9ZwFU.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.props.onLayoutChange(layout, newLayouts);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = $97a32746a0ab7e12$var$getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = $97a32746a0ab7e12$var$getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const _this_props = this.props, { breakpoint: breakpoint, breakpoints: breakpoints, cols: cols, layouts: layouts, margin: margin, containerPadding: containerPadding, onBreakpointChange: onBreakpointChange, onLayoutChange: onLayoutChange, onWidthChange: onWidthChange } = _this_props, other = (0, $bLhVg._)(_this_props, [
            "breakpoint",
            "breakpoints",
            "cols",
            "layouts",
            "margin",
            "containerPadding",
            "onBreakpointChange",
            "onLayoutChange",
            "onWidthChange"
        ]);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $97a32746a0ab7e12$var$React.createElement($97a32746a0ab7e12$var$_ReactGridLayout.default, $97a32746a0ab7e12$var$_extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: $97a32746a0ab7e12$var$getIndentationValue(margin, this.state.breakpoint),
            containerPadding: $97a32746a0ab7e12$var$getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
    constructor(){
        super(...arguments);
        $97a32746a0ab7e12$var$_defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        $97a32746a0ab7e12$var$_defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, (0, $2qxEV._)((0, $9tqwB._)({}, this.props.layouts), {
                [this.state.breakpoint]: layout
            }));
        });
    }
}
module.exports.default = $97a32746a0ab7e12$var$ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
$97a32746a0ab7e12$var$_defineProperty($97a32746a0ab7e12$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $97a32746a0ab7e12$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $97a32746a0ab7e12$var$_propTypes.default.object,
    allowOverlap: $97a32746a0ab7e12$var$_propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: $97a32746a0ab7e12$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $97a32746a0ab7e12$var$_propTypes.default.oneOfType([
        $97a32746a0ab7e12$var$_propTypes.default.array,
        $97a32746a0ab7e12$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $97a32746a0ab7e12$var$_propTypes.default.oneOfType([
        $97a32746a0ab7e12$var$_propTypes.default.array,
        $97a32746a0ab7e12$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if ($97a32746a0ab7e12$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $97a32746a0ab7e12$var$type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $9ZwFU.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $97a32746a0ab7e12$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $97a32746a0ab7e12$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $97a32746a0ab7e12$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $97a32746a0ab7e12$var$_propTypes.default.func
});
$97a32746a0ab7e12$var$_defineProperty($97a32746a0ab7e12$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: $9ZwFU.noop,
    onLayoutChange: $9ZwFU.noop,
    onWidthChange: $9ZwFU.noop
});

});
parcelRegister("bcpRL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findOrGenerateResponsiveLayout = $8274e127462d5868$var$findOrGenerateResponsiveLayout;
module.exports.getBreakpointFromWidth = $8274e127462d5868$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $8274e127462d5868$var$getColsFromBreakpoint;
module.exports.sortBreakpoints = $8274e127462d5868$var$sortBreakpoints;

var $9ZwFU = parcelRequire("9ZwFU");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $8274e127462d5868$var$getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = $8274e127462d5868$var$sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $8274e127462d5868$var$getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $8274e127462d5868$var$findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $9ZwFU.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = $8274e127462d5868$var$sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $9ZwFU.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $9ZwFU.compact)((0, $9ZwFU.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $8274e127462d5868$var$sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("huUaE", function(module, exports) {

var $bLhVg = parcelRequire("bLhVg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbd0cf5a7b053b9a$var$WidthProvideRGL;

var $cbd0cf5a7b053b9a$var$React = $cbd0cf5a7b053b9a$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $cbd0cf5a7b053b9a$var$_propTypes = $cbd0cf5a7b053b9a$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $cbd0cf5a7b053b9a$var$_resizeObserverPolyfill = $cbd0cf5a7b053b9a$var$_interopRequireDefault((parcelRequire("2e0Bh")));

var $cbd0cf5a7b053b9a$var$_clsx = $cbd0cf5a7b053b9a$var$_interopRequireDefault((parcelRequire("1CnAf")));
function $cbd0cf5a7b053b9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cbd0cf5a7b053b9a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cbd0cf5a7b053b9a$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $cbd0cf5a7b053b9a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $cbd0cf5a7b053b9a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $cbd0cf5a7b053b9a$var$_extends() {
    $cbd0cf5a7b053b9a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cbd0cf5a7b053b9a$var$_extends.apply(this, arguments);
}
function $cbd0cf5a7b053b9a$var$_defineProperty(obj, key, value) {
    key = $cbd0cf5a7b053b9a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cbd0cf5a7b053b9a$var$_toPropertyKey(arg) {
    var key = $cbd0cf5a7b053b9a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $cbd0cf5a7b053b9a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const $cbd0cf5a7b053b9a$var$layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $cbd0cf5a7b053b9a$var$WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _class;
    return _class = class WidthProvider extends $cbd0cf5a7b053b9a$var$React.Component {
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new $cbd0cf5a7b053b9a$var$_resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width: width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const _this_props = this.props, { measureBeforeMount: measureBeforeMount } = _this_props, rest = (0, $bLhVg._)(_this_props, [
                "measureBeforeMount"
            ]);
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $cbd0cf5a7b053b9a$var$React.createElement("div", {
                className: (0, $cbd0cf5a7b053b9a$var$_clsx.default)(this.props.className, $cbd0cf5a7b053b9a$var$layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ $cbd0cf5a7b053b9a$var$React.createElement(ComposedComponent, $cbd0cf5a7b053b9a$var$_extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
        constructor(){
            super(...arguments);
            $cbd0cf5a7b053b9a$var$_defineProperty(this, "state", {
                width: 1280
            });
            $cbd0cf5a7b053b9a$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $cbd0cf5a7b053b9a$var$React.createRef());
            $cbd0cf5a7b053b9a$var$_defineProperty(this, "mounted", false);
            $cbd0cf5a7b053b9a$var$_defineProperty(this, "resizeObserver", void 0);
        }
    }, $cbd0cf5a7b053b9a$var$_defineProperty(_class, "defaultProps", {
        measureBeforeMount: false
    }), $cbd0cf5a7b053b9a$var$_defineProperty(_class, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $cbd0cf5a7b053b9a$var$_propTypes.default.bool
    }), _class;
}

});
parcelRegister("2e0Bh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $19ed5ac92d0c9dbe$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $19ed5ac92d0c9dbe$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $19ed5ac92d0c9dbe$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $19ed5ac92d0c9dbe$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $19ed5ac92d0c9dbe$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($19ed5ac92d0c9dbe$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $19ed5ac92d0c9dbe$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $19ed5ac92d0c9dbe$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $19ed5ac92d0c9dbe$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $19ed5ac92d0c9dbe$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $19ed5ac92d0c9dbe$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $19ed5ac92d0c9dbe$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $19ed5ac92d0c9dbe$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $19ed5ac92d0c9dbe$var$throttle(this.refresh.bind(this), $19ed5ac92d0c9dbe$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($19ed5ac92d0c9dbe$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $19ed5ac92d0c9dbe$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $19ed5ac92d0c9dbe$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $19ed5ac92d0c9dbe$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $19ed5ac92d0c9dbe$var$global$1;
};
// Placeholder of an empty content rectangle.
var $19ed5ac92d0c9dbe$var$emptyRect = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $19ed5ac92d0c9dbe$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $19ed5ac92d0c9dbe$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $19ed5ac92d0c9dbe$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $19ed5ac92d0c9dbe$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $19ed5ac92d0c9dbe$var$emptyRect;
    var styles = $19ed5ac92d0c9dbe$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $19ed5ac92d0c9dbe$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $19ed5ac92d0c9dbe$var$toFloat(styles.width), height = $19ed5ac92d0c9dbe$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$19ed5ac92d0c9dbe$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $19ed5ac92d0c9dbe$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $19ed5ac92d0c9dbe$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $19ed5ac92d0c9dbe$var$isDocumentElement(target) {
    return target === $19ed5ac92d0c9dbe$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getContentRect(target) {
    if (!$19ed5ac92d0c9dbe$var$isBrowser) return $19ed5ac92d0c9dbe$var$emptyRect;
    if ($19ed5ac92d0c9dbe$var$isSVGGraphicsElement(target)) return $19ed5ac92d0c9dbe$var$getSVGContentRect(target);
    return $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $19ed5ac92d0c9dbe$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $19ed5ac92d0c9dbe$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $19ed5ac92d0c9dbe$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $19ed5ac92d0c9dbe$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $19ed5ac92d0c9dbe$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $19ed5ac92d0c9dbe$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $19ed5ac92d0c9dbe$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $19ed5ac92d0c9dbe$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $19ed5ac92d0c9dbe$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $19ed5ac92d0c9dbe$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $19ed5ac92d0c9dbe$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $19ed5ac92d0c9dbe$var$ResizeObserverController.getInstance();
        var observer = new $19ed5ac92d0c9dbe$var$ResizeObserverSPI(callback, controller, this);
        $19ed5ac92d0c9dbe$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $19ed5ac92d0c9dbe$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $19ed5ac92d0c9dbe$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $19ed5ac92d0c9dbe$var$index = function() {
    // Export existing implementation if available.
    if (typeof $19ed5ac92d0c9dbe$var$global$1.ResizeObserver !== 'undefined') return $19ed5ac92d0c9dbe$var$global$1.ResizeObserver;
    return $19ed5ac92d0c9dbe$var$ResizeObserver;
}();
var $19ed5ac92d0c9dbe$export$2e2bcd8739ae039 = $19ed5ac92d0c9dbe$var$index;

});



parcelRegister("7LZtP", function(module, exports) {

$parcel$export(module.exports, "MAXPROVIDERCOUNT", function () { return $5a8c9cdab96eba85$export$561436d2efcf2380; });
$parcel$export(module.exports, "CONSTPROVIDERLIST", function () { return $5a8c9cdab96eba85$export$5cb332b7f131c90d; });
const $5a8c9cdab96eba85$export$561436d2efcf2380 = 5;
const $5a8c9cdab96eba85$export$5cb332b7f131c90d = {
    0: {
        "provider-group": [],
        emirate: [],
        "provider-type": [],
        "provider-name": [],
        "clinician-speciality": [],
        "clinician-name": [],
        "transaction-fromdate": [
            "01-01-2025"
        ],
        "transaction-todate": [
            "31-12-2025"
        ],
        "claim-status": [
            "partially_paid",
            "paid",
            "open",
            "rejected"
        ],
        "claim-type": [
            "1"
        ],
        encounter: [
            "outpatient"
        ]
    }
};

});


parcelRegister("3MLTY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c1b031ce0fa2278$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");



var $7jL4F = parcelRequire("7jL4F");

var $ftQl8 = parcelRequire("ftQl8");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $3RNaF = parcelRequire("3RNaF");

var $91ID4 = parcelRequire("91ID4");

var $hQtyv = parcelRequire("hQtyv");

var $6NwTb = parcelRequire("6NwTb");

var $cMvyt = parcelRequire("cMvyt");

var $15jOT = parcelRequire("15jOT");

var $7OeXd = parcelRequire("7OeXd");

var $e9Nto = parcelRequire("e9Nto");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2c1b031ce0fa2278$var$_excluded = [
    "className"
], $2c1b031ce0fa2278$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $15jOT.getListItemUtilityClass), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $kDBhE.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $kY3Ke.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $7OeXd.default).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $15jOT.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $15jOT.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $15jOT.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $15jOT.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $15jOT.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7jL4F.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $kDBhE.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cFLic.default)(props.ContainerProps, $2c1b031ce0fa2278$var$_excluded), other = (0, $cFLic.default)(props, $2c1b031ce0fa2278$var$_excluded2);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $hQtyv.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $91ID4.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $6NwTb.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9MRga.default)((0, $15jOT.default).focusVisible, focusVisibleClassName);
        Component = (0, $3RNaF.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, (0, $kY3Ke.default)({
                as: ContainerComponent,
                className: (0, $9MRga.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $ftQl8.default)(Root) && {
                        as: Component,
                        ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $ftQl8.default)(Root) && {
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e9Nto.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;

});
parcelRegister("15jOT", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $0ca5a1e6788dced6$export$5682c366c0c669d9; });
$parcel$export(module.exports, "default", function () { return $0ca5a1e6788dced6$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $k6RDS.default)('MuiListItem', slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $4jzsB.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;

});

parcelRegister("7OeXd", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", function () { return $5af8cd7874d684d8$export$c09531d8563c67a5; });
$parcel$export(module.exports, "default", function () { return $5af8cd7874d684d8$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $k6RDS.default)('MuiListItemButton', slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $4jzsB.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;

});

parcelRegister("e9Nto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e848490d2ab66f$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $cMvyt = parcelRequire("cMvyt");

var $cpeX4 = parcelRequire("cpeX4");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a4e848490d2ab66f$var$_excluded = [
    "className"
];
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cpeX4.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $kDBhE.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a4e848490d2ab66f$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, (0, $kY3Ke.default)({
        className: (0, $9MRga.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;

});
parcelRegister("cpeX4", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $90836af743b99227$export$ccdb26aeba48a86e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $k6RDS.default)('MuiListItemSecondaryAction', slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $4jzsB.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;

});



parcelRegister("aeoYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $772e96a1af9615ac$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $ke2Sj = parcelRequire("ke2Sj");

var $ip8f1 = parcelRequire("ip8f1");

var $99c9I = parcelRequire("99c9I");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $772e96a1af9615ac$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $772e96a1af9615ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ip8f1.getAvatarUtilityClass), classes);
};
const $772e96a1af9615ac$var$AvatarRoot = (0, $kDBhE.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $kY3Ke.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $kY3Ke.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $772e96a1af9615ac$var$AvatarImg = (0, $kDBhE.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $772e96a1af9615ac$var$AvatarFallback = (0, $kDBhE.default)((0, $ke2Sj.default), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $772e96a1af9615ac$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $772e96a1af9615ac$var$Avatar = /*#__PURE__*/ $7fPBF.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $cFLic.default)(props, $772e96a1af9615ac$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $772e96a1af9615ac$var$useLoaded((0, $kY3Ke.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $772e96a1af9615ac$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $99c9I.default)('img', {
        className: classes.img,
        elementType: $772e96a1af9615ac$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $kY3Ke.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $bbzbN.jsx)(ImgSlot, (0, $kY3Ke.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $bbzbN.jsx)($772e96a1af9615ac$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($772e96a1af9615ac$var$AvatarRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9MRga.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $772e96a1af9615ac$export$2e2bcd8739ae039 = $772e96a1af9615ac$var$Avatar;

});
parcelRegister("ke2Sj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb97585ed36aff99$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $eb97585ed36aff99$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

});

parcelRegister("ip8f1", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $d660f45ac865db82$export$ffd560f22c0ecf04; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d660f45ac865db82$export$ffd560f22c0ecf04(slot) {
    return (0, $k6RDS.default)('MuiAvatar', slot);
}
const $d660f45ac865db82$var$avatarClasses = (0, $4jzsB.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $d660f45ac865db82$export$2e2bcd8739ae039 = $d660f45ac865db82$var$avatarClasses;

});

parcelRegister("99c9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a8e6231295d6b22$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $jTdAm = parcelRequire("jTdAm");

var $5VXZW = parcelRequire("5VXZW");

var $eWvFH = parcelRequire("eWvFH");

var $ex1Wy = parcelRequire("ex1Wy");
'use client';
const $6a8e6231295d6b22$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $6a8e6231295d6b22$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $6a8e6231295d6b22$var$_excluded3 = [
    "component"
];
function $6a8e6231295d6b22$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $cFLic.default)(parameters, $6a8e6231295d6b22$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $cFLic.default)(externalForwardedProps, $6a8e6231295d6b22$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $eWvFH.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $ex1Wy.default)((0, $kY3Ke.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $cFLic.default)(_mergeSlotProps.props, $6a8e6231295d6b22$var$_excluded3);
    const ref = (0, $jTdAm.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $kY3Ke.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $5VXZW.default)(elementType, (0, $kY3Ke.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

});


parcelRegister("k8McI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea99f2520fe8509d$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");

var $de55R = parcelRequire("de55R");


var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kyirV = parcelRequire("kyirV");

var $5VXZW = parcelRequire("5VXZW");

var $bNCjr = parcelRequire("bNCjr");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $aSK9T = parcelRequire("aSK9T");

var $41bfV = parcelRequire("41bfV");

var $1XFnq = parcelRequire("1XFnq");

var $6NwTb = parcelRequire("6NwTb");

var $bwizY = parcelRequire("bwizY");

var $ahx27 = parcelRequire("ahx27");

var $568MF = parcelRequire("568MF");

var $8X2Os = parcelRequire("8X2Os");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ea99f2520fe8509d$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $ea99f2520fe8509d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ea99f2520fe8509d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $b6UUh.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8X2Os.getTooltipUtilityClass), classes);
};
const $ea99f2520fe8509d$var$TooltipPopper = (0, $kDBhE.default)((0, $41bfV.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $8X2Os.default).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $8X2Os.default).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $8X2Os.default).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $8X2Os.default).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $ea99f2520fe8509d$var$TooltipTooltip = (0, $kDBhE.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $b6UUh.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7jL4F.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$ea99f2520fe8509d$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $8X2Os.default).popper}[data-popper-placement*="left"] &`]: (0, $kY3Ke.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $kY3Ke.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $8X2Os.default).popper}[data-popper-placement*="right"] &`]: (0, $kY3Ke.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $kY3Ke.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $8X2Os.default).popper}[data-popper-placement*="top"] &`]: (0, $kY3Ke.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $8X2Os.default).popper}[data-popper-placement*="bottom"] &`]: (0, $kY3Ke.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $ea99f2520fe8509d$var$TooltipArrow = (0, $kDBhE.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7jL4F.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $ea99f2520fe8509d$var$hystersisOpen = false;
const $ea99f2520fe8509d$var$hystersisTimer = new (0, $de55R.Timeout)();
let $ea99f2520fe8509d$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ea99f2520fe8509d$export$b9ee5a7ace0541f8() {
    $ea99f2520fe8509d$var$hystersisOpen = false;
    $ea99f2520fe8509d$var$hystersisTimer.clear();
}
function $ea99f2520fe8509d$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $ea99f2520fe8509d$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $aSK9T.default), TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $ea99f2520fe8509d$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $g9bTP.default)();
    const isRtl = (0, $kyirV.useRtl)();
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $de55R.default)();
    const enterTimer = (0, $de55R.default)();
    const leaveTimer = (0, $de55R.default)();
    const touchTimer = (0, $de55R.default)();
    const [openState, setOpenState] = (0, $568MF.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $bwizY.default)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = (0, $1XFnq.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $7fPBF.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.clear();
        $ea99f2520fe8509d$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $1XFnq.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $ea99f2520fe8509d$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $ea99f2520fe8509d$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $ea99f2520fe8509d$var$hystersisOpen && enterNextDelay) enterTimer.start($ea99f2520fe8509d$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $ahx27.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $6NwTb.default)((0, $bNCjr.default)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ea99f2520fe8509d$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $kY3Ke.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9MRga.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ea99f2520fe8509d$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ea99f2520fe8509d$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ea99f2520fe8509d$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ea99f2520fe8509d$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $7fPBF.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $kY3Ke.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $ea99f2520fe8509d$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $ea99f2520fe8509d$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $aSK9T.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $ea99f2520fe8509d$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $ea99f2520fe8509d$var$TooltipArrow;
    const popperProps = (0, $5VXZW.default)(PopperComponent, (0, $kY3Ke.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9MRga.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $5VXZW.default)(TransitionComponent, (0, $kY3Ke.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $5VXZW.default)(TooltipComponent, (0, $kY3Ke.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9MRga.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $5VXZW.default)(ArrowComponent, (0, $kY3Ke.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9MRga.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $bbzbN.jsx)(PopperComponent, (0, $kY3Ke.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $41bfV.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ea99f2520fe8509d$var$cursorPosition.y,
                            left: $ea99f2520fe8509d$var$cursorPosition.x,
                            right: $ea99f2520fe8509d$var$cursorPosition.x,
                            bottom: $ea99f2520fe8509d$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(TooltipComponent, (0, $kY3Ke.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $bbzbN.jsx)(ArrowComponent, (0, $kY3Ke.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $ea99f2520fe8509d$export$2e2bcd8739ae039 = $ea99f2520fe8509d$var$Tooltip;

});
parcelRegister("bwizY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8631184a92cee7e5$export$2e2bcd8739ae039; });

var $65Itt = parcelRequire("65Itt");
'use client';
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $65Itt.default);

});

parcelRegister("8X2Os", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", function () { return $684603ff395d34b1$export$837848f5f6cee923; });
$parcel$export(module.exports, "default", function () { return $684603ff395d34b1$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $684603ff395d34b1$export$837848f5f6cee923(slot) {
    return (0, $k6RDS.default)('MuiTooltip', slot);
}
const $684603ff395d34b1$var$tooltipClasses = (0, $4jzsB.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $684603ff395d34b1$export$2e2bcd8739ae039 = $684603ff395d34b1$var$tooltipClasses;

});


parcelRegister("4Kxg6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $375541c69d4ec6b6$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $9MRga = parcelRequire("9MRga");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $ahx27 = parcelRequire("ahx27");

var $6NwTb = parcelRequire("6NwTb");

var $3loMv = parcelRequire("3loMv");

var $cjzM0 = parcelRequire("cjzM0");

var $Q7L0K = parcelRequire("Q7L0K");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $375541c69d4ec6b6$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $375541c69d4ec6b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $b6UUh.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cjzM0.getLinkUtilityClass), classes);
};
const $375541c69d4ec6b6$var$LinkRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $b6UUh.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $kY3Ke.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $kY3Ke.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $Q7L0K.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $cjzM0.default).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $375541c69d4ec6b6$var$Link = /*#__PURE__*/ $7fPBF.forwardRef(function Link(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $cFLic.default)(props, $375541c69d4ec6b6$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $ahx27.default)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    const handlerRef = (0, $6NwTb.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $375541c69d4ec6b6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($375541c69d4ec6b6$var$LinkRoot, (0, $kY3Ke.default)({
        color: color,
        className: (0, $9MRga.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $Q7L0K.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $375541c69d4ec6b6$export$2e2bcd8739ae039 = $375541c69d4ec6b6$var$Link;

});
parcelRegister("cjzM0", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $8f730237ea7fc559$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $8f730237ea7fc559$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f730237ea7fc559$export$d6efab9620b78fec(slot) {
    return (0, $k6RDS.default)('MuiLink', slot);
}
const $8f730237ea7fc559$var$linkClasses = (0, $4jzsB.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $8f730237ea7fc559$export$2e2bcd8739ae039 = $8f730237ea7fc559$var$linkClasses;

});

parcelRegister("Q7L0K", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $09cadfdec33133b7$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $09cadfdec33133b7$export$2e2bcd8739ae039; });

var $190Wm = parcelRequire("190Wm");

var $7jL4F = parcelRequire("7jL4F");
const $09cadfdec33133b7$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $09cadfdec33133b7$var$transformDeprecatedColors = (color)=>{
    return $09cadfdec33133b7$export$c4e140d5d351182b[color] || color;
};
const $09cadfdec33133b7$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $09cadfdec33133b7$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $190Wm.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $190Wm.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7jL4F.alpha)(color, 0.4);
};
var $09cadfdec33133b7$export$2e2bcd8739ae039 = $09cadfdec33133b7$var$getTextDecoration;

});


parcelRegister("5ycdX", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("9GZv3"))((parcelRequire("4SSe9")).resolve("g8EOa")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("72Rpr")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("aCKAR"))
]).then(()=>parcelRequire('kmQ89'));

});
parcelRegister("9GZv3", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});


parcelRegister("laNql", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("hT1Xn")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("1ObvT"))
]).then(()=>parcelRequire('eTU5o'));

});

parcelRegister("1REm0", function(module, exports) {


module.exports = (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("RMF3q")).then(()=>parcelRequire('4jmL2'));

});

parcelRegister("in2hs", function(module, exports) {


module.exports = (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("bcom3")).then(()=>parcelRequire('a9bOg'));

});

parcelRegister("hRLoG", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("9GZv3"))((parcelRequire("4SSe9")).resolve("5jkkm")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9V8Ag")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("iLZ9g")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8FNIx")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jbADz"))
]).then(()=>parcelRequire('dtlYo'));

});

parcelRegister("fVqJE", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("2tmuh")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8ym5h")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jukSN")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("kwwrD")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9V8Ag")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("iLZ9g")),
    (parcelRequire("9GZv3"))((parcelRequire("4SSe9")).resolve("gjEMq")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("1JIRy"))
]).then(()=>parcelRequire('8NfoK'));

});

parcelRegister("1Ecu1", function(module, exports) {


module.exports = (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("SO72z")).then(()=>parcelRequire('l4INJ'));

});

parcelRegister("jvom8", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("94vmv"))
]).then(()=>parcelRequire('jEMeS'));

});

parcelRegister("lJlhH", function(module, exports) {


module.exports = (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("aEPXj")).then(()=>parcelRequire('3Ep1W'));

});

parcelRegister("2hlqk", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("hT1Xn")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("gJOPP"))
]).then(()=>parcelRequire('bzUVE'));

});

parcelRegister("7tDli", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9V8Ag")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8FNIx")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("5e8fK"))
]).then(()=>parcelRequire('cAaol'));

});

parcelRegister("ep2U8", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("9GZv3"))((parcelRequire("4SSe9")).resolve("8qX6L")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("dRrnu"))
]).then(()=>parcelRequire('6Be3X'));

});

parcelRegister("bFpYi", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9Iw54")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("aiIC2")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("2tmuh")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8ym5h")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jukSN")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("kwwrD")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("hT1Xn")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("72Rpr")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("6wDjV"))
]).then(()=>parcelRequire('85CzH'));

});

parcelRegister("eOXI1", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9Iw54")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("aiIC2")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8ym5h")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jukSN")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("kwwrD")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("hT1Xn")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("72Rpr")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8rReN"))
]).then(()=>parcelRequire('gE9xH'));

});

parcelRegister("c3PC0", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9Iw54")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("aiIC2")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jukSN")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("kwwrD")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("fytLd")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("hT1Xn")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("72Rpr")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("91JE7"))
]).then(()=>parcelRequire('jMw7k'));

});

parcelRegister("6m9QJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("9Iw54")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("2h0bF"))
]).then(()=>parcelRequire('amaUp'));

});

parcelRegister("6BYYk", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("2tmuh")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("8ym5h")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("jukSN")),
    (parcelRequire("1iyJ7"))((parcelRequire("4SSe9")).resolve("isAX8"))
]).then(()=>parcelRequire('b8VLQ'));

});

var $4205f5a4f89d60cc$exports = {};


(parcelRequire("4SSe9")).register((parcelRequire("dfCPr")).getBundleURL('5rDGr'), JSON.parse("[\"5rDGr\",\"index.1a798b67.js\",\"1aJc3\",\"dashboard_icon.822d5642.png\",\"e9IDR\",\"hospital.1b4d9a78.png\",\"9yHLY\",\"analyticsWhite.27c4a547.svg\",\"aCKAR\",\"dashboard.006ba0f8.js\",\"SrsNz\",\"excel_icon.30f66493.svg\",\"72Rpr\",\"dashboard.cc05df43.js\",\"g8EOa\",\"dashboard.3eb895e3.css\",\"1ObvT\",\"library.cc3dc4fe.js\",\"fIE4a\",\"logo_new.ec15887e.png\",\"heDXC\",\"bar.ef04f8e9.png\",\"44kga\",\"pie-chart.3825cd23.png\",\"5LgBu\",\"table.7edd2fa0.png\",\"am0k6\",\"map.d5e1e679.png\",\"1AJ1d\",\"multiline.017591f7.png\",\"jQmnr\",\"scatter-graph.c5930372.png\",\"jswZM\",\"rule table.2853149d.png\",\"jvQQH\",\"summarycard.e7603e0d.png\",\"hT1Xn\",\"library.f14365cf.js\",\"fytLd\",\"library.ec7fb47b.js\",\"RMF3q\",\"widget.db67b653.js\",\"bcom3\",\"Premium.fbbd3467.js\",\"jbADz\",\"Forecasting.c54fab0f.js\",\"ch2np\",\"excel.faa78b06.png\",\"8FNIx\",\"Forecasting.ca912dff.js\",\"iLZ9g\",\"Forecasting.84355a11.js\",\"9V8Ag\",\"Forecasting.f974e777.js\",\"5jkkm\",\"Forecasting.bb2589dc.css\",\"1JIRy\",\"Workspace.ff6e6aae.js\",\"gjEMq\",\"Workspace.30a40b08.css\",\"jNRU9\",\"1e7b63404cd2fb8e6525b2fd4ee4d286.391a2975.png\",\"kwwrD\",\"Workspace.28c031d4.js\",\"jukSN\",\"Workspace.87169e41.js\",\"8ym5h\",\"Workspace.104a7d9c.js\",\"2tmuh\",\"Workspace.186e2c5a.js\",\"SO72z\",\"Login.35a50921.js\",\"77yrx\",\"analyticsDark.05b37f88.svg\",\"94vmv\",\"likelihood.ff20b99d.js\",\"aEPXj\",\"claimAmountForecast.5d0466ba.js\",\"gJOPP\",\"fraudDetection.fbe771a2.js\",\"5e8fK\",\"churnMember.309289bf.js\",\"dRrnu\",\"page.e2cf8e41.js\",\"1aFZ9\",\"down.89ded79d.png\",\"80t6y\",\"up.100a5340.png\",\"8qX6L\",\"page.4e5e211a.css\",\"6wDjV\",\"utilization-dashboard.ff775a62.js\",\"aiIC2\",\"utilization-dashboard.ce73e785.js\",\"9Iw54\",\"utilization-dashboard.1bda52ec.js\",\"8rReN\",\"fwa-dashboard.87c2ccb3.js\",\"91JE7\",\"contracts-dashboard.2feac6c3.js\",\"2h0bF\",\"custom-dashboard.a897d7ae.js\",\"isAX8\",\"ChatbotPage.00c1c4ad.js\"]"));


var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $dc45162978353a1a$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dc45162978353a1a$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $dc45162978353a1a$exports));
try {
    regeneratorRuntime = $dc45162978353a1a$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $dc45162978353a1a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($dc45162978353a1a$var$runtime);
}



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");

var $iOYnm = parcelRequire("iOYnm");



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $b4iGv = parcelRequire("b4iGv");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6e382b045249d040$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $iOYnm.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7o2xp.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6e382b045249d040$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $iOYnm.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7o2xp.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
var $6e382b045249d040$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6e382b045249d040$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $iOYnm.createLocation)(to, null, null, currentLocation) : to;
};
var $6e382b045249d040$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6e382b045249d040$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef;
if (typeof $6e382b045249d040$var$forwardRef === "undefined") $6e382b045249d040$var$forwardRef = $6e382b045249d040$var$forwardRefShim;
function $6e382b045249d040$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6e382b045249d040$var$LinkAnchor = $6e382b045249d040$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $cFLic.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $kY3Ke.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6e382b045249d040$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6e382b045249d040$var$forwardRefShim !== $6e382b045249d040$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6e382b045249d040$export$a6c7ac8248d6e38a = $6e382b045249d040$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6e382b045249d040$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $cFLic.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7o2xp.__RouterContext).Consumer, null, function(context) {
        !context && (0, $b4iGv.default)(false);
        var history = context.history;
        var location = $6e382b045249d040$var$normalizeToLocation($6e382b045249d040$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $kY3Ke.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6e382b045249d040$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $iOYnm.createPath)(context.location) === (0, $iOYnm.createPath)($6e382b045249d040$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6e382b045249d040$var$forwardRefShim !== $6e382b045249d040$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, props);
    });
});
var $6e382b045249d040$var$toType, $6e382b045249d040$var$refType;
var $6e382b045249d040$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6e382b045249d040$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef;
if (typeof $6e382b045249d040$var$forwardRef$1 === "undefined") $6e382b045249d040$var$forwardRef$1 = $6e382b045249d040$var$forwardRefShim$1;
function $6e382b045249d040$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6e382b045249d040$export$b0d92dbee9b5b60d = $6e382b045249d040$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $cFLic.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7o2xp.__RouterContext).Consumer, null, function(context) {
        !context && (0, $b4iGv.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6e382b045249d040$var$normalizeToLocation($6e382b045249d040$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $7o2xp.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6e382b045249d040$var$joinClassnames(className, activeClassName);
            style = (0, $kY3Ke.default)({}, style, activeStyle);
        }
        var props = (0, $kY3Ke.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6e382b045249d040$var$forwardRefShim$1 !== $6e382b045249d040$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6e382b045249d040$export$a6c7ac8248d6e38a, props);
    });
});
var $6e382b045249d040$var$ariaCurrentType;


var $7o2xp = parcelRequire("7o2xp");

var $aili3 = parcelRequire("aili3");

var $egzHc = parcelRequire("egzHc");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $aili3 = parcelRequire("aili3");

var $kDBhE = parcelRequire("kDBhE");

var $jilX7 = parcelRequire("jilX7");

var $9tqwB = parcelRequire("9tqwB");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $kDBhE = parcelRequire("kDBhE");

var $7TOmr = parcelRequire("7TOmr");






//current code for dashboard list auto width

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7o2xp = parcelRequire("7o2xp");

var $kDBhE = parcelRequire("kDBhE");

var $lE3FT = parcelRequire("lE3FT");



var $57cKd = parcelRequire("57cKd");

var $bbzbN = parcelRequire("bbzbN");


var $5ZeKC = parcelRequire("5ZeKC");
var $aUdfW = parcelRequire("aUdfW");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $eNZsp = parcelRequire("eNZsp");
var $58CWL = parcelRequire("58CWL");
var $a2ay0 = parcelRequire("a2ay0");
var $f6ezL = parcelRequire("f6ezL");
var $3loMv = parcelRequire("3loMv");

var $57cKd = parcelRequire("57cKd");

var $kDBhE = parcelRequire("kDBhE");

var $7fPBF = parcelRequire("7fPBF");

var $3b268cef40f82f4f$exports = {};

$3b268cef40f82f4f$exports = (parcelRequire("dfCPr")).getBundleURL('5rDGr') + "dashboard_icon.822d5642.png";



var $nTWXA = parcelRequire("nTWXA");

var $7bFjM = parcelRequire("7bFjM");

var $7fPBF = parcelRequire("7fPBF");
var $b360d6e53eee36eb$export$86bdb2b9e42f41bc = function(loaderName, frames, suffix) {
    var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
    if (typeof window == "undefined" || !window.document) return animationName;
    var styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    var styleSheet = styleEl.sheet;
    var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
    if (styleSheet) styleSheet.insertRule(keyFrames, 0);
    return animationName;
};


var $17cbabd4062b8723$var$cssUnit = {
    cm: true,
    mm: true,
    in: true,
    px: true,
    pt: true,
    pc: true,
    em: true,
    ex: true,
    ch: true,
    rem: true,
    vw: true,
    vh: true,
    vmin: true,
    vmax: true,
    "%": true
};
function $17cbabd4062b8723$export$78b59f8245744464(size) {
    if (typeof size === "number") return {
        value: size,
        unit: "px"
    };
    var value;
    var valueString = (size.match(/^[0-9.]*/) || "").toString();
    if (valueString.includes(".")) value = parseFloat(valueString);
    else value = parseInt(valueString, 10);
    var unit = (size.match(/[^0-9]*$/) || "").toString();
    if ($17cbabd4062b8723$var$cssUnit[unit]) return {
        value: value,
        unit: unit
    };
    console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
    return {
        value: value,
        unit: "px"
    };
}
function $17cbabd4062b8723$export$55101aa37e5c1f8f(value) {
    var lengthWithunit = $17cbabd4062b8723$export$78b59f8245744464(value);
    return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}


var $86a78d075ce586f3$var$__assign = undefined && undefined.__assign || function() {
    $86a78d075ce586f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $86a78d075ce586f3$var$__assign.apply(this, arguments);
};
var $86a78d075ce586f3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $86a78d075ce586f3$var$sync = (0, $b360d6e53eee36eb$export$86bdb2b9e42f41bc)("SyncLoader", "33% {transform: translateY(10px)}\n  66% {transform: translateY(-10px)}\n  100% {transform: translateY(0)}", "sync");
function $86a78d075ce586f3$var$SyncLoader(_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 15 : _f, _g = _a.margin, margin = _g === void 0 ? 2 : _g, additionalprops = $86a78d075ce586f3$var$__rest(_a, [
        "loading",
        "color",
        "speedMultiplier",
        "cssOverride",
        "size",
        "margin"
    ]);
    var wrapper = $86a78d075ce586f3$var$__assign({
        display: "inherit"
    }, cssOverride);
    var style = function(i) {
        return {
            backgroundColor: color,
            width: (0, $17cbabd4062b8723$export$55101aa37e5c1f8f)(size),
            height: (0, $17cbabd4062b8723$export$55101aa37e5c1f8f)(size),
            margin: (0, $17cbabd4062b8723$export$55101aa37e5c1f8f)(margin),
            borderRadius: "100%",
            display: "inline-block",
            animation: "".concat($86a78d075ce586f3$var$sync, " ").concat(0.6 / speedMultiplier, "s ").concat(i * 0.07, "s infinite ease-in-out"),
            animationFillMode: "both"
        };
    };
    if (!loading) return null;
    return $7fPBF.createElement("span", $86a78d075ce586f3$var$__assign({
        style: wrapper
    }, additionalprops), $7fPBF.createElement("span", {
        style: style(1)
    }), $7fPBF.createElement("span", {
        style: style(2)
    }), $7fPBF.createElement("span", {
        style: style(3)
    }));
}
var $86a78d075ce586f3$export$2e2bcd8739ae039 = $86a78d075ce586f3$var$SyncLoader;



var $aqd0z = parcelRequire("aqd0z");
const $6fd6d96fbbc3ac23$var$ModifiedListItemIcon = (0, $kDBhE.default)((0, $57cKd.default))(()=>({
        minWidth: "20px"
    }));
const $6fd6d96fbbc3ac23$var$Dropdown = ({ pathName: pathName, ToggleDash: ToggleDash, setWork: setWork, setIsDialogueOpen: setIsDialogueOpen })=>{
    const { dashboards: dashboards, loading: loading, setLoading: setLoading, error: error, fetchDashboardList: fetchDashboardList } = (0, $nTWXA.useDashboards)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const [creatingDashboard, setCreatingDashboard] = (0, $7fPBF.useState)(false);
    const [newDashboardName, setNewDashboardName] = (0, $7fPBF.useState)("");
    const [openCreateDialog, setOpenCreateDialog] = (0, $7fPBF.useState)(false);
    const handleMenuOpen = (event)=>{
        // console.log(event.currentTarget);
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = ()=>{
        setAnchorEl(null);
    };
    const handleCreateNewClick = ()=>{
        setIsDialogueOpen(true);
        setCreatingDashboard(true);
        setNewDashboardName("");
        setOpenCreateDialog(true);
    };
    const handleCreateDashboard = ()=>{
        if (newDashboardName && newDashboardName !== "") {
            const body = {
                name: newDashboardName,
                widgets: []
            };
            try {
                setLoading(true);
                (0, $7bFjM.default)("POST", "create_save_dashboard/", JSON.stringify(body), "").then((res)=>{
                    if (res.msg === "success") fetchDashboardList();
                });
            } catch (error) {
                alert("Error Occured.");
            }
            setCreatingDashboard(false);
            setNewDashboardName("");
            setOpenCreateDialog(false);
        }
    };
    const handleCancelCreate = ()=>{
        setIsDialogueOpen(false);
        setCreatingDashboard(false);
        setNewDashboardName("");
        setOpenCreateDialog(false);
    };
    const handleDashboardClick = (dashboardId)=>{
        ToggleDash();
        handleMenuClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a2ay0.default), {
            elevation: 0,
            square: true,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    height: "auto",
                    width: "fit-content",
                    marginTop: 50
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        variant: "h5",
                        sx: {
                            marginLeft: 5
                        },
                        children: "Dashboards"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "mt-10 ml-6",
                        children: loading ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "w-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $86a78d075ce586f3$export$2e2bcd8739ae039), {
                                size: 10,
                                color: (0, $aqd0z.NAVBAR_BLUE)
                            })
                        }) : error ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            disabled: true,
                            children: error
                        }) : creatingDashboard ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aUdfW.default), {
                            open: openCreateDialog,
                            onClose: handleCancelCreate,
                            maxWidth: "xs",
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eNZsp.default), {
                                    style: {
                                        fontSize: "16px"
                                    },
                                    children: "Create New Dashboard"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8wwTv.default), {
                                    style: {
                                        paddingTop: "5px",
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), {
                                        style: {
                                            fontSize: "16px"
                                        },
                                        label: "Dashboard Name",
                                        value: newDashboardName,
                                        onChange: (e)=>setNewDashboardName(e.target.value),
                                        fullWidth: true,
                                        size: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            onClick: handleCancelCreate,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                            onClick: handleCreateDashboard,
                                            children: "Create"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a2ay0.default), {
                            elevation: 0,
                            square: true,
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                style: {
                                    marginLeft: "1.3rem",
                                    marginTop: "-0.9rem",
                                    minWidth: "11rem",
                                    width: "fit-content"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                        className: "dashboard_listItem",
                                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                        to: "/utilization-dashboard",
                                        onClick: ()=>handleDashboardClick('utilization'),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                className: "me-1",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3b268cef40f82f4f$exports))),
                                                alt: "",
                                                height: 20,
                                                width: 20
                                            }),
                                            "Utilization Dashboard"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                        className: "dashboard_listItem",
                                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                        to: "/fwa-dashboard",
                                        onClick: ()=>handleDashboardClick('fwa'),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                className: "me-1",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3b268cef40f82f4f$exports))),
                                                alt: "",
                                                height: 20,
                                                width: 20
                                            }),
                                            "Fraud Waste and Abuse"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                        divider: true
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                        className: "d-flex",
                                        style: {
                                            fontSize: "12px",
                                            textAlign: "left",
                                            background: "white",
                                            cursor: "default"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "me-4 bold-hover",
                                                style: {
                                                    width: "65%",
                                                    cursor: "pointer",
                                                    color: "#dd6f6f"
                                                },
                                                onClick: handleCreateNewClick,
                                                children: "Create New +"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                style: {
                                                    cursor: "pointer",
                                                    width: "25%"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                        divider: true
                                    }),
                                    dashboards.map((dashboard)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                            className: "dashboard_listItem",
                                            onClick: ()=>handleDashboardClick(dashboard.id),
                                            component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                            to: `/dashboard/${dashboard.id}_${dashboard.name}`,
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                    className: "me-1",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3b268cef40f82f4f$exports))),
                                                    alt: "",
                                                    height: 20,
                                                    width: 20
                                                }),
                                                dashboard.name
                                            ]
                                        }, dashboard.id))
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $6fd6d96fbbc3ac23$export$2e2bcd8739ae039 = $6fd6d96fbbc3ac23$var$Dropdown;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $58CWL = parcelRequire("58CWL");
var $a2ay0 = parcelRequire("a2ay0");
var $3loMv = parcelRequire("3loMv");


var $kDBhE = parcelRequire("kDBhE");

var $57cKd = parcelRequire("57cKd");



var $nTWXA = parcelRequire("nTWXA");

var $aqd0z = parcelRequire("aqd0z");
parcelRequire("7bFjM");


parcelRequire("gj7kf");

const $b806a76bbb774244$var$ModifiedListItemIcon = (0, $kDBhE.default)((0, $57cKd.default))(()=>({
        minWidth: "20px"
    }));
const $b806a76bbb774244$var$Dropdown = ({ pathName: pathName, ToggleForecast: ToggleForecast, setOnWorkspace: setOnWorkspace })=>{
    // console.log("Dropdown", pathName);
    const { dashboards: dashboards, loading: loading, setLoading: setLoading, error: error, fetchDashboardList: fetchDashboardList } = (0, $nTWXA.useDashboards)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const handleMenuOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = ()=>{
        setAnchorEl(null);
    };
    const [openDashboard, setOpenDashboard] = (0, $7fPBF.useState)(false);
    const [clickedID, setClickedID] = (0, $7fPBF.useState)(null);
    const handleItemClick = (id)=>{
        ToggleForecast();
        setOnWorkspace(false);
        setOpenDashboard(true);
        setClickedID(id);
    };
    const menuItems = [
        "Premium Prediction",
        "Likelihood of Purchase",
        "Claim Amount Forecast",
        "Fraud Detection",
        // "Provider Fraud Detection",
        // "Member Fraud Detection",
        "Member Churn Prediction",
        "Forecasting"
    ];
    const nav = [
        "Premium",
        "likelihood",
        "claimAmountForecast",
        "fraudDetection",
        // "fraudDetectionMember",
        "churnMember",
        "forecasting"
    ];
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a2ay0.default), {
            elevation: 0,
            square: true,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    height: "auto",
                    marginTop: 50
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        variant: "h5",
                        sx: {
                            marginLeft: 5
                        },
                        children: "Forecasting"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "mt-10 ml-6",
                        children: loading ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "w-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $86a78d075ce586f3$export$2e2bcd8739ae039), {
                                size: 10,
                                color: (0, $aqd0z.NAVBAR_BLUE)
                            })
                        }) : error ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            disabled: true,
                            children: error
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a2ay0.default), {
                            elevation: 0,
                            square: true,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                style: {
                                    marginTop: "-0.9rem"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "flex flex-col items-start",
                                    children: menuItems.map((menuItem, index)=>{
                                        const menuItemText = menuItem;
                                        const navigation = nav[index];
                                        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                            className: "flex justify-start dashboard_listItem",
                                            style: {
                                                fontSize: "12px",
                                                background: "white",
                                                cursor: "pointer"
                                            },
                                            onClick: ()=>{
                                                handleItemClick(index + 1);
                                            },
                                            component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                            to: `/forecasting/${navigation}`,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "bold-hover flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                        // className="me-1"
                                                        className: "mr-1",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3b268cef40f82f4f$exports))),
                                                        alt: "",
                                                        height: 20,
                                                        width: 20
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                        style: {
                                                            width: "calc(100% - 26px)"
                                                        },
                                                        children: menuItemText
                                                    })
                                                ]
                                            })
                                        }, `Nav-${index}`);
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $b806a76bbb774244$export$2e2bcd8739ae039 = $b806a76bbb774244$var$Dropdown;



var $7bFjM = parcelRequire("7bFjM");
var $8809e193781e5f13$exports = {};
"use strict";
function $8809e193781e5f13$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty($8809e193781e5f13$exports, "__esModule", {
    value: !0
});

var $7o2xp = parcelRequire("7o2xp");

var $8809e193781e5f13$var$React = $8809e193781e5f13$var$_interopDefault((parcelRequire("7fPBF")));

var $iOYnm = parcelRequire("iOYnm");


!(parcelRequire("2oXYc")), (parcelRequire("8knIu"));

var $8809e193781e5f13$var$invariant = $8809e193781e5f13$var$_interopDefault((parcelRequire("b4iGv")));
function $8809e193781e5f13$var$_extends() {
    return ($8809e193781e5f13$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
    }).apply(this, arguments);
}
function $8809e193781e5f13$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $8809e193781e5f13$var$_setPrototypeOf(e.prototype.constructor = e, t);
}
function $8809e193781e5f13$var$_setPrototypeOf(e, t) {
    return ($8809e193781e5f13$var$_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function $8809e193781e5f13$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, a = Object.keys(e);
    for(o = 0; o < a.length; o++)r = a[o], 0 <= t.indexOf(r) || (n[r] = e[r]);
    return n;
}
var $8809e193781e5f13$var$BrowserRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $iOYnm.createBrowserHistory(e.props), e;
    }
    return $8809e193781e5f13$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $8809e193781e5f13$var$React.createElement($7o2xp.Router, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($8809e193781e5f13$var$React.Component), $8809e193781e5f13$var$HashRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $iOYnm.createHashHistory(e.props), e;
    }
    return $8809e193781e5f13$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $8809e193781e5f13$var$React.createElement($7o2xp.Router, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($8809e193781e5f13$var$React.Component), $8809e193781e5f13$var$resolveToLocation = function(e, t) {
    return "function" == typeof e ? e(t) : e;
}, $8809e193781e5f13$var$normalizeToLocation = function(e, t) {
    return "string" == typeof e ? $iOYnm.createLocation(e, null, null, t) : e;
}, $8809e193781e5f13$var$forwardRefShim = function(e) {
    return e;
}, $8809e193781e5f13$var$forwardRef = $8809e193781e5f13$var$React.forwardRef;
function $8809e193781e5f13$var$isModifiedEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
void 0 === $8809e193781e5f13$var$forwardRef && ($8809e193781e5f13$var$forwardRef = $8809e193781e5f13$var$forwardRefShim);
var $8809e193781e5f13$var$LinkAnchor = $8809e193781e5f13$var$forwardRef(function(e, t) {
    var r = e.innerRef, o = e.navigate, n = e.onClick, a = $8809e193781e5f13$var$_objectWithoutPropertiesLoose(e, [
        "innerRef",
        "navigate",
        "onClick"
    ]), i = a.target, c = $8809e193781e5f13$var$_extends({}, a, {
        onClick: function(t) {
            try {
                n && n(t);
            } catch (e) {
                throw t.preventDefault(), e;
            }
            t.defaultPrevented || 0 !== t.button || i && "_self" !== i || $8809e193781e5f13$var$isModifiedEvent(t) || (t.preventDefault(), o());
        }
    });
    return c.ref = $8809e193781e5f13$var$forwardRefShim !== $8809e193781e5f13$var$forwardRef && t || r, $8809e193781e5f13$var$React.createElement("a", c);
}), $8809e193781e5f13$var$Link = $8809e193781e5f13$var$forwardRef(function(e, a) {
    var t = e.component, i = void 0 === t ? $8809e193781e5f13$var$LinkAnchor : t, c = e.replace, u = e.to, f = e.innerRef, s = $8809e193781e5f13$var$_objectWithoutPropertiesLoose(e, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return $8809e193781e5f13$var$React.createElement($7o2xp.__RouterContext.Consumer, null, function(r) {
        r || $8809e193781e5f13$var$invariant(!1);
        var o = r.history, e = $8809e193781e5f13$var$normalizeToLocation($8809e193781e5f13$var$resolveToLocation(u, r.location), r.location), t = e ? o.createHref(e) : "", n = $8809e193781e5f13$var$_extends({}, s, {
            href: t,
            navigate: function() {
                var e = $8809e193781e5f13$var$resolveToLocation(u, r.location), t = $iOYnm.createPath(r.location) === $iOYnm.createPath($8809e193781e5f13$var$normalizeToLocation(e));
                (c || t ? o.replace : o.push)(e);
            }
        });
        return $8809e193781e5f13$var$forwardRefShim !== $8809e193781e5f13$var$forwardRef ? n.ref = a || f : n.innerRef = f, $8809e193781e5f13$var$React.createElement(i, n);
    });
}), $8809e193781e5f13$var$forwardRefShim$1 = function(e) {
    return e;
}, $8809e193781e5f13$var$forwardRef$1 = $8809e193781e5f13$var$React.forwardRef;
function $8809e193781e5f13$var$joinClassnames() {
    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
    return t.filter(function(e) {
        return e;
    }).join(" ");
}
void 0 === $8809e193781e5f13$var$forwardRef$1 && ($8809e193781e5f13$var$forwardRef$1 = $8809e193781e5f13$var$forwardRefShim$1);
var $8809e193781e5f13$var$NavLink = $8809e193781e5f13$var$forwardRef$1(function(e, s) {
    var t = e["aria-current"], l = void 0 === t ? "page" : t, r = e.activeClassName, p = void 0 === r ? "active" : r, R = e.activeStyle, h = e.className, y = e.exact, d = e.isActive, m = e.location, v = e.sensitive, b = e.strict, P = e.style, w = e.to, x = e.innerRef, g = $8809e193781e5f13$var$_objectWithoutPropertiesLoose(e, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return $8809e193781e5f13$var$React.createElement($7o2xp.__RouterContext.Consumer, null, function(e) {
        e || $8809e193781e5f13$var$invariant(!1);
        var t = m || e.location, r = $8809e193781e5f13$var$normalizeToLocation($8809e193781e5f13$var$resolveToLocation(w, t), t), o = r.pathname, n = o && o.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1"), a = n ? $7o2xp.matchPath(t.pathname, {
            path: n,
            exact: y,
            sensitive: v,
            strict: b
        }) : null, i = !!(d ? d(a, t) : a), c = "function" == typeof h ? h(i) : h, u = "function" == typeof P ? P(i) : P;
        i && (c = $8809e193781e5f13$var$joinClassnames(c, p), u = $8809e193781e5f13$var$_extends({}, u, R));
        var f = $8809e193781e5f13$var$_extends({
            "aria-current": i && l || null,
            className: c,
            style: u,
            to: r
        }, g);
        return $8809e193781e5f13$var$forwardRefShim$1 !== $8809e193781e5f13$var$forwardRef$1 ? f.ref = s || x : f.innerRef = x, $8809e193781e5f13$var$React.createElement($8809e193781e5f13$var$Link, f);
    });
});
Object.defineProperty($8809e193781e5f13$exports, "MemoryRouter", {
    enumerable: !0,
    get: function() {
        return $7o2xp.MemoryRouter;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "Prompt", {
    enumerable: !0,
    get: function() {
        return $7o2xp.Prompt;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "Redirect", {
    enumerable: !0,
    get: function() {
        return $7o2xp.Redirect;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "Route", {
    enumerable: !0,
    get: function() {
        return $7o2xp.Route;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "Router", {
    enumerable: !0,
    get: function() {
        return $7o2xp.Router;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "StaticRouter", {
    enumerable: !0,
    get: function() {
        return $7o2xp.StaticRouter;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "Switch", {
    enumerable: !0,
    get: function() {
        return $7o2xp.Switch;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "generatePath", {
    enumerable: !0,
    get: function() {
        return $7o2xp.generatePath;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "matchPath", {
    enumerable: !0,
    get: function() {
        return $7o2xp.matchPath;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "useHistory", {
    enumerable: !0,
    get: function() {
        return $7o2xp.useHistory;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "useLocation", {
    enumerable: !0,
    get: function() {
        return $7o2xp.useLocation;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "useParams", {
    enumerable: !0,
    get: function() {
        return $7o2xp.useParams;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "useRouteMatch", {
    enumerable: !0,
    get: function() {
        return $7o2xp.useRouteMatch;
    }
}), Object.defineProperty($8809e193781e5f13$exports, "withRouter", {
    enumerable: !0,
    get: function() {
        return $7o2xp.withRouter;
    }
}), $8809e193781e5f13$exports.BrowserRouter = $8809e193781e5f13$var$BrowserRouter, $8809e193781e5f13$exports.HashRouter = $8809e193781e5f13$var$HashRouter, $8809e193781e5f13$exports.Link = $8809e193781e5f13$var$Link, $8809e193781e5f13$exports.NavLink = $8809e193781e5f13$var$NavLink;


// // current code
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import InsightsIcon from "@mui/icons-material/Insights";
// import PolylineIcon from "@mui/icons-material/Polyline";
// import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
// import WorkspacesIcon from "@mui/icons-material/Workspaces";
// import { List, ListItem } from "@mui/material";
// import IconButton from "@mui/material/IconButton";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import React from "react";
// import { NavLink } from "react-router-dom";
// import logo from "../../assets/images/analyticsWhite.svg";
// const NormalSidebar = ({
//   handleMenuClick,
//   pathName,
//   anchorEl,
//   handleClose,
//   setDashboardOpen,
//   setForecastOpen,
//   ToggleForecast,
//   ToggleDash,
//   setOnWorkspace,
//   CollapsedListItemIcon,
//   handleMouseLeave,
// }) => {
//   return (
//     <div className={`${pathName === "/workspace" ? "close" : ""}`}>
//       <div className="flex justify-center mt-3 ">
//         <img src={logo} alt="" width="25" height="25" />
//       </div>
//       <List sx={{ marginTop: 4 }}>
//         <NavLink
//           to="/workspace"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//             setOnWorkspace(true);
//           }}
//           title="Workspace"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <WorkspacesIcon
//                 color={pathName === "/workspace" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>
//         <NavLink to="#" title="Dashboards" onClick={() => ToggleDash()}>
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <SpaceDashboardIcon
//                 color={pathName === "/home" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>
//         <NavLink
//           to="/widget-generator"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//           }}
//           title="Widget Generator"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <PolylineIcon
//                 color={pathName === "/widget-generator" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink>
//         {/* <NavLink
//           to="/forecasting/forecasting"
//           onClick={() => {
//             setDashboardOpen(false);
//             setForecastOpen(false);
//           }}
//           title="Forecasting"
//         >
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <InsightsIcon
//                 color={pathName === "/forecasting/forecasting" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink> */}
//         {/* <NavLink to="#" onClick={() => ToggleForecast()} title="Forecasting">
//           <ListItem className="d-flex justify-content-center mb-2" button>
//             <CollapsedListItemIcon>
//               <InsightsIcon
//                 color={pathName === "/Forecasting" ? "primary" : ""}
//               />
//             </CollapsedListItemIcon>
//           </ListItem>
//         </NavLink> */}
//         <div
//           style={{
//             position: "fixed",
//             bottom: 0,
//           }}
//           className="flex justify-center items-center   mx-2"
//         >
//           <IconButton
//             className="dropdown-trigger"
//             data-target="account-dropdown"
//             onClick={handleMenuClick}
//           >
//             <AccountCircleIcon style={{ color: "grey", fontSize: "28px" }} />
//           </IconButton>
//           <Menu
//             anchorEl={anchorEl}
//             keepMounted
//             open={Boolean(anchorEl)}
//             PaperProps={{
//               style: {
//                 left: "50%",
//                 transform: "translateX(25%) translateY(1330%)",
//               },
//             }}
//             onClick={handleMenuClick}
//             onClose={handleMenuClick}
//           >
//             <MenuItem onMouseLeave={handleMouseLeave} onClick={handleClose}>
//               Logout
//             </MenuItem>
//           </Menu>
//         </div>
//       </List>
//       {/* <style>{styles}</style> */}
//     </div>
//   );
// };
// export default NormalSidebar;
//current code for design fix in logout 

var $bbzbN = parcelRequire("bbzbN");

var $hxRgH = parcelRequire("hxRgH");

var $b4a59750876448d9$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($b4a59750876448d9$exports, "__esModule", {
    value: true
});
$b4a59750876448d9$exports.default = void 0;

var $b4a59750876448d9$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $b4a59750876448d9$var$_default = $b4a59750876448d9$exports.default = (0, $b4a59750876448d9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6z"
}), 'Polyline');


var $64b32bce6140c077$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($64b32bce6140c077$exports, "__esModule", {
    value: true
});
$64b32bce6140c077$exports.default = void 0;

var $64b32bce6140c077$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $64b32bce6140c077$var$_default = $64b32bce6140c077$exports.default = (0, $64b32bce6140c077$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6zm2 0h6c1.1 0 2-.9 2-2v-7h-8zm8-11V5c0-1.1-.9-2-2-2h-6v7z"
}), 'SpaceDashboard');


var $cb8d62c529dfb71f$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($cb8d62c529dfb71f$exports, "__esModule", {
    value: true
});
$cb8d62c529dfb71f$exports.default = void 0;

var $cb8d62c529dfb71f$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $cb8d62c529dfb71f$var$_default = $cb8d62c529dfb71f$exports.default = (0, $cb8d62c529dfb71f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
}), 'Workspaces');


var $9291ff02b1f1a303$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($9291ff02b1f1a303$exports, "__esModule", {
    value: true
});
$9291ff02b1f1a303$exports.default = void 0;

var $9291ff02b1f1a303$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $9291ff02b1f1a303$var$_default = $9291ff02b1f1a303$exports.default = (0, $9291ff02b1f1a303$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), 'Logout');





var $aili3 = parcelRequire("aili3");
var $lAoIf = parcelRequire("lAoIf");
var $3MLTY = parcelRequire("3MLTY");
var $ahaA4 = parcelRequire("ahaA4");

var $aeoYN = parcelRequire("aeoYN");

var $k8McI = parcelRequire("k8McI");

var $7fPBF = parcelRequire("7fPBF");

var $ecee2d22037c3e2c$exports = {};

$ecee2d22037c3e2c$exports = (parcelRequire("dfCPr")).getBundleURL('5rDGr') + "analyticsWhite.27c4a547.svg";


const $615cb8602b138953$var$NormalSidebar = ({ handleMenuClick: handleMenuClick, pathName: pathName, anchorEl: anchorEl, handleClose: handleClose, setDashboardOpen: setDashboardOpen, setForecastOpen: setForecastOpen, ToggleForecast: ToggleForecast, ToggleDash: ToggleDash, CollapsedListItemIcon: CollapsedListItemIcon, handleMouseLeave: handleMouseLeave })=>{
    // Get the first letter of the username for the avatar
    const username = localStorage.getItem("user") || "User";
    const userInitial = username.charAt(0).toUpperCase();
    // State for account menu
    const [accountMenuAnchorEl, setAccountMenuAnchorEl] = (0, $7fPBF.useState)(null);
    const isAccountMenuOpen = Boolean(accountMenuAnchorEl);
    // Handle account icon click
    const handleAccountClick = (event)=>{
        setAccountMenuAnchorEl(event.currentTarget);
    };
    // Handle closing the account menu
    const handleAccountMenuClose = ()=>{
        setAccountMenuAnchorEl(null);
    };
    // Handle profile click
    const handleProfileClick = ()=>{
        // Add your profile navigation logic here
        handleAccountMenuClose();
    };
    // Handle settings click
    const handleSettingsClick = ()=>{
        // Add your settings navigation logic here
        handleAccountMenuClose();
    };
    // Handle logout click
    const handleLogoutClick = ()=>{
        handleClose(); // Use the existing logout function
        handleAccountMenuClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `${pathName === "/workspace" ? "close" : ""}`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex justify-center mt-3 ",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ecee2d22037c3e2c$exports))),
                    alt: "",
                    width: "25",
                    height: "25"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $lAoIf.default), {
                sx: {
                    marginTop: 4
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6e382b045249d040$export$b0d92dbee9b5b60d), {
                        to: "/workspace",
                        onClick: ()=>{
                            setDashboardOpen(false);
                            setForecastOpen(false);
                        },
                        title: "Workspace",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3MLTY.default), {
                            className: "d-flex justify-content-center mb-2",
                            button: true,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)(CollapsedListItemIcon, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb8d62c529dfb71f$exports))), {
                                    color: pathName === "/workspace" ? "primary" : ""
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6e382b045249d040$export$b0d92dbee9b5b60d), {
                        to: "#",
                        title: "Dashboards",
                        onClick: ()=>ToggleDash(),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3MLTY.default), {
                            className: "d-flex justify-content-center mb-2",
                            button: true,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)(CollapsedListItemIcon, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64b32bce6140c077$exports))), {
                                    color: pathName === "/home" ? "primary" : ""
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6e382b045249d040$export$b0d92dbee9b5b60d), {
                        to: "/widget-generator",
                        onClick: ()=>{
                            setDashboardOpen(false);
                            setForecastOpen(false);
                        },
                        title: "Widget Generator",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3MLTY.default), {
                            className: "d-flex justify-content-center mb-2",
                            button: true,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)(CollapsedListItemIcon, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4a59750876448d9$exports))), {
                                    color: pathName === "/widget-generator" ? "primary" : ""
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        style: {
                            position: "fixed",
                            bottom: "10px",
                            paddingBottom: "15px"
                        },
                        className: "flex justify-center items-center mx-2",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k8McI.default), {
                                title: "Account",
                                placement: "left",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeoYN.default), {
                                    onClick: handleAccountClick,
                                    onMouseEnter: handleAccountClick,
                                    sx: {
                                        bgcolor: "#305697",
                                        width: 32,
                                        height: 32,
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxRgH))), {
                                        fontSize: "small"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ahaA4.default), {
                                open: isAccountMenuOpen,
                                anchorEl: accountMenuAnchorEl,
                                onClose: handleAccountMenuClose,
                                anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right'
                                },
                                transformOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                PaperProps: {
                                    onMouseLeave: handleAccountMenuClose
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                    sx: {
                                        display: 'flex',
                                        p: 1
                                    },
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k8McI.default), {
                                        title: "Logout",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeoYN.default), {
                                            onClick: handleLogoutClick,
                                            sx: {
                                                bgcolor: '#305697',
                                                width: 32,
                                                height: 32,
                                                fontSize: '14px',
                                                cursor: 'pointer',
                                                mx: 0.5
                                            },
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9291ff02b1f1a303$exports))), {
                                                fontSize: "small"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $615cb8602b138953$export$2e2bcd8739ae039 = $615cb8602b138953$var$NormalSidebar;


const $dbd12097814231b5$var$CollapsedListItemIcon = (0, $kDBhE.default)((0, $57cKd.default))(()=>({
        minWidth: "max-content"
    }));
function $dbd12097814231b5$export$2e2bcd8739ae039(props) {
    const location = (0, $7o2xp.useLocation)();
    const pathName = location.pathname;
    // Hide sidebar on utilization, FWA, chatbot, workspace, widget-generator, and custom dashboards
    if ([
        "/utilization-dashboard",
        "/fwa-dashboard",
        "/chatbot",
        "/workspace",
        "/widget-generator",
        "/contracts-dashboard"
    ].includes(pathName) || pathName.startsWith("/dashboard/")) return null;
    const history = (0, $8809e193781e5f13$exports.useHistory)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const dropdownRef = (0, $7fPBF.useRef)(null);
    const [dashboardOpen, setDashboardOpen] = (0, $7fPBF.useState)(false);
    const [forecastOpen, setForecastOpen] = (0, $7fPBF.useState)(false);
    const drawerWidth = 240;
    const openedMixin = (theme)=>({
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            overflowX: "hidden",
            width: drawerWidth
        });
    const DrawerHeader = (0, $kDBhE.default)("div")(({ theme: theme })=>(0, $9tqwB._)({
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            minHeight: "10px"
        }, theme.mixins.toolbar));
    const closedMixin = (theme)=>({
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            overflowY: "hidden",
            width: `calc(${theme.spacing(7)} + 1px)`,
            [theme.breakpoints.up("sm")]: {
                width: `calc(${theme.spacing(7)} + 1px)`
            }
        });
    const Drawer = (0, $kDBhE.default)((0, $lE3FT.default), {
        shouldForwardProp: (prop)=>prop !== "open"
    })(({ theme: theme, open: open })=>(0, $9tqwB._)({
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: "nowrap",
            boxSizing: "border-box"
        }, open && (0, $2qxEV._)((0, $9tqwB._)({}, openedMixin(theme)), {
            "& .MuiDrawer-paper": openedMixin(theme)
        }), !open && (0, $2qxEV._)((0, $9tqwB._)({}, closedMixin(theme)), {
            "& .MuiDrawer-paper": closedMixin(theme)
        })));
    const handleClose = ()=>{
        (0, $7bFjM.default)("GET", "logout/", "").then(()=>{
            localStorage.clear();
            document.cookie.split(";").forEach((cookie)=>{
                document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
            });
        }).then(()=>{
            history.push("/login");
        });
    };
    const handleMouseLeave = (event)=>{
        setAnchorEl(null);
    };
    const handleMenuClick = (event)=>{
        if (anchorEl) setAnchorEl(null);
        else {
            const target = event.currentTarget;
            setAnchorEl(target);
        }
    };
    const [isDialogueOpen, setIsDialogueOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        function handleClickOutside(event) {
            if (!isDialogueOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDashboardOpen(false);
                setForecastOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        dropdownRef,
        isDialogueOpen
    ]);
    const ToggleDash = ()=>{
        setDashboardOpen(!dashboardOpen);
    };
    const ToggleForecast = ()=>{
        setForecastOpen(!forecastOpen);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex mr-0",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Drawer, {
                    variant: "permanent",
                    open: props.open,
                    onClose: props.handleDrawerClose,
                    PaperProps: {
                        sx: {
                            backgroundColor: "f7f7f7",
                            boxShadow: "2px 0 5px rgba(0,0,0,0.1)"
                        }
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $615cb8602b138953$export$2e2bcd8739ae039), {
                        ToggleForecast: ToggleForecast,
                        ToggleDash: ToggleDash,
                        setForecastOpen: setForecastOpen,
                        setDashboardOpen: setDashboardOpen,
                        handleMenuClick: handleMenuClick,
                        anchorEl: anchorEl,
                        handleClose: handleClose,
                        pathName: pathName,
                        CollapsedListItemIcon: $dbd12097814231b5$var$CollapsedListItemIcon,
                        handleMouseLeave: handleMouseLeave
                    })
                })
            }),
            dashboardOpen && [
                "/widget-generator",
                "/workspace"
            ].includes(pathName) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                ref: dropdownRef,
                className: "bg-white square w-64 z-50 fixed -mt-10 mr-4 ml-8",
                style: {
                    height: "150%",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
                    width: "25rem"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6fd6d96fbbc3ac23$export$2e2bcd8739ae039), {
                    setIsDialogueOpen: setIsDialogueOpen,
                    pathName: pathName,
                    ToggleDash: ToggleDash
                })
            }),
            forecastOpen && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                ref: dropdownRef,
                className: "bg-white square w-64 z-50 fixed -mt-10 mr-4 ml-8",
                style: {
                    height: "150%",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b806a76bbb774244$export$2e2bcd8739ae039), {
                    pathName: pathName,
                    ToggleForecast: ToggleForecast
                })
            })
        ]
    });
}



var $7bFjM = parcelRequire("7bFjM");
parcelRequire("aqd0z");
const $de57965fc8b63a2f$var$convertToTitleCase = (inputString)=>{
    const splitStringArray = inputString.toLowerCase().split(" ");
    for(let i = 0; i < splitStringArray.length; i++)splitStringArray[i] = splitStringArray[i].charAt(0).toUpperCase() + splitStringArray[i].substring(1);
    return splitStringArray.join(" ");
};
var $de57965fc8b63a2f$export$2e2bcd8739ae039 = $de57965fc8b63a2f$var$convertToTitleCase;



const $d85088be8077f305$var$drawerWidth = 240;
const $d85088be8077f305$var$AppBar = (0, $kDBhE.default)((0, $7TOmr.default), {
    shouldForwardProp: (prop)=>prop !== "open"
})(({ theme: theme, open: open })=>(0, $9tqwB._)({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create([
            "width",
            "margin"
        ], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    }, open && {
        marginLeft: $d85088be8077f305$var$drawerWidth,
        width: `calc(100% - ${$d85088be8077f305$var$drawerWidth}px)`,
        transition: theme.transitions.create([
            "width",
            "margin"
        ], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    }));
function $d85088be8077f305$export$2e2bcd8739ae039({ open: open, setOpen: setOpen, shouldDashboardsReload: shouldDashboardsReload, setShouldDashboardsReload: setShouldDashboardsReload, heading: heading, hideSidebar: hideSidebar // If true, the sidebar will not be rendered
 }) {
    const history = (0, $7o2xp.useHistory)();
    const username = localStorage.getItem("user") || "";
    const handleDrawerOpen = ()=>{
        setOpen(true);
    };
    const handleDrawerClose = ()=>{
        setOpen(false);
    };
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const handleMouseLeave = (event)=>{
        setAnchorEl(null);
    };
    const handleMenuClick = (event)=>{
        if (anchorEl) setAnchorEl(null);
        else {
            const target = event.currentTarget;
            setAnchorEl(target);
        }
    };
    const handleClose = ()=>{
        (0, $7bFjM.default)("GET", "logout/", "").then(()=>{
            localStorage.clear();
            /* change expire attribute of cookies to current time, so it expires. 
        Note this doesn't work for http only cookies, so only csrf cookie will expire. sessionid is handled by django itself */ document.cookie.split(";").forEach((cookie)=>{
                document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
            });
        }).then(()=>{
            history.push("/login");
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: !hideSidebar && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dbd12097814231b5$export$2e2bcd8739ae039), {
            open: open,
            setOpen: setOpen,
            handleDrawerClose: handleDrawerClose,
            handleDrawerOpen: handleDrawerOpen,
            shouldDashboardsReload: shouldDashboardsReload,
            setShouldDashboardsReload: setShouldDashboardsReload
        })
    });
}



var $7bFjM = parcelRequire("7bFjM");

var $egzHc = parcelRequire("egzHc");
const $a5c5d23854a547ba$var$DrawerHeader = (0, $kDBhE.default)("div")(({ theme: theme })=>(0, $9tqwB._)({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar));
function $a5c5d23854a547ba$export$2e2bcd8739ae039(_param) {
    var { component: Component } = _param, rest = (0, $bLhVg._)(_param, [
        "component"
    ]);
    const auth = (0, $jilX7.useAuth)();
    const history = (0, $7o2xp.useHistory)();
    const loggedInUser = localStorage.getItem("user");
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [shouldDashboardsReload, setShouldDashboardsReload] = (0, $7fPBF.useState)(true);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        (0, $7bFjM.default)("GET", "logged_in/", "").then((res)=>{
            if (!res.is_authenticated) {
                localStorage.removeItem("user");
                history.push("/login");
            } else {
                const userName = res.user;
                if (res.status === 200) auth.signin(200, userName);
                else auth.signin(400, userName);
            }
            setIsLoading(false);
        });
    }, []);
    if (isLoading || loggedInUser === null || loggedInUser === undefined) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egzHc))), {
            style: {
                position: "fixed",
                top: "50%",
                left: "50%"
            },
            color: "primary"
        })
    });
    const path = window.location.href.split("/");
    const mockup = path[path.length - 1];
    let heading = "";
    const mapping = {
        likelihood: "Likelihood of Purchase",
        Premium: "Premium Prediction",
        claimAmountForecast: "Claim Amount Forecast",
        fraudDetection: "Fraud Detection",
        // "fraudDetectionMember" : "Member Fraud Detection",
        churnMember: "Churn Prediction"
    };
    if (mockup in mapping) heading = mapping[mockup];
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
            component: "main",
            sx: {
                flexGrow: 1
            },
            children: auth.user && auth.user.replace(" ", "") !== "" && auth.status === 200 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Route), (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
                render: ({ match: match, location: location })=>loggedInUser !== undefined && loggedInUser !== null ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "d-flex",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("main", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d85088be8077f305$export$2e2bcd8739ae039), {
                                        open: open,
                                        setOpen: setOpen,
                                        shouldDashboardsReload: shouldDashboardsReload,
                                        setShouldDashboardsReload: setShouldDashboardsReload,
                                        heading: heading
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    style: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
                                        open: open,
                                        match: match,
                                        sidebarOPen: open,
                                        shouldDashboardsReload: shouldDashboardsReload,
                                        setShouldDashboardsReload: setShouldDashboardsReload
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Redirect), {
                        to: {
                            pathname: "/login",
                            state: {
                                from: location
                            }
                        }
                    })
            })) : ""
        })
    });
}



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");

var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $8TDId = parcelRequire("8TDId");
var $4Kxg6 = parcelRequire("4Kxg6");
var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $5e9bd48dfa939366$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($5e9bd48dfa939366$exports, "__esModule", {
    value: true
});
$5e9bd48dfa939366$exports.default = void 0;

var $5e9bd48dfa939366$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $5e9bd48dfa939366$var$_default = $5e9bd48dfa939366$exports.default = (0, $5e9bd48dfa939366$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7 12h-2v-2h2zm0-4h-2V6h2z"
}), 'Feedback');


const $d3e02cecd7cb99f5$var$FooterContainer = (0, $kDBhE.default)((0, $aili3.default))(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2, 2),
        backgroundColor: 'transparent',
        width: '100%',
        position: 'relative',
        bottom: 0,
        left: 0,
        right: 0
    }));
const $d3e02cecd7cb99f5$var$FooterContent = (0, $kDBhE.default)((0, $aili3.default))(({ theme: theme })=>({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        justifyContent: 'center',
        maxWidth: 1400,
        width: '100%',
        border: '1.5px solid #D0DBEB',
        borderRadius: 20,
        background: '#fff',
        padding: '24px 32px',
        boxShadow: 'none',
        margin: '0 auto',
        position: 'relative'
    }));
const $d3e02cecd7cb99f5$var$FooterLink = (0, $kDBhE.default)((0, $4Kxg6.default))(({ theme: theme })=>({
        color: '#1976d2',
        textDecoration: 'underline',
        fontSize: '14px',
        fontWeight: 400,
        '&:hover': {
            textDecoration: 'none',
            color: '#1565c0'
        }
    }));
const $d3e02cecd7cb99f5$var$FooterText = (0, $kDBhE.default)((0, $3loMv.default))(({ theme: theme })=>({
        color: '#23272E',
        fontSize: '14px',
        fontWeight: 400
    }));
const $d3e02cecd7cb99f5$var$Separator = (0, $kDBhE.default)((0, $3loMv.default))(({ theme: theme })=>({
        color: '#A0A4AF',
        fontSize: '14px',
        fontWeight: 400
    }));
const $d3e02cecd7cb99f5$var$FeedbackButton = (0, $kDBhE.default)((0, $8TDId.default))(({ theme: theme })=>({
        color: '#A0A4AF',
        padding: theme.spacing(0.5),
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            color: '#23272E'
        }
    }));
const $d3e02cecd7cb99f5$var$Footer = ()=>{
    const handleFeedbackClick = (e)=>{
        e.preventDefault();
        // Handle feedback click - could open a modal or redirect to feedback form
        console.log('Feedback clicked');
    };
    const handleLinkClick = (e)=>{
        e.preventDefault();
        console.log('Link clicked:', e.target.textContent);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterContainer, {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($d3e02cecd7cb99f5$var$FooterContent, {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterText, {
                    children: "\xa9 2025 Perceptiviti"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$Separator, {
                    children: "|"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterLink, {
                    href: "#",
                    underline: "hover",
                    onClick: handleLinkClick,
                    children: "All Rights Reserved"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$Separator, {
                    children: "|"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterLink, {
                    href: "#",
                    underline: "hover",
                    onClick: handleLinkClick,
                    children: "Terms of Service"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$Separator, {
                    children: "|"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterLink, {
                    href: "#",
                    underline: "hover",
                    onClick: handleLinkClick,
                    children: "Privacy Policy"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$Separator, {
                    children: "|"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FeedbackButton, {
                            onClick: handleFeedbackClick,
                            size: "small",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5e9bd48dfa939366$exports))), {
                                fontSize: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($d3e02cecd7cb99f5$var$FooterText, {
                            children: "Send feedback"
                        })
                    ]
                })
            ]
        })
    });
};
var $d3e02cecd7cb99f5$export$2e2bcd8739ae039 = $d3e02cecd7cb99f5$var$Footer;



var $7o2xp = parcelRequire("7o2xp");
const $2676b58b3d4dad2c$var$LayoutContainer = (0, $kDBhE.default)((0, $aili3.default))(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#f5f7fa'
    }));
const $2676b58b3d4dad2c$var$MainContent = (0, $kDBhE.default)((0, $aili3.default))(({ theme: theme })=>({
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: theme.spacing(0)
    }));
const $2676b58b3d4dad2c$var$Layout = ({ children: children })=>{
    const location = (0, $7o2xp.useLocation)();
    const hideFooter = location.pathname === '/widget-generator';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2676b58b3d4dad2c$var$LayoutContainer, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($2676b58b3d4dad2c$var$MainContent, {
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d3e02cecd7cb99f5$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2676b58b3d4dad2c$export$2e2bcd8739ae039 = $2676b58b3d4dad2c$var$Layout;



var $7bFjM = parcelRequire("7bFjM");

var $5nUae = parcelRequire("5nUae");

var $aqd0z = parcelRequire("aqd0z");
let $5dc27a9e3c703cb1$var$_ = (t)=>t, $5dc27a9e3c703cb1$var$t;

const $5dc27a9e3c703cb1$var$Home = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("5ycdX")));

const $5dc27a9e3c703cb1$var$Library = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("laNql")));

const $5dc27a9e3c703cb1$var$WidgetList = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("1REm0")));

const $5dc27a9e3c703cb1$var$DetailDashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>Promise.resolve((parcelRequire("gj7kf"))));

const $5dc27a9e3c703cb1$var$PremiumDashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("in2hs")));

const $5dc27a9e3c703cb1$var$Forecasting = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("hRLoG")));

const $5dc27a9e3c703cb1$var$Workspace = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("fVqJE")));

const $5dc27a9e3c703cb1$var$Login = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("1Ecu1")));

const $5dc27a9e3c703cb1$var$Likelihood = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("jvom8")));

const $5dc27a9e3c703cb1$var$ClaimAmountForecast = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("lJlhH")));

const $5dc27a9e3c703cb1$var$FraudDetection = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("2hlqk")));

const $5dc27a9e3c703cb1$var$ChurnMember = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("7tDli")));

const $5dc27a9e3c703cb1$var$Page = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("ep2U8")));

const $5dc27a9e3c703cb1$var$UtilizationDashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("bFpYi")));

const $5dc27a9e3c703cb1$var$FWADashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("eOXI1")));

const $5dc27a9e3c703cb1$var$ContractsDashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("c3PC0")));

const $5dc27a9e3c703cb1$var$CustomDashboard = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("6m9QJ")));

const $5dc27a9e3c703cb1$var$ChatbotPage = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("6BYYk")));
const $5dc27a9e3c703cb1$var$loaderStyles = (0, $5nUae.css)($5dc27a9e3c703cb1$var$t || ($5dc27a9e3c703cb1$var$t = $5dc27a9e3c703cb1$var$_`
  display: block;
  margin: auto;
`));
const $5dc27a9e3c703cb1$var$RenderLoader = ()=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
            width: "100vw",
            height: "100vh"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($egzHc))), {
            color: (0, $aqd0z.NAVBAR_BLUE),
            css: $5dc27a9e3c703cb1$var$loaderStyles,
            size: 15
        })
    });
function $5dc27a9e3c703cb1$var$useDashboards() {
    const [dashboards, setDashboards] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const history = (0, $7o2xp.useHistory)();
    (0, $7fPBF.useEffect)(()=>{
        const loggedInUser = localStorage.getItem("user");
        if (loggedInUser) (0, $7bFjM.default)("GET", "get_dashboard_list/", "", "").then((response)=>{
            setDashboards(response.data || []);
        }).catch((error)=>{
            console.error("Error fetching dashboards:", error);
        }).finally(()=>setLoading(false));
        else {
            setLoading(false);
            history.push("/login");
        }
    }, [
        history
    ]);
    return {
        dashboards: dashboards,
        loading: loading
    };
}
function $5dc27a9e3c703cb1$export$2e2bcd8739ae039() {
    const { dashboards: dashboards, loading: loading } = $5dc27a9e3c703cb1$var$useDashboards();
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$RenderLoader, {});
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
        sx: {
            display: "flex"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6e382b045249d040$export$7221d69dcfc8e36b), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                fallback: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$RenderLoader, {}),
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7o2xp.Switch), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Route), {
                            path: "/login",
                            component: $5dc27a9e3c703cb1$var$Login
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/widget-generator",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$Library, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/workspace",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$Workspace, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/WidgetList",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$WidgetList, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/utilization-dashboard",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$UtilizationDashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/fwa-dashboard",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$FWADashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/contracts-dashboard",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$ContractsDashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/dashboard/:dashboardId",
                            hideSidebar: true,
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$CustomDashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/dashboard",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$DetailDashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/premium",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$PremiumDashboard, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/forecasting",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$Page, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/fraudDetection",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$FraudDetection, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/churnMember",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$ChurnMember, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/likelihood",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$Likelihood, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/forecasting/claimAmountForecast",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$ClaimAmountForecast, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/test",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$Forecasting, (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                                        changeColor: true
                                    }))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a5c5d23854a547ba$export$2e2bcd8739ae039), {
                            path: "/chatbot",
                            component: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2676b58b3d4dad2c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($5dc27a9e3c703cb1$var$ChatbotPage, (0, $9tqwB._)({}, props))
                                })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Route), {
                            path: "/dashboard",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Redirect), {
                                to: dashboards.length > 0 ? `/dashboard/${dashboards[0].id}_${dashboards[0].name}` : "/utilization-dashboard"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Route), {
                            exact: true,
                            path: "/",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Redirect), {
                                to: "/utilization-dashboard"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Route), {
                            render: ()=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $7o2xp.Redirect), {
                                    to: "/utilization-dashboard"
                                })
                        })
                    ]
                })
            })
        })
    });
}





var $jilX7 = parcelRequire("jilX7");

var $hmhHQ = parcelRequire("hmhHQ");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $gFfZb = parcelRequire("gFfZb");

var $fC1zT = parcelRequire("fC1zT");

var $3ax6g = parcelRequire("3ax6g");

var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fC1zT.default)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $3ax6g.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFfZb.default).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;


var $fC1zT = parcelRequire("fC1zT");

parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $84PRT = parcelRequire("84PRT");

var $kyirV = parcelRequire("kyirV");

var $7eatR = parcelRequire("7eatR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $84PRT.default)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $fC1zT.default)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kyirV.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7eatR.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;



var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $jwhZE.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $kY3Ke.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $kY3Ke.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: finalTheme
    }));
}



var $aqd0z = parcelRequire("aqd0z");
const $6aaba76260e26777$var$theme = (0, $hmhHQ.default)({
    palette: {
        primary: {
            main: (0, $aqd0z.NAVBAR_BLUE)
        },
        secondary: {
            main: (0, $aqd0z.GREEN)
        }
    }
});
function $6aaba76260e26777$var$App() {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jilX7.AuthProvider), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6e382b045249d040$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
                theme: $6aaba76260e26777$var$theme,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5dc27a9e3c703cb1$export$2e2bcd8739ae039), {})
            })
        })
    });
}
var $6aaba76260e26777$export$2e2bcd8739ae039 = $6aaba76260e26777$var$App;


(0, $fw0lo.render)(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6aaba76260e26777$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=index.1a798b67.js.map
